(function () {
    'use strict';

    var pages = [
        'ui.router',
        'NGOMonitoringClientApp.pages.auth',
        'NGOMonitoringClientApp.pages.main'
    ];

    angular.module('NGOMonitoringClientApp.pages', pages)
        .config(['$urlRouterProvider', '$httpProvider', '$stateProvider', routeConfig])
        .run(['$state', '$transitions', '$rootScope', 'authService', 'toastr', 'menuPermissionService', onRun]);

    /** @ngInject */
    function routeConfig($urlRouterProvider, $httpProvider, $stateProvider) {
        $urlRouterProvider.otherwise('/login');
        $httpProvider.interceptors.push('httpInterceptor');
    }
    //
    function onRun($state, $transitions, $rootScope, authService, toastr, menuPermissionService) {
        // $state.go(menuPermissionService.getDefaultState());
        $transitions.onBefore({
            to: function (state) {
                return state.name != 'login';
            }
        }, function (trans) {
            if (!authService.isAuthenticated()) {
                return $state.target("login");
            } else {
                if(!$rootScope.loggedInUser){
                    $rootScope.loggedInUser = authService.getLoggedInUser();
                }
                if(trans.to().name && menuPermissionService.hasStatePermission(trans.to().name)) return true;
            }
        });
        $rootScope.$on('unauthorized', function(){
            console.log("unauthorized event");
            authService.clearSession();
            $state.transitionTo('login');
            toastr.error('Your session has expired! Please sign in again!','Session Expired!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        });
        $rootScope.$on('server-down', function(){
            console.log("server down event");
            authService.clearSession();
            $state.transitionTo('login');
            toastr.error('Please try again later!','Server problem!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        });
        $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
            console.log("state change error event");
            // this is required if you want to prevent the $UrlRouter reverting the URL to the previous valid location
            event.preventDefault();
            toastr.error('Please try again later!','Server problem!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
            $state.go(menuPermissionService.getDefaultState());
        });

        //
    }

})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();

(function(){
    'use strict';

    var authStateModules = [
        'ui.router',
        'NGOMonitoringClientApp.pages.auth.login',
        'NGOMonitoringClientApp.pages.auth.logout'
    ];

    angular.module('NGOMonitoringClientApp.pages.auth', authStateModules)
        .config(['$stateProvider' , function ($stateProvider) {
            $stateProvider
                /* public template*/
                .state('public', {
                    url : "",
                    views : {
                        'root' : {
                            templateUrl : 'app/pages/auth/auth.html'
                        }
                    },
                    abstract : true
                })
        }]);
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main', [
        'ui.router',
        'NGOMonitoringClientApp.pages.main.employees',
        'NGOMonitoringClientApp.pages.main.home',
        'NGOMonitoringClientApp.pages.main.generalReport',
        // 'NGOMonitoringClientApp.pages.main.profile',
        // 'NGOMonitoringClientApp.pages.main.outcomeDetails',
        // 'NGOMonitoringClientApp.pages.main.outputDetails',
        // 'NGOMonitoringClientApp.pages.main.activityDetails',
        // 'NGOMonitoringClientApp.pages.main.activityMenu',
        // 'NGOMonitoringClientApp.pages.main.outputMenu',
        'NGOMonitoringClientApp.pages.main.setup',
        'NGOMonitoringClientApp.pages.main.dataCollection',
        'NGOMonitoringClientApp.pages.main.monitoring',
        'NGOMonitoringClientApp.pages.main.projects',
        'ui.bootstrap',
        'ui.bootstrap.tpls'
    ]).config(['$stateProvider' , function ($stateProvider) {
        $stateProvider
            .state('app', {
                url: '',
                views : {
                    'root' : {
                        templateUrl: 'app/pages/main/main.html',
                        controller : 'MainCtrl'
                    }
                },
                abstract : true
            });
    }]);
})();


(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

(function(){
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.auth.login', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('login', {
                url : '/login',
                parent : 'public',
                views : {
                    'pub@public' : {
                        templateUrl : 'app/pages/auth/login/login.html',
                        controller : 'LoginCtrl'
                    }
                },
                title : 'Login'
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.activityDetails',[])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('activityDetails', {
                url: '/activityDetails/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/activityDetails/activityDetails.html',
                        controller: 'ActivityDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('createActivityIndicator', {
                url: '/createActivityIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/activityDetails/create/createIndicator.html',
                        controller : 'ActivityIndicatorCreateCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.auth.logout', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('logout', {
                url: '/logout',
                parent : 'public',
                views : {
                    'pub@public' : {
                        template : '<div></div>',
                        controller : 'LogoutCtrl'
                    }
                },
                title: 'Logout'
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.activityMenu', ['smart-table'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('activityMenu', {
                url: '/activityMenu',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/activityMenu/activityMenu.html',
                        controller: 'ActivityMenuCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Activity Menu',
                sidebarMeta: {
                    icon : 'ion-clipboard',
                    order: 70
                }
            });
        $stateProvider
            .state('activityReport', {
                url: '/activityReport',
                params:{
                    activityIds:{
                        squash: false,
                        value: null,
                    }
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/activityMenu/activityReport/activityReport.html',
                        controller: 'ActivityReportCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection',[
            'NGOMonitoringClientApp.pages.main.dataCollection.impactData',
            'NGOMonitoringClientApp.pages.main.dataCollection.outcomeData',
            'NGOMonitoringClientApp.pages.main.dataCollection.outputData',
            'NGOMonitoringClientApp.pages.main.dataCollection.activityData'

        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dataCollection', {
                url: '/dataCollection',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="dataCollection" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Data Collection',
                sidebarMeta: {
                    icon : 'ion-compose',
                    order: 3
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.employees', ['smart-table'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('employees', {
                url: '/employees',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/employees/employees.html',
                        controller: 'EmployeesCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Manage Users',
                sidebarMeta: {
                    icon : 'ion-person-stalker',
                    order: 7
                }
            });

        $stateProvider
            .state('createEmployee', {
                url: '/employees/createEmployee',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/employees/create/createEmployee.html',
                        controller : 'EmployeeCreateModalCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Create Employee'
            });

        $stateProvider.state('employeeActions', {
                url: '/employees/employeeActions',
                params : {
                    selectedEmployees : {
                        squash : false,
                        value : null
                    },
                    notSelectedEmployees : {
                        squash : false,
                        value : null
                    }

                },
                title : 'Employee Actions',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/employees/actions/employeeActions.html',
                        controller : 'EmployeeActionsCtrl',
                        controllerAs : 'vm'
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport',[
            'NGOMonitoringClientApp.pages.main.generalReport.impactReport',
            'NGOMonitoringClientApp.pages.main.generalReport.outcomeReport',
            'NGOMonitoringClientApp.pages.main.generalReport.outputReport',
            'NGOMonitoringClientApp.pages.main.generalReport.activityReport',
            'NGOMonitoringClientApp.pages.main.generalReport.activityDetailsReport'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport', {
                url: '/generalReport',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="generalReport" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'General Report',
                sidebarMeta: {
                    icon : 'ion-compose',
                    order: 5
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.home', [])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('home', {
                url: '/home',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/home/home.html',
                        controller: 'HomeCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Home',
                sidebarMeta: {
                    icon : 'ion-home',
                    order: 1
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring',[
            'NGOMonitoringClientApp.pages.main.monitoring.impactMonitoring',
            'NGOMonitoringClientApp.pages.main.monitoring.outcomeMonitoring',
            'NGOMonitoringClientApp.pages.main.monitoring.outputMonitoring',
            'NGOMonitoringClientApp.pages.main.monitoring.activityMonitoring'
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('monitoring', {
                url: '/monitoring',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="monitoring" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Monitoring',
                sidebarMeta: {
                    icon : 'ion-ios-pulse-strong',
                    order: 4
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.outcomeDetails',[])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('outcomeDetails', {
                url: '/outcomeDetails/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/outcomeDetails/outcomeDetails.html',
                        controller: 'OutcomeDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            })

}
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.outputDetails',[])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('outputDetails', {
                url: '/outputDetails/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/outputDetails/outputDetails.html',
                        controller: 'OutputDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('createOutputIndicator', {
                url: '/createOutputIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/outputDetails/create/createIndicator.html',
                        controller : 'OutputIndicatorCreateCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();

(function () {
  'use strict';

  angular.module('NGOMonitoringClientApp.pages.main.profile', ['ngFileUpload', 'ngImgCrop', 'daterangepicker','ui.bootstrap.datetimepicker','ui.bootstrap'])
      .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('profile', {
                url: '/profile/:employeeId',
                params : {
                    employeeId : {
                        squash : false,
                        value : null
                    }
                },
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/profile/profile.html',
                        controller: 'ProfileCtrl',
                        controllerAs : 'vm'
                    }
                },
                title: 'Profile'
            });
    }

})();

(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.outputMenu', ['smart-table'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('outputMenu', {
                url: '/outputMenu',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/outputMenu/outputMenu.html',
                        controller: 'OutputMenuCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Output Menu',
                sidebarMeta: {
                    icon : 'ion-person-stalker',
                    order: 80
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.projects', ['smart-table'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('projects', {
                url: '/projects',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/projects/projects.html',
                        controller: 'ProjectsCtrl',
                        controllerAs: "vm"
                    }
                },
                title: 'Manage Projects',
                sidebarMeta: {
                    icon : 'ion-flag',
                    order: 6
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.setup',[
            'NGOMonitoringClientApp.pages.main.setup.impactList',
            'NGOMonitoringClientApp.pages.main.impactSetup',
            'NGOMonitoringClientApp.pages.main.setup.outcomeList',
            'NGOMonitoringClientApp.pages.main.outcomeSetup',
            'NGOMonitoringClientApp.pages.main.setup.outputList',
            'NGOMonitoringClientApp.pages.main.outputSetup',
            // 'NGOMonitoringClientApp.pages.main.setup.activityList',
            'NGOMonitoringClientApp.pages.main.setup.activity',
        ])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('setup', {
                url: '/setup',
                abstract : true,
                views : {
                    'app' : {
                        template: '<div ui-view="setup" autoscroll="true" autoscroll-body-top></div>'
                    }
                },
                parent : 'app',
                title: 'Setup',
                sidebarMeta: {
                    icon : 'ion-settings',
                    order: 2
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.impactData', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dataCollection.impactData',
                {
                    url: '/impactData',
                    views : {
                        'dataCollection' : {
                            templateUrl: 'app/pages/main/dataCollection/impactData/impactData.html',
                            controller:'ImpactDataCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Impact Data Collection',
                    sidebarMeta: {
                        order: 91
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.activityData', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dataCollection.activityData',
                {
                    url: '/activityData',
                    views : {
                        'dataCollection' : {
                            templateUrl: 'app/pages/main/dataCollection/activityData/activityData.html',
                            controller:'ActivityDataCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Activity Data',
                    sidebarMeta: {
                        order: 95
                    }
                });
        $stateProvider
            .state('activityDataCollection', {
                url: '/activityDataCollection/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/dataCollection/activityData/dataCollection/activityDataCollection.html',
                        controller: 'ActivityDataCollectionCtrl',
                        controllerAs: "vm"
                    }
                }
            });

    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.outcomeData', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dataCollection.outcomeData',
                {
                    url: '/outcomeData',
                    views : {
                        'dataCollection' : {
                            templateUrl: 'app/pages/main/dataCollection/outcomeData/outcomeData.html',
                            controller:'OutcomeDataCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Outcome Data Collection',
                    sidebarMeta: {
                        order: 92
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.outputData', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('dataCollection.outputData',
                {
                    url: '/outputData',
                    views : {
                        'dataCollection' : {
                            templateUrl: 'app/pages/main/dataCollection/outputData/outputData.html',
                            controller:'OutputDataCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Output Data Collection',
                    sidebarMeta: {
                        order: 94
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.activityReport', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport.activityReport',
                {
                    url: '/activityReport',
                    views : {
                        'generalReport' : {
                            templateUrl: 'app/pages/main/generalReport/activityReport/activityReport.html',
                            controller:'ActivityReportCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Activity Yearly Report',
                    sidebarMeta: {
                        order: 96
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.impactReport', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport.impactReport',
                {
                    url: '/impactReport',
                    views : {
                        'generalReport' : {
                            templateUrl: 'app/pages/main/generalReport/impactReport/impactReport.html',
                            controller:'ImpactReportCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Impact Report',
                    sidebarMeta: {
                        order: 94
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.outcomeReport', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport.outcomeReport',
                {
                    url: '/outcomeReport',
                    views : {
                        'generalReport' : {
                            templateUrl: 'app/pages/main/generalReport/outcomeReport/outcomeReport.html',
                            controller:'OutcomeReportCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Outcome Report',
                    sidebarMeta: {
                        order: 95
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.outputReport', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport.outputReport',
                {
                    url: '/outputReport',
                    views : {
                        'generalReport' : {
                            templateUrl: 'app/pages/main/generalReport/outputReport/outputReport.html',
                            controller:'OutputReportCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Output Report',
                    sidebarMeta: {
                        order: 95
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.impactMonitoring', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('monitoring.impactMonitoring',
                {
                    url: '/impactMonitoring',
                    views : {
                        'monitoring' : {
                            templateUrl: 'app/pages/main/monitoring/impactMonitoring/impactMonitoring.html',
                            controller:'ImpactMonitoringCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Impact Monitoring',
                    sidebarMeta: {
                        order: 95
                    }
                })
            .state('monitoring.impactMonitoringDetails', {
                url: '/impactMonitoringDetails/{id}',
                views : {
                    'monitoring' : {
                        templateUrl : 'app/pages/main/monitoring/impactMonitoring/impactMonitoringDetails/impactMonitoringDetails.html',
                        controller : 'ImpactMonitoringDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.activityMonitoring', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('monitoring.activityMonitoring',
                {
                    url: '/activityMonitoring',
                    views : {
                        'monitoring' : {
                            templateUrl: 'app/pages/main/monitoring/activityMonitoring/activityMonitoring.html',
                            controller:'ActivityMonitoringCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Activity Monitoring',
                    sidebarMeta: {
                        order: 98
                    }
                });

        $stateProvider
            .state('activityPerformMonitoring', {
                url: '/activityPerformMonitoring/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/monitoring/activityMonitoring/monitoring/activityPerformMonitoring.html',
                        controller: 'ActivityPerformMonitoringCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outcomeMonitoring', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('monitoring.outcomeMonitoring',
                {
                    url: '/outcomeMonitoring',
                    views : {
                        'monitoring' : {
                            templateUrl: 'app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoring.html',
                            controller:'OutcomeMonitoringCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Outcome Monitoring',
                    sidebarMeta: {
                        order: 96
                    }
                })
            .state('monitoring.outcomeMonitoringDetails', {
                url: '/outcomeMonitoringDetails/{id}',
                views : {
                    'monitoring' : {
                        templateUrl : 'app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoringDetails/outcomeMonitoringDetails.html',
                        controller : 'OutcomeMonitoringDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outputMonitoring', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('monitoring.outputMonitoring',
                {
                    url: '/outputMonitoring',
                    views : {
                        'monitoring' : {
                            templateUrl: 'app/pages/main/monitoring/outputMonitoring/outputMonitoring.html',
                            controller:'OutputMonitoringCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Output Monitoring',
                    sidebarMeta: {
                        order: 97
                    }
                })
            .state('monitoring.outputMonitoringDetails', {
                url: '/outputMonitoringDetails/{id}',
                views : {
                    'monitoring' : {
                        templateUrl : 'app/pages/main/monitoring/outputMonitoring/outputMonitoringDetails/outputMonitoringDetails.html',
                        controller : 'OutputMonitoringDetailsCtrl',
                        controllerAs: "vm"
                    }
                }
            });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.setup.activity', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('setup.activities',
                {
                    url: '/activities',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/activity/activity.html',
                            controller:'ActivityCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Activity',
                    sidebarMeta: {
                        order: 89
                    }
                });
        $stateProvider
            .state('setup.createActivity',
                {
                    url: '/createActivity',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/activity/createActivity/createActivity.html',
                            controller:'CreateActivityCtrl',
                            controllerAs:'vm'
                        }
                    }
                });

        $stateProvider
            .state('setup.editActivity',
                {
                    url: '/editActivity/:activityId',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/activity/editActivity/editActivity.html',
                            controller:'EditActivityCtrl',
                            controllerAs:'vm'
                        }
                    },
                    params : {
                        activityId : null
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.setup.impactList', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('setup.impacts',
                {
                    url: '/impacts',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/impact/impactList/impactList.html',
                            controller:'ImpactListCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Impacts',
                    sidebarMeta: {
                        order: 86
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.impactSetup',['ngAnimate'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('impactSetup', {
                url: '/impactSetup/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/setupMenu/impact/impactSetup/impactSetup.html',
                        controller: 'ImpactSetupCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('createImpactIndicator', {
            url: '/createImpactIndicator/{id}',
            parent : 'app',
            views : {
                'app' : {
                    templateUrl : 'app/pages/main/setupMenu/impact/impactSetup/create/indicator/createIndicator.html',
                    controller : 'ImpactIndicatorCreateCtrl',
                    controllerAs: "vm"
                }
            }
            })
            .state('editImpactIndicator', {
                url: '/editImpactIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/setupMenu/impact/impactSetup/edit/editIndicatorDetails/editIndicatorDetails.html',
                        controller : 'ImpactIndicatorEditCtrl',
                        controllerAs: "vm"
                    }
                }
            });



    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.setup.outcomeList', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('setup.outcomes',
                {
                    url: '/outcomes',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/outcome/outcomeList/outcomeList.html',
                            controller:'OutcomeListCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Outcomes',
                    sidebarMeta: {
                        order: 87
                    }
                });
    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.outcomeSetup',['ngAnimate'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('outcomeSetup', {
                url: '/outcomeSetup/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/setupMenu/outcome/outcomeSetup/outcomeSetup.html',
                        controller: 'OutcomeSetupCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('createOutcomeIndicator', {
                url: '/createOutcomeIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/setupMenu/outcome/outcomeSetup/create/indicator/createIndicator.html',
                        controller : 'OutcomeIndicatorCreateCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('editOutcomeIndicator', {
                url: '/editOutcomeIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/setupMenu/outcome/outcomeSetup/edit/editIndicatorDetails/editIndicatorDetails.html',
                        controller : 'OutcomeIndicatorEditCtrl',
                        controllerAs: "vm"
                    }
                }
            });




    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.outputSetup',['ngAnimate'])
        .config(['$stateProvider', routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('outputSetup', {
                url: '/outputSetup/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl: 'app/pages/main/setupMenu/output/outputSetup/outputSetup.html',
                        controller: 'OutputSetupCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('createOutputIndicator', {
                url: '/createOutputIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/setupMenu/output/outputSetup/create/indicator/createIndicator.html',
                        controller : 'OutputIndicatorCreateCtrl',
                        controllerAs: "vm"
                    }
                }
            })
            .state('editOutputIndicator', {
                url: '/editOutputIndicator/{id}',
                parent : 'app',
                views : {
                    'app' : {
                        templateUrl : 'app/pages/main/setupMenu/output/outputSetup/edit/editIndicatorDetails/editIndicatorDetails.html',
                        controller : 'OutputIndicatorEditCtrl',
                        controllerAs: "vm"
                    }
                }
            });




    }
})();
(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.setup.outputList', ['ui.bootstrap', 'ui.bootstrap.tpls'])
        .config(['$stateProvider',routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('setup.outputs',
                {
                    url: '/outputs',
                    views : {
                        'setup' : {
                            templateUrl: 'app/pages/main/setupMenu/output/outputList/outputList.html',
                            controller:'OutputListCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Outputs',
                    sidebarMeta: {
                        order: 88
                    }
                });
    }
})();
'use strict';

var app = angular.module('NGOMonitoringClientApp', [
    'ngAnimate',
    'ui.bootstrap',
    'ui.sortable',
    'ui.router',
    'ngTouch',
    'toastr',
    'smart-table',
    "xeditable",
    'ui.slimscroll',
    'ngJsTree',
    'angular-progress-button-styles',
    'ngBootstrap',
    'ui.bootstrap.datetimepicker',
    'BlurAdmin.theme',
    'NGOMonitoringClientApp.pages'
]);

app.config(['$locationProvider', function ($locationProvider) {
    // enable html5Mode for pushstate ('#'-less URLs)
    $locationProvider.html5Mode(true);
    $locationProvider.hashPrefix('!');
}]);
(function () {
    var apiLink = 'http://localhost:1994/ngo-monitoring-api/v1';
    // var apiLink = 'http://test.tdh.inovacetech.com/ngo-monitoring-api/v1';
    // var apiLink = 'https://tdh.inovacetech.com/ngo-monitoring-api/v1';
    // var apiLink = 'http://ec2-13-229-143-251.ap-southeast-1.compute.amazonaws.com:1993/ngo-monitoring-api/v1';

    var apiLink = window.location.origin + "/ngo-monitoring-api/v1";
    if(window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') apiLink = 'http://127.0.0.1:1994/ngo-monitoring-api/v1';

    app.constant('API', {
        employee: {
            'create': apiLink + '/employee/',
            'all': apiLink + '/employee',
            'majorActivityCoordinator': apiLink + '/employee/major-activity-coordinator/',
            'allByRole': apiLink + '/employee/role/',
            'findById': apiLink + '/employee/profile/',
            'updateBasicInfo': apiLink + '/employee/profile/',
            'detailedProfile': apiLink + '/employee/profile/details/',
            'uploadProfilePicture': apiLink + '/employee/profile/picture/',
            'removeProfilePicture': apiLink + '/employee/profile/picture/remove/',
            'updateDetailsInfo': apiLink + '/employee/profile/details/',
            'updatePassword': apiLink + '/employee/password/',
            'uploadDocument': apiLink + '/employee/profile/',
            'document': '/document/',
            'updateAllowLogin': apiLink + '/employee/',
            'allowLogin': '/allowLogin/',
            'createAddress': {
                "prefix": apiLink + '/employee/',
                "suffix": '/address/'
            },
            'updateAddress': {
                "prefix": apiLink + '/employee/',
                "suffix": '/address/'
            },
            'enrolEmployee': apiLink + '/employee/enrollment/enroll/',
            'employeesAssignedToWeeklyOffDaysPolicy': apiLink + '/employee/' + 'weekly-off-days/',
            'enrol': {
                'getFingers': apiLink + '/employee/enrollment/',
                'deleteFinger': apiLink + '/employee/enrollment/delete/'
            }
        },
        impact: {
            'all': apiLink + '/impact/',
            'allActive': apiLink + '/impact/active/',
            'edit': apiLink + '/impact/',
            'delete': {
                'prefix': apiLink + '/impact/',
                'suffix': '/delete/',
            },
        },
        impactIndicator: {
            'setupResearchFrameworkForImpactIndicator': apiLink + '/impact-indicator/setup/research-framework/',
            'setupResearchFrameworkForImpactIndicator': apiLink + '/impact-indicator/setup/research-framework/',
            'edit': apiLink + '/impact-indicator/',
            'create': apiLink + '/impact-indicator/create/',
            'createMonitoringSession': {
                'prefix': apiLink + '/impact-indicator/',
                'suffix': '/create-monitoring-session/',
            },
            'delete': {
                'prefix': apiLink + '/impact-indicator/',
                'suffix': '/delete/',
            },
            'get': apiLink + '/impact-indicator/'
        },
        impactMonitoringSession: {
            'dataCollection': apiLink + '/impact-monitoring-session/data-collection/',
            'monitoringFeedback': apiLink + '/impact-monitoring-session/monitoring-feedback/',
            'delete': {
                'prefix': apiLink + '/impact-monitoring-session/',
                'suffix': '/delete/',
            },
            'edit': apiLink + '/impact-monitoring-session/',
        },
        outcome: {
            'all': apiLink + '/outcome/',
            'getAllActive': apiLink + '/outcome/active/',
            'delete': apiLink + '/outcome/delete/'
        },
        outcomeIndicator: {
            'edit': apiLink + '/outcome-indicator/',
            'create': apiLink + '/outcome-indicator/create/',
            'all': apiLink + '/outcome-indicator/',
            'setupResearchFramework': apiLink + '/outcome-indicator/setup/research-framework/',
            'createMonitoringSession': {
                'prefix': apiLink + '/outcome-indicator/',
                'suffix': '/create-monitoring-session/',
            },
            'delete': {
                'prefix': apiLink + '/outcome-indicator/',
                'suffix': '/delete/',
            },
        },
        outcomeMonitoringSession: {
            'dataCollection': apiLink + '/outcome-monitoring-session/data-collection/',
            'monitoringFeedback': apiLink + '/outcome-monitoring-session/monitoring-feedback/',
            'delete': {
                'prefix': apiLink + '/outcome-monitoring-session/',
                'suffix': '/delete/',
            },
            'edit': apiLink + '/outcome-monitoring-session/',
        },
        output: {
            'all': apiLink + '/output/',
            'delete': {
                'prefix': apiLink + '/output/',
                'suffix': '/delete/',
            },
        },
        outputIndicator: {
            'edit': apiLink + '/output-indicator/',
            'create': apiLink + '/output-indicator/create/',
            'all': apiLink + '/output-indicator/',
            'setupResearchFramework': apiLink + '/output-indicator/setup/research-framework/',
            'createMonitoringSession': {
                'prefix': apiLink + '/output-indicator/',
                'suffix': '/create-monitoring-session/',
            },
            'delete': {
                'prefix': apiLink + '/output-indicator/',
                'suffix': '/delete/',
            },
        },
        outputMonitoringSession: {
            'all': apiLink + '/output-monitoring-session/',
            'dataCollection': apiLink + '/output-monitoring-session/data-collection/',
            'monitoringFeedback': apiLink + '/output-monitoring-session/monitoring-feedback/',
            'delete': {
                'prefix': apiLink + '/output-monitoring-session/',
                'suffix': '/delete/',
            },
            'edit': apiLink + '/output-monitoring-session/',
        },
        auth: {
            'signin': apiLink + '/auth/signin',
            'signout': apiLink + '/auth/signout'
        },
        activity: {
            'all': apiLink + '/activity/',
            'allActive': apiLink + '/activity/active/',
            'update': apiLink + '/activity/',
            'delete': {
                'prefix': apiLink + '/activity/',
                'suffix': '/delete/',
            },
            report : apiLink + '/activity/report',
            detailedReport : apiLink + '/activity/detailed-report',
            detailedReportExcel : apiLink + '/activity/report-excel',
            yearlyReportExcel : apiLink + '/activity/yearly-report-excel',
            performDataCollection   : apiLink + '/activity/data-collection/',
            performMonitoring   : apiLink + '/activity/monitoring/perform-monitoring/',
            updateMonitoringSession : apiLink + '/activity/monitoring/update/',
            addMonitoringSession : apiLink + '/activity/monitoring/',
            deleteMonitoringSession : apiLink + '/activity/monitoring/delete/',

        },
        project: {
            'create': apiLink + '/project/',
            'getAll': apiLink + '/project/',
            'getAllActive': apiLink + '/project/active/',
            'updateName': apiLink + '/project/',
            'updateStatus': {
                'prefix': apiLink + '/project/',
                'suffix': '/status/',
            },
            'deleteProject': {
                'prefix': apiLink + '/project/',
                'suffix': '/delete/',
            },
        },
        report: {
            'getReport': apiLink + '/report/'
        }

    });

    app.constant('aclLevel', {
        value: 'office'
    });

    app.constant('CONSTANT', {
        apiLink: 'http://127.0.0.0:1990/inovace-client/api/v1'
    });

    app.constant('TIME_IN_MILLISECOND', {
        'ONE_SECOND': 1000,
        'ONE_MINUTE': 60 * 1000,
        'ONE_HOUR': 60 * 60 * 1000,
        'ONE_DAY': 24 * 60 * 60 * 1000,
        'SEVEN_DAYS': 7 * 24 * 60 * 60 * 1000
    });

    app.constant('_', window._);

    app.constant('RESPONSE_CODE', {
        success: 200,
        notFound: 404,
        error: 500
    });

    app.constant('ROLES', {
        'BY_NAME': {
            'EXECUTIVE_DIRECTOR': 1,
            'ADMIN': 2,
            'MNE': 3,
            'RESEARCHER': 4,
            'COORDINATOR': 5,
            'PARTNER_NGO': 6,
        },
        'BY_VALUE': {
            1: 'Executive Director',
            2: 'Admin',
            3: 'MNE',
            4: 'Researcher',
            5: 'Coordinator',
            6: 'Partner NGO'
        }
    });

    app.constant('timeInterval', {
        '3 months': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                }
            ],
            'value': 3
        },
        '6 months': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                }
            ],
            'value': 6
        },
        '1 year': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                }
            ],
            'value': 12
        },
        '2 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                }
            ],
            'value': 24
        },
        '3 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '3 year',
                    value: 36
                }
            ],
            'value': 36
        },
        '4 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                },
                {
                    time: '3 year',
                    value: 36
                },
                {
                    time: '4 year',
                    value: 48
                }
            ],
            'value': 48
        },
        '5 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '5 year',
                    value: 60
                }
            ],
            'value': 60
        },
        '6 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                },
                {
                    time: '3 year',
                    value: 36
                },
                {
                    time: '6 year',
                    value: 72
                }
            ],
            'value': 72
        },
        '7 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '7 year',
                    value: 84,
                }
            ],
            'value': 84
        },
        '8 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                },
                {
                    time: '3 year',
                    value: 36
                },
                {
                    time: '4 year',
                    value: 48
                },
                {
                    time: '8 year',
                    value: 96
                }
            ],
            'value': 96
        },
        '9 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                },
                {
                    time: '3 year',
                    value: 36
                },
                {
                    time: '9 year',
                    value: 108
                }
            ],
            'value': 108
        },
        '10 years': {
            'options': [
                {
                    time: '1 month',
                    value: 1
                },
                {
                    time: '3 month',
                    value: 3
                },
                {
                    time: '6 month',
                    value: 6
                },
                {
                    time: '1 year',
                    value: 12
                },
                {
                    time: '2 year',
                    value: 24
                },
                {
                    time: '3 year',
                    value: 36
                },
                {
                    time: '4 year',
                    value: 48
                },
                {
                    time: '5 year',
                    value: 60
                }
            ],
            'value': 120
        }


    });

    app.constant('PRINTMEDIABOOTSTRAP',
        {link: "https://s3-ap-southeast-1.amazonaws.com/inovace-client-panel-required-files/bootstrap-without-print-media.css"});
}).call(this);
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    //baConfigProvider.changeTheme({blur: true});
    //
    //baConfigProvider.changeColors({
    //  default: 'rgba(#000000, 0.2)',
    //  defaultText: '#ffffff',
    //  dashboard: {
    //    white: '#ffffff',
    //  },
    //});
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();

/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main')
        .controller('MainCtrl', ['$rootScope', '$scope', '$state', 'authService', 'toastr', MainCtrl]);


    /** @ngInject */
    function MainCtrl($rootScope, $scope, $state, authService, toastr) {
        // $rootScope.loggedInUser = authService.getAllInformation();
        // if(authService.isAuthenticated()) {
        //     $rootScope.isLoginState = false;
        //     $state.go('home');
        // }
        // $rootScope.isLoginState = true;
        // console.log("login page");
        //
        // $scope.login = function () {
        //     toastr.clear();
        //     console.log($scope.loginData.email);
        //     console.log($scope.loginData.password);
        //     authService
        //         .login($scope.loginData)
        //         .then(loginSuccess, loginFailed);
        // };
        //
        // var loginSuccess = function(){ showSuccessToast(); };
        // var loginFailed = function (message) { showErrorToast(message); };
        //
        //
        //
        // var showErrorToast = function (message) {
        //     toastr.error(message, 'Sign In Failed', {
        //         "autoDismiss": false,
        //         "positionClass": "toast-top-right",
        //         "type": "error",
        //         "timeOut": "5000",
        //         "extendedTimeOut": "2000",
        //         "allowHtml": false,
        //         "closeButton": false,
        //         "tapToDismiss": true,
        //         "progressBar": false,
        //         "newestOnTop": true,
        //         "maxOpened": 0,
        //         "preventDuplicates": false,
        //         "preventOpenDuplicates": false
        //     });
        // };
        //
        // var showSuccessToast = function(){
        //     toastr.success('Welcome to Inovace Client Panel!', 'Sign in success!', {
        //         "autoDismiss": false,
        //         "positionClass": "toast-top-right",
        //         "type": "success",
        //         "timeOut": "5000",
        //         "extendedTimeOut": "2000",
        //         "allowHtml": false,
        //         "closeButton": false,
        //         "tapToDismiss": true,
        //         "progressBar": false,
        //         "newestOnTop": true,
        //         "maxOpened": 0,
        //         "preventDuplicates": false,
        //         "preventOpenDuplicates": false
        //     })
        // };
    }


})();
/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
'use strict';

(function (angular) {
  // Create all modules and define dependencies to make sure they exist
  // and are loaded in the correct order to satisfy dependency injection
  // before all nested files are concatenated by Gulp

  // Config
  angular.module('ui.carousel.config', []).value('ui.carousel.config', {
    debug: true
  });

  // Modules
  angular.module('ui.carousel.providers', []);
  angular.module('ui.carousel.controllers', []);
  angular.module('ui.carousel.directives', []);
  angular.module('ui.carousel', ['ui.carousel.config', 'ui.carousel.directives', 'ui.carousel.controllers', 'ui.carousel.providers']);
})(angular);
'use strict';

/**
 * angular-ui-carousel
 * for example:
 * length = 8, show = 4, scroll = 3, current = 0
 *          ---------
 *          |       |
 *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
 *          |       |
 *          ---------
 * rectangle is visible for users
 */
angular.module('ui.carousel.controllers').controller('CarouselController', ['$scope', '$element', '$timeout', '$q', 'Carousel', '$window', function ($scope, $element, $timeout, $q, Carousel, $window) {
  var _this = this;

  /**
   * Initial carousel
   *
   * Mirgate to angularjs 1.6
   * @see https://docs.angularjs.org/guide/migration#commit-bcd0d4
   */
  this.$onInit = function () {
    _this.initOptions();
    _this.initRanges();
    _this.setProps();
    _this.setupInfinite();
  };

  /**
   * Init option based on directive config
   */
  this.initOptions = function () {
    _this.options = angular.extend({}, Carousel.getOptions());

    // TODO customize attribute from directive
    if (_this.initialSlide !== undefined) {
      _this.options.initialSlide = _this.initialSlide;
    }
    if (_this.fade !== undefined) {
      _this.options.fade = _this.fade;
    }
    if (_this.autoplay !== undefined) {
      _this.options.autoplay = _this.autoplay;
    }
    if (_this.autoplaySpeed !== undefined) {
      _this.options.autoplaySpeed = _this.autoplaySpeed;
    }
    if (_this.cssEase !== undefined) {
      _this.options.cssEase = _this.cssEase;
    }
    if (_this.speed !== undefined) {
      _this.options.speed = _this.speed;
    }
    if (_this.infinite !== undefined) {
      _this.options.infinite = _this.infinite;
    }
    if (_this.arrows !== undefined) {
      _this.options.arrows = _this.arrows;
    }
    if (_this.dots !== undefined) {
      _this.options.dots = _this.dots;
    }
    if (_this.visiblePrev !== undefined) {
      _this.options.visiblePrev = _this.visiblePrev;
    }
    if (_this.visibleNext !== undefined) {
      _this.options.visibleNext = _this.visibleNext;
    }

    // TODO write more options for fade mode
    // In fade mode we have to setting slides-to-show and slides-to-scroll
    // to 1 slide
    if (_this.options.fade) {
      _this.options.slidesToShow = 1;
      _this.options.slidesToScroll = 1;
    } else {
      if (_this.show) {
        _this.options.slidesToShow = _this.show;
      }
      if (_this.scroll) {
        _this.options.slidesToScroll = _this.scroll;
      }
    }
  };

  /**
   * init variables, slides, ..
   */
  this.initRanges = function () {
    if (!_this.slides) {
      _this.slides = [];
    }

    _this.isCarouselReady = false;
    _this.isTrackMoving = false;
    _this.track = $element.find('.track');
    _this.width = 1; // Fake width
    _this.currentSlide = _this.options.initialSlide;
    _this.trackStyle = {};
    _this.slideStyle = {};

    _this.isVisibleDots = false;
    _this.isVisiblePrev = _this.options.visiblePrev;
    _this.isVisibleNext = _this.options.visibleNext;

    _this.isClickablePrev = false;
    _this.isClickableNext = false;

    _this.animType = null;
    _this.transformType = null;
    _this.transitionType = null;
  };

  /**
   * Init UI and carousel track
   */
  this.initUI = function () {
    _this.width = $element[0].clientWidth;

    // Update track width first
    _this.initTrack();

    // Then item style
    $timeout(function () {
      _this.updateItemStyle();
    }, 200);
  };
  var next ;
  /**
   * update common style for each carousel item
   */
  this.updateItemStyle = function () {
    _this.itemWidth = _this.width / _this.options.slidesToShow;
    _this.slideStyle = {
      'width': _this.itemWidth + 'px'
    };
      console.log("updateItemStyle calling next from inside ui-carousel");
      next();
  };

  /**
   * init carousel track
   * also make Carousel is Ready
   */
  this.initTrack = function () {
    var itemWidth = _this.width / _this.options.slidesToShow;
    var trackWidth = itemWidth * _this.slidesInTrack.length;

    _this.trackStyle.width = trackWidth + 'px';

    _this.slideHandler(_this.currentSlide).finally(function () {
      _this.isCarouselReady = true;

      if (!_this.options.fade) {
        _this.refreshTrackStyle();
      }

      // onInit callback
      if (_this.onInit) {
        _this.onInit();
      }
    }).catch(function () {
      // Catch err
    });
  };

  /**
   * @see https://github.com/kenwheeler/slick/blob/master/slick/slick.js#L680
   *
   * Sync slide to place it should be
   * for example:
   * - 9 total, 3 show, 3 scroll, current 1
   *   => next index = 3 (previous index counted = 0)
   *
   * and scroll to next page:
   * - 6 total, 1 show, 1 scroll, current 0 => next index = 1
   * - 9 total, 3 show, 3 scroll, current 1 => next index = 3
   * - 9 total, 3 show, 3 scroll, current 3 => next index = 6
   * - 9 total, 3 show, 3 scroll, current 8 => next index = 3
   * - 8 total, 4 show, 3 scroll, current 1 => next index = 4
   */
  this.next = function () {
    if (!_this.isClickableNext) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : indexOffset;

    _this.slideHandler(_this.currentSlide + slideOffset).catch(function () {
      // Catch err
    });
  };

  next = this.next;

  /**
   * move to previous slide
   * same calculate with next
   * @see next function
   */
  this.prev = function () {
    if (!_this.isClickablePrev) {
      return false;
    }

    var indexOffset = _this.getIndexOffset();
    var slideOffset = indexOffset === 0 ? _this.options.slidesToScroll : _this.options.slidesToShow - indexOffset;

    _this.slideHandler(_this.currentSlide - slideOffset).catch(function () {
      // Catch err
    });
  };

  /**
   * Get index offset
   */
  this.getIndexOffset = function () {
    var scrollOffset = _this.slides.length % _this.options.slidesToScroll !== 0;
    var indexOffset = scrollOffset ? 0 : (_this.slides.length - _this.currentSlide) % _this.options.slidesToScroll;

    return indexOffset;
  };

  /**
   * move to page
   * @params int page
   * Page counter from 0 (start = 0)
   */
  this.movePage = function (page) {
    var target = _this.options.slidesToScroll * page;
    _this.slideHandler(target).catch(function () {
      // Catch err
    });
  };

  /**
   * hanlder carousel
   * @description move carousel to correct page
   *
   * @params int index
   */
  this.slideHandler = function (index) {
    // TODO prevent when slides not exists
    if (!_this.slides) {
      return $q.reject('Carousel not fully setup');
    }

    // TODO Prevent when track is moving
    if (_this.isTrackMoving) {
      return $q.reject('Track is moving');
    }

    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    if (len <= show) {
      _this.correctTrack();
      return $q.reject('Length of slides smaller than slides to show');
    }

    // We need target to destination
    // and a anim slide to translate track
    //
    // anim = animSlide (which we use to move)
    // target = targetSlide
    var anim = index;
    var target = null;

    if (anim < 0) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = len - len % _this.options.slidesToScroll;
      } else {
        target = len + anim;
      }
    } else if (anim >= len) {
      if (len % _this.options.slidesToScroll !== 0) {
        target = 0;
      } else {
        target = anim - len;
      }
    } else {
      target = anim;
    }

    if (_this.onBeforeChange) {
      // @see https://docs.angularjs.org/guide/directive
      _this.onBeforeChange({ currentSlide: _this.currentSlide, target: target });
    }

    // Fade handler
    if (_this.options.fade) {
      _this.currentSlide = target;

      // XXX
      // afterChange method
      // fire after faded
      // Should be revised
      $timeout(function () {
        _this.autoplayTrack();

        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, _this.options.speed);
      return $q.when('Handler fade');
    }

    // No-fade handler
    var itemWidth = _this.width / _this.options.slidesToShow;
    var left = -1 * target * itemWidth;
    if (_this.options.infinite) {
      left = -1 * (anim + show) * itemWidth;
    }

    _this.isTrackMoving = true;
    return _this.moveTrack(left).then(function () {
      _this.isTrackMoving = false;
      _this.currentSlide = target;
      _this.autoplayTrack();

      if (target !== anim) {
        _this.correctTrack();
      }

      if (!_this.options.infinite) {
        if (_this.currentSlide === 0) {
          _this.isClickablePrev = false;
          _this.isClickableNext = true;
        } else if (_this.currentSlide === _this.slidesInTrack.length - _this.options.slidesToShow) {
          _this.isClickableNext = false;
          _this.isClickablePrev = true;
        } else {
          _this.isClickablePrev = true;
          _this.isClickableNext = true;
        }
      }

      // XXX
      // afterChange method
      // fire after 200ms wakeup and correct track
      // Should be revised
      $timeout(function () {
        if (_this.onAfterChange) {
          _this.onAfterChange({ currentSlide: _this.currentSlide });
        }
      }, 200);
    });
  };

  /**
   * moveTrack
   * move track to left position using css3 translate
   * for example left: -1000px
   */
  this.moveTrack = function (left) {
    var deferred = $q.defer();
    if (_this.options.vertical === false) {
      _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0px, 0px)';
    } else {
      _this.trackStyle[_this.animType] = 'translate3d(0px, ' + left + 'px, 0px)';
    }

    $timeout(function () {
      deferred.resolve('Track moved');
    }, _this.options.speed);

    return deferred.promise;
  };

  /**
   * correctTrack
   * @description correct track after move to animSlide we have to move track
   * to exactly its position
   */
  this.correctTrack = function () {
    if (_this.options.infinite) {
      (function () {
        var left = 0;
        if (_this.slides.length > _this.options.slidesToShow) {
          left = -1 * (_this.currentSlide + _this.options.slidesToShow) * _this.itemWidth;
        }

        // Move without anim
        _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + 0 + 'ms ' + _this.options.cssEase;

        _this.isTrackMoving = true;
        $timeout(function () {
          _this.trackStyle[_this.animType] = 'translate3d(' + left + 'px, 0, 0px)';

          // Revert animation
          $timeout(function () {
            _this.refreshTrackStyle();
            _this.isTrackMoving = false;
          }, 200);
        });
      })();
    }
  };

  /**
   * Refresh track style
   */
  this.refreshTrackStyle = function () {
    _this.trackStyle[_this.transitionType] = _this.transformType + ' ' + _this.options.speed + 'ms ' + _this.options.cssEase;
  };

  /**
   * autoplay track
   * @description autoplay = true
   */
  this.autoplayTrack = function () {
    if (_this.options.autoplay) {
      if (_this.timeout) {
        $timeout.cancel(_this.timeout);
      }

      _this.timeout = $timeout(function () {
        _this.next();

        $timeout.cancel(_this.timeout);
        _this.timeout = null;
      }, _this.options.autoplaySpeed);
    }
  };

  this.getSlideStyle = function (index) {
    var style = _this.slideStyle;
    if (_this.options.fade) {
      var left = -1 * index * _this.itemWidth;
      var uniqueStyle = {
        position: 'relative',
        top: '0px',
        left: left + 'px',
        'z-index': index === _this.currentSlide ? 10 : 9,
        opacity: index === _this.currentSlide ? 1 : 0
      };

      if (index >= _this.currentSlide - 1 && index <= _this.currentSlide + 1) {
        uniqueStyle.transition = 'opacity 250ms linear';
      }

      style = angular.extend(style, uniqueStyle);
    }

    return style;
  };

  /**
   * setupInfinite
   * To make carouse infinite we need close number of slidesToShow elements to
   * previous elements and to after elements
   *
   * length = 8, show = 4, scroll = 3, current = 0
   *          ---------
   *          |       |
   *  |4|5|6|7|0|1|2|3|4|5|6|7|1|2|3|4
   *          |       |
   *          ---------
   */
  this.setupInfinite = function () {
    // Clone
    var len = _this.slides.length;
    var show = _this.options.slidesToShow;

    var tmpTrack = angular.copy(_this.slides);

    if (_this.options.infinite && _this.options.fade === false) {
      if (len > show) {
        var number = show;
        for (var i = 0; i < number; i++) {
          tmpTrack.push(angular.copy(_this.slides[i]));
        }
        for (var _i = len - 1; _i >= len - show; _i--) {
          tmpTrack.unshift(angular.copy(_this.slides[_i]));
        }
      }
    }

    _this.slidesInTrack = tmpTrack;
  };

  /**
   * get number of dosts
   *
   * @return Array
   */
  this.getDots = function () {
    if (!_this.slides) {
      return [];
    }

    var dots = Math.ceil(_this.slides.length / _this.options.slidesToScroll);

    var res = [];
    for (var i = 0; i < dots; i++) {
      res.push(i);
    }
    return res;
  };

  /**
   * set carousel property
   *
   * - animType
   * - transformType
   * - transitionType
   */
  this.setProps = function () {
    var bodyStyle = document.body.style;

    /* eslint-disable */
    if (bodyStyle.OTransform !== undefined) {
      _this.animType = 'OTransform';
      _this.transformType = '-o-transform';
      _this.transitionType = 'OTransition';
    }
    if (bodyStyle.MozTransform !== undefined) {
      _this.animType = 'MozTransform';
      _this.transformType = '-moz-transform';
      _this.transitionType = 'MozTransition';
    }
    if (bodyStyle.webkitTransform !== undefined) {
      _this.animType = 'webkitTransform';
      _this.transformType = '-webkit-transform';
      _this.transitionType = 'webkitTransition';
    }
    if (bodyStyle.msTransform !== undefined) {
      _this.animType = 'msTransform';
      _this.transformType = '-ms-transform';
      _this.transitionType = 'msTransition';
    }
    if (bodyStyle.transform !== undefined && _this.animType !== false) {
      _this.animType = 'transform';
      _this.transformType = 'transform';
      _this.transitionType = 'transition';
    }
    /* eslint-enable */

    _this.transformsEnabled = true;
  };

  /**
   * Refresh carousel
   */
  this.refreshCarousel = function () {
    if (_this.slides && _this.slides.length && _this.slides.length > _this.options.slidesToShow) {
      _this.isVisibleDots = true;
      _this.isVisiblePrev = true;
      _this.isVisibleNext = true;
      _this.isClickablePrev = true;
      _this.isClickableNext = true;
    } else {
      _this.isVisibleDots = false;
      _this.isVisiblePrev = _this.options.visiblePrev || false;
      _this.isVisibleNext = _this.options.visibleNext || false;
      _this.isClickablePrev = false;
      _this.isClickableNext = false;
    }

    // Re-init UI
    _this.initUI();
  };

  /**
   * refresh model
   */
  $scope.$watchCollection('ctrl.slides', function (slides) {
    if (!slides) {
      return;
    }

    // Init carousel
    if (_this.currentSlide > slides.length - 1) {
      _this.currentSlide = slides.length - 1;
    }

    _this.setupInfinite();
    _this.refreshCarousel();
  });

  $scope.$watch('ctrl.show', function (nVal, oVal) {
        if(nVal !== oVal) {
            _this.options.slidesToShow = nVal;

            if (_this.options.slidesToScroll > nVal) {
                _this.options.slidesToScroll = nVal;
            }

            _this.refreshCarousel();
        }
    });

  /**
   * update when resize
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  // angular.element($window).on('resize', this.refreshCarousel);
  //   $scope.$on('$viewContentLoaded', function (event) {
  //     console.log("calling next from inside ui-carousel");
  //     this.next;
  //   });
  //   $window.onload(function () {
  //           console.log("calling next onload from inside ui-carousel");
  //           this.next;
  //   });

  /**
   * cleanup when done
   *
   * @see https://github.com/mihnsen/ui-carousel/issues/10
   * @author tarkant
   */
  $scope.$on('$destroy', function () {
    angular.element($window).off('resize');
  });

  // Prior to v1.5, we need to call `$onInit()` manually.
  // (Bindings will always be pre-assigned in these versions.)
  if (angular.version.major === 1 && angular.version.minor < 5) {
    this.$onInit();
  }
}]);
'use strict';

angular.module('ui.carousel.directives').directive('uiCarousel', ['$compile', '$templateCache', '$sce', function ($compile, $templateCache, $sce) {

  return { restrict: 'AE',
    bindToController: true,
    scope: {
      name: '=?',
      slides: '=',
      show: '=?slidesToShow',
      scroll: '=?slidesToScroll',
      classes: '@',
      fade: '=?',
      onChange: '=?',
      disableArrow: '=?',
      autoplay: '=?',
      autoplaySpeed: '=?',
      cssEase: '=?',
      speed: '=?',
      infinite: '=?',
      arrows: '=?',
      dots: '=?',
      initialSlide: '=?',
      visibleNext: '=?',
      visiblePrev: '=?',

      // Method
      onBeforeChange: '&',
      onAfterChange: '&',
      onInit: '&'
    },
    link: function link($scope, el) {
      var template = angular.element($templateCache.get('ui-carousel/carousel.template.html'));

      // dynamic injections to override the inner layers' components
      var injectComponentMap = {
        'carousel-item': '.carousel-item',
        'carousel-prev': '.carousel-prev',
        'carousel-next': '.carousel-next'
      };

      var templateInstance = template.clone();
      angular.forEach(injectComponentMap, function (innerSelector, outerSelector) {
        var outerElement = el[0].querySelector(outerSelector);
        if (outerElement) {
          angular.element(templateInstance[0].querySelector(innerSelector)).html(outerElement.innerHTML);
        }
      });

      var compiledElement = $compile(templateInstance)($scope);
      el.addClass('ui-carousel').html('').append(compiledElement);
    },


    controller: 'CarouselController',
    controllerAs: 'ctrl'
  };
}]);
'use strict';

angular.module('ui.carousel.providers').provider('Carousel', function () {
  var _this = this;

  this.options = {
    // Init like Slick carousel
    // XXX Should be revised
    arrows: true,
    autoplay: false,
    autoplaySpeed: 3000,
    cssEase: 'ease',
    dots: false,

    easing: 'linear',
    fade: false,
    infinite: true,
    initialSlide: 0,

    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,

    visiblePrev: false,
    visibleNext: false,

    // Not available right now
    draggable: true,

    lazyLoad: 'ondemand',

    swipe: true,
    swipeToSlide: false,
    touchMove: true,

    vertical: false,
    verticalSwiping: false
  };
  this.$get = [function () {
    return {
      setOptions: function setOptions(options) {
        _this.options = angular.extend(_this.options, options);
      },
      getOptions: function getOptions() {
        return _this.options;
      }
    };
  }];
});
'use strict';

(function (module) {
  try {
    module = angular.module('ui.carousel');
  } catch (e) {
    module = angular.module('ui.carousel', []);
  }
  module.run(['$templateCache', function ($templateCache) {
    $templateCache.put('ui-carousel/carousel.template.html', '<div class="carousel-wrapper" ng-show="ctrl.isCarouselReady"><div class="track-wrapper"><div class="track" ng-style="ctrl.trackStyle"><div class="slide" ng-repeat="item in ctrl.slidesInTrack track by $index" ng-style="ctrl.getSlideStyle($index)"><div class="carousel-item"></div></div></div></div><div class="carousel-prev" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisiblePrev &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickablePrev}" ng-click="ctrl.prev()"><button class="carousel-btn"><i class="ui-icon-prev"></i></button></div><div class="carousel-next" ng-if="!ctrl.disableArrow" ng-show="ctrl.isVisibleNext &amp;&amp; ctrl.options.arrows" ng-class="{\'carousel-disable\': !ctrl.isClickableNext}" ng-click="ctrl.next()"><button class="carousel-btn"><i class="ui-icon-next"></i></button></div><ul class="carousel-dots" ng-show="ctrl.isVisibleDots &amp;&amp; ctrl.options.dots"><li ng-repeat="dot in ctrl.getDots()" ng-class="{ \'carousel-active\': dot == ctrl.currentSlide/ctrl.options.slidesToScroll }" ng-click="ctrl.movePage(dot)"><button>{{ dot }}</button></li></ul></div>');
  }]);
})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    };

    this.hasAttr = function (elem, attrName) {
      var attr = $(elem).attr(attrName);
      return (typeof attr !== typeof undefined && attr !== false);
    }
  }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function(){

    'use strict';

    function menuPermissionService(ROLES){
        var self = this;
        var defaultStateForCurrentUser = 'home';
        var currentUserRole = ROLES.BY_NAME.EXECUTIVE_DIRECTOR;

        self.setupStateAndMenuPermissions = function (role) {
            currentUserRole = role;
            if(role === ROLES.BY_NAME.PARTNER_NGO) {
                defaultStateForCurrentUser = 'dataCollection.activityData';
            } else {
                defaultStateForCurrentUser = 'home';
            }
        };

        self.getDefaultState = function () {
            return defaultStateForCurrentUser;
        };

        self.hasStatePermission = function (stateName) {
            if(currentUserRole === ROLES.BY_NAME.PARTNER_NGO){
                switch(stateName.toString().trim().toLowerCase().valueOf()){
                    case 'dataCollection'.trim().toLowerCase().valueOf():
                        return true;
                    case 'dataCollection.activityData'.trim().toLowerCase().valueOf():
                        return true;
                    default:
                        return false;
                }
            } else {
                return true;
            }
        };

    }

    app.service('menuPermissionService', ['ROLES', menuPermissionService]);

})();
(function(){

    'use strict';

    function dateService(stringService){

        var self = this;

        self.getDateTime = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).format('DD MMMM YYYY');
        };

        self.getDateTimeFromNow = function(date){

            if(!date) return stringService.EMPTY;
            return moment(new Date(date)).fromNow();
        };

    }

    app.service('dateService', ['stringService', dateService]);

})();
(function(){

    'use strict';

    function httpInterceptor($window, $q, $rootScope){
        this.request = function(config){
            var token = $window.localStorage.getItem('token');
            if (token){
                config.headers = config.headers || {};
                config.headers['token'] = token;
            }
            return config;
        };

        this.responseError = function(resp){
            console.log("response intercepted : " + resp.status);
            // resp.data will contain your response object from the server
            if(resp.status === 401){
                console.log("unauthorized event emitting now");
                $rootScope.$emit("unauthorized");
                return $q.reject(resp);
            } else if(resp.status === -1){
                console.error("Internal Screams! Server Down!");
                $rootScope.$emit("server-down");
                return $q.reject(resp);
            }
            return resp || $q.when(resp);
        }
    }
    app.service('httpInterceptor', ['$window', '$q', '$rootScope', httpInterceptor]);
})();

(function(){

    'use strict';

    function message($rootScope, toastr){

        var self = this;

        self.success = {
            CATEGORY_ADDED: {
                title:'Category Added',
                success: true
            },
            CATEGORY_DELETED: {
                title:'Category deleted',
                success: true
            },
            FRIEND_REQUEST_SENT:{
                title:'Friend request sent',
                success: true
            },
            POST_ADDED:{
                title:'New post added',
                success: true
            },
            SETTINGS_SAVED:{
                title:'Settings saved',
                success: true
            }
        };

        self.error = {
            GENERAL:{
                title:'Something went wrong',
                success: false
            }
        };

        self.info = {
            CATEGORY_DELETE_CONFIRMATION:{
                title: 'Are you sure to Delete this category?'
            }
        };

        $rootScope.$on('toast-message', function(event, message){
            if(message.success){
                toastr.success(message.title);
            }
            else toastr.error(message.title);
        });
    }

    app.service('message', ['$rootScope', 'toastr', message]);

})();
(function(){

    'use strict';

    function utilService() {

        var self = this;

        var daysOfWeek = {
            0: "Sunday",
            1: "Monday",
            2: "Tuesday",
            3: "Wednesday",
            4: "Thursday",
            5: "Friday",
            6: "Saturday"
        };

        self.checkIfValidHoliday = function (startDate, endDate) {
            return moment(endDate).isSameOrAfter(moment(startDate).format("YYYY-MM-DD"));
        };

        self.checkIfDatesEmpty = function(startDate, endDate) {
            if (!startDate || !endDate)
                return true
            else
                return false;
        };

        self.isDateEmpty = function (date) {
            if(!date)
                return false;
            return true;
        };

        self.isTimeInCurrentYear = function (time) {
            return moment(time).year() === new moment().year();
        };

        self.isDateEmpty = function (date) {
            return date === null;
        };

        self.createInputModelFromString = function (string) {
            var multiSelectInputModel = [];
            for (var i = 0; i < 7; i++) {
                if (string.charAt(i) === '1') {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: true})
                }
                else {
                    multiSelectInputModel.push({name: daysOfWeek[i], value: i, isSelected: false})
                }
            }
            console.log(multiSelectInputModel);
            return multiSelectInputModel;
        };

        self.getFormattedString = function (multiSelectInputModel) {
            var stringToPost = '';
            for (var i = 0; i < 7; i++) {
                multiSelectInputModel[i].isSelected === true ? stringToPost += '1' : stringToPost += '0';
            }
            return stringToPost;
        };

        self.getDateObjectFromShiftTimeString = function (s) {
            var hours = parseInt(s.substr(0, 2));
            var minutes = parseInt(s.substr(3, 2));
            var d = new moment();
            d.hour(hours);
            d.minute(minutes);
            return d;
        };

        self.isCyclic = function(obj) {
            var seenObjects = [];

            function detect (obj) {
                if (obj && typeof obj === 'object') {
                    if (seenObjects.indexOf(obj) !== -1) {
                        return true;
                    }
                    seenObjects.push(obj);
                    for (var key in obj) {
                        if (obj.hasOwnProperty(key) && detect(obj[key])) {
                            console.log(obj, 'cycle at ' + key);
                            return true;
                        }
                    }
                }
                return false;
            }

            return detect(obj);
        }
    }
    app.service('utilService',[utilService]);

})();
(function () {

    'use strict';

    function activityService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;

        self.getAllActivities = function () {
            var defer = $q.defer();
            var url = API.activity.allActive;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getByFilter = function (impactId,outcomeId, outputId, name, startDate) {
            var defer = $q.defer();
            var url = API.activity.all;
            var filterUrl = getFilterURL(impactId, outcomeId, outputId, name, startDate);
            if(filterUrl && filterUrl !== undefined && filterUrl !== null){
                url = url + filterUrl;
            }

            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        function getFilterURL(impactId, outcomeId, outputId, name, startDate){
            var impactURL = buildURL("impactId", impactId);
            var outcomeURL = buildURL("outcomeId", outcomeId);
            var outputURL = buildURL("outputId", outputId);
            var nameURL = buildURL("keyword", name);
            var startDateURL = buildURL("startDate", startDate);
            if(impactURL || outcomeURL || outputURL || nameURL || startDateURL) return "?" + impactURL + outcomeURL + outputURL + nameURL + startDateURL;
        }

        function buildURL(key, value) {
            if (!key || !value) return "";
            var url = "&" + key + "=";
            url = url + value;
            return url;
        }

        self.getActivityById = function(id){
            var defer = $q.defer();
            var url = API.activity.all+id;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activity);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getReport = function(params){
            var defer = $q.defer();
            var url = API.activity.report;

            $http.get(url, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


        self.getDetailedReport = function(params){
            var defer = $q.defer();
            var url = API.activity.detailedReport;

            $http.get(url, params)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getDetailedReportExcelUrl = function(params){
            var url = API.activity.detailedReportExcel;
            var queryParams = "";
            Object.keys(params).forEach(function (key) {
                if(key == null || params[key] == null) return;
                if(queryParams === "") {
                    if(params[key].constructor !== Array) queryParams = "?" + key + "=" + params[key]
                    else queryParams = "?" + key + "=" + params[key].join(",");
                }
                else {
                    if(params[key].constructor !== Array) queryParams = queryParams + "&" + key + "=" + params[key]
                    else queryParams = queryParams + "&" + key + "=" + params[key].join(",");
                }
            });
            // url = url + "?from="+params.from+"&to="+params.to
            //     +"&activityExtrasToShow="
            //     +params.activityExtrasToShow.join(',')
            //     +"&monitoringSessionExtrasToShow="
            //     +params.monitoringSessionExtrasToShow.join(',')
            //     +"&activityIdList="
            //     +params.activityIdList.join(',');
            return url + queryParams;
        }

        self.getYearlyReportExcelUrl = function(params){
            var url = API.activity.yearlyReportExcel;

            url = url + "?year=" + params.year +
                ((params.impactId != null) ? ("&impactId=" + params.impactId) : "") +
                ((params.outcomeId != null) ? ("&outcomeId=" + params.outcomeId) : "") +
                ((params.outputId != null) ? ("&outputId=" + params.outputId) : "") +
                ((params.keyword != null && params.keyword.trim() !== "") ? ("&keyword=" + params.keyword) : "") +
                "&activityExtrasToShow=" + params.activityExtrasToShow.join(",") +
                "&monitoringSessionExtrasToShow=" + params.monitoringSessionExtrasToShow.join(",");

            return url;
        }


        self.createActivity = function (data) {
            var defer = $q.defer();
            var url = API.activity.all;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateActivity = function (data,activityId) {
            var defer = $q.defer();
            var url = API.activity.update+activityId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.majorActivityList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateMonitoringSession = function (data,monitoringSessionId) {
            var defer = $q.defer();
            var url = API.activity.updateMonitoringSession+monitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.addMonitoringSession = function (activityId,data) {
            var defer = $q.defer();
            var url = API.activity.addMonitoringSession+activityId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteMonitoringSession = function (id) {
            var defer = $q.defer();
            var url = API.activity.deleteMonitoringSession+id;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve();
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


        self.delete = function (activityId) {
            var defer = $q.defer();
            var url = API.activity.delete.prefix + activityId + API.activity.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }


        self.performDataCollection = function (monitoringSessionId,data) {
            var defer = $q.defer();
            var url = API.activity.performDataCollection+ monitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityMonitoringSessions);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }


        self.performMonitoring = function (monitoringSessionId,data) {
            var defer = $q.defer();
            var url = API.activity.performMonitoring+ monitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.activityMonitoringSessions);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }


    }

    app.service('activityService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', activityService]);

})();
(function(){

    'use strict';

    function authService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE, menuPermissionService){

        var self = this;

        function loginHandler(data, headers){
            self.setLoggedInToken(headers('token'));
            self.setRefreshToken(headers('refresh-token'));
            self.setUserInfo(data.user);
            // $rootScope.$on('connect-socket');
            menuPermissionService.setupStateAndMenuPermissions(data.user.role);
        }

        self.fakeLogin = function () {
            self.setLoggedInToken("very nice token");
            console.log("logged in ");
        };

        self.login = function(data){

            var defer = $q.defer();
            $http.post(API.auth.signin, data)
                .success(function(data, status, headers, config){
                    if(status === RESPONSE_CODE.success){
                        loginHandler(data, headers);
                        $state.go(menuPermissionService.getDefaultState());
                    }
                    else {
                        defer.reject(data.message ? data.message : "");
                    }
                })
                .error(function(data, status, headers, config){
                    if(status == -1) {
                        defer.reject(null);
                    } else {
                        console.log("Login Response from server : Data : " + JSON.stringify(data) + ", status : " + status + ", headers : " + JSON.stringify(headers));
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        // self.loginWithLinkedIn = function(provider){
        //
        //     var defer = $q.defer();
        //     $auth.authenticate(provider).then(function(userData){
        //         loginHandler(userData.data.data);
        //         $state.go('home');
        //     });
        //     return defer.promise;
        // };

        self.logout = function(){
            $http.post(API.auth.signout, {}).then(function(){
                self.clearSession();
                $state.go('login');
            }, function () {
                self.clearSession();
                $state.go('login');
            });
        };


        self.setUserInfo = function(userInfo){
            $rootScope.loggedInUser = userInfo;
            $window.localStorage.setItem('userInfo', JSON.stringify(userInfo)) ;
        };

        self.setLoggedInToken= function(token){
            $window.localStorage.setItem('token', token);
        };

        self.setRefreshToken= function(token){
            $window.localStorage.setItem('refresh-token', token);
        };

        self.getLoggedInId = function(){
            return self.getAllInformation().id;
        };

        self.getLoggedInToken = function(){
            return $window.localStorage.getItem('token');
        };

        self.getRefreshToken = function(){
            return $window.localStorage.getItem('refresh-token');
        };

        self.getLoggedInUser = function(){
            return self.getAllInformation();
        };

        self.updateAField = function(fieldName, value){
            var userInfo = self.getAllInformation();
            userInfo[fieldName] = value;
            self.setUserInfo(userInfo);
        };

        self.updateUserInfo = function (data) {
            var userInfo = self.getAllInformation();
            angular.extend(userInfo,data);
            self.setUserInfo(userInfo);
        };

        self.updateUserDetailedInfo = function (data) {
            var userInfo = self.getAllInformation();
            angular.extend(userInfo.employeeDetails,data);
            self.setUserInfo(userInfo);
        };

        self.addDocumentToUserInfo = function (employeeDocument) {
            var userInfo = self.getAllInformation();
            userInfo.documents.push(employeeDocument);
            self.setUserInfo(userInfo);
        };

        self.addAddressToUserInfo = function (address) {
            var userInfo = self.getAllInformation();
            userInfo.addresses.push(address);
            self.setUserInfo(userInfo);
        };

        self.getAllInformation = function(){
            return JSON.parse($window.localStorage.getItem('userInfo')) || {};
        };

        self.isAuthenticated = function(){
            return  !!$window.localStorage.getItem('token');
        };

        self.clearSession = function(){
            $window.localStorage.clear();
        };



    }
    app.service('authService', ['$http', '$q', '$state','$window', '$rootScope', 'API', 'RESPONSE_CODE', 'menuPermissionService', authService]);

})();
(function () {

    'use strict';

    function employeeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;
        self.createEmployee = function (data) {
            var defer = $q.defer();
            $http.post(API.employee.create, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.user);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.getAllEmployees = function () {
            var defer = $q.defer();
            var url = API.employee.all;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.users);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
        self.getAllEmployeesByRole = function (roleId) {
            var defer = $q.defer();
            var url = API.employee.allByRole + roleId;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.users);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllEmployeesForMajorActivityCoordinator = function () {
            var defer = $q.defer();
            var url = API.employee.majorActivityCoordinator;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.users);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getFilteredEmployees = function (companyIdList, officeIdList, departmentIdList, shiftIdList, employeeName) {
            var defer = $q.defer();
            var url = API.employee.all;
            var urlQuery = buildURLFromArray("companyId", companyIdList) + buildURLFromArray("officeId", officeIdList) + buildURLFromArray("departmentId", departmentIdList) + buildURLFromArray("shiftId", shiftIdList);
            if (urlQuery) url = url + "?" + urlQuery
            if (employeeName) url = url + "&employeeName=" + employeeName;

            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        };

        self.getDetailedProfile = function (employeeId) {
            var defer = $q.defer();
            $http.get(API.employee.detailedProfile + (employeeId ? employeeId : ''))
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.findById = function (id) {
            var defer = $q.defer();
            var data = {
                userId: id
            };
            $http.post(API.user.findById, data)
                .success(function (results) {
                    if (results.response_code === RESPONSE_CODE.success) {

                        defer.resolve(results.data);
                    }
                    else if (results.response_code === RESPONSE_CODE.error) {
                        defer.resolve(null);
                    }

                }).error(function (data) {
                defer.reject(data.message ? data.message : "");
            });
            return defer.promise;
        };

        self.updateBasicInfo = function (data, employeeId) {

            var defer = $q.defer();
            $http.post(API.employee.updateBasicInfo + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updateAddress = function (data, employeeId, addressId) {

            var defer = $q.defer();
            $http.post(API.employee.updateAddress.prefix + employeeId + API.employee.updateAddress.suffix + addressId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {

                        defer.resolve(responseData);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updateAllowLogin = function (data, employeeId) {

            var defer = $q.defer();
            $http.post(API.employee.updateAllowLogin + employeeId + API.employee.allowLogin, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };


        self.updatePassword = function (data, employeeId) {
            var defer = $q.defer();
            $http.post(API.employee.updatePassword + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.uploadProfilePicture = function (file, employeeId) {

            var defer = $q.defer();
            var formData = new FormData();
            formData.append('file', file);
            $http.post(API.employee.uploadProfilePicture + employeeId, formData, {
                headers: {
                    'Content-Type': undefined
                },
                transformRequest: angular.identity,
            }).success(function (responseData, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    if (authService.getLoggedInId() === employeeId) {
                        authService.updateUserInfo(data);
                    }
                    defer.resolve();
                }
                else {
                    defer.reject(responseData.message);
                }
            })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.uploadDocument = function (description, documentType, file, userId) {
            var defer = $q.defer();
            var url = API.employee.uploadDocument + userId + API.employee.document;
            var requestJSON = {};
            requestJSON.description = description;
            requestJSON.type = documentType;
            var formData = new FormData();
            formData.append("file", file);
            formData.append("request", JSON.stringify(requestJSON));
            $http({
                url: url,
                method: 'POST',
                headers: {'Content-Type': undefined},
                data: formData,
                transformRequest: function (data, headersGetterFunction) {
                    return data;
                }

            }).success(function (response, status, headers, config) {
                if (status === RESPONSE_CODE.success) {
                    if (authService.getLoggedInId() == userId) {
                        authService.addDocumentToUserInfo(response.employeeDocument);
                    }
                    defer.resolve(response.employeeDocument);
                }
                else {
                    defer.reject(response.message);
                }
            }).error(function (data, status, headers, config) {
                if (status == -1) {
                    defer.reject(null);
                } else {
                    defer.reject(data.message ? data.message : "");
                }
            });
            return defer.promise;
        };

        self.removeEmployeeProfilePicture = function (employeeId) {
            var defer = $q.defer();
            var url = API.employee.removeProfilePicture + employeeId;

            $http.post(url)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() == employeeId) {
                            authService.updateUserInfo({'employeePicture': null});
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                }).error(function (data, status, headers, config) {
                if (status == -1) {
                    defer.reject(null);
                } else {
                    defer.reject(data.message ? data.message : "");
                }
            });
            return defer.promise;
        };

        self.createAddress = function (data, employeeId) {
            var defer = $q.defer();
            var url = API.employee.createAddress.prefix + employeeId + API.employee.createAddress.suffix;
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.addAddressToUserInfo(responseData.address);
                        }
                        defer.resolve(responseData.address);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.updateEmployeeDetailedInfo = function (data, employeeId) {

            var defer = $q.defer();
            $http.post(API.employee.updateDetailsInfo + employeeId, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        if (authService.getLoggedInId() === employeeId) {
                            authService.updateUserDetailedInfo(data);
                        }
                        defer.resolve();
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.getEmployeesAssignedToWeeklyOffDaysPolicy = function(weeklyOffDaysPolicyId) {
            var defer = $q.defer();
            $http.get(API.employee.employeesAssignedToWeeklyOffDaysPolicy+weeklyOffDaysPolicyId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.employees);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });

            return defer.promise;
        }

    }

    app.service('employeeService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', employeeService]);

})();
(function () {

    'use strict';

    function impactService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                             message, authService) {

        var self = this;

        self.getAllImpacts = function () {
            var defer = $q.defer();

            $http.get(API.impact.allActive)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getImpact = function (impactId) {
            var defer = $q.defer();
            var url = API.impact.all+impactId;

            $http.get(API.impact.all+impactId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.getImpactIndicator = function (impactIndicatorId) {
            var defer = $q.defer();
            $http.get(API.impactIndicator.get+impactIndicatorId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateIndicator = function (indicatorId,data) {
            var defer = $q.defer();
            var url = API.impactIndicator.edit+indicatorId;

            $http.post(url , data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.createImpactIndicator = function (impactId,data) {
            var defer = $q.defer();
            var url = API.impactIndicator.create+impactId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteImpactIndicator = function (impactIndicatorId) {
            var defer = $q.defer();
            var url = API.impactIndicator.delete.prefix+impactIndicatorId+API.impactIndicator.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createImpact = function (data) {
            var defer = $q.defer();
            $http.post(API.impact.all,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.editSummary = function (impactId,data) {
            var defer = $q.defer();
            $http.post(API.impact.all+impactId+'/summary',data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.editImpact = function (impactId,data) {
            var defer = $q.defer();
            var url = API.impact.edit + impactId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.setupResearchFrameworkForImpactIndicator = function (impactIndicatorId,data) {
            var defer = $q.defer();
            var url = API.impactIndicator.setupResearchFrameworkForImpactIndicator + impactIndicatorId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.impactDataCollection = function (impactMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.impactMonitoringSession.dataCollection + impactMonitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.monitoringFeedbackUpdate = function (impactMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.impactMonitoringSession.monitoringFeedback + impactMonitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impact);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.delete = function (impactId) {
            var defer = $q.defer();
            var url = API.impact.delete.prefix + impactId + API.impact.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteMonitoringSession = function (monitoringSessionId) {
            var defer = $q.defer();
            var url = API.impactMonitoringSession.delete.prefix + monitoringSessionId + API.impactMonitoringSession.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createMonitoringSession = function (indicatorId, monitoringSession) {
            var defer = $q.defer();
            var url = API.impactIndicator.createMonitoringSession.prefix + indicatorId + API.impactIndicator.createMonitoringSession.suffix;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactMonitoringSession);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.editMonitoringSession = function (monitoringSessionId, monitoringSession) {
            var defer = $q.defer();
            var url = API.impactMonitoringSession.edit + monitoringSessionId;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('impactService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', impactService]);

})();
(function () {

    'use strict';

    function outcomeService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                            message, authService) {

        var self = this;

        self.updateIndicator = function (indicatorId, data) {
            var defer = $q.defer();
            var url = API.outcomeIndicator.edit + indicatorId;

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteIndicator = function (indicatorId) {
            var defer = $q.defer();
            var url = API.outcomeIndicator.delete.prefix + indicatorId + API.outcomeIndicator.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllOutcomes = function () {
            var defer = $q.defer();
            var url = API.outcome.getAllActive;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray) return "";
            var url = "&" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }

        self.getAllOutcomesByFilter = function (impactIdArray) {
            var defer = $q.defer();
            var url = API.outcome.all;
            var urlQuery = buildURLFromArray("impactIdArray", impactIdArray);
            if (urlQuery) url = url + "?" + urlQuery;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createOutcomeIndicator = function (outcomeId, data) {
            var defer = $q.defer();
            $http.post(API.outcomeIndicator.create + outcomeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getOutcomeIndicator = function (outcomeId) {
            var defer = $q.defer();
            $http.get(API.outcomeIndicator.all + outcomeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createOutcome = function (data) {
            var defer = $q.defer();
            $http.post(API.outcome.all, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.setupResearchFrameworkForOutcomeIndicator = function (indicatorId, data) {
            var defer = $q.defer();
            var url = API.outcomeIndicator.setupResearchFramework + indicatorId;

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getOutcome = function (outcomeId) {
            var defer = $q.defer();
            $http.get(API.outcome.all + outcomeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.editOutcome = function (outcomeId, data) {
            var defer = $q.defer();
            $http.post(API.outcome.all + outcomeId, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        }

        self.deleteOutcome = function (outcomeId) {
            var defer = $q.defer();
            console.log("delete request to url : " + API.outcome.delete + outcomeId);
            $http.post(API.outcome.delete + outcomeId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.outcomeDataCollection = function (outcomeMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.outcomeMonitoringSession.dataCollection + outcomeMonitoringSessionId;

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.monitoringFeedbackUpdate = function (outcomeMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.outcomeMonitoringSession.monitoringFeedback + outcomeMonitoringSessionId;

            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcome);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteMonitoringSession = function (monitoringSessionId) {
            var defer = $q.defer();
            var url = API.outcomeMonitoringSession.delete.prefix + monitoringSessionId + API.outcomeMonitoringSession.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createMonitoringSession = function (indicatorId, monitoringSession) {
            var defer = $q.defer();
            var url = API.outcomeIndicator.createMonitoringSession.prefix + indicatorId + API.outcomeIndicator.createMonitoringSession.suffix;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeMonitoringSession);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.editMonitoringSession = function (monitoringSessionId, monitoringSession) {
            var defer = $q.defer();
            var url = API.outcomeMonitoringSession.edit + monitoringSessionId;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outcomeIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };
    }

    app.service('outcomeService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', outcomeService]);

})();
(function () {

    'use strict';

    function outputService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                           message, authService) {

        var self = this;

        self.updateIndicator = function (indicatorId,data) {
            var defer = $q.defer();
            var url = API.outputIndicator.edit+indicatorId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllMonitoringSessionsByIndicatorIds = function (indicatorIdList) {
            var defer = $q.defer();
            var url = API.outputMonitoringSession.all + buildURLFromArray('indicatorId', indicatorIdList);
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.monitoringSessions);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteIndicator = function (indicatorId) {
            var defer = $q.defer();
            var url = API.outputIndicator.delete.prefix + indicatorId + API.outputIndicator.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllOutputs = function () {
            var defer = $q.defer();
            $http.get(API.output.all)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createOutputIndicator = function (outputId,data) {
            var defer = $q.defer();
            var url = API.outputIndicator.create+outputId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getOutputIndicator = function (outputId) {
            var defer = $q.defer();
            $http.get(API.outputIndicator.all + outputId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createOutput = function (data) {
            var defer = $q.defer();
            $http.post(API.output.all,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.setupResearchFrameworkForOutputIndicator = function (outputIndicatorId,data) {
            var defer = $q.defer();
            var url = API.outputIndicator.setupResearchFramework + outputIndicatorId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getOutput = function (outputId) {
            var defer = $q.defer();
            $http.get(API.output.all+outputId)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateOutput = function (outputId,data) {
            var defer = $q.defer();
            $http.post(API.output.all+outputId,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.delete = function (outputId) {
            var defer = $q.defer();
            var url = API.output.delete.prefix + outputId + API.output.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.outputDataCollection = function (outputMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.outputMonitoringSession.dataCollection + outputMonitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.monitoringFeedbackUpdate = function (outputMonitoringSessionId, data) {
            var defer = $q.defer();
            var url = API.outputMonitoringSession.monitoringFeedback + outputMonitoringSessionId;

            $http.post(url,data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.output);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.deleteMonitoringSession = function (monitoringSessionId) {
            var defer = $q.defer();
            var url = API.outputMonitoringSession.delete.prefix + monitoringSessionId + API.outputMonitoringSession.delete.suffix;

            $http.post(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.createMonitoringSession = function (indicatorId, monitoringSession) {
            var defer = $q.defer();
            var url = API.outputIndicator.createMonitoringSession.prefix + indicatorId + API.outputIndicator.createMonitoringSession.suffix;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputMonitoringSession);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.editMonitoringSession = function (monitoringSessionId, monitoringSession) {
            var defer = $q.defer();
            var url = API.outputMonitoringSession.edit + monitoringSessionId;

            $http.post(url, monitoringSession)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.outputIndicator);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        function buildURLFromArray(key, valueArray) {
            if (!key || !valueArray || valueArray.length < 1) return "";
            var url = "?" + key + "=";
            if (valueArray.constructor === Array) {
                url = url + valueArray.join(",");
            } else {
                // not an array. so just add that value at the end of the url
                url = url + valueArray;
            }
            return url;
        }
    }

    app.service('outputService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', outputService]);

})();
(function () {

    'use strict';

    function projectService($http, $q, API, RESPONSE_CODE) {

        var self = this;
        self.createProject = function (data) {
            var defer = $q.defer();
            var url = API.project.create;
            $http.post(url, data)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.project);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllProjects = function () {
            var defer = $q.defer();
            var url = API.project.getAll;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.projectList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllImpactsOfAProject = function (projectId) {
            var defer = $q.defer();
            var url = API.project.getAll + '' + projectId + '/impacts';
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.impactList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.getAllActiveProjects = function () {
            var defer = $q.defer();
            var url = API.project.getAllActive;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data.projectList);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };

        self.updateNameOfProject = function (projectId, data) {

            var defer = $q.defer();
            var url = API.project.updateName + projectId;
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.projectList);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.updateStatusOfProject = function (data, projectId) {

            var defer = $q.defer();
            var url = API.project.updateStatus.prefix + projectId + API.project.updateStatus.suffix;
            $http.post(url, data)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.projectList);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };

        self.deleteProject = function (projectId) {

            var defer = $q.defer();
            var url = API.project.deleteProject.prefix + projectId + API.project.deleteProject.suffix;
            $http.post(url)
                .success(function (responseData, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(responseData.projectList);
                    }
                    else {
                        defer.reject(responseData.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    if (status == -1) {
                        defer.reject(null);
                    } else {
                        defer.reject(data.message ? data.message : "");
                    }
                });
            return defer.promise;
        };
    }

    app.service('projectService', ['$http', '$q', 'API', 'RESPONSE_CODE', projectService]);

})();
(function () {

    'use strict';

    function reportService($http, $q, $state, $window, $rootScope, API, RESPONSE_CODE,
                           message, authService) {

        var self = this;

        self.getReport = function (projectId, date) {
            var defer = $q.defer();
            var url = API.report.getReport + "?projectId=" + projectId + "&time=" + date;
            $http.get(url)
                .success(function (data, status, headers, config) {
                    if (status === RESPONSE_CODE.success) {
                        defer.resolve(data);
                    }
                    else {
                        defer.reject(data.message);
                    }
                })
                .error(function (data, status, headers, config) {
                    defer.reject(data.message ? data.message : "");
                });
            return defer.promise;
        };


    }

    app.service('reportService', ['$http', '$q', '$state', '$window', '$rootScope', 'API', 'RESPONSE_CODE',
        'message', 'authService', reportService]);

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.auth.login')
        .controller('LoginCtrl', ['$scope', '$state', 'authService', 'toastr', 'menuPermissionService', LoginCtrl]);

    /** @ngInject */
    function LoginCtrl($scope, $state, authService, toastr, menuPermissionService) {

        var fake = false;
        if(authService.isAuthenticated()) {
            // $state.go('home');
            $state.go(menuPermissionService.getDefaultState());
        }

        $scope.login = function () {
            toastr.clear();
            authService
                .login($scope.loginData)
                .then(loginSuccess, loginFailed);
        };

        var loginFailed = function (message) { showErrorToast(message); };
        var loginSuccess = function () {
            showSuccessToast();
        };

        var showErrorToast = function (message) {
            toastr.error(message, 'Sign In Failed', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "error",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            });
        };

        var showSuccessToast = function(){
            toastr.success('Welcome to Inovace Client Panel!', 'Sign in success!', {
                "autoDismiss": false,
                "positionClass": "toast-top-right",
                "type": "success",
                "timeOut": "5000",
                "extendedTimeOut": "2000",
                "allowHtml": false,
                "closeButton": false,
                "tapToDismiss": true,
                "progressBar": false,
                "newestOnTop": true,
                "maxOpened": 0,
                "preventDuplicates": false,
                "preventOpenDuplicates": false
            })
        };
    }


})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.activityDetails');
    app.controller('ActivityDetailsCtrl',['activityService','$stateParams','toastr','$uibModal', ActivityDetailsCtrl]);

    /** @ngInject */
    function ActivityDetailsCtrl(activityService,$stateParams,toastr,$uibModal) {

        var vm = this;

        var activityId = null;
        vm.activity = null;

        vm.openEditModal = openEditModal;
        vm.openCreateIndicatorModal = openCreateIndicatorModal;
        vm.actionPlanCreateModalCtrl = actionPlanCreateModalCtrl;
        vm.openEditSummaryModal = openEditSummaryModal;

        function init() {
            activityId = $stateParams.id;
            activityService.getActivity(activityId).then(function (data) {
                vm.activity = data;
            },function () {
                toastr.error("Could not fetch activity");
            });
        }
        init();

        function openEditModal(indicator,type) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/activityDetails/edit/editActivityIndicator.modal.html',
                size:'lg',
                controller : 'ActivityIndicatorEditModalCtrl',
                controllerAs : "vm",
                resolve : {
                    indicator : function () {
                        return indicator ;
                    },
                    type: function () {
                        return type;
                    }
                }
            }).result.then(function(data) {
                vm.activity.activityIndicators = data;
                toastr.success("Update Successful");
            });
        }

        function openCreateIndicatorModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/activityDetails/create/createActivityIndicator.modal.html',
                size:'lg',
                controller : 'ActivityIndicatorCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    activityId:function () {
                        return vm.activity.id;
                    }
                }
            }).result.then(function(data) {
                vm.activity.activityIndicators.push(data);
                toastr.success("Update Successful");
            });
        }

        function actionPlanCreateModalCtrl() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/activityDetails/create/createActivity.modal.html',
                size:'lg',
                controller : 'ActivityCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    activityId: function () {
                        return vm.activity.id;
                    }
                }
            }).result.then(function(data) {
                console.log("actionPlanCreateModalCtrl response data : " + JSON.stringify(data));
                vm.activity.activityIndicators.push(data);
                toastr.success("Update Successful");
            });
        }

        function openEditSummaryModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/activityDetails/edit/editSummary.modal.html',
                controller : 'EditActivitySummaryModalCtrl',
                controllerAs : "vm",
                resolve: {
                    activity: function () {
                        return vm.activity;
                    }
                }
            }).result.then(function(data) {
                vm.activity = data;
                toastr.success("Update Successful");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.auth.logout')
        .controller('LogoutCtrl', ['authService', LogoutCtrl]);

    /** @ngInject */
    function LogoutCtrl(authService) {
        console.log("logout page");
        authService.logout();
    }
})();
/*
 * Angular JS Multi Select
 * Creates a dropdown-like button with checkboxes.
 *
 * Project started on: Tue, 14 Jan 2014 - 5:18:02 PM
 * Current version: 4.0.0
 *
 * Released under the MIT License
 * --------------------------------------------------------------------------------
 * The MIT License (MIT)
 *
 * Copyright (c) 2014 Ignatius Steven (https://github.com/isteven)
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 * --------------------------------------------------------------------------------
 */

'use strict'

angular.module('NGOMonitoringClientApp.pages.main').directive( 'istevenMultiSelect' , [ '$sce', '$timeout', '$templateCache', function ( $sce, $timeout, $templateCache ) {
    return {
        restrict:
            'AE',

        scope:
            {
                // models
                inputModel      : '=',
                outputModel     : '=',

                // settings based on attribute
                isDisabled      : '=',

                // callbacks
                onClear         : '&',
                onClose         : '&',
                onSearchChange  : '&',
                onItemClick     : '&',
                onOpen          : '&',
                onReset         : '&',
                onSelectAll     : '&',
                onSelectNone    : '&',

                // i18n
                translation     : '='
            },

        /*
         * The rest are attributes. They don't need to be parsed / binded, so we can safely access them by value.
         * - buttonLabel, directiveId, helperElements, itemLabel, maxLabels, orientation, selectionMode, minSearchLength,
         *   tickProperty, disableProperty, groupProperty, searchProperty, maxHeight, outputProperties
         */

        templateUrl:
            'isteven-multi-select.htm',

        link: function ( $scope, element, attrs ) {

            $scope.backUp           = [];
            $scope.varButtonLabel   = '';
            $scope.spacingProperty  = '';
            $scope.indexProperty    = '';
            $scope.orientationH     = false;
            $scope.orientationV     = true;
            $scope.filteredModel    = [];
            $scope.inputLabel       = { labelFilter: '' };
            $scope.tabIndex         = 0;
            $scope.lang             = {};
            $scope.helperStatus     = {
                all     : true,
                none    : true,
                reset   : true,
                filter  : true
            };

            var
                prevTabIndex        = 0,
                helperItems         = [],
                helperItemsLength   = 0,
                checkBoxLayer       = '',
                scrolled            = false,
                selectedItems       = [],
                formElements        = [],
                vMinSearchLength    = 0,
                clickedItem         = null

            // v3.0.0
            // clear button clicked
            $scope.clearClicked = function( e ) {
                $scope.inputLabel.labelFilter = '';
                $scope.updateFilter();
                $scope.select( 'clear', e );
            }

            // A little hack so that AngularJS ng-repeat can loop using start and end index like a normal loop
            // http://stackoverflow.com/questions/16824853/way-to-ng-repeat-defined-number-of-times-instead-of-repeating-over-array
            $scope.numberToArray = function( num ) {
                return new Array( num );
            }

            // Call this function when user type on the filter field
            $scope.searchChanged = function() {
                if ( $scope.inputLabel.labelFilter.length < vMinSearchLength && $scope.inputLabel.labelFilter.length > 0 ) {
                    return false;
                }
                $scope.updateFilter();
            }

            $scope.updateFilter = function()
            {
                // we check by looping from end of input-model
                $scope.filteredModel = [];
                var i = 0;

                if ( typeof $scope.inputModel === 'undefined' ) {
                    return false;
                }

                for( i = $scope.inputModel.length - 1; i >= 0; i-- ) {

                    // if it's group end, we push it to filteredModel[];
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === false ) {
                        $scope.filteredModel.push( $scope.inputModel[ i ] );
                    }

                    // if it's data
                    var gotData = false;
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] === 'undefined' ) {

                        // If we set the search-key attribute, we use this loop.
                        if ( typeof attrs.searchProperty !== 'undefined' && attrs.searchProperty !== '' ) {

                            for (var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                    && attrs.searchProperty.indexOf( key ) > -1
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }
                        // if there's no search-key attribute, we use this one. Much better on performance.
                        else {
                            for ( var key in $scope.inputModel[ i ]  ) {
                                if (
                                    typeof $scope.inputModel[ i ][ key ] !== 'boolean'
                                    && String( $scope.inputModel[ i ][ key ] ).toUpperCase().indexOf( $scope.inputLabel.labelFilter.toUpperCase() ) >= 0
                                ) {
                                    gotData = true;
                                    break;
                                }
                            }
                        }

                        if ( gotData === true ) {
                            // push
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }

                    // if it's group start
                    if ( typeof $scope.inputModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.inputModel[ i ][ attrs.groupProperty ] === true ) {

                        if ( typeof $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] !== 'undefined'
                            && $scope.filteredModel[ $scope.filteredModel.length - 1 ][ attrs.groupProperty ] === false ) {
                            $scope.filteredModel.pop();
                        }
                        else {
                            $scope.filteredModel.push( $scope.inputModel[ i ] );
                        }
                    }
                }

                $scope.filteredModel.reverse();

                $timeout( function() {

                    $scope.getFormElements();

                    // Callback: on filter change
                    if ( $scope.inputLabel.labelFilter.length > vMinSearchLength ) {

                        var filterObj = [];

                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    var tempObj = angular.copy( value );
                                    var index = filterObj.push( tempObj );
                                    delete filterObj[ index - 1 ][ $scope.indexProperty ];
                                    delete filterObj[ index - 1 ][ $scope.spacingProperty ];
                                }
                            }
                        });

                        $scope.onSearchChange({
                            data:
                                {
                                    keyword: $scope.inputLabel.labelFilter,
                                    result: filterObj
                                }
                        });
                    }
                },0);
            };

            // List all the input elements. We need this for our keyboard navigation.
            // This function will be called everytime the filter is updated.
            // Depending on the size of filtered mode, might not good for performance, but oh well..
            $scope.getFormElements = function() {
                formElements = [];

                var
                    selectButtons   = [],
                    inputField      = [],
                    checkboxes      = [],
                    clearButton     = [];

                // If available, then get select all, select none, and reset buttons
                if ( $scope.helperStatus.all || $scope.helperStatus.none || $scope.helperStatus.reset ) {
                    selectButtons = element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    // If available, then get the search box and the clear button
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children().next()[ 0 ].getElementsByTagName( 'button' );
                    }
                }
                else {
                    if ( $scope.helperStatus.filter ) {
                        // Get helper - search and clear button.
                        inputField =    element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'input' );
                        clearButton =   element.children().children().next().children().children()[ 0 ].getElementsByTagName( 'button' );
                    }
                }

                // Get checkboxes
                if ( !$scope.helperStatus.all && !$scope.helperStatus.none && !$scope.helperStatus.reset && !$scope.helperStatus.filter ) {
                    checkboxes = element.children().children().next()[ 0 ].getElementsByTagName( 'input' );
                }
                else {
                    checkboxes = element.children().children().next().children().next()[ 0 ].getElementsByTagName( 'input' );
                }

                // Push them into global array formElements[]
                for ( var i = 0; i < selectButtons.length ; i++ )   { formElements.push( selectButtons[ i ] );  }
                for ( var i = 0; i < inputField.length ; i++ )      { formElements.push( inputField[ i ] );     }
                for ( var i = 0; i < clearButton.length ; i++ )     { formElements.push( clearButton[ i ] );    }
                for ( var i = 0; i < checkboxes.length ; i++ )      { formElements.push( checkboxes[ i ] );     }
            }

            // check if an item has attrs.groupProperty (be it true or false)
            $scope.isGroupMarker = function( item , type ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === type ) return true;
                return false;
            }

            $scope.removeGroupEndMarker = function( item ) {
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) return false;
                return true;
            }

            // call this function when an item is clicked
            $scope.syncItems = function( item, e, ng_repeat_index ) {

                e.preventDefault();
                e.stopPropagation();

                // if the directive is globaly disabled, do nothing
                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return false;
                }

                // if item is disabled, do nothing
                if ( typeof attrs.isDisabled !== 'undefined' && $scope.isDisabled === true ) {
                    return false;
                }

                // if end group marker is clicked, do nothing
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === false ) {
                    return false;
                }

                var index = $scope.filteredModel.indexOf( item );

                // if the start of group marker is clicked ( only for multiple selection! )
                // how it works:
                // - if, in a group, there are items which are not selected, then they all will be selected
                // - if, in a group, all items are selected, then they all will be de-selected
                if ( typeof item[ attrs.groupProperty ] !== 'undefined' && item[ attrs.groupProperty ] === true ) {

                    // this is only for multiple selection, so if selection mode is single, do nothing
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                        return false;
                    }

                    var i,j,k;
                    var startIndex = 0;
                    var endIndex = $scope.filteredModel.length - 1;
                    var tempArr = [];

                    // nest level is to mark the depth of the group.
                    // when you get into a group (start group marker), nestLevel++
                    // when you exit a group (end group marker), nextLevel--
                    var nestLevel = 0;

                    // we loop throughout the filtered model (not whole model)
                    for( i = index ; i < $scope.filteredModel.length ; i++) {

                        // this break will be executed when we're done processing each group
                        if ( nestLevel === 0 && i > index )
                        {
                            break;
                        }

                        if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === true ) {

                            // To cater multi level grouping
                            if ( tempArr.length === 0 ) {
                                startIndex = i + 1;
                            }
                            nestLevel = nestLevel + 1;
                        }

                        // if group end
                        else if ( typeof $scope.filteredModel[ i ][ attrs.groupProperty ] !== 'undefined' && $scope.filteredModel[ i ][ attrs.groupProperty ] === false ) {

                            nestLevel = nestLevel - 1;

                            // cek if all are ticked or not
                            if ( tempArr.length > 0 && nestLevel === 0 ) {

                                var allTicked = true;

                                endIndex = i;

                                for ( j = 0; j < tempArr.length ; j++ ) {
                                    if ( typeof tempArr[ j ][ $scope.tickProperty ] !== 'undefined' &&  tempArr[ j ][ $scope.tickProperty ] === false ) {
                                        allTicked = false;
                                        break;
                                    }
                                }

                                if ( allTicked === true ) {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = false;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = false;
                                            }
                                        }
                                    }
                                }

                                else {
                                    for ( j = startIndex; j <= endIndex ; j++ ) {
                                        if ( typeof $scope.filteredModel[ j ][ attrs.groupProperty ] === 'undefined' ) {
                                            if ( typeof attrs.disableProperty === 'undefined' ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;

                                            }
                                            else if ( $scope.filteredModel[ j ][ attrs.disableProperty ] !== true ) {
                                                $scope.filteredModel[ j ][ $scope.tickProperty ] = true;
                                                // we refresh input model as well
                                                inputModelIndex = $scope.filteredModel[ j ][ $scope.indexProperty ];
                                                $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = true;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                        // if data
                        else {
                            tempArr.push( $scope.filteredModel[ i ] );
                        }
                    }
                }

                // if an item (not group marker) is clicked
                else {

                    // If it's single selection mode
                    if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {

                        // first, set everything to false
                        for( i=0 ; i < $scope.filteredModel.length ; i++) {
                            $scope.filteredModel[ i ][ $scope.tickProperty ] = false;
                        }
                        for( i=0 ; i < $scope.inputModel.length ; i++) {
                            $scope.inputModel[ i ][ $scope.tickProperty ] = false;
                        }

                        // then set the clicked item to true
                        $scope.filteredModel[ index ][ $scope.tickProperty ] = true;
                    }

                    // Multiple
                    else {
                        $scope.filteredModel[ index ][ $scope.tickProperty ]   = !$scope.filteredModel[ index ][ $scope.tickProperty ];
                    }

                    // we refresh input model as well
                    var inputModelIndex = $scope.filteredModel[ index ][ $scope.indexProperty ];
                    $scope.inputModel[ inputModelIndex ][ $scope.tickProperty ] = $scope.filteredModel[ index ][ $scope.tickProperty ];
                }

                // we execute the callback function here
                clickedItem = angular.copy( item );
                if ( clickedItem !== null ) {
                    $timeout( function() {
                        delete clickedItem[ $scope.indexProperty ];
                        delete clickedItem[ $scope.spacingProperty ];
                        $scope.onItemClick( { data: clickedItem } );
                        clickedItem = null;
                    }, 0 );
                }

                $scope.refreshOutputModel();
                $scope.refreshButton();

                // We update the index here
                prevTabIndex = $scope.tabIndex;
                $scope.tabIndex = ng_repeat_index + helperItemsLength;

                // Set focus on the hidden checkbox
                e.target.focus();

                // set & remove CSS style
                $scope.removeFocusStyle( prevTabIndex );
                $scope.setFocusStyle( $scope.tabIndex );

                if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' ) {
                    // on single selection mode, we then hide the checkbox layer
                    $scope.toggleCheckboxes( e );
                }
            }

            // update $scope.outputModel
            $scope.refreshOutputModel = function() {

                $scope.outputModel  = [];
                var
                    outputProps     = [],
                    tempObj         = {};

                // v4.0.0
                if ( typeof attrs.outputProperties !== 'undefined' ) {
                    outputProps = attrs.outputProperties.split(' ');
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            tempObj         = {};
                            angular.forEach( value, function( value1, key1 ) {
                                if ( outputProps.indexOf( key1 ) > -1 ) {
                                    tempObj[ key1 ] = value1;
                                }
                            });
                            var index = $scope.outputModel.push( tempObj );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
                else {
                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if (
                            typeof value !== 'undefined'
                            && typeof value[ attrs.groupProperty ] === 'undefined'
                            && value[ $scope.tickProperty ] === true
                        ) {
                            var temp = angular.copy( value );
                            var index = $scope.outputModel.push( temp );
                            delete $scope.outputModel[ index - 1 ][ $scope.indexProperty ];
                            delete $scope.outputModel[ index - 1 ][ $scope.spacingProperty ];
                        }
                    });
                }
            }

            // refresh button label
            $scope.refreshButton = function() {

                $scope.varButtonLabel   = '';
                var ctr                 = 0;

                // refresh button label...
                if ( $scope.outputModel.length === 0 ) {
                    // https://github.com/isteven/angular-multi-select/pull/19
                    $scope.varButtonLabel = $scope.lang.nothingSelected;
                }
                else {
                    var tempMaxLabels = $scope.outputModel.length;
                    if ( typeof attrs.maxLabels !== 'undefined' && attrs.maxLabels !== '' ) {
                        tempMaxLabels = attrs.maxLabels;
                    }

                    // if max amount of labels displayed..
                    if ( $scope.outputModel.length > tempMaxLabels ) {
                        $scope.more = true;
                    }
                    else {
                        $scope.more = false;
                    }

                    angular.forEach( $scope.inputModel, function( value, key ) {
                        if ( typeof value !== 'undefined' && value[ attrs.tickProperty ] === true ) {
                            if ( ctr < tempMaxLabels ) {
                                $scope.varButtonLabel += ( $scope.varButtonLabel.length > 0 ? '</div>, <div class="buttonLabel">' : '<div class="buttonLabel">') + $scope.writeLabel( value, 'buttonLabel' );
                            }
                            ctr++;
                        }
                    });

                    if ( $scope.more === true ) {
                        // https://github.com/isteven/angular-multi-select/pull/16
                        if (tempMaxLabels > 0) {
                            $scope.varButtonLabel += ', ... ';
                        }
                        $scope.varButtonLabel += '(' + $scope.outputModel.length + ')';
                    }
                }
                $scope.varButtonLabel = $sce.trustAsHtml( $scope.varButtonLabel + '<span class="caret"></span>' );
            }

            // Check if a checkbox is disabled or enabled. It will check the granular control (disableProperty) and global control (isDisabled)
            // Take note that the granular control has higher priority.
            $scope.itemIsDisabled = function( item ) {

                if ( typeof attrs.disableProperty !== 'undefined' && item[ attrs.disableProperty ] === true ) {
                    return true;
                }
                else {
                    if ( $scope.isDisabled === true ) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }

            }

            // A simple function to parse the item label settings. Used on the buttons and checkbox labels.
            $scope.writeLabel = function( item, type ) {

                // type is either 'itemLabel' or 'buttonLabel'
                var temp    = attrs[ type ].split( ' ' );
                var label   = '';

                angular.forEach( temp, function( value, key ) {
                    item[ value ] && ( label += '&nbsp;' + value.split( '.' ).reduce( function( prev, current ) {
                        return prev[ current ];
                    }, item ));
                });

                if ( type.toUpperCase() === 'BUTTONLABEL' ) {
                    return label;
                }
                return $sce.trustAsHtml( label );
            }

            // UI operations to show/hide checkboxes based on click event..
            $scope.toggleCheckboxes = function( e ) {

                // We grab the button
                var clickedEl = element.children()[0];

                // Just to make sure.. had a bug where key events were recorded twice
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // The idea below was taken from another multi-select directive - https://github.com/amitava82/angular-multiselect
                // His version is awesome if you need a more simple multi-select approach.

                // close
                if ( angular.element( checkBoxLayer ).hasClass( 'show' )) {

                    angular.element( checkBoxLayer ).removeClass( 'show' );
                    angular.element( clickedEl ).removeClass( 'buttonClicked' );
                    angular.element( document ).off( 'click', $scope.externalClickListener );
                    angular.element( document ).off( 'keydown', $scope.keyboardListener );

                    // clear the focused element;
                    $scope.removeFocusStyle( $scope.tabIndex );
                    if ( typeof formElements[ $scope.tabIndex ] !== 'undefined' ) {
                        formElements[ $scope.tabIndex ].blur();
                    }

                    // close callback
                    $timeout( function() {
                        $scope.onClose();
                    }, 0 );

                    // set focus on button again
                    element.children().children()[ 0 ].focus();
                }
                // open
                else
                {
                    // clear filter
                    $scope.inputLabel.labelFilter = '';
                    $scope.updateFilter();

                    helperItems = [];
                    helperItemsLength = 0;

                    angular.element( checkBoxLayer ).addClass( 'show' );
                    angular.element( clickedEl ).addClass( 'buttonClicked' );

                    // Attach change event listener on the input filter.
                    // We need this because ng-change is apparently not an event listener.
                    angular.element( document ).on( 'click', $scope.externalClickListener );
                    angular.element( document ).on( 'keydown', $scope.keyboardListener );

                    // to get the initial tab index, depending on how many helper elements we have.
                    // priority is to always focus it on the input filter
                    $scope.getFormElements();
                    $scope.tabIndex = 0;

                    var helperContainer = angular.element( element[ 0 ].querySelector( '.helperContainer' ) )[0];

                    if ( typeof helperContainer !== 'undefined' ) {
                        for ( var i = 0; i < helperContainer.getElementsByTagName( 'BUTTON' ).length ; i++ ) {
                            helperItems[ i ] = helperContainer.getElementsByTagName( 'BUTTON' )[ i ];
                        }
                        helperItemsLength = helperItems.length + helperContainer.getElementsByTagName( 'INPUT' ).length;
                    }

                    // focus on the filter element on open.
                    if ( element[ 0 ].querySelector( '.inputFilter' ) ) {
                        element[ 0 ].querySelector( '.inputFilter' ).focus();
                        $scope.tabIndex = $scope.tabIndex + helperItemsLength - 2;
                        // blur button in vain
                        angular.element( element ).children()[ 0 ].blur();
                    }
                    // if there's no filter then just focus on the first checkbox item
                    else {
                        if ( !$scope.isDisabled ) {
                            $scope.tabIndex = $scope.tabIndex + helperItemsLength;
                            if ( $scope.inputModel.length > 0 ) {
                                formElements[ $scope.tabIndex ].focus();
                                $scope.setFocusStyle( $scope.tabIndex );
                                // blur button in vain
                                angular.element( element ).children()[ 0 ].blur();
                            }
                        }
                    }

                    // open callback
                    $scope.onOpen();
                }
            }

            // handle clicks outside the button / multi select layer
            $scope.externalClickListener = function( e ) {

                var targetsArr = element.find( e.target.tagName );
                for (var i = 0; i < targetsArr.length; i++) {
                    if ( e.target == targetsArr[i] ) {
                        return;
                    }
                }

                angular.element( checkBoxLayer.previousSibling ).removeClass( 'buttonClicked' );
                angular.element( checkBoxLayer ).removeClass( 'show' );
                angular.element( document ).off( 'click', $scope.externalClickListener );
                angular.element( document ).off( 'keydown', $scope.keyboardListener );

                // close callback
                $timeout( function() {
                    $scope.onClose();
                }, 0 );

                // set focus on button again
                element.children().children()[ 0 ].focus();
            }

            // select All / select None / reset buttons
            $scope.select = function( type, e ) {

                var helperIndex = helperItems.indexOf( e.target );
                $scope.tabIndex = helperIndex;

                switch( type.toUpperCase() ) {
                    case 'ALL':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = true;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectAll();
                        break;
                    case 'NONE':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                if ( typeof value[ attrs.groupProperty ] === 'undefined' ) {
                                    value[ $scope.tickProperty ] = false;
                                }
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onSelectNone();
                        break;
                    case 'RESET':
                        angular.forEach( $scope.filteredModel, function( value, key ) {
                            if ( typeof value[ attrs.groupProperty ] === 'undefined' && typeof value !== 'undefined' && value[ attrs.disableProperty ] !== true ) {
                                var temp = value[ $scope.indexProperty ];
                                value[ $scope.tickProperty ] = $scope.backUp[ temp ][ $scope.tickProperty ];
                            }
                        });
                        $scope.refreshOutputModel();
                        $scope.refreshButton();
                        $scope.onReset();
                        break;
                    case 'CLEAR':
                        $scope.tabIndex = $scope.tabIndex + 1;
                        $scope.onClear();
                        break;
                    case 'FILTER':
                        $scope.tabIndex = helperItems.length - 1;
                        break;
                    default:
                }
            }

            // just to create a random variable name
            function genRandomString( length ) {
                var possible    = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
                var temp        = '';
                for( var i=0; i < length; i++ ) {
                    temp += possible.charAt( Math.floor( Math.random() * possible.length ));
                }
                return temp;
            }

            // count leading spaces
            $scope.prepareGrouping = function() {
                var spacing     = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.spacingProperty ] = spacing;
                    if ( value[ attrs.groupProperty ] === true ) {
                        spacing+=2;
                    }
                    else if ( value[ attrs.groupProperty ] === false ) {
                        spacing-=2;
                    }
                });
            }

            // prepare original index
            $scope.prepareIndex = function() {
                var ctr = 0;
                angular.forEach( $scope.filteredModel, function( value, key ) {
                    value[ $scope.indexProperty ] = ctr;
                    ctr++;
                });
            }

            // navigate using up and down arrow
            $scope.keyboardListener = function( e ) {

                var key = e.keyCode ? e.keyCode : e.which;
                var isNavigationKey = false;

                // ESC key (close)
                if ( key === 27 ) {
                    e.preventDefault();
                    e.stopPropagation();
                    $scope.toggleCheckboxes( e );
                }


                // next element ( tab, down & right key )
                else if ( key === 40 || key === 39 || ( !e.shiftKey && key == 9 ) ) {

                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex++;
                    if ( $scope.tabIndex > formElements.length - 1 ) {
                        $scope.tabIndex = 0;
                        prevTabIndex = formElements.length - 1;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex++;
                        if ( $scope.tabIndex > formElements.length - 1 ) {
                            $scope.tabIndex = 0;
                        }
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                    }
                }

                // prev element ( shift+tab, up & left key )
                else if ( key === 38 || key === 37 || ( e.shiftKey && key == 9 ) ) {
                    isNavigationKey = true;
                    prevTabIndex = $scope.tabIndex;
                    $scope.tabIndex--;
                    if ( $scope.tabIndex < 0 ) {
                        $scope.tabIndex = formElements.length - 1;
                        prevTabIndex = 0;
                    }
                    while ( formElements[ $scope.tabIndex ].disabled === true ) {
                        $scope.tabIndex--;
                        if ( $scope.tabIndex === prevTabIndex ) {
                            break;
                        }
                        if ( $scope.tabIndex < 0 ) {
                            $scope.tabIndex = formElements.length - 1;
                        }
                    }
                }

                if ( isNavigationKey === true ) {

                    e.preventDefault();

                    // set focus on the checkbox
                    formElements[ $scope.tabIndex ].focus();
                    var actEl = document.activeElement;

                    if ( actEl.type.toUpperCase() === 'CHECKBOX' ) {
                        $scope.setFocusStyle( $scope.tabIndex );
                        $scope.removeFocusStyle( prevTabIndex );
                    }
                    else {
                        $scope.removeFocusStyle( prevTabIndex );
                        $scope.removeFocusStyle( helperItemsLength );
                        $scope.removeFocusStyle( formElements.length - 1 );
                    }
                }

                isNavigationKey = false;
            }

            // set (add) CSS style on selected row
            $scope.setFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().addClass( 'multiSelectFocus' );
            }

            // remove CSS style on selected row
            $scope.removeFocusStyle = function( tabIndex ) {
                angular.element( formElements[ tabIndex ] ).parent().parent().parent().removeClass( 'multiSelectFocus' );
            }

            /*********************
             *********************
             *
             * 1) Initializations
             *
             *********************
             *********************/

            // attrs to $scope - attrs-$scope - attrs - $scope
            // Copy some properties that will be used on the template. They need to be in the $scope.
            $scope.groupProperty    = attrs.groupProperty;
            $scope.tickProperty     = attrs.tickProperty;
            $scope.directiveId      = attrs.directiveId;

            // Unfortunately I need to add these grouping properties into the input model
            var tempStr = genRandomString( 5 );
            $scope.indexProperty = 'idx_' + tempStr;
            $scope.spacingProperty = 'spc_' + tempStr;

            // set orientation css
            if ( typeof attrs.orientation !== 'undefined' ) {

                if ( attrs.orientation.toUpperCase() === 'HORIZONTAL' ) {
                    $scope.orientationH = true;
                    $scope.orientationV = false;
                }
                else
                {
                    $scope.orientationH = false;
                    $scope.orientationV = true;
                }
            }

            // get elements required for DOM operation
            checkBoxLayer = element.children().children().next()[0];

            // set max-height property if provided
            if ( typeof attrs.maxHeight !== 'undefined' ) {
                var layer = element.children().children().children()[0];
                angular.element( layer ).attr( "style", "height:" + attrs.maxHeight + "; overflow-y:scroll;" );
            }

            // some flags for easier checking
            for ( var property in $scope.helperStatus ) {
                if ( $scope.helperStatus.hasOwnProperty( property )) {
                    if (
                        typeof attrs.helperElements !== 'undefined'
                        && attrs.helperElements.toUpperCase().indexOf( property.toUpperCase() ) === -1
                    ) {
                        $scope.helperStatus[ property ] = false;
                    }
                }
            }
            if ( typeof attrs.selectionMode !== 'undefined' && attrs.selectionMode.toUpperCase() === 'SINGLE' )  {
                $scope.helperStatus[ 'all' ] = false;
                $scope.helperStatus[ 'none' ] = false;
            }

            // helper button icons.. I guess you can use html tag here if you want to.
            $scope.icon        = {};
            $scope.icon.selectAll  = '&#10003;';    // a tick icon
            $scope.icon.selectNone = '&times;';     // x icon
            $scope.icon.reset      = '&#8630;';     // undo icon
            // this one is for the selected items
            $scope.icon.tickMark   = '&#10003;';    // a tick icon

            // configurable button labels
            if ( typeof attrs.translation !== 'undefined' ) {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;' + $scope.translation.selectAll );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;' + $scope.translation.selectNone );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;' + $scope.translation.reset );
                $scope.lang.search          = $scope.translation.search;
                $scope.lang.nothingSelected = $sce.trustAsHtml( $scope.translation.nothingSelected );
            }
            else {
                $scope.lang.selectAll       = $sce.trustAsHtml( $scope.icon.selectAll  + '&nbsp;&nbsp;Select All' );
                $scope.lang.selectNone      = $sce.trustAsHtml( $scope.icon.selectNone + '&nbsp;&nbsp;Select None' );
                $scope.lang.reset           = $sce.trustAsHtml( $scope.icon.reset      + '&nbsp;&nbsp;Reset' );
                $scope.lang.search          = 'Search...';
                $scope.lang.nothingSelected = 'Please Select';
            }
            $scope.icon.tickMark = $sce.trustAsHtml( $scope.icon.tickMark );

            // min length of keyword to trigger the filter function
            if ( typeof attrs.MinSearchLength !== 'undefined' && parseInt( attrs.MinSearchLength ) > 0 ) {
                vMinSearchLength = Math.floor( parseInt( attrs.MinSearchLength ) );
            }

            /*******************************************************
             *******************************************************
             *
             * 2) Logic starts here, initiated by watch 1 & watch 2
             *
             *******************************************************
             *******************************************************/

            // watch1, for changes in input model property
            // updates multi-select when user select/deselect a single checkbox programatically
            // https://github.com/isteven/angular-multi-select/issues/8
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            }, true );

            // watch2 for changes in input model as a whole
            // this on updates the multi-select when a user load a whole new input-model. We also update the $scope.backUp variable
            $scope.$watch( 'inputModel' , function( newVal ) {
                if ( newVal ) {
                    $scope.backUp = angular.copy( $scope.inputModel );
                    $scope.updateFilter();
                    $scope.prepareGrouping();
                    $scope.prepareIndex();
                    $scope.refreshOutputModel();
                    $scope.refreshButton();
                }
            });

            // watch for changes in directive state (disabled or enabled)
            $scope.$watch( 'isDisabled' , function( newVal ) {
                $scope.isDisabled = newVal;
            });

            // this is for touch enabled devices. We don't want to hide checkboxes on scroll.
            var onTouchStart = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = false;
                });
            };
            angular.element( document ).bind( 'touchstart', onTouchStart);
            var onTouchMove = function( e ) {
                $scope.$apply( function() {
                    $scope.scrolled = true;
                });
            };
            angular.element( document ).bind( 'touchmove', onTouchMove);

            // unbind document events to prevent memory leaks
            $scope.$on( '$destroy', function () {
                angular.element( document ).unbind( 'touchstart', onTouchStart);
                angular.element( document ).unbind( 'touchmove', onTouchMove);
            });
        }
    }
}]).run( [ '$templateCache' , function( $templateCache ) {
    var template =
        '<span class="multiSelect inlineBlock">' +
        // main button
        '<button id="{{directiveId}}" type="button"' +
        'ng-click="toggleCheckboxes( $event ); refreshSelectedItems(); refreshButton(); prepareGrouping; prepareIndex();"' +
        'ng-bind-html="varButtonLabel"' +
        'ng-disabled="disable-button"' +
        '>' +
        '</button>' +
        // overlay layer
        '<div class="checkboxLayer">' +
        // container of the helper elements
        '<div class="helperContainer" ng-if="helperStatus.filter || helperStatus.all || helperStatus.none || helperStatus.reset ">' +
        // container of the first 3 buttons, select all, none and reset
        '<div class="line" ng-if="helperStatus.all || helperStatus.none || helperStatus.reset ">' +
        // select all
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.all"' +
        'ng-click="select( \'all\', $event );"' +
        'ng-bind-html="lang.selectAll">' +
        '</button>'+
        // select none
        '<button type="button" class="helperButton"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.none"' +
        'ng-click="select( \'none\', $event );"' +
        'ng-bind-html="lang.selectNone">' +
        '</button>'+
        // reset
        '<button type="button" class="helperButton reset"' +
        'ng-disabled="isDisabled"' +
        'ng-if="helperStatus.reset"' +
        'ng-click="select( \'reset\', $event );"' +
        'ng-bind-html="lang.reset">'+
        '</button>' +
        '</div>' +
        // the search box
        '<div class="line" style="position:relative" ng-if="helperStatus.filter">'+
        // textfield
        '<input placeholder="{{lang.search}}" type="text"' +
        'ng-click="select( \'filter\', $event )" '+
        'ng-model="inputLabel.labelFilter" '+
        'ng-change="searchChanged()" class="inputFilter"'+
        '/>'+
        // clear button
        '<button type="button" class="clearButton" ng-click="clearClicked( $event )" >×</button> '+
        '</div> '+
        '</div> '+
        // selection items
        '<div class="checkBoxContainer">'+
        '<div '+
        'ng-repeat="item in filteredModel | filter:removeGroupEndMarker" class="multiSelectItem"'+
        'ng-class="{selected: item[ tickProperty ], horizontal: orientationH, vertical: orientationV, multiSelectGroup:item[ groupProperty ], disabled:itemIsDisabled( item )}"'+
        'ng-click="syncItems( item, $event, $index );" '+
        'ng-mouseleave="removeFocusStyle( tabIndex );"> '+
        // this is the spacing for grouped items
        '<div class="acol" ng-if="item[ spacingProperty ] > 0" ng-repeat="i in numberToArray( item[ spacingProperty ] ) track by $index">'+
        '</div>  '+
        '<div class="acol">'+
        '<label>'+
        // input, so that it can accept focus on keyboard click
        '<input class="checkbox focusable" type="checkbox" '+
        'ng-disabled="itemIsDisabled( item )" '+
        'ng-checked="item[ tickProperty ]" '+
        'ng-click="syncItems( item, $event, $index )" />'+
        // item label using ng-bind-hteml
        '<span '+
        'ng-class="{disabled:itemIsDisabled( item )}" '+
        'ng-bind-html="writeLabel( item, \'itemLabel\' )">'+
        '</span>'+
        '</label>'+
        '</div>'+
        // the tick/check mark
        '<span class="tickMark" ng-if="item[ groupProperty ] !== true && item[ tickProperty ] === true" ng-bind-html="icon.tickMark"></span>'+
        '</div>'+
        '</div>'+
        '</div>'+
        '</span>';
    $templateCache.put( 'isteven-multi-select.htm' , template );
}]);
(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.activityMenu')
        .controller('ActivityMenuCtrl', ['_','activityService','impactService','outcomeService','outputService','authService', 'toastr','$state', ActivityMenuCtrl]);

    /** @ngInject */
    function ActivityMenuCtrl(_,activityService,impactService,outcomeService,outputService,authService, toastr,$state) {

        var vm = this;

        vm.showFilters = true;
        vm.isOpen = false;
        vm.isActivityListLoaded = false;

        vm.activityName = null;
        vm.selectedMonth = new Date();
        vm.impactList = null;
        vm.outcomeList = null;
        vm.outputList = null;
        vm.selectedImpactList = [];
        vm.selectedOutcomeList = [];
        vm.selectedOutputList = [];

        vm.activityList = null;

        vm.isAllSelected = false;
        vm.datePicker = {};
        vm.datePicker.date  = null;
        vm.datePicker.options = null;
        vm.datePicker.ranges = null;

        vm.openCalendar = openCalendar;
        vm.searchActivity = searchActivity;
        vm.checkIfAllSelected = checkIfAllSelected;
        vm.selectOrDeselectAll = selectOrDeselectAll;
        vm.generateReport = generateReport;

        function init() {
            activityService.getActivitiesByFilters([],[],[], null, moment().startOf('year').valueOf(),moment().endOf('year').valueOf(),null).then(function (data) {
                vm.isActivityListLoaded = true;
                vm.activityList = data;
                mapActivitiesForCheckbox();
            });

            impactService.getAllImpacts().then(function (data) {
                vm.impactList = data;
            });
            outcomeService.getAllOutcomes().then(function (data) {
                vm.outcomeList = data;
            });
            outputService.getAllOutputs().then(function (data) {
                vm.outputList = data;
            });

            vm.datePicker.date = getInitialFromAndToDate();
            vm.datePicker.options = {
                applyClass: 'btn-green',
                locale: {
                    applyLabel: "Apply",
                    fromLabel: "From",
                    // format: "YYYY-MM-DD", //will give you 2017-01-06
                    format: "D/MMM/YY", //will give you 6-Jan-17
                    //format: "D-MMMM-YY", //will give you 6-January-17
                    toLabel: "To",
                    cancelLabel: 'Cancel',
                    customRangeLabel: 'Custom range'
                },
                ranges: {
                    'Today': [moment(), moment()],
                    'Yesterday': [moment().subtract('days', 1), moment().subtract('days', 1)],
                    'Last 7 days': [moment().subtract('days', 7), moment()],
                    'Last 30 days': [moment().subtract('days', 30), moment()],
                    'This month': [moment().startOf('month'), moment().endOf('month')]
                }
            };
        }
        init();

        function searchActivity() {
            vm.isActivityListLoaded = false;
            var time = vm.selectedMonth === null ? null : vm.selectedMonth.valueOf();
            activityService.getActivitiesByFilters(getIdArrayFromMultiSelectOutput(vm.selectedImpactList,'id'),getIdArrayFromMultiSelectOutput(vm.selectedOutcomeList,'id'),
                getIdArrayFromMultiSelectOutput(vm.selectedOutputList,'id'),time,
                vm.datePicker.date.startDate.valueOf(),vm.datePicker.date.endDate.valueOf(),vm.activityName).then(function (data) {
                    vm.isActivityListLoaded = true;
                    mapActivitiesForCheckbox();
                    vm.activityList = data;
                },function (error) {
                toastr.error(error);
            });
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function getInitialFromAndToDate  () {
            var start = moment().startOf('year')
            var end = moment().endOf('year');
            return {
                'startDate': start,
                'endDate': end
            };
        }

        function getIdArrayFromMultiSelectOutput (array, keyToExtract) {
            var returnArray = [];
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                returnArray.push(item[keyToExtract]);
            }
            return returnArray;
        }
        
        function mapActivitiesForCheckbox() {
            angular.forEach(vm.activityList,function (item) {
                item.selected = false;
            });
            angular.forEach(vm.activityList,function (item) {
                console.log(item.selected);
            })
        }

        function checkIfAllSelected() {
           for(var i = 0 ; i < vm.activityList.length;i++){
               if(vm.activityList[i].selected === false){
                   return;
               }
           }
           vm.isAllSelected = true;
        }

        function selectOrDeselectAll () {
            if(vm.isAllSelected === true){
                angular.forEach(vm.activityList,function (item) {
                    item.selected = true;
                })
            }
            else{
                angular.forEach(vm.activityList,function (item) {
                    item.selected = false;
                })
            }
        }
        
        function generateReport() {
            var activityIdArray = [];
            angular.forEach(vm.activityList,function (item) {
                if(item.selected === true)
                    activityIdArray.push(item.activity.id);
            });
            console.log("generatedActivityIds : " + activityIdArray);
            return $state.go('activityReport',{activityIds:activityIdArray});
        }
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main')
        .directive('yearlyMonitoringSession', function () {
            return {
                restrict: 'E',
                // transclude: true,
                controller: 'YearlyMonitoringSessionCtrl as vm',
                scope : {
                    monitoringSessions               : '=',
                    monitoringSessionExtrasToShow    : '=',
                },
                templateUrl: 'app/pages/main/directives/monitoringSessionDirective.html',
            }
        })
})();
(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main')
        .controller('YearlyMonitoringSessionCtrl',
            ['$scope', YearlyMonitoringSessionCtrl]);

    /** @ngInject */
    function YearlyMonitoringSessionCtrl($scope) {
        var vm = this;

        vm.monitoringSessionList = $scope.monitoringSessions;
        console.log(vm.monitoringSessionList);
        console.log($scope)
    }

})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.employees')
      .controller('EmployeesCtrl', ['$uibModal','_','employeeService','authService', 'toastr','$state', EmployeesCtrl]);

  /** @ngInject */
  function EmployeesCtrl($uibModal,_,employeeService,authService, toastr,$state) {

      var vm = this;

      vm.allEmployees = null;

      vm.openCreateEmployeeModal = openCreateEmployeeModal;

      function init() {
          employeeService.getAllEmployees().then(function (data) {
              vm.allEmployees = data;
              console.log(vm.allEmployees);
          },function () {
              toastr.error("Could not fetch User List")
          });
      }

      init();

      function openCreateEmployeeModal() {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/main/employees/create/createEmployee.modal.html',
              controller : 'EmployeeCreateModalCtrl',
              controllerAs : "vm"
          }).result.then(function(data) {
              vm.allEmployees.push(data);
              toastr.success("User created Successful");
          });
      }
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 * @deprecated
 */
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.employees')
        .directive('selectpicker', selectpicker);

    /** @ngInject */
    function selectpicker() {
        return {
            restrict: 'A',
            require: '?ngOptions',
            priority: 1500, // make priority bigger than ngOptions and ngRepeat
            link: {
                pre: function(scope, elem, attrs) {
                    elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
                },
                post: function(scope, elem, attrs) {
                    function refresh() {
                        elem.selectpicker('refresh');
                    }

                    if (attrs.ngModel) {
                        scope.$watch(attrs.ngModel, refresh);
                    }

                    if (attrs.ngDisabled) {
                        scope.$watch(attrs.ngDisabled, refresh);
                    }

                    elem.selectpicker({ dropupAuto: false, hideDisabled: true });
                }
            }
        };
    }


})();
(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.home')
      .controller('GeneralReportCtrl', ['_', 'toastr','$state', 'reportService','projectService',GeneralReportCtrl]);

  /** @ngInject */
  function GeneralReportCtrl(_,toastr,$state, reportService,projectService) {

      var vm = this;

      vm.format = 'MMM yyyy';
      vm.isOpen = false;
      vm.time = new Date();
      vm.impactList = [];
      vm.outcomeList = [];
      vm.outputList = [];
      vm.selectedProject = [];
      vm.projects = [];
      vm.dataLoaded = false;

      vm.search = search;
      vm.openCalendar = openCalendar;

      init();

      function init() {
          projectService.getAllProjects().then(function (data) {
              vm.projects = data;
          });
      }

      function openCalendar (e) {
          e.preventDefault();
          e.stopPropagation();
          vm.isOpen = true;
      }

      function search() {
          vm.dataLoaded = false;
          reportService.getReport(vm.selectedProject[0].id, vm.time.getTime()).then(function (responseData) {
            vm.impactList = responseData.reportImpactResponseList;
            vm.outcomeList = responseData.reportOutcomeResponseList;
            vm.outputList = responseData.reportOutputResponseList;
            vm.dataLoaded = true;
          }, function () {
              return toastr.error("Failed to fetch report");
          })
      }
    }
})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.home')
      .controller('HomeCtrl', ['_', 'toastr','$state', HomeCtrl]);

  /** @ngInject */
  function HomeCtrl(_,toastr,$state) {

      var vm = this;
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeDetails');
    app.controller('OutcomeDetailsCtrl',['outcomeService','$stateParams','toastr','$uibModal', OutcomeDetailsCtrl]);

    /** @ngInject */
    function OutcomeDetailsCtrl(outcomeService,$stateParams,toastr,$uibModal) {

        var vm = this;

        var outcomeId = null;
        vm.outcome = null;

        vm.openEditModal = openEditModal;
        vm.outputCreateModal = outputCreateModal;
        vm.openEditSummaryModal = openEditSummaryModal;

        function init() {
            outcomeId = $stateParams.id;
            outcomeService.getOutcome(outcomeId).then(function (data) {
                vm.outcome = data;
            },function () {
                toastr.error("Could not fetch impact");
            });
        }
        init();

        function openEditModal(indicator,type) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outcomeDetails/edit/edit.modal.html',
                size:'lg',
                controller : 'OutcomeEditModalCtrl',
                controllerAs : "vm",
                resolve : {
                    indicator : function () {
                        return indicator ;
                    },
                    type: function () {
                        return type;
                    }
                }
            }).result.then(function(data) {
                vm.outcome = data;
                toastr.success("Update Successful");
            });
        }

        // function openCreateIndicatorModal() {
        //     $uibModal.open({
        //         animation : true,
        //         templateUrl : 'app/pages/main/outcomeDetails/create/createIndicator.modal.html',
        //         size:'lg',
        //         controller : 'OutcomeIndicatorCreateModalCtrl',
        //         controllerAs : "vm",
        //         resolve : {
        //             outcomeId:function () {
        //                 return vm.outcome.id;
        //             }
        //         }
        //     }).result.then(function(data) {
        //         vm.outcome = data;
        //         toastr.success("Update Successful");
        //     });
        // }

        function outputCreateModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outcomeDetails/create/createOutput.modal.html',
                size:'lg',
                controller : 'OutputCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    outcomeId:function () {
                        return vm.outcome.id;
                    }
                }
            }).result.then(function(data) {
                vm.outcome.outputs = data;
                toastr.success("Update Successful");
            });
        }

        function openEditSummaryModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outcomeDetails/edit/editSummary.modal.html',
                controller : 'EditOutcomeSummaryModalCtrl',
                controllerAs : "vm",
                resolve: {
                    outcome: function () {
                        return vm.outcome;
                    }
                }
            }).result.then(function(data) {
                vm.outcome = data;
                toastr.success("Update Successful");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputDetails');
    app.controller('OutputDetailsCtrl',['outputService','$stateParams','toastr','$uibModal', OutputDetailsCtrl]);

    /** @ngInject */
    function OutputDetailsCtrl(outputService,$stateParams,toastr,$uibModal) {

        var vm = this;

        var outputId = null;
        vm.output = null;

        vm.openEditModal = openEditModal;
        vm.openCreateIndicatorModal = openCreateIndicatorModal;
        vm.activityCreateModalCtrl = activityCreateModalCtrl;
        vm.openEditSummaryModal = openEditSummaryModal;

        function init() {
            outputId = $stateParams.id;
            outputService.getOutput(outputId).then(function (data) {
                vm.output = data;
            },function () {
                toastr.error("Could not fetch output");
            });
        }
        init();

        function openEditModal(indicator,type) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outputDetails/edit/editOutputIndicator.modal.html',
                size:'lg',
                controller : 'OutputIndicatorEditModalCtrl',
                controllerAs : "vm",
                resolve : {
                    indicator : function () {
                        return indicator ;
                    },
                    type: function () {
                        return type;
                    }
                }
            }).result.then(function(data) {
                vm.output.outputIndicators = data;
                toastr.success("Update Successful");
            });
        }

        function openCreateIndicatorModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outputDetails/create/createOutputIndicator.modal.html',
                size:'lg',
                controller : 'OutputIndicatorCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    outputId:function () {
                        return vm.output.id;
                    }
                }
            }).result.then(function(data) {
                vm.output.outputIndicators.push(data);
                toastr.success("Update Successful");
            });
        }

        function activityCreateModalCtrl() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outputDetails/create/createActivity.modal.html',
                size:'lg',
                controller : 'ActivityCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    outputId: function () {
                        return vm.output.id;
                    }
                }
            }).result.then(function(data) {
                vm.output.activities.push(data);
                toastr.success("Update Successful");
            });
        }

        function openEditSummaryModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/outputDetails/edit/editSummary.modal.html',
                controller : 'EditOutputSummaryModalCtrl',
                controllerAs : "vm",
                resolve: {
                    output: function () {
                        return vm.output;
                    }
                }
            }).result.then(function(data) {
                vm.output = data;
                toastr.success("Update Successful");
            });
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfileCtrl', ['$scope', '$stateParams', '$timeout', 'authService', 'employeeService', 'toastr', ProfileCtrl]);

    /** @ngInject */
    function ProfileCtrl($scope, $stateParams, $timeout, authService, employeeService, toastr) {

        var vm = this;
        vm.user = null;
        vm.waitForLoading = true;
        vm.isEnrolTabActive = false;
        vm.onProfileInfoTabSelect = onProfileInfoTabSelect;
        vm.onAttendanceTabSelect = onAttendanceTabSelect;

        function onProfileInfoTabSelect() {

        }

        function onAttendanceTabSelect() {
            $scope.$broadcast("attendance-tab-select");
        }

        function init(employeeId) {
            if (!employeeId) {
                employeeId = authService.getLoggedInId();
            }
            employeeService.getDetailedProfile(employeeId).then(function (data) {
                console.log("Profile of employeeId : " + data.employee.id + " is loaded");
                vm.waitForLoading = false;
                if (employeeId === authService.getLoggedInId()) authService.setUserInfo(data.employee);
                $timeout(function () {
                    vm.user = data.employee;
                    $scope.$broadcast("profile-info-loaded", data.employee);
                });
            }, function (message) {
                console.error("Profile details fetch failure. Error message : " + message);
                toastr.error("Profile details fetch failure. Error message : " + message);
            });

            $scope.$on("profile-updated", function (event, change) {
                console.log("profile of employeeId : " + employeeId+ " changed. change : " + JSON.stringify(change));
                vm.user = buildWholeUserDataFromChange(vm.user, change, employeeId);
                $scope.$broadcast("profile-info-loaded", vm.user);
            });

            $scope.$on("profile-action-switch-to-enrol-tab", function (event) {
                vm.isEnrolTabActive = true;
            });

            $scope.$on('leave-management-apply',function () {
                $scope.$broadcast('leave-management-open-apply-modal');
            });
        }

        function buildWholeUserDataFromChange(user, change, employeeId) {
            if(change.key.valueOf() == "employeeDetails".valueOf()){
                if(change.subkey){
                    if(!user.employeeDetails) user.employeeDetails = {};
                    user.employeeDetails[change.subkey] = change.value;
                } else {
                    employeeService.getDetailedProfile(employeeId).then(function (data) {
                        return data.employee;
                    }, function (message) {
                        console.error("Failed to load profile : " + message);
                    });
                }
            } else if(change.key.valueOf() == "documents".valueOf()){
                if(change.type.valueOf() == "new".valueOf()){
                    user.documents.push(change.value);
                } else if(change.type.valueOf() == "modified".valueOf()) {
                    user.documents = updateArrayWithModifiedEntry(user.documents, change.value);
                } else {
                    console.warn("Probable wrong implementation in ProfileCtrl");
                    employeeService.getDetailedProfile(employeeId).then(function (data) {
                        return data.employee;
                    }, function (message) {
                        console.error("Failed to load profile : " + message);
                    });
                }
            }  else if(change.key.valueOf() == "addresses".valueOf()){
                if(change.type.valueOf() == "new".valueOf()){
                    user.addresses.push(change.value);
                } else if(change.type.valueOf() == "modified".valueOf()) {
                    user.addresses = updateArrayWithModifiedEntry(user.addresses, change.value);
                } else {
                    console.warn("Probable wrong implementation in ProfileCtrl");
                    employeeService.getDetailedProfile(employeeId).then(function (data) {
                        return data.employee;
                    }, function (message) {
                        console.error("Failed to load profile : " + message);
                    });
                }
            } else {
                user[change.key] = change.value;
            }
            return user;
        }

        function updateArrayWithModifiedEntry (array, obj) {
            for(var i = 0 ;i<array.length;i++){
                if(array[i].id===obj.id){
                    array[i] = obj;
                    return array;
                }
            }
        }

        init($stateParams.employeeId);
    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.outputMenu')
        .controller('OutputMenuCtrl', ['_','outputService','authService', 'toastr','$state', OutputMenuCtrl]);

    /** @ngInject */
    function OutputMenuCtrl(_,outputService,authService, toastr,$state) {

        var vm = this;

        vm.outputList = null;

        function init() {
            outputService.getAllOutputs().then(function (data) {
                console.log(JSON.stringify(data));
                vm.outputList = data;
            })
        }

        init();
    }
})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.projects')
      .controller('ProjectsCtrl', ['$uibModal','_','projectService', 'toastr','$state', ProjectsCtrl]);

  /** @ngInject */
  function ProjectsCtrl($uibModal,_,projectService, toastr,$state) {

      var vm = this;

      vm.allProjects = null;

      vm.openCreateProjectModal = openCreateProjectModal;
      vm.openEditProjectModal = openEditProjectModal;
      vm.changeStatus = changeStatus;
      vm.deleteProject = deleteProject;

      function init() {
          projectService.getAllProjects().then(function (data) {
              vm.allProjects = data;
          },function () {
              toastr.error("Could not fetch Project List")
          });
      }

      init();

      function openCreateProjectModal() {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/main/projects/create/createProject.modal.html',
              controller : 'ProjectCreateModalCtrl',
              controllerAs : "vm"
          }).result.then(function(data) {
              vm.allProjects.push(data);
              toastr.success("Project created successfully");
          });
      }

      function openEditProjectModal(project) {
          $uibModal.open({
              animation : true,
              templateUrl : 'app/pages/main/projects/edit/editProject.modal.html',
              controller : 'ProjectEditModalCtrl',
              controllerAs : "vm",
              resolve: {
                  'projectId': function () {
                      return project.id;
                  },
                  'project': function () {
                      return project;
                  }
              }
          }).result.then(function(data) {
              vm.allProjects = data;
              toastr.success("Project updated successfully");
          });
      }

      function changeStatus(project, status) {
          projectService.updateStatusOfProject({
              status : status,
          }, project.id).then(function (responseData) {
              vm.allProjects = responseData;
          },function () {
              toastr.error("Could not update project status");
          })
      }

      function deleteProject(project) {
          projectService.deleteProject(project.id).then(function (responseData) {
              console.log(responseData);
              vm.allProjects = responseData;
          },function () {
              toastr.error("Could not update project status");
          })
      }
    }
})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('BaSidebarCtrl', BaSidebarCtrl);

  /** @ngInject */
  function BaSidebarCtrl($scope, baSidebarService, menuPermissionService) {

    $scope.menuItems = baSidebarService.getMenuItems().filter(function(s) {
        if(menuPermissionService.hasStatePermission(s.name)) return s;
        return false;
    });
    // console.log("BA SIDEBAR CONTROLLER: MENU ITEMS: " + JSON.stringify($scope.menuItems));
    $scope.defaultSidebarState = $scope.menuItems[0].stateRef;

    $scope.hoverItem = function ($event) {
      $scope.showHoverElem = true;
      $scope.hoverElemHeight =  $event.currentTarget.clientHeight;
      var menuTopValue = 66;
      $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
    };

    $scope.$on('$stateChangeSuccess', function () {
      if (baSidebarService.canSidebarBeHidden()) {
        baSidebarService.setMenuCollapsed(true);
      }
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });

          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name,
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', baWizardCtrl);

  /** @ngInject */
  function baWizardCtrl($scope) {
    var vm = this;
    vm.tabs = [];

    vm.tabNum = 0;
    vm.progress = 0;

    vm.addTab = function(tab) {
      tab.setPrev(vm.tabs[vm.tabs.length - 1]);
      vm.tabs.push(tab);
      vm.selectTab(0);
    };

    $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);

    vm.selectTab = function (tabNum) {
      vm.tabs[vm.tabNum].submit();
      if (vm.tabs[tabNum].isAvailiable()) {
        vm.tabNum = tabNum;
        vm.tabs.forEach(function (t, tIndex) {
          tIndex == vm.tabNum ? t.select(true) : t.select(false);
        });
      }
    };

    vm.isFirstTab = function () {
      return vm.tabNum == 0;
    };

    vm.isLastTab = function () {
      return vm.tabNum == vm.tabs.length - 1 ;
    };

    vm.nextTab = function () {
      vm.selectTab(vm.tabNum + 1)
    };

    vm.previousTab = function () {
      vm.selectTab(vm.tabNum - 1)
    };

    function calcProgress() {
      vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
    }
  }
})();


(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('pageTop', ['authService', pageTop]);

  /** @ngInject */
  function pageTop(authService) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/pageTop/pageTop.html'
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', baSwitcher);

  /** @ngInject */
  function baSwitcher() {
    return {
      templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
      scope: {
        switcherStyle: '@',
        switcherValue: '='
      }
    };
  }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.activityDetails');
    app.controller('ActivityIndicatorCreateCtrl',['activityService','toastr','$state','$stateParams', 'timeInterval', ActivityIndicatorCreateCtrl]);

    /** @ngInject */
    function ActivityIndicatorCreateCtrl(activityService,toastr,$state,$stateParams,timeInterval) {

        var vm = this;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.isQuantitative = false;
        vm.unit = null;
        vm.timeLines = null;
        vm.startDate = null;
        vm.isOpen = false;
        vm.format = null;
        vm.timeLines = null;
        vm.intervals = null;
        vm.selectedTimeLine = null;
        vm.selectedInterval = null;
        vm.intervalsToBeShown = null;
        vm.typeOptions = null;
        vm.type = null;
        vm.baseline = null;
        vm.rowsToCreate = null;
        vm.tableData = [];

        vm.openCalendar = openCalendar;
        vm.createIndicator = createIndicator;
        vm.selectInterval = selectInterval;
        vm.createTableData = createTableData;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;
        vm.createActivityIndicator = createActivityIndicator;

        function init() {
            vm.startDate = new Date();
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
            vm.type = 1;
            vm.timeLines = [
                'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];
            vm.typeOptions = [{
                name:"Qualitative",
                value:0
            },{
                name:"Quantitative",
                value:1
            }];
            vm.intervals = timeInterval;
        }
        init();

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }

        function createIndicator() {
            var data = {
                indicator:{
                    indicator:vm.indicator,
                    meansOfVerification:vm.meansOfVerification,
                    assumption:vm.assumption
                }
            };

            outcomeService.createImpactIndicator(vm.impactId,data).then(function (responseData) {
            },function () {
                toastr.error("Could not create indicator ");
            });
        }

        function selectInterval () {
            if(vm.selectedTimeLine !== 'Immediate'){
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
        }

        function createTableData() {
            if(vm.type === null)
                return toastr.error("Please select Indicator type to edit");
            if(vm.selectedTimeLine === 'Immediate') {
                vm.tableData = [];
                vm.tableData.push({
                        "timeOfMonitoring" : angular.copy(vm.startDate),
                        "targetAchieved" : (vm.type === 1 && vm.baseline !== '') ? vm.baseline : '',
                        "target" : (vm.type === 1 && vm.baseline !== '')? '': '',
                        'assumption' : ' ',
                        'isOpen' : false
                });
                return;
            }
            var rowsToCreate = parseInt(vm.intervals[vm.selectedTimeLine].value);
            console.log("Rows to create "+rowsToCreate);
            vm.tableData = [];
            for(var i = 0 ;i < rowsToCreate;i++){
                vm.tableData.push({
                    "timeOfMonitoring" : moment(vm.startDate).add(i,'M').toDate(),
                    "targetAchieved" : (vm.type === 1 && vm.baseline !== '') ? vm.baseline : '',
                    "target" : (vm.type === 1 && vm.baseline !== '')? '': '',
                    'assumption' : ' ',
                    'isOpen' : false
                });
            }
        }

        function createActivityIndicator() {
            var monitoringData = angular.copy(vm.tableData);
            monitoringData = monitoringData.map( function (data) {
                data.timeOfMonitoring = data.timeOfMonitoring.getTime();
                return data;
            });
            var data = {
                "indicator" : vm.indicator,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : vm.baseline,
                "unit"      : vm.unit,
                "timeline"  : vm.intervals[vm.selectedTimeLine].value,
                "activityMonitoringSessions" : monitoringData
            };
            activityService.createActivityIndicator($stateParams.id,data).then(function () {
                toastr.success("Indicator created");
                $state.go('activityDetails',{id:$stateParams.id});
            },function () {
                toastr.error("Could not create indicator");
            });
        }

        function getUnitString() {
            return "( " + vm.unit +" )";
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.activityDetails')
        .controller('ActivityIndicatorEditModalCtrl', [ '$uibModalInstance','activityService','toastr','indicator','type', ActivityIndicatorEditModalCtrl]);

    /** @ngInject */
    function ActivityIndicatorEditModalCtrl($uibModalInstance,activityService,toastr,indicator,type) {

        var vm = this;

        vm.type = null;
        vm.indicator = null;

        vm.updateIndicator = updateIndicator;

        function init() {
            console.log(type);
            vm.type = type;
            vm.indicator = angular.copy(indicator);
        }

        function updateIndicator() {
           var data = {
               indicator:{
                    indicator:vm.indicator.indicator,
                    meansOfVerification:vm.indicator.meansOfVerification,
                    assumption: vm.indicator.assumption
                },
               actionPlan:{
                   timeFrame:vm.indicator.timeFrame,
                   responsibility: vm.indicator.responsibility
               },
               researchFramework:{
                    informationRequired:vm.indicator.informationRequired,
                    sourceOfInfo:vm.indicator.sourceOfInfo,
                    dataCollectionMethod:vm.indicator.dataCollectionMethod,
                    respondents:vm.indicator.respondents,
                    frequency:vm.indicator.frequency,
                    place:vm.indicator.place,
                    timeOfDataCollection:vm.indicator.timeOfDataCollection,
                    actualStatus:vm.indicator.actualStatus,
                    commentsFromSupervisor:vm.indicator.commentsFromSupervisor
               },
               monitoringFramework:{
                   deviation:vm.indicator.deviation,
                   causality:vm.indicator.causality,
                   recommendation:vm.indicator.recommendation,
                   reflectionInFuturePlan:vm.indicator.reflectionInFuturePlan,
               }

           };
            activityService.updateActivityIndicator(indicator.id,data).then(function (data) {
                $uibModalInstance.close(data);
           },function () {
               toastr.error("Could not update indicator");
           })
        }
        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.activityDetails')
        .controller('EditActivitySummaryModalCtrl', [ '$uibModalInstance','activityService','toastr','activity', EditActivitySummaryModalCtrl]);

    /** @ngInject */
    function EditActivitySummaryModalCtrl($uibModalInstance,activityService,toastr,activity) {

        var vm = this;

        vm.activity = null;

        vm.updateSummary = updateSummary;

        function init() {
            vm.activity = angular.copy(activity);
        }

        function updateSummary() {
            var data = {
                summary:vm.activity.summary,
                number : vm.activity.number
            };
            console.log(data);
            activityService.editSummary(vm.activity.id,data).then(function (data) {
                $uibModalInstance.close(data);
                console.log(data)
            },function () {
                toastr.error("Could not update summary")
            })
        }

        init();
    }

})();
(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.activityMenu')
        .controller('ActivityReportCtrl', ['_','activityService', 'toastr','$stateParams', ActivityReportCtrl]);

    /** @ngInject */
    function ActivityReportCtrl(_,activityService, toastr,$stateParams) {
        var vm = this;
        vm.reportObjectList = null;

        function init() {
            if($stateParams.activityIds === null) {
                toastr.error("Please select activities to generate report")
            }else{
                activityService.getReportObject($stateParams.activityIds).then(function (data) {
                    vm.reportObjectList = data;
                });
            }
        }
        init();
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.impactData')
        .controller('ImpactDataCtrl', ['_','impactService', 'toastr','$uibModal', ImpactDataCtrl]);

    /** @ngInject */
    function ImpactDataCtrl(_,impactService, toastr, $uibModal) {

        var vm = this;

        vm.impacts = null;
        vm.openDataCollectionModal = openDataCollectionModal;

        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            })
        }

        init();

        function openDataCollectionModal(impact) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/dataCollection/impactData/dataCollectionModal/impactDataCollection.modal.html',
                size:'lg',
                controller : 'ImpactDataCollectionModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'impact': function () {
                        return impact;
                    }
                }
            }).result.then(function(data) {
                vm.impacts = data;
                toastr.success("Data collected.");
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.activityData')
        .controller('ActivityDataCtrl', ['_', 'projectService', 'impactService', 'toastr', ActivityDataCtrl]);

    /** @ngInject */
    function ActivityDataCtrl(_, projectService, impactService, toastr) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.multiselectOutcomes = [];
        vm.multiSelectOutputs = [];
        vm.selectedImpacts = [];
        vm.selectedOutcomes = [];
        vm.selectedOutputs = [];
        vm.outputsToShow = [];
        vm.showFilters = false;
        vm.search = {};
        vm.search.searchName = "";
        vm.format = 'MMM yyyy';
        vm.startDate = null;
        vm.isOpen = false;
        vm.showDiv = false;

        var allImpacts = [];
        var allOutputs = [];

        vm.mapOutcomes = mapOutcomes;
        vm.mapOutputs = mapOutputs;
        vm.searchActivities = searchActivities;
        vm.isActivityEligibleForDataCollection = isActivityEligibleForDataCollection;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;
        vm.openCalendar = openCalendar;

        function isActivityEligibleForDataCollection(activity) {
            if (
                activity.targetEvent == null
                || activity.targetUnit == null
                || activity.maleParticipants == null
                || activity.femaleParticipants == null
            ) {
                return false;
            }
            return true;
        }

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                vm.impacts.forEach(function (impact) {
                    impact.outcomes.forEach(function (outcome) {
                        outcome.outputs.forEach(function (output) {
                            if (output.activities.length > 0) vm.outputsToShow.push(output);
                        });
                    });
                    allOutputs = angular.copy(vm.outputsToShow);
                });
            });
        }

        init();

        function mapImpactsToMultiSelectFormat(impact) {
            return {
                id: impact,
                number: impact.number,
                outcomes: impact.outcomes
            }
        }

        function filterImpactsDisplayValues() {
            if (vm.selectedProjects.length == 0) {
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            } else {
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function mapOutcomes() {
            if (vm.selectedImpacts.length === 0) {
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.multiselectOutcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.multiselectOutcomes = _.flatten(vm.multiselectOutcomes);
            vm.multiselectOutcomes = vm.multiselectOutcomes.filter(function (outcomes) {
                return outcomes.outputs != null && outcomes.outputs.length > 0;
            })
        }

        function mapOutputs() {
            vm.multiSelectOutputs = vm.selectedOutcomes.map(function (outcome) {
                if (outcome.outputs != null && outcome.outputs.length > 0)
                    return outcome.outputs;
            });
            vm.multiSelectOutputs = _.flatten(vm.multiSelectOutputs);
            vm.multiSelectOutputs = vm.multiSelectOutputs.filter(function (o) {
                return o.activities != null && o.activities.length > 0;
            });
        }


        function searchActivities() {
            if (vm.selectedImpacts.length > 0 && vm.selectedOutcomes.length === 0 && vm.selectedOutputs.length === 0) {
                vm.outputsToShow = [];
                var tempOutput = [];
                vm.selectedImpacts.forEach(function (impact) {
                    if (impact.outcomes != null && impact.outcomes.length > 0) {
                        impact.outcomes.forEach(function (outcome) {
                            if (outcome.outputs != null && outcome.outputs.length > 0) {
                                outcome.outputs.forEach(function (output) {
                                    if (output.activities != null && output.activities.length > 0)
                                        tempOutput.push(angular.copy(output))
                                });
                            }
                        });
                    }
                });
                vm.outputsToShow = angular.copy(angular.copy(tempOutput))
            } else if (vm.selectedImpacts.length > 0 && vm.selectedOutcomes.length > 0 && vm.selectedOutputs.length === 0) {
                vm.outputsToShow = [];
                var tempOutput = [];
                vm.selectedOutcomes.forEach(function (outcome) {
                    if (outcome.outputs != null && outcome.outputs.length > 0) {
                        outcome.outputs.forEach(function (output) {
                            if (output.activities != null && output.activities.length > 0)
                                tempOutput.push(angular.copy(output))
                        })
                    }
                })
                vm.outputsToShow = angular.copy(angular.copy(tempOutput))
            } else if(vm.selectedOutputs.length > 0) {
                vm.outputsToShow = angular.copy(vm.selectedOutputs);
            } else {
                vm.outputsToShow = angular.copy(allOutputs);
            }
            if (vm.search.searchName !== "" && vm.search.searchName != null) {
                var temp = vm.outputsToShow.filter(function (output) {
                    if (output.summary.toLowerCase().includes(vm.search.searchName.toLowerCase())) {
                        return output.summary.toLowerCase().includes(vm.search.searchName.toLowerCase());
                    } else {
                        output.activities = output.activities.filter(function (activity) {
                            return activity.responsibleAgency.toLowerCase().includes(vm.search.searchName.toLowerCase())
                        })
                        if (output.activities.length != 0) {
                            return true;
                        }
                        return false;
                    }
                })
                vm.outputsToShow = angular.copy(temp);
            }
            if (vm.startDate != null) {
                var temp = vm.outputsToShow.filter(function (output) {
                    output.activities = output.activities.filter(function (activity) {
                        return activity.startDate >= vm.startDate
                    })
                    if (output.activities.length != 0) {
                        return true;
                    }
                    return false;

                })
                vm.outputsToShow = angular.copy(temp);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.outcomeData')
        .controller('OutcomeDataCtrl', ['_','projectService','outcomeService', 'impactService', 'toastr','$uibModal', OutcomeDataCtrl]);

    /** @ngInject */
    function OutcomeDataCtrl(_,projectService, outcomeService, impactService, toastr, $uibModal) {

        var vm = this;
        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.filteredImpacts = [];
        vm.allOutcomes = [];
        vm.selectedOutcomes = [];
        vm.showFilters = false;
        var allImpacts = [];
        vm.isOutcomeValidForDataCollection = isOutcomeValidForDataCollection;

        vm.openDataCollectionModal = openDataCollectionModal;
        vm.filterImpacts = filterImpacts;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                vm.filteredImpacts = data;
            });
            outcomeService.getAllOutcomes().then(function (data) {
                vm.allOutcomes = data;
                vm.selectedOutcomes = data;
            });
        }

        init();

        function openDataCollectionModal(outcome) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/dataCollection/outcomeData/dataCollectionModal/outcomeDataCollection.modal.html',
                size:'lg',
                controller : 'OutcomeDataCollectionModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'outcome': function () {
                        return outcome;
                    }
                }
            }).result.then(function(data) {
                vm.outcomes = data;
                toastr.success("Data collected.");
            });
        }


        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function filterImpacts() {
            if(!vm.selectedImpacts || !vm.selectedImpacts.length) vm.selectedOutcomes = vm.allOutcomes;
            outcomeService.getAllOutcomesByFilter(vm.selectedImpacts.map(function (impact) {
                return impact.id;
            })).then(function (responseData) {
                vm.selectedOutcomes = responseData;
            });
        }

        function isOutcomeValidForDataCollection(outcome) {
            if(outcome && outcome.outcomeIndicators && outcome.outcomeIndicators.length > 0){
                for(var i = 0; i < outcome.outcomeIndicators.length; i++){
                    if(outcome.outcomeIndicators[i] && outcome.outcomeIndicators[i].outcomeMonitoringSessions && outcome.outcomeIndicators[i].outcomeMonitoringSessions.length > 0) return true;
                }
            }
            return false;
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.outputData')
        .controller('OutputDataCtrl', ['_','projectService','impactService', 'toastr', '$uibModal', OutputDataCtrl]);

    /** @ngInject */
    function OutputDataCtrl(_,projectService,impactService, toastr,$uibModal) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = [];
        vm.selectedImpacts = [];
        vm.outcomes = null;
        vm.selectedOutcomes = [];
        vm.allOutputs = [];
        vm.selectedOutputs = [];
        vm.showFilters = false;
        var allImpacts = [];

        vm.mapOutcomes = mapOutcomes;
        vm.searchOutputs = searchOutputs;
        vm.openDataCollectionModal = openDataCollectionModal;
        vm.isOutputValidForDataCollection = isOutputValidForDataCollection;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                for(var i = 0; i< vm.impacts.length;i++){
                    for(var j=0; j<vm.impacts[i].outcomes.length;j++){
                        vm.impacts[i].outcomes[j].impact = {};
                        vm.impacts[i].outcomes[j].impact.id = vm.impacts[i].id;
                        vm.impacts[i].outcomes[j].impact.number = vm.impacts[i].number;
                        vm.impacts[i].outcomes[j].impact.summary = vm.impacts[i].summary;
                        for(var k=0; k< vm.impacts[i].outcomes[j].outputs.length; k++){
                            vm.impacts[i].outcomes[j].outputs[k].outcome = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.id = vm.impacts[i].outcomes[j].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.number = vm.impacts[i].outcomes[j].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.summary = vm.impacts[i].outcomes[j].summary;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.id = vm.impacts[i].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.number = vm.impacts[i].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.summary = vm.impacts[i].summary;
                        }
                    }
                }
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            });
        }

        function openDataCollectionModal(output) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/dataCollection/outputData/dataCollectionModal/outputDataCollection.modal.html',
                size:'lg',
                controller : 'OutputDataCollectionModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'output': function () {
                        return output;
                    }
                }
            }).result.then(function(data) {
                vm.outcomes = data;
                toastr.success("Data collected.");
            });
        }

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function isOutputValidForDataCollection(output) {
            if(output && output.outputIndicators && output.outputIndicators.length > 0){
                for(var i = 0; i < output.outputIndicators.length; i++){
                    if(output.outputIndicators[i] && output.outputIndicators[i].outputMonitoringSessions && output.outputIndicators[i].outputMonitoringSessions.length > 0) return true;
                }
            }
            return false;
        }

        function getActiveOutputsFromImpacts(impactList) {
            var outputList = [];
            impactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function getActiveOutputsFromMultiSelectImpacts(multiselectImpactList) {
            var outputList = [];
            multiselectImpactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function getActiveOutputsFromMultiSelectOutcomes(multiselectOutcomeList) {
            var outputList = [];
            multiselectOutcomeList.forEach(function (outcome) {
                outcome.outputs.forEach(function (output) {
                    if (output.status === 1) {
                        outputList.push(output);
                    }
                })
            });
            return outputList;
        }

        init();

        function mapOutcomes() {
            vm.outcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.outcomes = _.flatten(vm.outcomes);
        }

        function searchOutputs() {
            if (vm.selectedImpacts && vm.selectedImpacts.length>0 && (!vm.selectedOutcomes || vm.selectedOutcomes.length === 0)) {
                vm.allOutputs = getActiveOutputsFromMultiSelectImpacts(vm.selectedImpacts);
            } else if (vm.selectedOutcomes && vm.selectedOutcomes.length>0) {
                vm.allOutputs = getActiveOutputsFromMultiSelectOutcomes(vm.selectedOutcomes);
            } else {
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.employees')
        .controller('EmployeeActionsCtrl', ['_','designationService','shiftService', 'departmentService', 'leavePolicyService', 'weeklyOffDaysService', 'deviceService', 'toastr','$stateParams', EmployeeActionsCtrl]);

    /** @ngInject */
    function EmployeeActionsCtrl(_, designationService,shiftService, departmentService, leavePolicyService, weeklyOffDaysService, deviceService, toastr,$stateParams) {

        var vm = this;

        vm.select = {};
        vm.select.selectedEmployees = $stateParams.selectedEmployees;
        vm.select.notSelectedEmployees = $stateParams.notSelectedEmployees;

        vm.select.multiselectEmployees = [];

        vm.leavePolicy = {};
        vm.leavePolicy.leavePolicyList = null;
        vm.designation = {};
        vm.designation.designationList = null;
        vm.shift = {};
        vm.shift.shiftList = null;
        vm.department = {};
        vm.department.departmentList = null;
        vm.weeklyOffDaysPolicy = {};
        vm.weeklyOffDaysPolicy.weeklyOffDaysPolicyList = null;
        vm.devices = [];
        vm.selectedDevice = null;
        vm.fromTime = new Date();
        vm.toTime = new Date();
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.temporarySelectedDevice = [];

        vm.saveTemporaryAllocation = saveTemporaryAllocation;
        vm.openCalendarFromTime = openCalendarFromTime;
        vm.openCalendarToTime = openCalendarToTime;

        vm.populateTableFromMultiSelect  = populateTableFromMultiSelect;
        vm.removeEmployeeFromTable = removeEmployeeFromTable;
        vm.assignBatchLeavePolicy = assignBatchLeavePolicy;
        vm.assignBatchDesignation = assignBatchDesignation;
        vm.assignBatchShift = assignBatchShift;
        vm.assignBatchDepartment = assignBatchDepartment;
        vm.assignBatchWeeklyOffDaysPolicy = assignBatchWeeklyOffDaysPolicy;
        vm.allocateToDevice = allocateToDevice;

        function init() {
            leavePolicyService.getAllLeavePolicies().then(onLeavePolicyListFetchSuccess,onLeavePolicyListFetchFailure);
            designationService.getAllDesignations().then(onDesignationListFetchSuccess, onDesignationListFetchFailure);
            shiftService.getAllShifts().then(onShiftListFetchSuccess, onShiftListFetchFailure);
            departmentService.getAllDepartments().then(onDepartmentListFetchSuccess, onDepartmentListFetchFailure);
            weeklyOffDaysService.getAllWeeklyOffDayPolicies().then(onWeeklyOffDaysPolicyListFetchSuccess, onWeeklyOffDaysPolicyListFetchFailure);
            deviceService.getAllDevices().then(onDevicesFetchSuccess,onDevicesFetchFailure);
        }

        init();

        function onDevicesFetchSuccess(data) {
            vm.devices = data;
        }

        function onDevicesFetchFailure() {
            toastr.error("Could not fetch device list");
        }

        function onLeavePolicyListFetchSuccess(leavePolicyList) {
            vm.leavePolicy.leavePolicyList = leavePolicyList;
        }

        function onLeavePolicyListFetchFailure(error) {
            console.error(error);
        }

        function onDesignationListFetchSuccess(designationList) {
            vm.designation.designationList = designationList;
        }

        function onDesignationListFetchFailure(error) {
            console.error(error);
        }

        function onShiftListFetchSuccess(shiftList) {
            vm.shift.shiftList = shiftList;
        }

        function onShiftListFetchFailure(error) {
            console.error(error);
        }

        function onDepartmentListFetchSuccess(departmentList) {
            vm.department.departmentList = departmentList;
            console.log(vm.department.departmentList);
        }

        function onDepartmentListFetchFailure(error) {
            console.error(error);
        }

        function onWeeklyOffDaysPolicyListFetchSuccess(weeklyOffDaysPolicyList) {
            vm.weeklyOffDaysPolicy.weeklyOffDaysPolicyList = weeklyOffDaysPolicyList;
        }

        function onWeeklyOffDaysPolicyListFetchFailure(error) {
            console.error(error);
        }

         function populateTableFromMultiSelect() {
            vm.select.selectedEmployees.push.
                apply(vm.select.selectedEmployees, vm.select.multiselectEmployees);
            angular.forEach(vm.select.multiselectEmployees, function (el) {
                vm.select.notSelectedEmployees = _.reject(vm.select.notSelectedEmployees, function (employee) {
                    return employee.id == el.id;
                });
            });
        }

        function removeEmployeeFromTable(employee) {
            vm.select.selectedEmployees = _.reject(vm.select.selectedEmployees, function (el) {
                return el.id == employee.id;
            });
            vm.select.notSelectedEmployees.push(employee);
        }

         function assignBatchLeavePolicy() {
            var batchEmployees = {
                employeeIdList : []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            leavePolicyService.updateBatchLeavePolicy(batchEmployees, vm.select.selectedLeavePolicy.id).then(onBatchLeavePolicyUpdateSuccess, onBatchLeavePolicyUpdateFailure);
        }

        function onBatchLeavePolicyUpdateSuccess(data) {
            vm.select.selectedEmployees = data;
            toastr.success("Leave policy assigned");
        }

        function onBatchLeavePolicyUpdateFailure(error) {
            console.error(error);
            toastr.error("Could not assign leave policy");
        }

        function assignBatchDesignation() {
            var batchEmployees = {
                employeeIdList : []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            designationService.updateBatchDesignation(batchEmployees, vm.select.selectedDesignation.id).then(onBatchDesignationUpdateSuccess, onBatchDesignationUpdateFailure)
        }

        function onBatchDesignationUpdateSuccess(data) {
            vm.select.selectedEmployees = data;
            toastr.success("Designation assigned");
        }

        function onBatchDesignationUpdateFailure(error) {
            console.error(error);
            toastr.error("Could not assign designation");
        }

        function assignBatchShift() {
            var batchEmployees = {
                employeeIdList : []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            shiftService.updateBatchShift(batchEmployees, vm.select.selectedShift.id).then(onBatchShiftUpdateSuccess, onBatchShiftUpdateFailure)
        }

        function onBatchShiftUpdateSuccess(data) {
            vm.select.selectedEmployees = data;
            toastr.success("Shift assigned");
        }

        function onBatchShiftUpdateFailure(error) {
            console.error(error);
            toastr.error("Could not assign shift");
        }
        
        function assignBatchDepartment() {
            var batchEmployees = {
                employeeIdList : []
            };
            console.log(vm.select.selectedEmployees);
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            departmentService.updateBatchDepartment(batchEmployees, vm.select.selectedDepartment.id).then(onBatchDepartmentUpdateSuccess, onBatchDepartmentUpdateFailure);
        }

        function onBatchDepartmentUpdateSuccess(data) {
            vm.select.selectedEmployees = data;
            toastr.success("Department assigned");
        }

        function onBatchDepartmentUpdateFailure(error) {
            console.error(error);
            toastr.error("Could not assign department");
        }
        
        function assignBatchWeeklyOffDaysPolicy() {
            var batchEmployees = {
                employeeIdList : []
            };
            angular.forEach(vm.select.selectedEmployees, function (employee) {
                batchEmployees.employeeIdList.push(employee.id);
            });
            weeklyOffDaysService.updateBatchWeeklyOffDaysPolicyPolicy(batchEmployees, vm.select.selectedWeeklyOffDaysPolicy.id).then(onBatchBatchWeeklyOffDaysPolicyUpdateSuccess, onBatchBatchWeeklyOffDaysPolicyUpdateFailure);
        }

        function onBatchBatchWeeklyOffDaysPolicyUpdateSuccess(data) {
            vm.select.selectedEmployees = data;
            toastr.success("Weekly Off Days Policy assigned");
        }

        function onBatchBatchWeeklyOffDaysPolicyUpdateFailure(error) {
            console.error(error);
            toastr.error("Could not assign weekly off days policy")
        }
        
        function allocateToDevice() {
            var data = {"requestList":mapDataForBatchAllocate()}
            console.log(data);
            deviceService.allocateEmployeeBatch(data,vm.selectedDevice.identifier).then(function () {
                toastr.success("Employees successfully allocated");
            },function (error) {
                toastr.error("Could not allocate employee "+error)
            });
        }

        function mapDataForBatchAllocate() {
           var data = vm.select.selectedEmployees.map(function (employee) {
                return {
                    "person_identifier" : employee.employeeIdentifier,
                    "deviceIdentifier" : vm.selectedDevice.identifier,
                    "action" : "allocate"
                };
            });
           return data;
        }

        function mapDataForBatchTemporaryAllocation() {
            var data = vm.select.selectedEmployees.map(function (employee) {
                return {
                    "person_identifier" : employee.employeeIdentifier,
                    "deviceIdentifier" : vm.temporarySelectedDevice[0].identifier,
                    "timeOfAllocation" : vm.fromTime.getTime(),
                    "timeOfRevoke" : vm.toTime.getTime()
                }
            });
            return data;
        }

        function openCalendarFromTime (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenFrom = true;
        }

        function openCalendarToTime (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenTo = true;
        }

        function saveTemporaryAllocation() {
            if(vm.temporarySelectedDevice.length < 1)
                return toastr.error("Select a device");
            if(vm.fromTime === null || vm.toTime === null )
                return toastr.error("Times cannot be empty");
            if(vm.fromTime > vm.toTime)
                return toastr.error("Start time can not be after end time?");

            var data = {
                requestList : mapDataForBatchTemporaryAllocation()
            }
            deviceService.allocateTemporarily(data,vm.temporarySelectedDevice[0].identifier).then(function () {
                toastr.success("Allocation successful");
            },function () {
                toastr.error("Could not allocate employee")
            })

        }
    }
})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.employees')
      .controller('EmployeeCreateModalCtrl',
          ['employeeService','$state','toastr','$uibModalInstance', EmployeeCreateModalCtrl]);

  /** @ngInject */
  function EmployeeCreateModalCtrl(employeeService,$state,toastr,$uibModalInstance) {

      var vm = this;

      vm.createEmployee = createEmployee;

      vm.name = null;
      vm.email = null;
      vm.password = null;
      vm.confirmPassword = null;
      vm.role = null;

      function createEmployee() {
          if(vm.name === null || vm.email === null) return toastr.error('Name or email cannot be empty');
          if(vm.password !== vm.confirmPassword) return toastr.error("Passwords must match");
          if(vm.role === null || vm.role ==='') return toastr.error("Please select a role");
          var data = {
                name : vm.name,
                email: vm.email,
                password : vm.password,
                role:vm.role
            };
          employeeService.createEmployee(data).then(function (responseData) {
              $uibModalInstance.close(responseData);
          },function () {
              toastr.error("Could not create employee");
          })
      }

  }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main')
        .controller('ActivityDetailsReportCtrl', ['_','impactService','projectService', 'activityService', 'toastr', '$uibModal', ActivityDetailsReportCtrl]);

    /** @ngInject */
    function ActivityDetailsReportCtrl(_,impactService,projectService, activityService, toastr, $uibModal) {

        var vm = this;

        vm.activityList = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.outcomes = [];
        vm.selectedOutcomes = [];
        vm.outputs = [];
        vm.selectedOutputs= [];
        vm.showFilters = false;
        vm.search = {};
        vm.search.searchName = null;
        vm.search.agencyName = null;
        vm.format = 'MMM yyyy';
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.isOpenFrom = false;
        vm.isOpenTo = false;
        vm.showFilters = false;
        vm.isDataLoaded = false;
        vm.excelUrl = null;
        vm.selectedProjects = []
        vm.projects = []
        vm.reportResponse = null;
        vm.monthList = [];
        vm.extras = [
            {
                name  : 'Custom Unit',
                value : 'customUnit'
            },
            {
                name  : 'Activity Description Per Proposal',
                value : 'activityDescriptionPerProposal'
            },
            {
                name  : 'Reason of Deviation',
                value : 'reasonOfDeviation',
            },
            {
                name  : 'Not Done Sub Activities',
                value : 'notDoneSubActivities',
            },
            {
                name  : 'Challenge',
                value : 'challenge'
            },
            {
                name  : 'Lesson Learnt',
                value : 'lessonLearnt'
            },
            {
                name  : 'Activity Description',
                value : 'activityDescription'
            },
            {
                name  : 'Recommendation',
                value : 'recommendation'
            }
        ];
        vm.selectedExtras = [];
        vm.activityExtrasToShow = [];
        vm.monitoringSessionExtrasToShow = [];

        vm.generateOutcomes = generateOutcomes;
        vm.generateOutputs = generateOutputs;
        vm.search = search;
        vm.openCalendarFrom = openCalendarFrom;
        vm.openCalendarTo = openCalendarTo;
        vm.openCreateActivityModal = openCreateActivityModal;
        vm.convertMillisToDate = convertMillisToDate;
        vm.translateEmployeeArrayToEmployeeNameCommaSeparated = translateEmployeeArrayToEmployeeNameCommaSeparated;
        vm.populateExtrasToShow = populateExtrasToShow;
        vm.logItems = logItems;

        function logItems(){}

        function init() {
            vm.isDataLoaded = false;
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            });
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            getDetailedReport();
        }

        init();

        function generateOutcomes() {
            if(vm.selectedImpacts.length === 0){
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.outcomes = vm.selectedImpacts[0].outcomes;
        }

        function generateOutputs() {
            if(vm.selectedOutcomes.length === 0){
                vm.selectedOutputs = [];
                return;
            }
            vm.outputs = vm.selectedOutcomes[0].outputs;
        }

        function search() {
            vm.isDataLoaded = false;
            var params = {
                params : {
                    impactId : vm.selectedImpacts && vm.selectedImpacts.length > 0 ? vm.selectedImpacts[0].id : null,
                    outcomeId : vm.selectedOutcomes && vm.selectedOutcomes.length > 0 ? vm.selectedOutcomes[0].id : null,
                    outputId : vm.selectedOutputs && vm.selectedOutputs.length > 0 ? vm.selectedOutputs[0].id : null,
                    projectId: vm.selectedProjects && vm.selectedProjects.length > 0 ? vm.selectedProjects[0].id : null,
                    keyword : vm.search.agencyName != null ? vm.search.agencyName.trim() : null,
                    startDate : vm.startDate.getTime(),
                    endDate : vm.endDate.getTime()
                }
            };
            getDetailedReport(params);
        }

        function getDetailedReport(params) {
            activityService.getDetailedReport(params).then(function (data) {
                vm.reportResponse = data.perActivityReportResponses;
                vm.populateExtrasToShow();
                vm.isDataLoaded = true;
                vm.monthList = data.monthList;
            });
        }

        function convertMillisToDate(millis){
            return moment(millis).format("MMM YYYY");
        }

        function openCalendarFrom (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenFrom = true;
        }


        function openCalendarTo (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpenTo = true;
        }

        function openCreateActivityModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/activity/createModal/createActivity.modal.html',
                size:'lg',
                controller : 'CreateActivityModalCtrl',
                controllerAs : "vm",
                resolve : {
                    impacts:function () {
                        return vm.impacts;
                    }
                }
            }).result.then(function(data) {
                vm.activityList = data;
                resetFilters();
                toastr.success("Major Activity Created Successfully");
            });
        }

        function resetFilters() {
            vm.selectedImpacts = [];
            vm.outcomes = [];
            vm.selectedOutcomes = [];
            vm.outputs = [];
            vm.selectedOutputs= [];
            vm.showFilters = false;
            vm.search = {};
            vm.search.searchName = null;
            vm.startDate = null;
            vm.isOpen = false;
        }



        function translateEmployeeArrayToEmployeeNameCommaSeparated(employees){
            var employeeNames = "";
            for(var i =0; i< employees.length;i++){
                employeeNames = employeeNames + employees[i].name;
                if(employees.length - i > 1) employeeNames = employeeNames + ", "
            }
            return employeeNames;
        }

        function populateExtrasToShow() {
            var all = vm.selectedExtras.map(function (e) {
                return e.value;
            });
            vm.activityExtrasToShow = [];
            vm.monitoringSessionExtrasToShow = [];
            all.forEach(function (e) {
                if(e == 'activityDescriptionPerProposal' || e == 'customUnit' )
                    vm.activityExtrasToShow.push(e);
                else
                    vm.monitoringSessionExtrasToShow.push(e);
            });
            var params = {
                impactId : vm.selectedImpacts && vm.selectedImpacts.length > 0 ? vm.selectedImpacts[0].id : null,
                outcomeId : vm.selectedOutcomes && vm.selectedOutcomes.length > 0 ? vm.selectedOutcomes[0].id : null,
                outputId : vm.selectedOutputs && vm.selectedOutputs.length > 0 ? vm.selectedOutputs[0].id : null,
                keyword : vm.search.agencyName != null ? vm.search.agencyName.trim() : null,
                startDate : vm.startDate.getTime(),
                endDate : vm.endDate.getTime(),
                activityExtrasToShow          : vm.activityExtrasToShow,
                monitoringSessionExtrasToShow : vm.monitoringSessionExtrasToShow
            }
            vm.excelUrl = activityService.getDetailedReportExcelUrl(params);
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.activityDetailsReport', [])
        .config(['$stateProvider' , routeConfig]);

    /** @ngInject */
    function routeConfig($stateProvider){
        $stateProvider
            .state('generalReport.activityDetailsReport',
                {
                    url: '/activityDetailsReport',
                    views : {
                        'generalReport' : {
                            templateUrl: 'app/pages/main/generalReport/activityDetailsReport/activityDetailsReport.html',
                            controller:'ActivityDetailsReportCtrl',
                            controllerAs:'vm'
                        }
                    },
                    title: 'Activity  Report',
                    sidebarMeta: {
                        order: 98
                    }
                });
    }
})();
(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main')
        .controller('ActivityReportCtrl', ['_', 'impactService', 'projectService', 'activityService', 'toastr', '$uibModal', '$q', ActivityReportCtrl]);

    /** @ngInject */
    function ActivityReportCtrl(_, impactService, projectService, activityService, toastr, $uibModal, $q) {

        var vm = this;

        vm.activityList = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.outcomes = [];
        vm.selectedOutcomes = [];
        vm.outputs = [];
        vm.selectedOutputs = [];
        vm.showFilters = false;
        vm.search = {};
        vm.search.searchName = null;
        vm.search.agencyName = null;
        vm.format = 'yyyy';
        vm.startDate = new Date();
        vm.isOpen = false;
        vm.showFilters = false;
        vm.isDataLoaded = false;

        vm.reportResponse = null;

        vm.excelUrl = null;

        vm.firstQuarter = ['January', 'February', 'March', 'Quarter-1'];
        vm.secondQuarter = ['April', 'May', 'June', 'Quarter-2'];
        vm.thirdQuarter = ['July', 'August', 'September', 'Quarter-3'];
        vm.fourthQuarter = ['October', 'November', 'December', 'Quarter-4'];

        vm.extras = [
            {
                name  : 'Custom Unit',
                value : 'customUnit'
            },
            {
                name  : 'Activity Description Per Proposal',
                value : 'activityDescriptionPerProposal'
            },
            {
                name  : 'Reason of Deviation',
                value : 'reasonOfDeviation',
            },
            {
                name  : 'Not Done Sub Activities',
                value : 'notDoneSubActivities',
            },
            {
                name  : 'Challenge',
                value : 'challenge'
            },
            {
                name  : 'Lesson Learnt',
                value : 'lessonLearnt'
            },
            {
                name  : 'Activity Description',
                value : 'activityDescription'
            },
            {
                name  : 'Recommendation',
                value : 'recommendation'
            }
        ];
        vm.selectedExtras = [];
        vm.activityExtrasToShow = [];
        vm.monitoringSessionExtrasToShow = [];

        vm.generateOutcomes = generateOutcomes;
        vm.generateOutputs = generateOutputs;
        vm.search = search;
        vm.openCalendar = openCalendar;
        vm.openCreateActivityModal = openCreateActivityModal;
        vm.convertMillisToDate = convertMillisToDate;
        vm.translateEmployeeArrayToEmployeeNameCommaSeparated = translateEmployeeArrayToEmployeeNameCommaSeparated;
        vm.populateExtrasToShow = populateExtrasToShow;
        vm.getColspanForMonthlyCells = getColspanForMonthlyCells;
        vm.selectedProjects = []
        vm.projects = []

        function init() {
            vm.isDataLoaded = false;
            $q.all([
                getAllImpacts(),
                getReport(getSearchParams())
            ]).then(function () {
                vm.isDataLoaded = true;
                populateExtrasToShow();
            });
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
        };

        init();

        function getAllImpacts() {
            return impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            });
        }

        function getColspanForMonthlyCells(index){
            var colspan = 10;
            if(vm.activityExtrasToShow.includes('customUnit'))
                colspan+=2;
            if(index > 0 && index % 3 === 0 ){
                return colspan;
            }else {
                return colspan+vm.monitoringSessionExtrasToShow.length;
            }

        }

        function generateOutcomes() {
            if(vm.selectedImpacts.length === 0){
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.outcomes = vm.selectedImpacts[0].outcomes;
        }

        function generateOutputs() {
            if(vm.selectedOutcomes.length === 0){
                vm.selectedOutputs = [];
                return;
            }
            vm.outputs = vm.selectedOutcomes[0].outputs;
        }

        function search() {
            vm.isDataLoaded = false;
            getReport(getSearchParams());
        }

        function getSearchParams() {
            return {
                params: {
                    impactId: vm.selectedImpacts && vm.selectedImpacts.length > 0 ? vm.selectedImpacts[0].id : null,
                    outcomeId: vm.selectedOutcomes && vm.selectedOutcomes.length > 0 ? vm.selectedOutcomes[0].id : null,
                    outputId: vm.selectedOutputs && vm.selectedOutputs.length > 0 ? vm.selectedOutputs[0].id : null,
                    projectId: vm.selectedProjects && vm.selectedProjects.length > 0 ? vm.selectedProjects[0].id : null,
                    keyword: vm.search.agencyName != null ? vm.search.agencyName.trim() : null,
                    year: vm.startDate.getFullYear()
                }
            };
        }

        function getReport(params) {
            return activityService.getReport(params).then(function (data) {
                vm.reportResponse = data.perActivityReportResponses;
                vm.isDataLoaded = true;
                populateExtrasToShow();
            });
        }

        function convertMillisToDate(millis){
            return moment(millis).format("MMM YYYY");
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCreateActivityModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/activity/createModal/createActivity.modal.html',
                size:'lg',
                controller : 'CreateActivityModalCtrl',
                controllerAs : "vm",
                resolve : {
                    impacts:function () {
                        return vm.impacts;
                    }
                }
            }).result.then(function(data) {
                vm.activityList = data;
                resetFilters();
                toastr.success("Major Activity Created Successfully");
            });
        }

        function resetFilters() {
            vm.selectedImpacts = [];
            vm.outcomes = [];
            vm.selectedOutcomes = [];
            vm.outputs = [];
            vm.selectedOutputs= [];
            vm.showFilters = false;
            vm.search = {};
            vm.search.searchName = null;
            vm.startDate = new Date();
            vm.isOpen = false;
        }


        function translateEmployeeArrayToEmployeeNameCommaSeparated(employees) {
            var employeeNames = "";
            for (var i = 0; i < employees.length; i++) {
                employeeNames = employeeNames + employees[i].name;
                if (employees.length - i > 1) employeeNames = employeeNames + ", "
            }
            return employeeNames;
        }

        function populateExtrasToShow() {
            var all = vm.selectedExtras.map(function (e) {
                return e.value;
            });
            vm.activityExtrasToShow = [];
            vm.monitoringSessionExtrasToShow = [];
            all.forEach(function (e) {
                if (e == 'activityDescriptionPerProposal' || e == 'customUnit')
                    vm.activityExtrasToShow.push(e);
                else
                    vm.monitoringSessionExtrasToShow.push(e);
            })

            var params = {
                impactId : vm.selectedImpacts && vm.selectedImpacts.length > 0 ? vm.selectedImpacts[0].id : null,
                outcomeId : vm.selectedOutcomes && vm.selectedOutcomes.length > 0 ? vm.selectedOutcomes[0].id : null,
                outputId : vm.selectedOutputs && vm.selectedOutputs.length > 0 ? vm.selectedOutputs[0].id : null,
                keyword : vm.search.agencyName != null ? vm.search.agencyName.trim() : null,
                year : vm.startDate.getFullYear(),
                activityExtrasToShow : vm.activityExtrasToShow,
                monitoringSessionExtrasToShow : vm.monitoringSessionExtrasToShow
            };

            vm.excelUrl = activityService.getYearlyReportExcelUrl(params);
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.impactReport')
        .controller('ImpactReportCtrl', ['_', 'toastr','$state', 'reportService','projectService',ImpactReportCtrl]);

    /** @ngInject */
    function ImpactReportCtrl(_,toastr,$state, reportService,projectService) {
        var vm = this;

        vm.projects = [];
        vm.selectedProject = [];
        vm.impactList = [];
        vm.selectedImpact = [];
        vm.selectedImpactList = [];
        vm.indicatorList = [];
        vm.monitoringSessionList = [];
        vm.timeToSessionIdListMap = {};
        vm.filteredMonitoringSessionList = [];
        vm.selectedMonitoringSessionTimes = [];
        vm.selectedMonitoringSessionList = [];
        vm.selectedMonitoringSessionIdSet = {};
        vm.dataLoaded = false;

        vm.search = search;
        vm.generateImpacts = generateImpacts;

        init();

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            });
        }

        function generateImpacts() {
            projectService.getAllImpactsOfAProject(vm.selectedProject[0].id).then(function (data) {
                vm.impactList = data;
                //console.log(vm.impactList);
                generateImpactIndicatorList();
                generateMonitoringSessions();
            });
        }

        function generateImpactIndicatorList() {
            vm.indicatorList = vm.impactList.map(function (impact) {return impact.impactIndicators}).flat();
        }

        function generateMonitoringSessions() {
            vm.monitoringSessionList = [];
            var tempMonitoringSessionList = vm.indicatorList.map(function (impactIndicator) {return impactIndicator.impactMonitoringSessions}).flat();
            var monitoringSessionIdSet = new Set();
            tempMonitoringSessionList.forEach(function (session) {
                if(!monitoringSessionIdSet.has(session.id)) vm.monitoringSessionList.push(session);
                monitoringSessionIdSet.add(session.id);
            });
            vm.monitoringSessionList.sort(function (a,b) {return a.timeOfMonitoring - b.timeOfMonitoring});
            var tempMonitoringSessionTimes = Array.from(new Set(vm.monitoringSessionList.map(function (session) {return session.timeOfMonitoringText})));
            vm.filteredMonitoringSessionList = tempMonitoringSessionTimes.map(function (time) {
                return {'name' : time}
            });
            vm.monitoringSessionList.forEach(function (session) {
                var idList = vm.timeToSessionIdListMap[session.timeOfMonitoringText];
                if(idList == null || idList.length === 0) idList = [];
                idList.push(session.id);
                vm.timeToSessionIdListMap[session.timeOfMonitoringText] = idList;
            })
        }

        function search() {
            vm.dataLoaded = false;
            vm.selectedMonitoringSessionIdSet = new Set(vm.selectedMonitoringSessionTimes.map(function (session) {
                return vm.timeToSessionIdListMap[session.name]
            }).flat());
            vm.selectedMonitoringSessionList = vm.monitoringSessionList.filter(function (session) {
                return vm.selectedMonitoringSessionIdSet.has(session.id)
            });
            var selectedImpactIndicatorIdSet = new Set(vm.selectedMonitoringSessionList.map(function (session) {
                return session.impactIndicatorId
            }));
            var selectedImpactIdSet = new Set(vm.indicatorList.filter(function (indicator) {return selectedImpactIndicatorIdSet.has(indicator.id)}).map(function (indicator) {return indicator.impactId}));
            vm.selectedImpactList = vm.impactList.filter(function (impact) {
                return selectedImpactIdSet.has(impact.id)
            });
            vm.selectedImpactList.forEach(function (impact) {
                impact.impactIndicators = impact.impactIndicators.filter(function (indicator) {return selectedImpactIndicatorIdSet.has(indicator.id)});
                impact.impactIndicators.forEach(function (indicator) {indicator.impactMonitoringSessions.sort(function (a,b) {return a.timeOfMonitoring - b.timeOfMonitoring})});
            });
            vm.dataLoaded = true;
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.outcomeReport')
        .controller('OutcomeReportCtrl', ['_', 'toastr','$state', 'reportService','projectService',OutcomeReportCtrl]);

    /** @ngInject */
    function OutcomeReportCtrl(_,toastr,$state, reportService,projectService) {
        var vm = this;

        vm.projects = [];
        vm.selectedProject = [];
        vm.impactList = [];
        vm.selectedImpact = [];
        vm.outcomeList = [];
        vm.selectedOutcome = [];
        vm.selectedOutcomeList = [];
        vm.indicatorList = [];
        vm.monitoringSessionList = [];
        vm.timeToSessionIdListMap = {};
        vm.filteredMonitoringSessionList = [];
        vm.selectedMonitoringSessionTimes = [];
        vm.selectedMonitoringSessionList = [];
        vm.selectedMonitoringSessionIdSet = {};
        vm.dataLoaded = false;

        vm.generateImpacts = generateImpacts;
        vm.generateOutcomes = generateOutcomes;

        vm.search = search;

        init();

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            });
        }

        function generateImpacts() {
            projectService.getAllImpactsOfAProject(vm.selectedProject[0].id).then(function (data) {
                vm.impactList = data;
                vm.outcomeList = vm.impactList.map(function (impact) {return impact.outcomes}).flat();
                generateOutcomeIndicatorList();
                generateMonitoringSessions();
            });
        }

        function generateOutcomes() {
            vm.outcomeList = vm.selectedImpact[0].outcomes.sort(function (a,b) {return a.number.localeCompare(b.number)});
            generateOutcomeIndicatorList();
            generateMonitoringSessions();
        }

        function generateOutcomeIndicatorList() {
            vm.indicatorList = vm.outcomeList.map(function (outcome) {return outcome.outcomeIndicators}).flat();
        }

        function generateMonitoringSessions() {
            vm.monitoringSessionList = [];
            var tempMonitoringSessionList = vm.indicatorList.map(function (outcomeIndicator) {return outcomeIndicator.outcomeMonitoringSessions}).flat();
            var monitoringSessionIdSet = new Set();
            tempMonitoringSessionList.forEach(function (session) {
                if(!monitoringSessionIdSet.has(session.id)) vm.monitoringSessionList.push(session);
                monitoringSessionIdSet.add(session.id);
            });
            vm.monitoringSessionList.sort(function (a,b) {return a.timeOfMonitoring - b.timeOfMonitoring});
            var tempMonitoringSessionTimes = Array.from(new Set(vm.monitoringSessionList.map(function (session) {return session.timeOfMonitoringText})));
            vm.filteredMonitoringSessionList = tempMonitoringSessionTimes.map(function (time) {
                return {'name' : time}
            });
            vm.monitoringSessionList.forEach(function (session) {
                var idList = vm.timeToSessionIdListMap[session.timeOfMonitoringText];
                if(idList == null || idList.length === 0) idList = [];
                idList.push(session.id);
                vm.timeToSessionIdListMap[session.timeOfMonitoringText] = idList;
            });
        }

        function search() {
            vm.dataLoaded = false;
            vm.selectedMonitoringSessionIdSet = new Set(vm.selectedMonitoringSessionTimes.map(function (session) {return vm.timeToSessionIdListMap[session.name]}).flat());
            vm.selectedMonitoringSessionList = vm.monitoringSessionList.filter(function (session) {return vm.selectedMonitoringSessionIdSet.has(session.id)});
            var selectedOutcomeIndicatorIdSet = new Set(vm.selectedMonitoringSessionList.map(function (session) {return session.outcomeIndicatorId}));
            var selectedOutcomeIdSet = new Set(vm.indicatorList.filter(function (indicator) {return selectedOutcomeIndicatorIdSet.has(indicator.id)}).map(function (indicator) {return indicator.outcomeId}));
            vm.selectedOutcomeList = vm.outcomeList.filter(function (outcome) {return selectedOutcomeIdSet.has(outcome.id)});
            vm.selectedOutcomeList.forEach(function (outcome) {
                outcome.outcomeIndicators = outcome.outcomeIndicators.filter(function (indicator) {return selectedOutcomeIndicatorIdSet.has(indicator.id)});
                outcome.outcomeIndicators.forEach(function (indicator) {indicator.outcomeMonitoringSessions.sort(function (a,b) {return a.timeOfMonitoring - b.timeOfMonitoring})});
            });
            vm.dataLoaded = true;
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.generalReport.outputReport')
        .controller('OutputReportCtrl', ['_', 'toastr','$state', 'reportService','projectService', 'outputService', OutputReportCtrl]);

    /** @ngInject */
    function OutputReportCtrl(_,toastr,$state, reportService,projectService,outputService) {
        var vm = this;

        vm.projects = [];
        vm.selectedProject = [];
        vm.impactList = [];
        vm.selectedImpact = [];
        vm.outcomeList = [];
        vm.selectedOutcome = [];
        vm.outputList = [];
        vm.selectedOutputList = [];
        vm.indicatorList = [];
        vm.monitoringSessionList = [];
        vm.timeToSessionIdListMap = {};
        vm.filteredMonitoringSessionList = [];
        vm.selectedMonitoringSessionTimes = [];
        vm.selectedMonitoringSessionList = [];
        vm.selectedMonitoringSessionIdSet = {};
        vm.dataLoaded = false;

        vm.generateImpacts = generateImpacts;
        vm.generateOutcomes = generateOutcomes;
        vm.generateOutputs = generateOutputs;
        vm.search = search;

        init();

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            });
        }

        function generateImpacts() {
            projectService.getAllImpactsOfAProject(vm.selectedProject[0].id).then(function (data) {
                vm.impactList = data;
                vm.outputList = vm.impactList.map(function (impact) {
                    return impact.outcomes;
                }).flat().map(function(outcome) {
                    return outcome.outputs;
                }).flat();
                generateOutputIndicatorList();
                generateMonitoringSessions();
            });
        }

        function generateOutcomes() {
            vm.outcomeList = vm.selectedImpact[0].outcomes.sort(function(a,b) {
                return a.number.localeCompare(b.number)});
            vm.outputList = vm.outcomeList.map(function (outcome) {
                return outcome.outputs;
            }).flat();
            generateOutputIndicatorList();
            generateMonitoringSessions();
        }

        function generateOutputs() {
            vm.outputList = vm.selectedOutcome[0].outputs;
            generateOutputIndicatorList();
            generateMonitoringSessions();
        }

        function generateOutputIndicatorList() {
            vm.indicatorList = vm.outputList.map(function (output) {
                return output.outputIndicators;
            }).flat();
        }

        function generateMonitoringSessions() {
            vm.monitoringSessionList = [];
            var tempMonitoringSessionList = vm.indicatorList.map(function (outputIndicator) {return outputIndicator.outputMonitoringSessions}).flat();
            var monitoringSessionIdSet = new Set();
            tempMonitoringSessionList.forEach(function (session) {
                if(!monitoringSessionIdSet.has(session.id)) vm.monitoringSessionList.push(session);
                monitoringSessionIdSet.add(session.id);
            });
            vm.monitoringSessionList.sort(function (a,b) {
                return a.timeOfMonitoring - b.timeOfMonitoring;
            });
            var tempMonitoringSessionTimes = Array.from(new Set(vm.monitoringSessionList.map(function (session) {
                return session.timeOfMonitoringText;
            })));
            vm.filteredMonitoringSessionList = tempMonitoringSessionTimes.map(function (time) {
                return {'name' : time}
            });
            vm.monitoringSessionList.forEach(function (session) {
                var idList = vm.timeToSessionIdListMap[session.timeOfMonitoringText];
                if(idList == null || idList.length === 0) idList = [];
                idList.push(session.id);
                vm.timeToSessionIdListMap[session.timeOfMonitoringText] = idList;
            });
        }


        function search() {
            vm.dataLoaded = false;
            vm.selectedMonitoringSessionIdSet = new Set(vm.selectedMonitoringSessionTimes.map(function (session) {
                return vm.timeToSessionIdListMap[session.name];
            }).flat());
            vm.selectedMonitoringSessionList = vm.monitoringSessionList.filter(function (session) {
                return vm.selectedMonitoringSessionIdSet.has(session.id)
            });
            var selectedOutputIndicatorIdSet = new Set(vm.selectedMonitoringSessionList.map(function (session) {
                return session.outputIndicatorId
            }));
            var selectedOutputIdSet = new Set(vm.indicatorList.filter(function (indicator) {return selectedOutputIndicatorIdSet.has(indicator.id)}).map(function (indicator) {return indicator.outputId}));
            vm.selectedOutputList = vm.outputList.filter(function (output) {return selectedOutputIdSet.has(output.id)});
            vm.selectedOutputList.forEach(function (output) {
                output.outputIndicators = output.outputIndicators.filter(function (indicator) {return selectedOutputIndicatorIdSet.has(indicator.id)});
                output.outputIndicators.forEach(function (indicator) {indicator.outputMonitoringSessions.sort(function (a,b) {return a.timeOfMonitoring - b.timeOfMonitoring})});
            });
            vm.dataLoaded = true;
        }


    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.impactMonitoring')
        .controller('ImpactMonitoringCtrl', ['_','impactService', 'toastr', ImpactMonitoringCtrl]);

    /** @ngInject */
    function ImpactMonitoringCtrl(_,impactService, toastr) {

        var vm = this;

        vm.impacts = null;

        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
                for(var i = 0 ; i < vm.impacts.length; i++){
                    if(vm.impacts[i] && vm.impacts[i].impactIndicators && vm.impacts[i].impactIndicators.length > 0){
                        for(var j=0; j<vm.impacts[i].impactIndicators.length; j++){
                            if(vm.impacts[i].impactIndicators[j] && vm.impacts[i].impactIndicators[j].impactMonitoringSessions && vm.impacts[i].impactIndicators[j].impactMonitoringSessions.length > 0){
                                vm.impacts[i].isValid = true;
                            }
                        }
                    }
                }
            })
        }

        init();
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.activityMonitoring')
        .controller('ActivityMonitoringCtrl', ['_', 'projectService', 'impactService', 'toastr', ActivityMonitoringCtrl]);

    /** @ngInject */
    function ActivityMonitoringCtrl(_, projectService, impactService, toastr) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.multiselectOutcomes = [];
        vm.multiSelectOutputs = [];
        vm.selectedImpacts = [];
        vm.selectedOutcomes = [];
        vm.selectedOutputs = [];
        vm.outputsToShow = [];
        vm.allOutputs = [];
        vm.showFilters = false;
        vm.search = {};
        vm.search.searchNam = "";
        vm.search.agencyName = "";
        var allImpacts = [];
        vm.format = 'MMM yyyy';
        vm.startDate = null;
        vm.endDate = null;
        vm.isStartDatePickerOpen = false;
        vm.isEndDatePickerOpen = false;

        vm.mapOutcomes = mapOutcomes;
        vm.mapOutputs = mapOutputs;
        vm.searchActivities = searchActivities;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;
        // vm.openCalendar = openCalendar;
        vm.openStartDatePicker = openStartDatePicker;
        vm.openEndDatePicker = openEndDatePicker;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                vm.impacts.forEach(function (impact) {
                    impact.outcomes.forEach(function (outcome) {
                        outcome.outputs.forEach(function (output) {
                            if (output.activities.length != 0) vm.outputsToShow.push(output);
                        })
                    });
                });
                vm.allOutputs = angular.copy(vm.outputsToShow);
            });
        };

        init();

        function mapOutcomes() {
            if (vm.selectedImpacts.length === 0) {
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.multiselectOutcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.multiselectOutcomes = _.flatten(vm.multiselectOutcomes);
            vm.multiselectOutcomes = vm.multiselectOutcomes.filter(function (outcomes) {
                return outcomes.outputs != null && outcomes.outputs.length > 0;
            })
        }

        function openStartDatePicker(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isStartDatePickerOpen = true;
        }

        function openEndDatePicker(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isEndDatePickerOpen = true;
        }

        function mapOutputs() {
            vm.multiSelectOutputs = vm.selectedOutcomes.map(function (outcome) {
                if (outcome.outputs != null && outcome.outputs.length > 0) {
                    return outcome.outputs;
                }

            });
            vm.multiSelectOutputs = _.flatten(vm.multiSelectOutputs);
            vm.multiSelectOutputs = vm.multiSelectOutputs.filter(function (o) {
                return o.activities != null && o.activities.length > 0;
            });
        }


        function mapImpactsToMultiSelectFormat(impact) {
            return {
                id: impact,
                number: impact.number,
                outcomes: impact.outcomes
            }
        }

        function filterImpactsDisplayValues() {
            if (vm.selectedProjects.length == 0) {
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            } else {
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        vm.searchAgencyName = searchAgencyName

        function searchAgencyName() {
            var temp = []
            vm.outputsToShow.forEach(function (output) {
                var activities = output.activities.filter(function (activity) {
                    return activity.responsibleAgency.toLowerCase().includes(vm.search.agencyName.toLowerCase())
                })
                if (activities.length !== 0) {
                    temp.push(output)
                }
            })
            vm.outputsToShow = angular.copy(temp);
        }


        function searchActivities() {
            if (vm.selectedImpacts.length > 0 && vm.selectedOutcomes.length === 0 && vm.selectedOutputs.length === 0) {
                vm.outputsToShow = [];
                var tempOutput = [];
                vm.selectedImpacts.forEach(function (impact) {
                    if (impact.outcomes != null && impact.outcomes.length > 0) {
                        impact.outcomes.forEach(function (outcome) {
                            if (outcome.outputs != null && outcome.outputs.length > 0) {
                                outcome.outputs.forEach(function (output) {
                                    if (output.activities != null && output.activities.length > 0)
                                        tempOutput.push(angular.copy(output))
                                });
                            }
                        });
                    }
                });
                vm.outputsToShow = angular.copy(angular.copy(tempOutput))
            } else if (vm.selectedImpacts.length > 0 && vm.selectedOutcomes.length > 0 && vm.selectedOutputs.length === 0) {
                vm.outputsToShow = [];
                var tempOutput = [];
                vm.selectedOutcomes.forEach(function (outcome) {
                    if (outcome.outputs != null && outcome.outputs.length > 0) {
                        outcome.outputs.forEach(function (output) {
                            if (output.activities != null && output.activities.length > 0)
                                tempOutput.push(angular.copy(output))
                        })
                    }
                })
                vm.outputsToShow = angular.copy(angular.copy(tempOutput))
            } else if(vm.selectedOutputs.length > 0) {
                vm.outputsToShow = angular.copy(vm.selectedOutputs);
            } else {
                vm.outputsToShow = angular.copy(vm.allOutputs);
            }
            if (vm.search.searchName !== "" && vm.search.searchName != null) {
                var temp = vm.outputsToShow.filter(function (output) {
                    if (output.summary.toLowerCase().includes(vm.search.searchName.toLowerCase())) {
                        return output.summary.toLowerCase().includes(vm.search.searchName.toLowerCase());
                    } else {
                        output.activities = output.activities.filter(function (activity) {
                            return activity.responsibleAgency.includes(vm.search.searchName)
                        })
                        if (output.activities.length != 0) {
                            return true;
                        }
                        return false;
                        //return output
                    }
                })
                vm.outputsToShow = angular.copy(temp);
            }
            if (vm.startDate != null) {
                var temp = vm.outputsToShow.filter(function (output) {
                    output.activities = output.activities.filter(function (activity) {
                        return activity.startDate >= vm.startDate.getTime();
                    });
                    if (output.activities.length != 0) {
                        return true;
                    }
                    return false;

                });

                vm.outputsToShow = angular.copy(temp);
            }

            if (vm.endDate != null) {
                var endDateInMillis = new Date(vm.endDate.getFullYear(), vm.endDate.getMonth() + 1, 0).getTime();
                var temp = vm.outputsToShow.filter(function (output) {
                    output.activities = output.activities.filter(function (activity) {
                        return activity.endDate <= endDateInMillis;
                    });
                    if (output.activities.length != 0) {
                        return true;
                    }
                    return false;

                });

                vm.outputsToShow = angular.copy(temp);
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outcomeMonitoring')
        .controller('OutcomeMonitoringCtrl', ['_','projectService','impactService','outcomeService', 'toastr', OutcomeMonitoringCtrl]);

    /** @ngInject */
    function OutcomeMonitoringCtrl(_,projectService,impactService,outcomeService,  toastr) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.allOutcomes = [];
        vm.filteredImpacts = [];
        vm.selectedOutcomes = [];
        vm.showFilters = false;
        var allImpacts = [];

        vm.filterImpacts = filterImpacts;
        vm.isOutcomeValidForMonitoring = isOutcomeValidForMonitoring;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                vm.filteredImpacts = data;
            });
            outcomeService.getAllOutcomes().then(function (data) {
                vm.allOutcomes = data;
                vm.selectedOutcomes = vm.allOutcomes;
            });
        }

        init();

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }


        function filterImpacts() {
            if(!vm.selectedImpacts || !vm.selectedImpacts.length) vm.selectedOutcomes = vm.allOutcomes;
            outcomeService.getAllOutcomesByFilter(vm.selectedImpacts.map(function (impact) {
                return impact.id;
            })).then(function (responseData) {
                vm.selectedOutcomes = responseData;
            });
        }

        function isOutcomeValidForMonitoring(outcome) {
            if(outcome && outcome.outcomeIndicators && outcome.outcomeIndicators.length > 0){
                for(var i=0; i<outcome.outcomeIndicators.length; i++){
                    if(outcome.outcomeIndicators[i] && outcome.outcomeIndicators[i].outcomeMonitoringSessions && outcome.outcomeIndicators[i].outcomeMonitoringSessions.length > 0){
                        return true;
                    }
                }
            }
            return false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outputMonitoring')
        .controller('OutputMonitoringCtrl', ['_','projectService','impactService', 'toastr', OutputMonitoringCtrl]);

    /** @ngInject */
    function OutputMonitoringCtrl(_,projectService,impactService, toastr) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.impacts = [];
        vm.selectedImpacts = [];
        vm.outcomes = null;
        vm.selectedOutcomes = [];
        vm.allOutputs = [];
        vm.selectedOutputs = [];
        vm.showFilters = false;
        var allImpacts = [];

        vm.mapOutcomes = mapOutcomes;
        vm.searchOutputs = searchOutputs;
        vm.isOutputValidForMonitoring = isOutputValidForMonitoring;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                for(var i = 0; i< vm.impacts.length;i++){
                    for(var j=0; j<vm.impacts[i].outcomes.length;j++){
                        vm.impacts[i].outcomes[j].impact = {};
                        vm.impacts[i].outcomes[j].impact.id = vm.impacts[i].id;
                        vm.impacts[i].outcomes[j].impact.number = vm.impacts[i].number;
                        vm.impacts[i].outcomes[j].impact.summary = vm.impacts[i].summary;
                        for(var k=0; k< vm.impacts[i].outcomes[j].outputs.length; k++){
                            vm.impacts[i].outcomes[j].outputs[k].outcome = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.id = vm.impacts[i].outcomes[j].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.number = vm.impacts[i].outcomes[j].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.summary = vm.impacts[i].outcomes[j].summary;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.id = vm.impacts[i].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.number = vm.impacts[i].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.summary = vm.impacts[i].summary;
                        }
                    }
                }
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            });
        }

        function openDataCollectionModal(output) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/dataCollection/outputData/dataCollectionModal/outputDataCollection.modal.html',
                size:'lg',
                controller : 'OutputDataCollectionModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'output': function () {
                        return output;
                    }
                }
            }).result.then(function(data) {
                vm.outcomes = data;
                toastr.success("Data collected.");
            });
        }

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function isOutputValidForMonitoring(output) {
            if(output && output.outputIndicators && output.outputIndicators.length > 0){
                for(var i = 0; i < output.outputIndicators.length; i++){
                    if(output.outputIndicators[i] && output.outputIndicators[i].outputMonitoringSessions && output.outputIndicators[i].outputMonitoringSessions.length > 0) return true;
                }
            }
            return false;
        }

        function getActiveOutputsFromImpacts(impactList) {
            var outputList = [];
            impactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function getActiveOutputsFromMultiSelectImpacts(multiselectImpactList) {
            var outputList = [];
            multiselectImpactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function getActiveOutputsFromMultiSelectOutcomes(multiselectOutcomeList) {
            var outputList = [];
            multiselectOutcomeList.forEach(function (outcome) {
                outcome.outputs.forEach(function (output) {
                    if (output.status === 1) {
                        outputList.push(output);
                    }
                })
            });
            return outputList;
        }

        init();

        function mapOutcomes() {
            vm.outcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.outcomes = _.flatten(vm.outcomes);
        }

        function searchOutputs() {
            if (vm.selectedImpacts && vm.selectedImpacts.length>0 && (!vm.selectedOutcomes || vm.selectedOutcomes.length === 0)) {
                vm.allOutputs = getActiveOutputsFromMultiSelectImpacts(vm.selectedImpacts);
            } else if (vm.selectedOutcomes && vm.selectedOutcomes.length>0) {
                vm.allOutputs = getActiveOutputsFromMultiSelectOutcomes(vm.selectedOutcomes);
            } else {
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup');
    app.controller('OutputCreateModalCtrl',['outputService','toastr','$uibModalInstance','outcomeId', OutputCreateModalCtrl]);

    /** @ngInject */
    function OutputCreateModalCtrl(outputService,toastr,$uibModalInstance,outcomeId) {

        var vm = this;

        vm.number = null;
        vm.summary = null;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;

        vm.createOutcome = createOutcome;

        function init() {
            vm.outcomeId = outcomeId;
            console.log(vm.outcomeId);
        }
        init();
        function createOutcome() {
            var data = {
                summary : vm.summary,
                number : vm.number,
                outcomeId: vm.outcomeId,
                indicators:[{
                    indicator:vm.indicator,
                    meansOfVerification: vm.meansOfVerification,
                    assumption: vm.assumption
                }]
            };
            outputService.createOutput(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create outcome ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeDetails')
        .controller('EditOutcomeSummaryModalCtrl', [ '$uibModalInstance','outcomeService','toastr','outcome', EditOutcomeSummaryModalCtrl]);

    /** @ngInject */
    function EditOutcomeSummaryModalCtrl($uibModalInstance,outcomeService,toastr,outcome) {

        var vm = this;

        vm.outcome = null;

        vm.updateSummary = updateSummary;

        function init() {
            vm.outcome = angular.copy(outcome);
        }

        function updateSummary() {
            var data = {
                summary:vm.outcome.summary,
                number : vm.outcome.number
            };

            outcomeService.editSummary(vm.outcome.id,data).then(function (data) {
                $uibModalInstance.close(data);
            },function () {
                toastr.error("Could not update summary")
            })

        }

        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeDetails')
        .controller('OutcomeEditModalCtrl', [ '$uibModalInstance','outcomeService','toastr','indicator','type', OutcomeEditModalCtrl]);

    /** @ngInject */
    function OutcomeEditModalCtrl($uibModalInstance,outcomeService,toastr,indicator,type) {

        var vm = this;

        vm.type = null;
        vm.indicator = null;

        vm.updateIndicator = updateIndicator;

        function init() {
            vm.type = type;
            vm.indicator = angular.copy(indicator);
        }

        function updateIndicator() {
            var data = {
                indicator:{
                    indicator:vm.indicator.indicator,
                    meansOfVerification:vm.indicator.meansOfVerification,
                    assumption: vm.indicator.assumption
                },
                researchFramework:{
                    informationRequired:vm.indicator.informationRequired,
                    sourceOfInfo:vm.indicator.sourceOfInfo,
                    dataCollectionMethod:vm.indicator.dataCollectionMethod,
                    respondents:vm.indicator.respondents,
                    frequency:vm.indicator.frequency,
                    place:vm.indicator.place,
                    timeOfDataCollection:vm.indicator.timeOfDataCollection,
                    actualStatus:vm.indicator.actualStatus,
                    commentsFromSupervisor:vm.indicator.commentsFromSupervisor
                },
                monitoringFramework:{
                    deviation:vm.indicator.deviation,
                    causality:vm.indicator.causality,
                    recommendation:vm.indicator.recommendation,
                    reflectionInFuturePlan:vm.indicator.reflectionInFuturePlan,
                }

            };
            outcomeService.updateOutcomeIndicator(vm.indicator.id,data).then(function (data) {
                $uibModalInstance.close(data);
                console.log(JSON.stringify(data))
            },function () {
                toastr.error("Could not update");
            })
        }
        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputDetails');
    app.controller('ActivityCreateModalCtrl',['activityService','toastr','$uibModalInstance','outputId', ActivityCreateModalCtrl]);

    /** @ngInject */
    function ActivityCreateModalCtrl(activityService,toastr,$uibModalInstance,outputId) {

        var vm = this;

        vm.summary = null;
        vm.number = null;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.isOpen = null;
        vm.time = null;

        vm.createActivity = createActivity;
        vm.openCalendar = openCalendar;

        function init() {
            vm.outputId = outputId;
            vm.isOpen = false;
            vm.time = new Date();

        }
        init();
        function createActivity() {
            var data = {
                summary : vm.summary,
                outputId: vm.outputId,
                number : vm.number,
                indicators:[{
                    indicator:vm.indicator,
                    meansOfVerification: vm.meansOfVerification,
                    assumption: vm.assumption
                }],
                time : vm.time.getTime()
            };
            activityService.createActivity(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create activity ");
            })
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }


    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputDetails');
    app.controller('OutputIndicatorCreateCtrl',['outputService','toastr','$stateParams','$state', 'timeInterval', OutputIndicatorCreateCtrl]);

    /** @ngInject */
    function OutputIndicatorCreateCtrl(outputService,toastr,$stateParams,$state,timeInterval) {

        var vm = this;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.isQuantitative = false;
        vm.unit = null;
        vm.timeLines = null;
        vm.startDate = null;
        vm.isOpen = false;
        vm.format = null;
        vm.timeLines = null;
        vm.intervals = null;
        vm.selectedTimeLine = null;
        vm.selectedInterval = null;
        vm.intervalsToBeShown = null;
        vm.typeOptions = null;
        vm.type = null;
        vm.baseline = null;
        vm.rowsToCreate = null;
        vm.tableData = [];

        vm.openCalendar = openCalendar;
        vm.selectInterval = selectInterval;
        vm.createTableData = createTableData;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;
        vm.createOutputIndicator = createOutputIndicator;

        function init() {
            vm.startDate = new Date();
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
            vm.type = 1;
            vm.timeLines = [
                'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];
            vm.typeOptions = [{
                name:"Qualitative",
                value:0
            },{
                name:"Quantitative",
                value:1
            }];
            vm.intervals = timeInterval;
        }
        init();

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }



        function selectInterval () {
            if(vm.selectedTimeLine !== 'Immediate'){
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
        }

        function createTableData() {
            if(vm.type === null)
                return toastr.error("Please select Indicator type to edit");
            if(vm.selectedTimeLine === 'Immediate') {
                vm.tableData = [];
                vm.tableData.push({
                    "timeOfMonitoring" : angular.copy(vm.startDate),
                    "targetAchieved" : (vm.type === 1 && vm.baseline !== '') ? vm.baseline : '',
                    "target" : (vm.type === 1 && vm.baseline !== '')? '': '',
                    'assumption' : ' ',
                    'isOpen' : false
                });
                return;
            }
            var rowsToCreate = (parseInt(vm.intervals[vm.selectedTimeLine].value))/parseInt(vm.selectedInterval.value);
            console.log('ROWS TO CREATE ' + rowsToCreate);
            vm.tableData = [];
            for(var i = 0 ;i < rowsToCreate;i++){
                vm.tableData.push({
                    "timeOfMonitoring" : moment(vm.startDate).add(i * vm.selectedInterval.value,'M').toDate(),
                    "targetAchieved" : (vm.type === 1 && vm.baseline !== '') ? vm.baseline : '',
                    "target" : (vm.type === 1 && vm.baseline !== '')? '': '',
                    'assumption' : ' ',
                    'isOpen' : false
                })
            }
        }

        function createOutputIndicator() {
            console.log("I am in create output Indicator CTRL");
            var monitoringData = angular.copy(vm.tableData);
            monitoringData = monitoringData.map( function (data) {
                data.timeOfMonitoring = data.timeOfMonitoring.getTime();
                data.target = data.target.toString();
                data.targetAchieved = data.targetAchieved.toString();
                return data;
            });
            var data = {
                "indicator" : vm.indicator,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : '' + vm.baseline,
                "unit"      : vm.unit,
                "timeline"  : vm.intervals[vm.selectedTimeLine].value,
                "interval"  : vm.selectedInterval.value,
                "type"      : vm.type,
                "outputMonitoringSessions" : monitoringData
            };
            outputService.createOutputIndicator($stateParams.id,data).then(function () {
                toastr.success("Indicator created");
                $state.go('outputDetails',{id:$stateParams.id});
            },function () {
                toastr.error("Could not create indicator");
            });
        }

        function getUnitString() {
            return "( " + vm.unit +" )";
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputDetails')
        .controller('EditOutputSummaryModalCtrl', [ '$uibModalInstance','outputService','toastr','output', EditOutputSummaryModalCtrl]);

    /** @ngInject */
    function EditOutputSummaryModalCtrl($uibModalInstance,outputService,toastr,output) {

        var vm = this;

        vm.output = null;

        vm.updateSummary = updateSummary;

        function init() {
            vm.output = angular.copy(output);
        }

        function updateSummary() {
            var data = {
                summary:vm.output.summary,
                number : vm.output.number
            };
            outputService.editSummary(vm.output.id,data).then(function (data) {
                $uibModalInstance.close(data);
            },function () {
                toastr.error("Could not update summary")
            })
        }

        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup')
        .controller('OutputIndicatorEditModalCtrl', [ '$uibModalInstance','outputService','toastr','indicator','type', OutputIndicatorEditModalCtrl]);

    /** @ngInject */
    function OutputIndicatorEditModalCtrl($uibModalInstance,outputService,toastr,indicator,type) {

        var vm = this;

        vm.type = null;
        vm.indicator = null;

        vm.updateIndicator = updateIndicator;

        function init() {
            console.log(type);
            vm.type = type;
            vm.indicator = angular.copy(indicator);
        }

        function updateIndicator() {
           var data = {
               indicator:{
                    indicator:vm.indicator.indicator,
                    meansOfVerification:vm.indicator.meansOfVerification,
                    assumption: vm.indicator.assumption
                },
               researchFramework:{
                    informationRequired:vm.indicator.informationRequired,
                    sourceOfInfo:vm.indicator.sourceOfInfo,
                    dataCollectionMethod:vm.indicator.dataCollectionMethod,
                    respondents:vm.indicator.respondents,
                    frequency:vm.indicator.frequency,
                    place:vm.indicator.place,
                    timeOfDataCollection:vm.indicator.timeOfDataCollection,
                    actualStatus:vm.indicator.actualStatus,
                    commentsFromSupervisor:vm.indicator.commentsFromSupervisor
               },
               monitoringFramework:{
                   deviation:vm.indicator.deviation,
                   causality:vm.indicator.causality,
                   recommendation:vm.indicator.recommendation,
                   reflectionInFuturePlan:vm.indicator.reflectionInFuturePlan,
               }

           };
            outputService.updateOutputIndicator(indicator.id,data).then(function (data) {
                $uibModalInstance.close(data);
           },function () {
               toastr.error("Could not update indicator");
           })
        }
        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfileInfoCtrl', [ProfileInfoCtrl]);

    /** @ngInject */
    function ProfileInfoCtrl() {

    }

})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.projects')
      .controller('ProjectCreateModalCtrl',
          ['projectService','toastr','$uibModalInstance', ProjectCreateModalCtrl]);

  /** @ngInject */
  function ProjectCreateModalCtrl(projectService,toastr,$uibModalInstance) {

      var vm = this;

      vm.createProject = createProject;

      vm.name = null;
      vm.country = null;

      function createProject() {
          if(!vm.name) return toastr.error('Name cannot be empty');
          projectService.createProject({
              name : vm.name,
              country : vm.country
          }).then(function (responseData) {
              $uibModalInstance.close(responseData);
          },function () {
              toastr.error("Could not create project");
          })
      }

  }

})();

(function () {
  'use strict';
  angular
      .module('NGOMonitoringClientApp.pages.main.projects')
      .controller('ProjectEditModalCtrl',
          ['projectService','toastr','$uibModalInstance','projectId','project', ProjectEditModalCtrl]);

  /** @ngInject */
  function ProjectEditModalCtrl(projectService,toastr,$uibModalInstance,projectId,project) {

      var vm = this;

      vm.updateProjectName = updateProjectName;

      vm.name = project.name;
      vm.country = project.country;

      function updateProjectName() {
          if(!vm.name) return toastr.error('Name cannot be empty');
          projectService.updateNameOfProject(projectId, {
              name : vm.name,
              country : vm.country
          }).then(function (responseData) {
              $uibModalInstance.close(responseData);
          },function () {
              toastr.error("Could not update project name");
          })
      }

  }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.setup.activity')
        .controller('ActivityCtrl', ['_','projectService','impactService', 'activityService', 'toastr', '$uibModal', ActivityCtrl]);

    /** @ngInject */
    function ActivityCtrl(_,projectService,impactService, activityService, toastr, $uibModal) {

        var vm = this;

        vm.projects = null;
        vm.selectedProjects = [];
        vm.activityList = [];
        vm.impacts = [];
        vm.selectedImpacts = [];
        vm.outcomes = [];
        vm.selectedOutcomes = [];
        vm.outputs = [];
        vm.selectedOutputs= [];
        vm.showFilters = false;
        vm.search = {};
        vm.search.searchName = null;
        vm.format = 'MMM yyyy';
        vm.startDate = null;
        vm.isOpen = false;
        vm.isResponsePending=false;
        vm.deletingImpact=null;
        var allImpacts = [];

        vm.generateOutcomes = generateOutcomes;
        vm.generateOutputs = generateOutputs;
        vm.search = search;
        vm.openCalendar = openCalendar;
        vm.openCreateActivityModal = openCreateActivityModal;
        vm.openEditModal = openEditModal;
        vm.deleteactivity = deleteactivity;
        vm.convertMillisToDate = convertMillisToDate;
        vm.translateEmployeeArrayToEmployeeNameCommaSeparated = translateEmployeeArrayToEmployeeNameCommaSeparated;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            activityService.getAllActivities().then(function (data) {
                vm.activityList = data;
            });

            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
            });
        };

        init();

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function generateOutcomes() {
            if(vm.selectedImpacts.length === 0){
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.outcomes = vm.selectedImpacts[0].outcomes;
        }

        function generateOutputs() {
            if(vm.selectedOutcomes.length === 0){
                vm.selectedOutputs = [];
                return;
            }
            vm.outputs = vm.selectedOutcomes[0].outputs;
        }
        
        function search() {
            var impactId = vm.selectedImpacts && vm.selectedImpacts.length > 0 ? vm.selectedImpacts[0].id : null
            var outcomeId = vm.selectedOutcomes && vm.selectedOutcomes.length > 0 ? vm.selectedOutcomes[0].id : null
            var outputId = vm.selectedOutputs && vm.selectedOutputs.length > 0 ? vm.selectedOutputs[0].id : null
            activityService.getByFilter(impactId, outcomeId, outputId, vm.search.searchName, vm.startDate ? vm.startDate.getTime() : null).then(function (data) {
                vm.activityList = data;
            })
        }

        function convertMillisToDate(millis){
            return moment(millis).format("MMM YYYY");
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCreateActivityModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/activity/createModal/createActivity.modal.html',
                size:'lg',
                controller : 'CreateActivityModalCtrl',
                controllerAs : "vm",
                resolve : {
                    impacts:function () {
                        return vm.impacts;
                    }
                }
            }).result.then(function(data) {
                vm.activityList = data;
                resetFilters();
                toastr.success("Major Activity Created Successfully");
            });
        }

        function resetFilters() {
            vm.selectedImpacts = [];
            vm.outcomes = [];
            vm.selectedOutcomes = [];
            vm.outputs = [];
            vm.selectedOutputs= [];
            vm.showFilters = false;
            vm.search = {};
            vm.search.searchName = null;
            vm.startDate = null;
            vm.isOpen = false;
        }

        function openEditModal(activity) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/activity/editModal/editactivity.modal.html',
                size:'lg',
                controller : 'EditactivityModalCtrl',
                controllerAs : "vm",
                resolve : {
                    'impacts': function () {
                        return vm.impacts;
                    },
                    'activity': function () {
                        return activity;
                    }
                }
            }).result.then(function(data) {
                vm.activityList = data;
                resetFilters();
                toastr.success("Major Activity Created Successfully");
            });
        }

        function deleteactivity(activity) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/activity/deleteModal/delete.modal.html',
                size:'sm',
            }).result.then(function () {
                vm.isResponsePending=true;
                vm.deletingImpact=activity.id;
                activityService.delete(activity.id).then(function (data) {
                    vm.activityList = data;
                    vm.isResponsePending=false;
                    vm.deletingImpact=null;
                    resetFilters();
                    toastr.success("Major Activity deleted Successfully");
                },function () {
                    toastr.error("Could not delete major activity ");
                })
            });
        }

        function translateEmployeeArrayToEmployeeNameCommaSeparated(employees){
            var employeeNames = "";
            for(var i =0; i< employees.length;i++){
                employeeNames = employeeNames + employees[i].name;
                if(employees.length - i > 1) employeeNames = employeeNames + ", "
            }
            return employeeNames;
        }
    }
})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.dataCollection.impactData');
    app.controller('ImpactDataCollectionModalCtrl',['impactService','toastr','$uibModalInstance', 'impact', ImpactDataCollectionModalCtrl]);

    /** @ngInject */
    function ImpactDataCollectionModalCtrl(impactService,toastr,$uibModalInstance, impact) {

        var vm = this;
        vm.impact = impact;
        vm.selectedIndicator = [];
        vm.selectedMonitoringSession = [];
        vm.impactMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.save = save;

        function mapIndicators() {
            vm.impactMonitoringSessions = [];
            var selectedIndicatorId = vm.selectedIndicator[0].id;
            for(var i = 0; i< vm.impact.impactIndicators.length; i++){
                if(vm.impact.impactIndicators[i].id === selectedIndicatorId){
                    vm.indicator = vm.impact.impactIndicators[i];
                    vm.impactMonitoringSessions = vm.impact.impactIndicators[i].impactMonitoringSessions;
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var selectedMonitoringSessionId = vm.selectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.impactMonitoringSessions.length; i++){
                if(vm.indicator.impactMonitoringSessions[i].id === selectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.impactMonitoringSessions[i].target = Number(vm.indicator.impactMonitoringSessions[i].target);
                        if(vm.indicator.impactMonitoringSessions[i].achieved) vm.indicator.impactMonitoringSessions[i].achieved = Number(vm.indicator.impactMonitoringSessions[i].achieved);
                    }
                    vm.monitoringSession = vm.indicator.impactMonitoringSessions[i];
                    break;
                }
            }
        }

        function save() {
            var data = {
                achieved : vm.monitoringSession.achieved,
            };
            impactService.impactDataCollection(vm.monitoringSession.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create impact ");
            })
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.dataCollection.activityData')
        .controller('ActivityDataCollectionCtrl', ['_','activityService', '$stateParams', 'toastr', ActivityDataCollectionCtrl]);

    /** @ngInject */
    function ActivityDataCollectionCtrl(_,activityService,$stateParams, toastr) {

        var vm = this;

        vm.activity = null;
        vm.monitoringSessions = [];
        vm.selectedMonitoringSession = [];

        vm.activityDescription = null;
        vm.achievedInUnit = null;
        vm.achievedEvent = null;
        vm.achievedMale = null;
        vm.achievedFemale = null;
        vm.maleParticipants = null;
        vm.maleBeneficiary = null;
        vm.femaleBeneficiary = null;
        vm.femaleParticipants = null;
        vm.budgetSpent = null;
        vm.achievedUnitEnabled = false;


        vm.setupMonitoringSessionForDataCollection = setupMonitoringSessionForDataCollection;
        vm.performDataCollection = performDataCollection;
        vm.getDeviation = getDeviation;

        function init() {
            activityService.getActivityById($stateParams.id).then(function (data) {
                vm.activity = data;
                vm.monitoringSessions  = angular.copy(vm.activity.activityMonitoringSessions);
                prepareMonitoringSessions();
            })
        }

        function getDeviation(a,b){
            return Math.abs(a-b);
        }

        function prepareMonitoringSessions() {
            vm.monitoringSessions = vm.monitoringSessions.map(function (m) {
                var readableDate = new moment(m.timeOfMonitoring).format('YYYY MMMM');
                m.readableDate = readableDate;
                return m;
            })
            vm.monitoringSessions = _.orderBy(vm.monitoringSessions,'timeOfMonitoring');
            vm.selectedMonitoringSession = [];
        }

        function setupMonitoringSessionForDataCollection() {
            console.log(vm.selectedMonitoringSession);
            vm.activityDescription = vm.selectedMonitoringSession[0].activityDescription;
            vm.achievedInUnit = vm.selectedMonitoringSession[0].achievedUnit;
            vm.achievedEvent = vm.selectedMonitoringSession[0].achievedEvent;
            vm.achievedMale = vm.selectedMonitoringSession[0].achievedMale;
            vm.achievedFemale = vm.selectedMonitoringSession[0].achievedFemale;
            vm.maleParticipants = vm.selectedMonitoringSession[0].maleParticipants;
            vm.femaleParticipants = vm.selectedMonitoringSession[0].femaleParticipants;
            vm.budgetSpent = vm.selectedMonitoringSession[0].spentBudget;
        }

        function performDataCollection() {
            var data = {
                activityDescription          : vm.activityDescription,
                achievedInUnit               : vm.achievedInUnit ? Number(vm.achievedInUnit) : null,
                achievedEvent                : Number(vm.achievedEvent),
                achievedMale                 : Number(vm.achievedMale),
                achievedFemale               : Number(vm.achievedFemale),
                budgetSpent                  : Number(vm.budgetSpent),
            }
            activityService.performDataCollection(vm.selectedMonitoringSession[0].id,data).then(function (data) {
                toastr.success('Data collection successful');
                var id  = vm.selectedMonitoringSession[0].id;
                vm.monitoringSessions = data;
                prepareMonitoringSessions();
                tickPreviouslySelectedMonitoringSession(id);
            },function (error) {
                toastr.error('Could not perform data collection');
            })
        }

        function tickPreviouslySelectedMonitoringSession(id) {
            for(var i = 0; i < vm.monitoringSessions.length ; i++){
                if( vm.monitoringSessions[i].id == id){
                    vm.monitoringSessions[i].ticked = true;
                    vm.selectedMonitoringSession.push(vm.monitoringSessions[i]);
                }
            }
        }
        init();
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.dataCollection.outcomeData');
    app.controller('OutcomeDataCollectionModalCtrl',['outcomeService','toastr','$uibModalInstance', 'outcome', OutcomeDataCollectionModalCtrl]);

    /** @ngInject */
    function OutcomeDataCollectionModalCtrl(outcomeService,toastr,$uibModalInstance, outcome) {

        var vm = this;
        vm.outcome = outcome;
        vm.selectedIndicator = [];
        vm.selectedMonitoringSession = [];
        vm.outcomeMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.save = save;

        function mapIndicators() {
            vm.outcomeMonitoringSessions = [];
            var selectedIndicatorId = vm.selectedIndicator[0].id;
            for(var i = 0; i< vm.outcome.outcomeIndicators.length; i++){
                if(vm.outcome.outcomeIndicators[i].id === selectedIndicatorId){
                    vm.indicator = vm.outcome.outcomeIndicators[i];
                    vm.outcomeMonitoringSessions = vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions;
                    console.log(JSON.stringify(vm.outcomeMonitoringSessions));
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var selectedMonitoringSessionId = vm.selectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.outcomeMonitoringSessions.length; i++){
                if(vm.indicator.outcomeMonitoringSessions[i].id === selectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.outcomeMonitoringSessions[i].target = Number(vm.indicator.outcomeMonitoringSessions[i].target);
                        if(vm.indicator.outcomeMonitoringSessions[i].achieved) vm.indicator.outcomeMonitoringSessions[i].achieved = Number(vm.indicator.outcomeMonitoringSessions[i].achieved);
                    }
                    vm.monitoringSession = vm.indicator.outcomeMonitoringSessions[i];
                    break;
                }
            }
        }

        function save() {
            var data = {
                achieved : vm.monitoringSession.achieved,
            };
            outcomeService.outcomeDataCollection(vm.monitoringSession.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not insert Data ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.dataCollection.outputData');
    app.controller('OutputDataCollectionModalCtrl',['outputService','toastr','$uibModalInstance', 'output', OutputDataCollectionModalCtrl]);

    /** @ngInject */
    function OutputDataCollectionModalCtrl(outputService,toastr,$uibModalInstance, output) {

        var vm = this;
        vm.output = output;
        vm.selectedIndicator = [];
        vm.selectedMonitoringSession = [];
        vm.outputMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.save = save;

        function mapIndicators() {
            vm.outputMonitoringSessions = [];
            var selectedIndicatorId = vm.selectedIndicator[0].id;
            for(var i = 0; i< vm.output.outputIndicators.length; i++){
                if(vm.output.outputIndicators[i].id === selectedIndicatorId){
                    vm.indicator = vm.output.outputIndicators[i];
                    vm.outputMonitoringSessions = vm.output.outputIndicators[i].outputMonitoringSessions;
                    console.log(JSON.stringify(vm.outputMonitoringSessions));
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var selectedMonitoringSessionId = vm.selectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.outputMonitoringSessions.length; i++){
                if(vm.indicator.outputMonitoringSessions[i].id === selectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.outputMonitoringSessions[i].target = Number(vm.indicator.outputMonitoringSessions[i].target);
                        if(vm.indicator.outputMonitoringSessions[i].achieved) vm.indicator.outputMonitoringSessions[i].achieved = Number(vm.indicator.outputMonitoringSessions[i].achieved);
                    }
                    vm.monitoringSession = vm.indicator.outputMonitoringSessions[i];
                    break;
                }
            }
        }

        function save() {
            var data = {
                achieved : vm.monitoringSession.achieved,
            };
            outputService.outputDataCollection(vm.monitoringSession.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not insert Data ");
            })
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.impactMonitoring')
        .controller('ImpactMonitoringDetailsCtrl', ['$stateParams', '_','impactService', 'toastr', '$uibModal', ImpactMonitoringDetailsCtrl]);

    /** @ngInject */
    function ImpactMonitoringDetailsCtrl($stateParams, _,impactService, toastr,$uibModal) {

        var vm = this;

        vm.impactId = null;
        vm.impact = null;
        vm.multiselectSelectedIndicator = [];
        vm.multiselectSelectedMonitoringSession = [];
        vm.impactMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.openEditMonitoringFeedbackModal = openEditMonitoringFeedbackModal;

        function init() {
            vm.impactId = $stateParams.id;
            impactService.getImpact(vm.impactId).then(function (data) {
                vm.impact = data;
            })
        }

        init();

        function mapIndicators() {
            vm.impactMonitoringSessions = [];
            var multiselectSelectedIndicatorId = vm.multiselectSelectedIndicator[0].id;
            for(var i = 0; i< vm.impact.impactIndicators.length; i++){
                if(vm.impact.impactIndicators[i].id === multiselectSelectedIndicatorId){
                    vm.indicator = vm.impact.impactIndicators[i];
                    vm.impactMonitoringSessions = vm.impact.impactIndicators[i].impactMonitoringSessions;
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var multiselectSelectedMonitoringSessionId = vm.multiselectSelectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.impactMonitoringSessions.length; i++){
                if(vm.indicator.impactMonitoringSessions[i].id === multiselectSelectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.impactMonitoringSessions[i].target = Number(vm.indicator.impactMonitoringSessions[i].target);
                        if(vm.indicator.impactMonitoringSessions[i].achieved){
                            vm.indicator.impactMonitoringSessions[i].achieved = Number(vm.indicator.impactMonitoringSessions[i].achieved);
                            vm.indicator.impactMonitoringSessions[i].dataCollected = true;
                        }
                    } else {
                        if(vm.indicator.impactMonitoringSessions[i].achieved){
                            vm.indicator.impactMonitoringSessions[i].dataCollected = true;
                        }
                    }
                    vm.monitoringSession = vm.indicator.impactMonitoringSessions[i];
                    break;
                }
            }
        }
        
        function openEditMonitoringFeedbackModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/monitoring/impactMonitoring/impactMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html',
                controller : 'EditImpactMonitoringFeedbackModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'indicator': function () {
                        return vm.indicator;
                    },
                    'monitoringSession': function () {
                        return vm.monitoringSession;
                    }
                }
            }).result.then(function(data) {
                vm.impact = data;
                toastr.success("Monitoring Feedback Updated.");
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.activityMonitoring')
        .controller('ActivityPerformMonitoringCtrl', ['_','activityService', '$stateParams', 'toastr', ActivityPerformMonitoringCtrl]);

    /** @ngInject */
    function ActivityPerformMonitoringCtrl(_,activityService,$stateParams, toastr) {

        var vm = this;

        vm.activity = null;
        vm.monitoringSessions = [];
        vm.selectedMonitoringSession = [];

        vm.reasonOfDeviation = null;
        vm.notDoneActivities = null;
        vm.challenge = null;
        vm.lessonLearnt = null;
        vm.recommendation = null;


        vm.setupMonitoringSessionForDataCollection = setupMonitoringSessionForDataCollection;
        vm.performMonitoring = performMonitoring;
        vm.getDeviation = getDeviation;

        function init() {
            activityService.getActivityById($stateParams.id).then(function (data) {
                vm.activity = data;
                vm.monitoringSessions  = angular.copy(vm.activity.activityMonitoringSessions);
                prepareMonitoringSessions();
            })
        }

        function getDeviation(a,b){
            return Math.abs(a-b);
        }

        function setupMonitoringSessionForDataCollection() {
            vm.reasonOfDeviation = vm.selectedMonitoringSession[0].reasonOfDeviation;
            vm.notDoneActivities = vm.selectedMonitoringSession[0].notDoneActivities;
            vm.challenge = vm.selectedMonitoringSession[0].challenge;
            vm.lessonLearnt = vm.selectedMonitoringSession[0].lessonLearnt;
            vm.recommendation = vm.selectedMonitoringSession[0].recommendation;
        }

        function prepareMonitoringSessions() {
            vm.monitoringSessions = vm.monitoringSessions.map(function (m) {
                var readableDate = new moment(m.timeOfMonitoring).format('YYYY MMMM');
                m.readableDate = readableDate;
                return m;
            });
            vm.monitoringSessions = _.orderBy(vm.monitoringSessions,'timeOfMonitoring');
            vm.selectedMonitoringSession = [];
        }

        function performMonitoring() {
            var data = {
                reasonOfDeviation : vm.reasonOfDeviation,
                notDoneActivities : vm.notDoneActivities,
                challenge         : vm.challenge,
                lessonLearnt      : vm.lessonLearnt,
                recommendation    : vm.recommendation,
            };
            activityService.performMonitoring(vm.selectedMonitoringSession[0].id,data).then(function (data) {
                toastr.success('Data collection successful');
                var id = vm.selectedMonitoringSession[0].id;
                vm.monitoringSessions  = data;
                tickPreviouslySelectedMonitoringSession(id);
                prepareMonitoringSessions();
            },function (error) {
                toastr.error('Could not perform data collection');
            })
        }

        function tickPreviouslySelectedMonitoringSession(id) {
            for(var i = 0; i < vm.monitoringSessions.length ; i++){
                if( vm.monitoringSessions[i].id == id){
                    vm.monitoringSessions[i].ticked = true;
                    vm.selectedMonitoringSession.push(vm.monitoringSessions[i]);
                }
            }
        }
        init();
    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outcomeMonitoring')
        .controller('OutcomeMonitoringDetailsCtrl', ['$stateParams', '_','outcomeService', 'toastr', '$uibModal', OutcomeMonitoringDetailsCtrl]);

    /** @ngInject */
    function OutcomeMonitoringDetailsCtrl($stateParams, _,outcomeService, toastr,$uibModal) {

        var vm = this;

        vm.outcomeId = null;
        vm.outcome = null;
        vm.multiselectSelectedIndicator = [];
        vm.multiselectSelectedMonitoringSession = [];
        vm.outcomeMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.openEditMonitoringFeedbackModal = openEditMonitoringFeedbackModal;

        function init() {
            vm.outcomeId = $stateParams.id;
            outcomeService.getOutcome(vm.outcomeId).then(function (data) {
                vm.outcome = data;
            })
        }

        init();

        function mapIndicators() {
            vm.outcomeMonitoringSessions = [];
            var multiselectSelectedIndicatorId = vm.multiselectSelectedIndicator[0].id;
            for(var i = 0; i< vm.outcome.outcomeIndicators.length; i++){
                if(vm.outcome.outcomeIndicators[i].id === multiselectSelectedIndicatorId){
                    vm.indicator = vm.outcome.outcomeIndicators[i];
                    vm.outcomeMonitoringSessions = vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions;
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var multiselectSelectedMonitoringSessionId = vm.multiselectSelectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.outcomeMonitoringSessions.length; i++){
                if(vm.indicator.outcomeMonitoringSessions[i].id === multiselectSelectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.outcomeMonitoringSessions[i].target = Number(vm.indicator.outcomeMonitoringSessions[i].target);
                        if(vm.indicator.outcomeMonitoringSessions[i].achieved) {
                            vm.indicator.outcomeMonitoringSessions[i].achieved = Number(vm.indicator.outcomeMonitoringSessions[i].achieved);
                            vm.indicator.outcomeMonitoringSessions[i].dataCollected = true;
                        }
                    } else {
                        if(vm.indicator.outcomeMonitoringSessions[i].achieved) {
                            vm.indicator.outcomeMonitoringSessions[i].dataCollected = true;
                        }
                    }
                    vm.monitoringSession = vm.indicator.outcomeMonitoringSessions[i];
                    break;
                }
            }
        }
        
        function openEditMonitoringFeedbackModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html',
                controller : 'EditOutcomeMonitoringFeedbackModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'indicator': function () {
                        return vm.indicator;
                    },
                    'monitoringSession': function () {
                        return vm.monitoringSession;
                    }
                }
            }).result.then(function(data) {
                vm.outcome = data;
                toastr.success("Monitoring Feedback Updated.");
            });
        }

    }
})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.monitoring.outputMonitoring')
        .controller('OutputMonitoringDetailsCtrl', ['$stateParams', '_','outputService', 'toastr', '$uibModal', OutputMonitoringDetailsCtrl]);

    /** @ngInject */
    function OutputMonitoringDetailsCtrl($stateParams, _,outputService, toastr,$uibModal) {

        var vm = this;

        vm.outputId = null;
        vm.output = null;
        vm.multiselectSelectedIndicator = [];
        vm.multiselectSelectedMonitoringSession = [];
        vm.outputMonitoringSessions = [];
        vm.indicator = null;
        vm.monitoringSession = null;

        vm.mapIndicators = mapIndicators;
        vm.mapMonitoringSession = mapMonitoringSession;
        vm.openEditMonitoringFeedbackModal = openEditMonitoringFeedbackModal;

        function init() {
            vm.outputId = $stateParams.id;
            outputService.getOutput(vm.outputId).then(function (data) {
                vm.output = data;
            })
        }

        init();

        function mapIndicators() {
            vm.outputMonitoringSessions = [];
            var multiselectSelectedIndicatorId = vm.multiselectSelectedIndicator[0].id;
            for(var i = 0; i< vm.output.outputIndicators.length; i++){
                if(vm.output.outputIndicators[i].id === multiselectSelectedIndicatorId){
                    vm.indicator = vm.output.outputIndicators[i];
                    vm.outputMonitoringSessions = vm.output.outputIndicators[i].outputMonitoringSessions;
                    break;
                }
            }
        }

        function mapMonitoringSession() {
            var multiselectSelectedMonitoringSessionId = vm.multiselectSelectedMonitoringSession[0].id;
            for(var i = 0; i< vm.indicator.outputMonitoringSessions.length; i++){
                if(vm.indicator.outputMonitoringSessions[i].id === multiselectSelectedMonitoringSessionId){
                    if(vm.indicator.type === 1){
                        vm.indicator.outputMonitoringSessions[i].target = Number(vm.indicator.outputMonitoringSessions[i].target);
                        if(vm.indicator.outputMonitoringSessions[i].achieved) {
                            vm.indicator.outputMonitoringSessions[i].achieved = Number(vm.indicator.outputMonitoringSessions[i].achieved);
                            vm.indicator.outputMonitoringSessions[i].dataCollected = true;
                        }
                    } else {
                        if(vm.indicator.outputMonitoringSessions[i].achieved) {
                            vm.indicator.outputMonitoringSessions[i].dataCollected = true;
                        }
                    }
                    vm.monitoringSession = vm.indicator.outputMonitoringSessions[i];
                    break;
                }
            }
        }
        
        function openEditMonitoringFeedbackModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/monitoring/outputMonitoring/outputMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html',
                controller : 'EditOutputMonitoringFeedbackModalCtrl',
                controllerAs : "vm",
                resolve: {
                    'indicator': function () {
                        return vm.indicator;
                    },
                    'monitoringSession': function () {
                        return vm.monitoringSession;
                    }
                }
            }).result.then(function(data) {
                vm.output = data;
                toastr.success("Monitoring Feedback Updated.");
            });
        }

    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfileActionCtrl', ['$scope', '$uibModal', 'authService', ProfileActionCtrl]);

    /** @ngInject */
    function ProfileActionCtrl($scope, $uibModal, authService) {
        var vm = this;

        vm.profileActions = [];
        vm.openAllowLoginModal = openAllowLoginModal;
        vm.showProfilePictureUploadModal = showProfilePictureUploadModal;
        vm.openUploadDocumentModal = openUploadDocumentModal;
        vm.openManualEntryModal = openManualEntryModal;
        vm.openAddAddressModal = openAddAddressModal;
        vm.enrolFingerprint = enrolFingerprint;
        vm.openApplyForLeaveModal = openApplyForLeaveModal;

        function init() {
            $scope.$on("profile-info-loaded", function (event, userData) {
                vm.user = userData;
                vm.profileActions = [
                    {
                        name: 'Allow Login',
                        icon: 'ion-android-done',
                        willBeSelected: vm.user.allowLogin
                    },
                    {
                        name: 'Change Password',
                        icon: 'ion-refresh',
                        willBeSelected: false,
                        action: function () {
                            $scope.$parent.$broadcast("change-password-action-clicked");
                        }
                    },
                    {
                        name: 'Upload Profile Picture',
                        icon: 'ion-android-camera',
                        willBeSelected: false

                    },
                    {
                        name: 'Upload Document',
                        icon: 'ion-android-attach',
                        willBeSelected: false
                    },
                    {
                        name: 'Manual Attendance Entry',
                        icon: 'ion-man',
                        willBeSelected: false
                    },
                    {
                        name: 'Add Address',
                        icon: 'ion-ios-list',
                        templateUrl: 'app/pages/main/profile/profileInfo/actions/createAddress.action.modal.html',
                        willBeSelected: false
                    },
                    {
                        name: 'Enrol Fingerprint',
                        icon: 'ion-ios-paw'
                    },
                    {
                        name: 'Apply for Leave ',
                        icon: 'ion-ios-body',
                    }

                ];
            });

        }

        init();

        function openAllowLoginModal () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/allowLogin/allowLogin.modal.html',
                controller : 'AllowLoginModalCtrl',
                controllerAs : 'vm',
                resolve : {
                    allowLogin : function () {
                        return vm.user.allowLogin;
                    },
                    userId : function () {
                        return vm.user.id;
                    },
                    userName : function () {
                        return vm.user.name;
                    }
                }
            }).result.then(function (loginValue) {
                vm.user.allowLogin = loginValue;
                vm.profileActions[0].willBeSelected = loginValue;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'allowLogin': loginValue});
                }
                $scope.$emit("profile-updated", { key : "allowLogin", value : loginValue});
            }, function () {
                console.log("Allow login modal dismissed.");
            });
        }

        function showProfilePictureUploadModal () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html',
                controller : 'ProfilePicUploadModalCtrl',
                controllerAs : 'vm',
                resolve : {
                    currentProfilePicURL : function () {
                        return (vm.user && vm.user.employeePicture && vm.user.employeePicture.employeeFile) ? vm.user.employeePicture.employeeFile.url : null;
                    },
                    userId : function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function (employeePicture) {
                vm.user.employeePicture = employeePicture;
                if (authService.getLoggedInId() == vm.user.id) {
                    authService.updateUserInfo({'employeePicture': employeePicture});
                }
                $scope.$emit("profile-updated", { key : "employeePicture", value : employeePicture});
                vm.noPicture = false;
            }, function () {
                console.log("Profile picture upload modal dismissed.");
            });
        }

        function openUploadDocumentModal () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/documentUpload/documentUpload.modal.html',
                controller : 'DocumentUploadModalCtrl',
                controllerAs : 'vm',
                resolve : {
                    userId : function () {
                        return vm.user.id;
                    }
                }
            }).result.then(function (document) {
                $scope.$emit("profile-updated", { "key" : "documents", "type" : "new", "value" : document});
            }, function () {
                console.log("Document upload modal dismissed.");
            });
        }

        function openManualEntryModal () {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/profile/attendance/detailsAttendanceLog/manualEntry/manualEntry.modal.html',
                controller : 'ManualEntryModalCtrl',
                controllerAs : 'vm',
                resolve : {
                    userId : function () {
                        return vm.user.id;
                    }
                }
            });
        }

        function openAddAddressModal () {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/actions/addAddress/addAddress.action.modal.html',
                controller : 'AddAddressModalCtrl',
                controllerAs : 'vm',
                resolve : {
                    userId : function () {
                        return vm.user.id;
                    },
                    currentAddress : function () {
                        console.log(vm.user.addresses);
                        return vm.user.addresses;
                    }
                }
            }).result.then(function (address) {
                $scope.$emit("profile-updated", { "key" : "addresses", "type" : "new", "value" : address});
            }, function () {
                console.log("Address upload modal dismissed.");
            });

        }

        function enrolFingerprint() {
            console.log("emitting profile-action-switch-to-enrol-tab event");
            $scope.$emit("profile-action-switch-to-enrol-tab");
        }

        function openApplyForLeaveModal() {
            $scope.$emit('leave-management-apply');
        }

    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfileDetailsAccordionCtrl', ['$anchorScroll', '$scope', '$location', '$q', 'employeeService', 'toastr', ProfileDetailsAccordionCtrl]);

    /** @ngInject */
    function ProfileDetailsAccordionCtrl($anchorScroll, $scope, $location, $q, employeeService, toastr) {
        var vm = this;

        vm.isChangedPasswordOpen = false;
        vm.user = null;
        vm.changePass = {};
        vm.changePass.passwordText = null;
        vm.changePass.confirmPasswordText = null;
        vm.addressTypeList = {};
        vm.addressTypeList.list = [{
                type: 'Permanent',
                value: 1
            }, {
                type: 'Present',
                value: 2
            }
        ];
        vm.opened = {};
        vm.updatePasswordFunction = updatePasswordFunction;
        vm.updateAddress = updateAddress;
        vm.updateFathersName = updateFathersName;
        vm.updateMothersName = updateMothersName;
        vm.updatePhoneOffice = updatePhoneOffice;
        vm.updateGender = updateGender;
        vm.updatePhoneHome = updatePhoneHome;
        vm.updatePhoneMobile = updatePhoneMobile;
        vm.updateEducationHistory = updateEducationHistory;
        vm.updateEmploymentHistory = updateEmploymentHistory;
        vm.open = open;
        vm.updateDateOfBirth = updateDateOfBirth;

        init();

        function init() {
            $scope.$on("profile-info-loaded", function (event, userData) {
                vm.user = userData;
                if (vm.user.employeeDetails && vm.user.employeeDetails.dateOfBirth) vm.user.employeeDetails.dateOfBirthDisplay = new Date(vm.user.employeeDetails.dateOfBirth);
            });

            $scope.$on("change-password-action-clicked", function () {
                $location.hash('passwordReset');
                vm.isChangedPasswordOpen = !vm.isChangedPasswordOpen;
                $anchorScroll();
                $location.hash('');
            });
        }

        function updatePasswordFunction() {
            if (!vm.changePass.passwordText || !vm.changePass.confirmPasswordText) return;
            if (vm.changePass.passwordText.localeCompare(vm.changePass.confirmPasswordText) != '0') return toastr.error("Passwords don't match");
            employeeService.updatePassword({password: vm.changePass.passwordText}, vm.user.id).then(function () {
                    toastr.success("Password Changed");
                }, function () {
                    toastr.error("Password change failed");
                }
            )
        }

        function updateAddress(data, addressId) {
            var defer = $q.defer();
            employeeService.updateAddress(data, vm.user.id, addressId).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "addresses", "type" : "modified", "value" : response.address});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateFathersName(data) {
            if (!data) return 'Fathers Name can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({fatherName: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "fatherName", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateMothersName(data) {
            if (!data) return 'Fathers Name can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({motherName: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "motherName", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updatePhoneOffice(data) {
            if (!data) return 'Office Phone can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneOffice: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "phoneOffice", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateGender(data) {
            if (!data) return 'Gender can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({gender: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "gender", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }


        function updatePhoneHome(data) {
            if (!data) return 'Gender can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneHome: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "phoneHome", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updatePhoneMobile(data) {
            if (!data) return 'Gender can not be empty.';
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({phoneMobile: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "phoneMobile", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }


        function updateEducationHistory(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({educationHistory: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "educationHistory", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateEmploymentHistory(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({employmentHistory: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "employmentHistory", "value" : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }


        function open($event, elementOpened) {
            $event.preventDefault();
            $event.stopPropagation();
            vm.opened[elementOpened] = !vm.opened[elementOpened];
        }

        function updateDateOfBirth(data) {
            var defer = $q.defer();
            employeeService.updateEmployeeDetailedInfo({dateOfBirth: data.getTime()}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { "key" : "employeeDetails", "subkey" : "dateOfBirth", "value" : data.getTime()});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('GeneralInfoCtrl', ['$filter', '$scope', '$q', '$timeout', 'departmentService', 'designationService', 'employeeService', 'shiftService', GeneralInfoCtrl]);

    /** @ngInject */
    function GeneralInfoCtrl($filter, $scope, $q, $timeout, departmentService, designationService, employeeService, shiftService) {
        var vm = this;
        vm.designationList = [];
        vm.departmentList = [];
        vm.shiftList = [];
        vm.isDataReady = null;
        vm.showDepartment = showDepartment;
        vm.showDesignation = showDesignation;
        vm.showShift = showShift;
        vm.updateName = updateName;
        vm.updateEmail = updateEmail;
        vm.updateDesignation = updateDesignation;
        vm.updateDepartment = updateDepartment;
        vm.updateShift = updateShift;


        function init () {
            designationService.getAllDesignations(false).then(function (designationList) {
                vm.designationList = designationList;
            }, function (message) {
                console.error("failed to load designation list : " + message);
            });
            departmentService.getAllDepartments(false).then(function (departmentList) {
                vm.departmentList = departmentList;
            }, function (message) {
                console.error("failed to load departmentList : " + message);
            });
            shiftService.getAllShifts(false).then(function (shiftList) {
                vm.shiftList = shiftList;
            }, function (message) {
                console.error("failed to load shiftList : " + message);
            });
            $scope.$on("profile-info-loaded", function (event, userData) {
                vm.user = userData;
                vm.isDataReady = true;
                $timeout(function () {
                    $scope.$broadcast("profile-pic-loaded", {
                        'userId' : userData.id,
                        'profilePicURL' : (!userData.employeePicture || !userData.employeePicture.employeeFile || !userData.employeePicture.employeeFile.url) ? null : userData.employeePicture.employeeFile.url
                    });
                })
            });
        }

        init();

        function showDepartment () {
            if (!vm.user) return 'No Data';
            var selected = $filter('filter')(vm.departmentList, {id: vm.user.department ? vm.user.department.id : -1});
            return (vm.user.department && selected && selected.length) ? selected[0].name : 'Not Set';
        }

        function showDesignation () {
            if (!vm.user) return 'No Data';
            var selected = $filter('filter')(vm.designationList, {id: vm.user.designation ? vm.user.designation.id : -1});
            return (vm.user.designation && selected && selected.length) ? selected[0].name : 'Not Set';
        }

        function showShift () {
            if (!vm.user) return 'No Data';
            var selected = $filter('filter')(vm.shiftList, {id: vm.user.shift ? vm.user.shift.id : -1});
            return (vm.user.shift && selected.length) ? selected[0].name : 'Not Set';
        }

        function updateName (data) {
            if (!data) return 'Name cannot be empty.';
            var defer = $q.defer();
            employeeService.updateBasicInfo({name: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "name", value : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateEmail (data) {
            if (!data) return 'Email cannot be empty.';
            if (!isValidEmail(data)) return 'Invalid email address';
            var defer = $q.defer();
            employeeService.updateBasicInfo({email: data}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "email", value : data});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function isValidEmail(email) {
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        }

        function updateDesignation (designationId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'designationId': designationId}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "designation", value : findObjectByIdFromArray(designationId, vm.designationList)});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateDepartment (departmentId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'departmentId': departmentId}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "department", value : findObjectByIdFromArray(departmentId, vm.departmentList)});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function updateShift (shiftId) {
            var defer = $q.defer();
            employeeService.updateBasicInfo({'shiftId': shiftId}, vm.user.id).then(function (response) {
                $scope.$emit("profile-updated", { key : "shift", value : findObjectByIdFromArray(shiftId, vm.shiftList)});
                defer.resolve(response);
            }, function(message){
                defer.reject(message);
            });
            return defer.promise;
        }

        function findObjectByIdFromArray(id, array){
            for(var i = 0; i < array.length; i++){
                if(array[i].id === id) return array[i];
            }
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.activity');
    app.controller('CreateActivityCtrl',['employeeService','$state','activityService','impactService','timeInterval','toastr', CreateActivityCtrl]);

    /** @ngInject */
    function CreateActivityCtrl(employeeService,$state,activityService,impactService,timeInterval,toastr) {

        var vm = this;

        vm.type = 1;
        vm.serialNumber = null;
        vm.budget = 0;
        vm.showCustomUnit = false;
        vm.event = null;
        vm.unit = null;
        vm.targetUnit = 0;
        vm.targetEvent = 0;
        vm.maleParticipants = 0;
        vm.femaleParticipants = 0;
        vm.responsibleAgency = null;
        vm.meansOfVerification = null;
        vm.description = null;
        vm.startDate = new Date();
        vm.endDate = new Date();
        vm.isOpen = false;
        vm.format = 'MMM yyyy';

        vm.impacts = null;
        vm.selectedImpacts = [];
        vm.outcomes = [];
        vm.selectedOutcomes = [];
        vm.outputs = [];
        vm.selectedOutputs= [];

        vm.timeLines = [];
        vm.intervals = [];
        vm.intervalsToBeShown = [];

        vm.selectedTimeLine = null;
        vm.selectedInterval = null;

        vm.tableData = [];

        vm.enableCustomTarget = false;

        vm.openCalendar = openCalendar;
        vm.generateOutcomes = generateOutcomes;
        vm.generateOutputs = generateOutputs;
        vm.determineTimelineAndInterval = determineTimelineAndInterval;
        vm.selectInterval = selectInterval;
        vm.openCalendarInTable = openCalendarInTable;
        vm.createTableData = createTableData;
        vm.createActivity = createActivity;
        vm.adjustTotalTargetUnit = adjustTotalTargetUnit;

        init();

        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            });

            vm.timeLines = [
                'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];

            vm.intervals = timeInterval;

        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }


        function selectInterval () {
            if(vm.selectedTimeLine !== 'Immediate'){
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
            createTableData();
        }

        function createTableData() {
            vm.tableData = [];
            if(vm.type === null)
                return toastr.error("Please select Indicator type to edit");
            if(vm.selectedTimeLine === 'Immediate') {
                vm.tableData = [];
                vm.tableData.push({
                    "timeOfMonitoring"  : angular.copy(vm.startDate),
                    "targetUnit"        : 0,
                    "targetEvent"       : 0,
                    'targetMale'        : 0,
                    'targetFemale'      : 0,
                    'targetPeople'      : 0,
                    'budget'            : 0,
                    'totalTargetUnit'   : 0,
                    'totalTargetEvent'  : 0,
                    'totalTargetMale'   : 0,
                    'totalTargetFemale' : 0,
                    'totalTargetPeople' : 0,
                    'totalBudget'       : 0,
                    'isOpen'            : false
                });
                return;
            }
            if(vm.selectedInterval == null) return;
            var rowsToCreate = (parseInt(vm.intervals[vm.selectedTimeLine].value))/parseInt(vm.selectedInterval.value);
            console.log('ROWS TO CREATE ' + rowsToCreate);
            vm.tableData = [];
            for(var i = 0 ;i < rowsToCreate;i++){
                vm.tableData.push({
                    "timeOfMonitoring" : moment(vm.startDate).add(i * vm.selectedInterval.value,'M').toDate(),
                    "targetUnit"        : 0,
                    "targetEvent"       : 0,
                    'targetMale'        : 0,
                    'targetFemale'      : 0,
                    'targetPeople'      : 0,
                    'budget'            : 0,
                    'totalTargetUnit'   : 0,
                    'totalTargetEvent'  : 0,
                    'totalTargetMale'   : 0,
                    'totalTargetFemale' : 0,
                    'totalTargetPeople' : 0,
                    'totalBudget'       : 0,
                    'isOpen'            : false
                })
            }
        }


        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function determineTimelineAndInterval() {
            if(vm.type == 1){
                vm.selectedTimeLine = 'Immediate';
                createTableData();
            }
        }



        function generateOutcomes() {
            if(vm.selectedImpacts.length === 0){
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.outcomes = vm.selectedImpacts[0].outcomes;
        }

        function generateOutputs() {
            if(vm.selectedOutcomes.length === 0){
                vm.selectedOutputs = [];
                return;
            }
            vm.outputs = vm.selectedOutcomes[0].outputs;
        }

        function createActivity() {
            if(!vm.selectedOutputs || vm.selectedOutputs.length===0) return toastr.error("Please select output");
            if(!vm.serialNumber) return toastr.error("Serial Number cannot be empty.");
            if(vm.showCustomUnit && !vm.unit) return toastr.error("Unit cannot be empty.");
            if(!vm.event) return toastr.error("Event cannot be empty.");
            if(!vm.title) return toastr.error("Title cannot be empty.");
            if(!vm.startDate) return toastr.error("Please select a start time.");
            if(vm.type == 2 && !vm.endDate) return toastr.error("Please select a end time.");
            // if(!vm.selectedEmployeesUI || vm.selectedEmployeesUI.length <=0) return toastr.error("Please select a coordinator for this major activity.");
            var monitoringSessions = angular.copy(vm.tableData);
            monitoringSessions = monitoringSessions.map(function (d) {
                console.log(d.timeOfMonitoring)
                d.timeOfMonitoring = d.timeOfMonitoring.getTime();
                return d;
            });
            var data = {
                serialNo                     : vm.serialNumber,
                title                        : vm.title,
                unit                         : vm.unit,
                event                        : vm.event,
                budget                       : vm.budget,
                targetEvent                  : vm.targetEvent,
                targetUnit                   : vm.targetUnit,
                maleParticipants             : vm.maleParticipants,
                femaleParticipants           : vm.femaleParticipants,
                meansOfVerification          : vm.meansOfVerification,
                responsibleAgency            : vm.responsibleAgency,
                type                         : vm.type,
                outputId                     : vm.selectedOutputs[0].id,
                startDate                    : vm.startDate.getTime(),
                endDate                      : vm.endDate.getTime(),
                monitoringSessions           : monitoringSessions,
                description                  : vm.description,
            };
            activityService.createActivity(data).then(function (responseData) {
                // $uibModalInstance.close(responseData);
                $state.go('setup.activities');
            },function () {
                toastr.error("Could not create major activity ");
            })
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function generateOutcomes() {
            if(vm.selectedImpacts.length === 0){
                vm.selectedOutcomes = [];
                vm.selectedOutputs = [];
                return;
            }
            vm.outcomes = vm.selectedImpacts[0].outcomes;
        }

        function generateOutputs() {
            if(vm.selectedOutcomes.length === 0){
                vm.selectedOutputs = [];
                return;
            }
            vm.outputs = vm.selectedOutcomes[0].outputs;
        }
        
        function adjustTotalTargetUnit(target,totalTarget) {
            var sum = 0;
            for(var i = 0; i < vm.tableData.length;i++){
                sum += Number(vm.tableData[i][target]);
                vm.tableData[i][totalTarget] = sum;
            }
            vm.targetEvent = vm.tableData[vm.tableData.length -1].totalTargetEvent
            vm.budget = vm.tableData[vm.tableData.length -1].totalBudget
            vm.maleParticipants = vm.tableData[vm.tableData.length -1].totalTargetMale
            vm.femaleParticipants = vm.tableData[vm.tableData.length -1].totalTargetFemale
            reloadTableData()
        }


        function reloadTableData(){

            vm.tableData.forEach(function (item, i){
                item.targetPeople = Number(item.targetMale) + Number(item.targetFemale);
                if (i === 0) {
                    item.totalTargetPeople = Number(item.totalTargetMale) + Number(item.totalTargetFemale)
                    item.totalBudget = item.budget
                } else {
                    item.totalTargetPeople = Number(vm.tableData[i - 1].totalTargetPeople) + Number(item.targetMale) + Number(item.targetFemale)
                    item.totalBudget = vm.tableData[i - 1].totalBudget + item.budget
                }
            })
        }

    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.setup.impactList')
        .controller('ImpactListCtrl', ['_','impactService', 'toastr', '$uibModal', ImpactListCtrl]);

    /** @ngInject */
    function ImpactListCtrl(_,impactService, toastr, $uibModal) {

        var vm = this;

        vm.impacts = null;
        vm.isResponsePending=false;
        vm.deletingImpact=null;

        vm.openCreateIndicatorModal = openCreateIndicatorModal;
        vm.openEditImpactModal = openEditImpactModal;
        vm.deleteImpact = deleteImpact;

        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            });
        }

        init();

        function openCreateIndicatorModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/impact/impactList/create/createImpact.modal.html',
                size:'lg',
                controller : 'CreateImpactCtrl',
                controllerAs : "vm",
            }).result.then(function(data) {
                vm.impacts.push(data);
                toastr.success("Impact created.");
            });
        }

        function openEditImpactModal(impact) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/impact/impactList/edit/editImpact.modal.html',
                size:'lg',
                controller : 'EditImpactCtrl',
                controllerAs : "vm",
                resolve:{
                    'impact': function () {
                        return impact;
                    }
                }
            }).result.then(function(data) {
                vm.impacts = data;
                toastr.success("Impact updated.");
            });
        }

        function deleteImpact(impact) {
            vm.isResponsePending=true;
            vm.deletingImpact=impact.id;
            impactService.delete(impact.id).then(function (data) {
                vm.impacts = data;
                vm.isResponsePending=false;
                vm.deletingImpact=null;
                toastr.success("Impact deleted.");
            })
        }


    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup');
    app.controller('ImpactSetupCtrl',['_','impactService','$stateParams','toastr','$uibModal', ImpactSetupCtrl]);

    /** @ngInject */
    function ImpactSetupCtrl(_, impactService,$stateParams,toastr,$uibModal) {

        var vm = this;

        var impactId = null;
        vm.impact = null;
        vm.accordion = {
            indicatorsIsOpen : false,
            researchFrameworkIsOpen : false,
            monitoringFrameworkIsOpen : false,
            outcomesIsOpen : false,
        };

        vm.openEditResearchFrameworkModal = openEditResearchFrameworkModal;
        vm.outcomeCreateModalCtrl = outcomeCreateModalCtrl;
        vm.convertMillisToDate = convertMillisToDate;
        vm.deleteImpactIndicator = deleteImpactIndicator;

        function init() {
            impactId = $stateParams.id;
            impactService.getImpact(impactId).then(function (data) {
                vm.impact = data;
                for(var i = 0; i<vm.impact.impactIndicators.length; i++){
                    vm.impact.impactIndicators[i].impactMonitoringSessions =_.orderBy(vm.impact.impactIndicators[i].impactMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            },function () {
                toastr.error("Could not fetch impact");
            });
        }
        init();

        function openEditResearchFrameworkModal(indicator) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/impact/impactSetup/edit/editResearchFramework.modal.html',
                size:'lg',
                controller : 'EditResearchFrameworkModalCtrl',
                controllerAs : "vm",
                resolve : {
                    indicator : function () {
                        return indicator ;
                    }
                }
            }).result.then(function(data) {
                vm.impact = data;
                for(var i = 0; i<vm.impact.impactIndicators.length; i++){
                    vm.impact.impactIndicators[i].impactMonitoringSessions =_.orderBy(vm.impact.impactIndicators[i].impactMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
                toastr.success("Update Successful");
            });
        }

        function outcomeCreateModalCtrl() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/impact/impactSetup/create/outcome/createOutcome.modal.html',
                size:'lg',
                controller : 'OutcomeCreateModalCtrl',
                controllerAs : "vm",
                resolve : {
                    impactId:function () {
                        return vm.impact.id;
                    }
                }
            }).result.then(function(data) {
                vm.impact.outcomes = data;
                toastr.success("Update Successful");
            });
        }

        function convertMillisToDate(millis){
            return moment(millis).format("MMM YYYY");
        }

        function deleteImpactIndicator(indicatorId) {
            impactService.deleteImpactIndicator(indicatorId).then(function (data) {
                vm.impact = data;
                for(var i = 0; i<vm.impact.impactIndicators.length; i++){
                    vm.impact.impactIndicators[i].impactMonitoringSessions =_.orderBy(vm.impact.impactIndicators[i].impactMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.activity');
    app.controller('EditActivityCtrl', ['$stateParams', 'employeeService', 'activityService', 'toastr', EditActivityCtrl]);

    /** @ngInject */
    function EditActivityCtrl($stateParams, employeeService, activityService, toastr) {

        var vm = this;

        vm.activity = null;
        vm.isOpen = false;
        vm.format = 'MMM yyyy';

        vm.showCustomUnit = false;

        vm.updateActivity = updateActivity;
        vm.openCalendar = openCalendar;
        vm.extendMonitoring = extendMonitoring;
        vm.editMonitoringSession = editMonitoringSession;
        vm.addMonitoringSession = addMonitoringSession;
        vm.openCalendarInTable = openCalendarInTable;
        vm.deleteMonitoringSession = deleteMonitoringSession;
        vm.adjustTotalTargetUnit = adjustTotalTargetUnit;

        init();

        function init() {
            activityService.getActivityById($stateParams.activityId).then(function (data) {
                vm.activity = data;
                // change by koushik
                vm.activity.budget =  vm.activity.activityMonitoringSessions[vm.activity.activityMonitoringSessions.length -1].totalBudget
                // change by koushik:end
                vm.activity.activityMonitoringSessions = vm.activity.activityMonitoringSessions.map(function (m, i) {
                    m.timeOfMonitoringInDate = new Date(m.timeOfMonitoring);
                    m.isOpen = false;

                    // change by koushik
                    m.targetPeople = m.targetMale + m.targetFemale
                    if (i == 0) {
                        m.totalTargetPeople = m.totalTargetMale + m.totalTargetFemale
                        m.totalBudget = m.budget
                    } else {
                        m.totalTargetPeople = vm.activity.activityMonitoringSessions[i - 1].totalTargetPeople + m.totalTargetMale + m.totalTargetFemale
                        m.totalBudget = vm.activity.activityMonitoringSessions[i - 1].totalBudget + m.budget
                    }
                    // change by koushik: end

                    return m;
                });
                vm.activity.activityMonitoringSessions = vm.activity.activityMonitoringSessions.sort(function (a, b) {
                    return a.timeOfMonitoring - b.timeOfMonitoring;
                });
            });
        }

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e, index) {
            e.preventDefault();
            e.stopPropagation();
            vm.activity.activityMonitoringSessions[index].isOpen = true;
        }


        function updateActivity() {
            var startTime = angular.copy(vm.activity.startDate);
            var endTime = angular.copy(vm.activity.endDate);
            startTime = new Date(startTime);
            endTime = new Date(endTime);
            // if(!vm.selectedEmployeesUI || vm.selectedEmployeesUI.length <=0) return toastr.error("Please select a coordinator for this major activity.");
            var data = {
                serialNo: vm.activity.serialNumber,
                title: vm.activity.title,
                unit: vm.activity.unit,
                event: vm.activity.event,
                budget: vm.activity.budget,
                targetEvent: vm.activity.targetEvent,
                targetUnit: vm.activity.targetUnit,
                maleParticipants: vm.activity.maleParticipants,
                femaleParticipants: vm.activity.femaleParticipants,
                meansOfVerification: vm.activity.meansOfVerification,
                responsibleAgency: vm.activity.responsibleAgency,
                // mainAchievementOfTheActivity : vm.activity.mainAchievementOfTheActivity,
                description: vm.activity.description,
                // type                : vm.type,
                // outputId            : vm.selectedOutputs[0].id,
                startDate: startTime.getTime(),
                endDate: endTime.getTime(),
            };
            activityService.updateActivity(data, vm.activity.id).then(function (responseData) {
                toastr.success('Update successful');
            }, function () {
                toastr.error("Could not update activity ");
            })
        }

        function extendMonitoring() {
            vm.activity.activityMonitoringSessions.push({
                "timeOfMonitoringInDate": new Date(),
                "targetUnit": null,
                "targetEvent": null,
                'targetMale': null,
                'targetFemale': null,
                'targetPeople': null,
                'budget': null,
                'totalTargetUnit': null,
                'totalTargetEvent': null,
                'totalTargetMale': null,
                'totalTargetFemale': null,
                'totalTargetPeople': null,
                'totalBudget': null,
                'isOpen': false
            });
        }


        function editMonitoringSession(row) {
            var timeOfMonitoring = new Date(row.timeOfMonitoringInDate);
            var data = angular.copy(row);
            data.timeOfMonitoring = timeOfMonitoring.getTime();
            activityService.updateMonitoringSession(data, data.id).then(function (response) {
                toastr.success('Save successful');
            })

        }

        function addMonitoringSession(row) {
            var timeOfMonitoring = new Date(row.timeOfMonitoringInDate);
            var data = angular.copy(row);
            data.timeOfMonitoring = timeOfMonitoring.getTime();
            activityService.addMonitoringSession(vm.activity.id, data).then(function (response) {
                toastr.success('Save successful');
            })
        }

        function deleteMonitoringSession(index, row) {
            if (row.id == null) {
                vm.activity.activityMonitoringSessions.splice(index, 1);

            } else {
                activityService.deleteMonitoringSession(row.id).then(function () {
                    toastr.success("Delete successful")
                    vm.activity.activityMonitoringSessions.splice(index, 1);
                }, function () {
                    toastr.error("Could not delete");
                });
            }
        }

        function adjustTotalTargetUnit(target, totalTarget) {
            var sum = 0;
            for (var i = 0; i < vm.activity.activityMonitoringSessions.length; i++) {
                sum += Number(vm.activity.activityMonitoringSessions[i][target]);
                vm.activity.activityMonitoringSessions[i][totalTarget] = sum;
                updatePeople();// changed by koushik
                updateActivityDataOnChange() // changed by koushik

            }
        }

        // by koushik

        function updateActivityDataOnChange(){
            vm.activity.budget = vm.activity.activityMonitoringSessions[vm.activity.activityMonitoringSessions.length -1].totalBudget
            vm.activity.maleParticipants = vm.activity.activityMonitoringSessions[vm.activity.activityMonitoringSessions.length -1].totalTargetMale
            vm.activity.femaleParticipants = vm.activity.activityMonitoringSessions[vm.activity.activityMonitoringSessions.length -1].totalTargetFemale
        }

        function updatePeople() {
            vm.activity.activityMonitoringSessions.map(function (m, i) {
                m.targetPeople = Number(m.targetMale ) + Number(m.targetFemale)
                m.totalTargetPeople = Number(m.totalTargetMale) +  Number(m.totalTargetFemale)
                if (i == 0) {
                    m.totalTargetPeople = Number(m.totalTargetMale) + Number(m.totalTargetFemale)
                } else {
                    m.totalTargetPeople = Number(vm.activity.activityMonitoringSessions[i - 1].totalTargetPeople) + Number(m.totalTargetMale) + Number(m.totalTargetFemale)
                }
            });
        }
        // by koushik:end

    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.setup.outcomeList')
        .controller('OutcomeListCtrl', ['_','outcomeService', 'impactService','projectService', 'toastr', '$uibModal', OutcomeListCtrl]);

    /** @ngInject */
    function OutcomeListCtrl(_,outcomeService, impactService, projectService, toastr, $uibModal) {

        var vm = this;

        vm.impacts = null;
        vm.projects = null;
        vm.selectedImpacts = [];
        vm.selectedProjects = [];
        vm.filteredProjects = [];
        vm.allOutcomes = [];
        vm.selectedOutcomes = [];
        vm.showFilters = false;
        vm.isResponsePending=false;
        vm.deletingImpact=null;
        var allImpacts = [];
        vm.filterImpacts = filterImpacts;
        vm.openCreateOutcomeModal = openCreateOutcomeModal;
        vm.openEditOutcomeModal = openEditOutcomeModal;
        vm.deleteOutcome = deleteOutcome;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = angular.copy(data);
            });
            outcomeService.getAllOutcomes().then(function (data) {
                vm.allOutcomes = data;
                vm.selectedOutcomes = data;
            });
        }

        init();

        function openCreateOutcomeModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/outcome/outcomeList/create/createOutcome.modal.html',
                size:'lg',
                controller : 'CreateOutcomeCtrl',
                controllerAs : "vm",
            }).result.then(function(data) {
                vm.allOutcomes.push(data);
                vm.selectedOutcomes = vm.allOutcomes;
                vm.selectedImpacts = [];
                toastr.success("Outcome created.");
            });
        }

        function openEditOutcomeModal(outcome) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/outcome/outcomeList/edit/editOutcome.modal.html',
                size:'lg',
                controller : 'EditOutcomeCtrl',
                controllerAs : "vm",
                resolve:{
                    'outcome': function () {
                        return outcome;
                    }
                }
            }).result.then(function(data) {
                vm.allOutcomes = data;
                vm.selectedOutcomes = vm.allOutcomes;
                vm.selectedImpacts = [];
                toastr.success("Outcome updated.");
            });
        }

        function deleteOutcome(outcome) {
            vm.isResponsePending=true;
            vm.deletingImpact=outcome.id;
            outcomeService.deleteOutcome(outcome.id).then(function (data) {
                vm.allOutcomes = data;
                vm.selectedOutcomes = vm.allOutcomes;
                vm.isResponsePending=false;
                vm.deletingImpact=null;
                vm.selectedImpacts = [];
                toastr.success("Outcome deleted.");
            })
        }

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function filterImpacts() {
            if(!vm.selectedImpacts || !vm.selectedImpacts.length)
                vm.selectedOutcomes = vm.allOutcomes;
            outcomeService.getAllOutcomesByFilter(vm.selectedImpacts.map(function (impact) {
                return impact.id;
            })).then(function (responseData) {
                vm.selectedOutcomes = responseData;
            });
        }
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeSetup');
    app.controller('OutcomeSetupCtrl', ['outcomeService', '$stateParams', 'toastr', '$uibModal', OutcomeSetupCtrl]);

    /** @ngInject */
    function OutcomeSetupCtrl(outcomeService, $stateParams, toastr, $uibModal) {

        var vm = this;

        var outcomeId = null;
        vm.outcome = null;
        vm.accordion = {
            indicatorsIsOpen: false,
            researchFrameworkIsOpen: false,
            monitoringFrameworkIsOpen: false,
            outputsIsOpen: false,
        };

        vm.openSetupResearchFrameworkModal = openSetupResearchFrameworkModal;
        vm.outputCreateModal = outputCreateModal;
        vm.convertMillisToDate = convertMillisToDate;
        vm.deleteIndicator = deleteIndicator;

        function init() {
            outcomeId = $stateParams.id;
            outcomeService.getOutcome(outcomeId).then(function (data) {
                vm.outcome = data;
                for(var i = 0; i<vm.outcome.outcomeIndicators.length; i++){
                    vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions =_.orderBy(vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            }, function () {
                toastr.error("Could not fetch outcome");
            });
        }

        init();

        function openSetupResearchFrameworkModal(indicator) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/setupMenu/outcome/outcomeSetup/edit/setupResearchFramework.modal.html',
                size: 'lg',
                controller: 'SetupOutcomeResearchFrameworkModalCtrl',
                controllerAs: "vm",
                resolve: {
                    indicator: function () {
                        return indicator;
                    }
                }
            }).result.then(function (data) {
                vm.outcome = data;
                for(var i = 0; i<vm.outcome.outcomeIndicators.length; i++){
                    vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions =_.orderBy(vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
                toastr.success("Update Successful");
            });
        }

        function outputCreateModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/setupMenu/outcome/outcomeSetup/create/output/createOutput.modal.html',
                size: 'lg',
                controller: 'OutputCreateModalCtrl',
                controllerAs: "vm",
                resolve: {
                    outcomeId: function () {
                        return vm.outcome.id;
                    }
                }
            }).result.then(function (data) {
                vm.outcome.outputs.push(data);
                toastr.success("Update Successful");
            });
        }

        function convertMillisToDate(millis) {
            return moment(millis).format("MMM YYYY");
        }

        function deleteIndicator(indicatorId) {
            outcomeService.deleteIndicator(indicatorId).then(function (data) {
                vm.outcome = data;
                for(var i = 0; i<vm.outcome.outcomeIndicators.length; i++){
                    vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions =_.orderBy(vm.outcome.outcomeIndicators[i].outcomeMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            })
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputSetup');
    app.controller('OutputSetupCtrl', ['outputService', '$stateParams', 'toastr', '$uibModal', OutputSetupCtrl]);

    /** @ngInject */
    function OutputSetupCtrl(outputService, $stateParams, toastr, $uibModal) {

        var vm = this;

        var outputId = null;
        vm.output = null;
        vm.accordion = {
            indicatorsIsOpen: false,
            researchFrameworkIsOpen: false,
            monitoringFrameworkIsOpen: false,
            activityIsOpen: false,
        };

        vm.openSetupResearchFrameworkModal = openSetupResearchFrameworkModal;
        vm.majorActivityCreateModal = majorActivityCreateModal;
        vm.convertMillisToDate = convertMillisToDate;
        vm.deleteIndicator = deleteIndicator;

        function init() {
            outputId = $stateParams.id;
            outputService.getOutput(outputId).then(function (data) {
                vm.output = data;
                for(var i = 0; i<vm.output.outputIndicators.length; i++){
                    vm.output.outputIndicators[i].outputMonitoringSessions =_.orderBy(vm.output.outputIndicators[i].outputMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            }, function () {
                toastr.error("Could not fetch output");
            });
        }

        init();

        function openSetupResearchFrameworkModal(indicator) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/setupMenu/output/outputSetup/edit/setupResearchFramework.modal.html',
                size: 'lg',
                controller: 'SetupOutputResearchFrameworkModalCtrl',
                controllerAs: "vm",
                resolve: {
                    indicator: function () {
                        return indicator;
                    }
                }
            }).result.then(function (data) {
                vm.output = data;
                for(var i = 0; i<vm.output.outputIndicators.length; i++){
                    vm.output.outputIndicators[i].outputMonitoringSessions =_.orderBy(vm.output.outputIndicators[i].outputMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
                toastr.success("Update Successful");
            });
        }

        function majorActivityCreateModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/setupMenu/output/outputSetup/create/majorActivity/createMajorActivity.modal.html',
                size: 'lg',
                controller: 'MajorActivityCreateModalCtrl',
                controllerAs: "vm",
                resolve: {
                    outputId: function () {
                        return vm.output.id;
                    }
                }
            }).result.then(function (data) {
                vm.output.majorActivities.push(data);
                toastr.success("Major Activity Created Successfully");
            });
        }

        function convertMillisToDate(millis) {
            return moment(millis).format("MMM YYYY");
        }

        function deleteIndicator(indicatorId) {
            outputService.deleteIndicator(indicatorId).then(function (data) {
                vm.output = data;
                for(var i = 0; i<vm.output.outputIndicators.length; i++){
                    vm.output.outputIndicators[i].outputMonitoringSessions =_.orderBy(vm.output.outputIndicators[i].outputMonitoringSessions, ['timeOfMonitoring'],['asc']);
                }
            })
        }
    }

})();

(function () {
    'use strict';
    angular
        .module('NGOMonitoringClientApp.pages.main.setup.outputList')
        .controller('OutputListCtrl', ['_', 'projectService', 'impactService', '$uibModal', 'outputService', 'toastr', 'utilService', OutputListCtrl]);

    /** @ngInject */
    function OutputListCtrl(_, projectService, impactService, $uibModal, outputService, toastr, utilService) {

        var vm = this;

        vm.impacts = [];
        vm.projects = null;
        vm.selectedProjects = [];
        vm.selectedImpacts = [];
        vm.outcomes = null;
        vm.selectedOutcomes = [];
        vm.allOutputs = [];
        vm.selectedOutputs = [];
        vm.showFilters = false;
        vm.isResponsePending=false;
        vm.deletingImpact=null;

        var allImpacts = [];

        vm.mapOutcomes = mapOutcomes;
        vm.searchOutputs = searchOutputs;
        vm.openCreateOutputModal = openCreateOutputModal;
        vm.openEditOutputModal = openEditOutputModal;
        vm.deleteOutput = deleteOutput;
        vm.filterImpactsDisplayValues = filterImpactsDisplayValues;

        init();

        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            })
            impactService.getAllImpacts().then(function (data) {
                allImpacts = data;
                vm.impacts = data;
                vm.isResponsePending=false;
                vm.deletingImpact=null;
                //console.log(data)
                for(var i = 0; i< vm.impacts.length;i++){
                    for(var j=0; j<vm.impacts[i].outcomes.length;j++){
                        vm.impacts[i].outcomes[j].impact = {};
                        vm.impacts[i].outcomes[j].impact.id = vm.impacts[i].id;
                        vm.impacts[i].outcomes[j].impact.number = vm.impacts[i].number;
                        vm.impacts[i].outcomes[j].impact.summary = vm.impacts[i].summary;
                        for(var k=0; k< vm.impacts[i].outcomes[j].outputs.length; k++){
                            vm.impacts[i].outcomes[j].outputs[k].outcome = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.id = vm.impacts[i].outcomes[j].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.number = vm.impacts[i].outcomes[j].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.summary = vm.impacts[i].outcomes[j].summary;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact = {};
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.id = vm.impacts[i].id;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.number = vm.impacts[i].number;
                            vm.impacts[i].outcomes[j].outputs[k].outcome.impact.summary = vm.impacts[i].summary;
                        }
                    }
                }
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            });
        }

        function openCreateOutputModal() {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/output/outputList/create/createOutput.modal.html',
                size:'lg',
                controller : 'CreateOutputCtrl',
                controllerAs : "vm",
                resolve: {
                    'impacts': function () {
                        return vm.impacts;
                    }
                }
            }).result.then(function(data) {
                init();
                toastr.success("Output created.");
            });
        }

        function openEditOutputModal(output) {
            $uibModal.open({
                animation : true,
                templateUrl : 'app/pages/main/setupMenu/output/outputList/edit/editOutput.modal.html',
                size:'lg',
                controller : 'EditOutputCtrl',
                controllerAs : "vm",
                resolve:{
                    'output': function () {
                        return output;
                    },
                    'impacts': function () {
                        return vm.impacts;
                    }
                }
            }).result.then(function(data) {
                init();
                toastr.success("Output edited.");
            });
        }

        function deleteOutput(output) {
            vm.isResponsePending=true;
            vm.deletingImpact=output.id;
            outputService.delete(output.id).then(function (data) {
                init();
                toastr.success("Output deleted.");
            })
        }

        function getActiveOutputsFromImpacts(impactList) {
            var outputList = [];
            impactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function mapImpactsToMultiSelectFormat(impact){
            return {
                id       : impact,
                number   : impact.number,
                outcomes : impact.outcomes
            }
        }

        function filterImpactsDisplayValues(){
            if(vm.selectedProjects.length == 0){
                vm.selectedImpacts = allImpacts.map(mapImpactsToMultiSelectFormat);
            }
            else{
                var selectedProjectIds = vm.selectedProjects.map(function (item) {
                    return item.id;
                })
                vm.impacts = allImpacts.filter(function (i) {
                    return selectedProjectIds.includes(i.project.id);
                });
            }
        }

        function getActiveOutputsFromMultiSelectImpacts(multiselectImpactList) {
            var outputList = [];
            multiselectImpactList.forEach(function (impact) {
                impact.outcomes.forEach(function (outcome) {
                    outcome.outputs.forEach(function (output) {
                        if (output.status === 1) {
                            outputList.push(output);
                        }
                    })
                })
            });
            return outputList;
        }

        function getActiveOutputsFromMultiSelectOutcomes(multiselectOutcomeList) {
            var outputList = [];
            multiselectOutcomeList.forEach(function (outcome) {
                outcome.outputs.forEach(function (output) {
                    if (output.status === 1) {
                        outputList.push(output);
                    }
                })
            });
            return outputList;
        }


        function mapOutcomes() {
            vm.outcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.outcomes = _.flatten(vm.outcomes);
        }

        function searchOutputs() {
            if (vm.selectedImpacts && vm.selectedImpacts.length>0 && (!vm.selectedOutcomes || vm.selectedOutcomes.length === 0)) {
                vm.allOutputs = getActiveOutputsFromMultiSelectImpacts(vm.selectedImpacts);
            } else if (vm.selectedOutcomes && vm.selectedOutcomes.length>0) {
                vm.allOutputs = getActiveOutputsFromMultiSelectOutcomes(vm.selectedOutcomes);
            } else {
                vm.allOutputs = getActiveOutputsFromImpacts(vm.impacts);
            }
        }
    }
})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.monitoring.impactMonitoring')
        .controller('EditImpactMonitoringFeedbackModalCtrl', [ '$uibModalInstance','impactService','toastr','indicator','monitoringSession', EditImpactMonitoringFeedbackModalCtrl]);

    /** @ngInject */
    function EditImpactMonitoringFeedbackModalCtrl($uibModalInstance,impactService,toastr,indicator,monitoringSession) {

        var vm = this;

        vm.indicator = indicator;
        vm.monitoringSession = monitoringSession;

        vm.save = save;

        function save() {
               var data = null;
               if(vm.indicator.type===1){
                   data = {
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               } else {
                   data = {
                       deviation:vm.monitoringSession.deviation,
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               }

               impactService.monitoringFeedbackUpdate(vm.monitoringSession.id, data).then(function (data) {
                   $uibModalInstance.close(data);
               },function () {
                   toastr.error("Could not edit monitoring feedback");
               });
        }
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.monitoring.outcomeMonitoring')
        .controller('EditOutcomeMonitoringFeedbackModalCtrl', [ '$uibModalInstance','outcomeService','toastr','indicator','monitoringSession', EditOutcomeMonitoringFeedbackModalCtrl]);

    /** @ngInject */
    function EditOutcomeMonitoringFeedbackModalCtrl($uibModalInstance,outcomeService,toastr,indicator,monitoringSession) {

        var vm = this;

        vm.indicator = indicator;
        vm.monitoringSession = monitoringSession;

        vm.save = save;

        function save() {
               var data = null;
               if(vm.indicator.type===1){
                   data = {
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               } else {
                   data = {
                       deviation:vm.monitoringSession.deviation,
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               }

               outcomeService.monitoringFeedbackUpdate(vm.monitoringSession.id, data).then(function (data) {
                   $uibModalInstance.close(data);
               },function () {
                   toastr.error("Could not edit monitoring feedback");
               });
        }
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.monitoring.outputMonitoring')
        .controller('EditOutputMonitoringFeedbackModalCtrl', [ '$uibModalInstance','outputService','toastr','indicator','monitoringSession', EditOutputMonitoringFeedbackModalCtrl]);

    /** @ngInject */
    function EditOutputMonitoringFeedbackModalCtrl($uibModalInstance,outputService,toastr,indicator,monitoringSession) {

        var vm = this;

        vm.indicator = indicator;
        vm.monitoringSession = monitoringSession;

        vm.save = save;

        function save() {
               var data = null;
               if(vm.indicator.type===1){
                   data = {
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               } else {
                   data = {
                       deviation:vm.monitoringSession.deviation,
                       causality:vm.monitoringSession.causality,
                       recommendation:vm.monitoringSession.recommendation,
                   };
               }

               outputService.monitoringFeedbackUpdate(vm.monitoringSession.id, data).then(function (data) {
                   $uibModalInstance.close(data);
               },function () {
                   toastr.error("Could not edit monitoring feedback");
               });
        }
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('AddAddressModalCtrl', ['$uibModalInstance', 'employeeService', 'toastr', 'userId', 'currentAddress', AddAddressModalCtrl]);

    /** @ngInject */
    function AddAddressModalCtrl($uibModalInstance, employeeService, toastr, userId, currentAddress) {

        var vm = this;

        vm.isAddressTypeAlreadyProvided = isAddressTypeAlreadyProvided;
        vm.addAddress = addAddress;

        function isAddressTypeAlreadyProvided (addressType) {
          for (var i = 0 ; i < currentAddress.length ; i++){
              if(addressType === currentAddress[i].type) {
                  return true;
              }
          }
          return false;
        }


        function addAddress(address, thana, district, type) {
            var data = {
                    "type": type,
                    "address": address,
                    "thana": thana,
                    "district": district
            };
            employeeService.createAddress(data,userId).then(function (address) {
                $uibModalInstance.close(address);
                toastr.success("New address added.");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to add new address." + response.message);
                    console.error("Failed to add new address : " + response.message);
                    toastr.error("Failed to add new address. " + response.message);
                }
            });
        };
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('DocumentUploadModalCtrl', ['$uibModalInstance', 'employeeService', 'toastr', 'userId', DocumentUploadModalCtrl]);

    /** @ngInject */
    function DocumentUploadModalCtrl($uibModalInstance, employeeService, toastr, userId) {
        var vm = this;

        vm.uploadDocument = uploadDocument;

        function uploadDocument (description, documentType, file) {
            if(!file) return toastr.error("File not selected or size limit exceeded.");
            employeeService.uploadDocument(description, documentType, file, userId).then(function (document) {
                $uibModalInstance.close(document);
                toastr.success("Document Uploaded");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload document. " + response.message);
                    console.error("Failed to upload document: " + response.message);
                    toastr.error("Failed to upload document. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('AllowLoginModalCtrl', ['$uibModalInstance', 'allowLogin', 'employeeService', 'toastr', 'userId', 'userName', AllowLoginModalCtrl]);

    /** @ngInject */
    function AllowLoginModalCtrl($uibModalInstance, allowLogin, employeeService, toastr, userId, userName) {

        var vm = this;
        vm.allowLogin = allowLogin;
        vm.name = userName;

        vm.updateAllowLogin = updateAllowLogin;

        function updateAllowLogin (loginValue) {
            employeeService.updateAllowLogin({allowLogin: loginValue}, userId).then(function () {
                $uibModalInstance.close(loginValue);
                toastr.success(loginValue ? "Login privilege granted." : "Login privilege revoked.");
            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to update allow login. " + response.message);
                    console.error("Failed to update allow login : " + response.message);
                    toastr.error("Failed to update allow login. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfilePicCtrl', ['$filter', '$scope', '$timeout', '$uibModal', 'authService', 'employeeService', 'toastr', ProfilePicCtrl]);

    /** @ngInject */
    function ProfilePicCtrl($filter, $scope, $timeout, $uibModal, authService, employeeService, toastr) {
        var vm = this;
        vm.userId = null;
        vm.currentProfilePicURL = null;
        vm.defaultPicture = null;
        vm.isDataReady = null;
        vm.imageSource = imageSource;
        vm.removePicture = removePicture;
        vm.showProfilePictureUploadModal = showProfilePictureUploadModal;

        function init () {
            vm.defaultPicture = $filter('appImage')('theme/no-photo.png');
            $scope.$on("profile-pic-loaded", function (event, userData) {
                $timeout(function () {
                    vm.userId = userData.userId;
                    vm.currentProfilePicURL = userData.profilePicURL ;
                    if (!vm.currentProfilePicURL) vm.noPicture = true;
                    vm.isDataReady = true;
                });
            });
        }

        init();

        function removePicture() {
            employeeService.removeEmployeeProfilePicture(vm.userId).then(function () {
                vm.noPicture = true;
                vm.currentProfilePicURL = null;
                toastr.success("Profile picture removed.");
            }, function (message) {
                toastr.error("Failed to remove profile picture.");
                console.error("Failed to remove profile picture : " + message);
            });
        }

        function imageSource() {
            if(vm.isDataReady){
                if (!vm.currentProfilePicURL) return vm.defaultPicture;
                return vm.currentProfilePicURL;
            }
            return vm.defaultPicture;
        }

        function showProfilePictureUploadModal() {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html',
                controller: 'ProfilePicUploadModalCtrl',
                controllerAs: 'vm',
                resolve: {
                    currentProfilePicURL: function () {
                        return imageSource();
                    },
                    userId: function () {
                        return vm.userId;
                    }
                }
            }).result.then(function (employeePicture) {
                vm.currentProfilePicURL = employeePicture.employeeFile.url;
                if (authService.getLoggedInId() == vm.userId) {
                    authService.updateUserInfo({'employeePicture': employeePicture});
                }
                $scope.$emit("profile-updated", { key : "employeePicture", value : employeePicture});
                vm.noPicture = false;
            }, function () {
                console.log("Profile picture upload modal dismissed.");
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.impactList');
    app.controller('CreateImpactCtrl',['impactService','toastr','$uibModalInstance', 'projectService', CreateImpactCtrl]);

    /** @ngInject */
    function CreateImpactCtrl(impactService,toastr,$uibModalInstance, projectService) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.selectedProject = [];
        vm.projects = [];

        vm.createImpact = createImpact;
        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
            });
        }
        init();
        function createImpact() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                projectId: vm.selectedProject[0].id,
            };
            impactService.createImpact(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create impact ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.impactList');
    app.controller('EditImpactCtrl',['impactService','toastr','$uibModalInstance', 'projectService', 'impact', EditImpactCtrl]);

    /** @ngInject */
    function EditImpactCtrl(impactService,toastr,$uibModalInstance, projectService, impact) {

        var vm = this;
        vm.number = impact.number;
        vm.summary = impact.summary;
        vm.selectedProject = [];
        vm.projects = [];

        vm.editImpact = editImpact;
        function init() {
            projectService.getAllProjects().then(function (data) {
                vm.projects = data;
                for(var i = 0; i< vm.projects.length; i++){
                    if(vm.projects[i].id === impact.project.id){
                        vm.projects[i].ticked = true;
                    }
                }
            });
        }
        init();
        function editImpact() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                projectId: vm.selectedProject[0].id,
            };
            impactService.editImpact(impact.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create impact ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup')
        .controller('EditResearchFrameworkModalCtrl', ['$uibModalInstance', 'impactService', 'toastr', 'indicator', EditResearchFrameworkModalCtrl]);

    /** @ngInject */
    function EditResearchFrameworkModalCtrl($uibModalInstance, impactService, toastr, indicator) {

        var vm = this;

        vm.indicator = null;

        vm.updateIndicator = updateIndicator;

        function init() {
            vm.indicator = angular.copy(indicator);
        }

        function updateIndicator() {
            var data = {
                informationRequired: vm.indicator.informationRequired,
                sourceOfInformation: vm.indicator.sourceOfInfo,
                dataCollectionMethod: vm.indicator.dataCollectionMethod,
            };
            impactService.setupResearchFrameworkForImpactIndicator(vm.indicator.id, data).then(function (data) {
                $uibModalInstance.close(data);
            }, function () {
                toastr.error("Could not setup indicator research framework");
            });
        }
        init();
    }

})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.outcomeList');
    app.controller('EditOutcomeCtrl',['outcomeService','toastr','$uibModalInstance','impactService', 'outcome', EditOutcomeCtrl]);

    /** @ngInject */
    function EditOutcomeCtrl(outcomeService,toastr,$uibModalInstance, impactService, outcome) {

        var vm = this;
        vm.number = outcome.number;
        vm.summary = outcome.summary;
        vm.selectedImpact = [];
        vm.impacts = [];

        vm.editOutcome = editOutcome;
        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
                for(var i = 0; i< vm.impacts.length; i++){
                    if(vm.impacts[i].id === outcome.impact.id){
                        vm.impacts[i].ticked = true;
                    }
                }
            });
        }
        init();
        function editOutcome() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                impactId: vm.selectedImpact[0].id,
            };
            outcomeService.editOutcome(outcome.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not edit outcome ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.outcomeList');
    app.controller('CreateOutcomeCtrl',['impactService','outcomeService','toastr','$uibModalInstance', CreateOutcomeCtrl]);

    /** @ngInject */
    function CreateOutcomeCtrl(impactService,outcomeService,toastr,$uibModalInstance) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.selectedImpact = [];
        vm.impacts = [];

        vm.createOutcome = createOutcome;
        function init() {
            impactService.getAllImpacts().then(function (data) {
                vm.impacts = data;
            });
        }
        init();
        function createOutcome() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                impactId: vm.selectedImpact[0].id,
            };
            outcomeService.createOutcome(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create outcome ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeSetup')
        .controller('SetupOutcomeResearchFrameworkModalCtrl', ['$uibModalInstance', 'outcomeService', 'toastr', 'indicator', SetupOutcomeResearchFrameworkModalCtrl]);

    /** @ngInject */
    function SetupOutcomeResearchFrameworkModalCtrl($uibModalInstance, outcomeService, toastr, indicator) {

        var vm = this;
        vm.indicator = null;

        vm.setupResearchFramework = setupResearchFramework;

        function init() {
            vm.indicator = angular.copy(indicator);
        }

        function setupResearchFramework() {
                var data = {
                    informationRequired: vm.indicator.informationRequired,
                    sourceOfInformation: vm.indicator.sourceOfInfo,
                    dataCollectionMethod: vm.indicator.dataCollectionMethod,
                };
                outcomeService.setupResearchFrameworkForOutcomeIndicator(vm.indicator.id, data).then(function (data) {
                    $uibModalInstance.close(data);
                }, function () {
                    toastr.error("Could not setup indicator research framework");
                });
        }
        init();
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputSetup')
        .controller('SetupOutputResearchFrameworkModalCtrl', ['$uibModalInstance', 'outputService', 'toastr', 'indicator', SetupOutputResearchFrameworkModalCtrl]);

    /** @ngInject */
    function SetupOutputResearchFrameworkModalCtrl($uibModalInstance, outputService, toastr, indicator) {

        var vm = this;
        vm.indicator = null;

        vm.setupResearchFramework = setupResearchFramework;

        function init() {
            vm.indicator = angular.copy(indicator);
        }

        function setupResearchFramework() {
                var data = {
                    informationRequired: vm.indicator.informationRequired,
                    sourceOfInformation: vm.indicator.sourceOfInfo,
                    dataCollectionMethod: vm.indicator.dataCollectionMethod,
                };
                outputService.setupResearchFrameworkForOutputIndicator(vm.indicator.id, data).then(function (data) {
                    $uibModalInstance.close(data);
                }, function () {
                    toastr.error("Could not setup indicator research framework");
                });
        }
        init();
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.outputList');
    app.controller('CreateOutputCtrl',['employeeService','outputService','toastr','$uibModalInstance', 'impacts', 'ROLES',CreateOutputCtrl]);

    /** @ngInject */
    function CreateOutputCtrl(employeeService,outputService,toastr,$uibModalInstance, impacts, ROLES) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.impacts = angular.copy(impacts);
        vm.coordinatorName = null;
        vm.selectedImpacts = [];
        vm.outcomes = null;
        vm.selectedOutcomes = [];
        vm.allEmployees = [];
        vm.selectedEmployeesUI = [];

        vm.createOutput = createOutput;
        vm.mapOutcomes = mapOutcomes;

        init();

        function init() {
            employeeService.getAllEmployeesByRole(ROLES.BY_NAME.COORDINATOR).then(function (data) {
                vm.allEmployees = data;
            })
        }


        function mapOutcomes() {
            vm.outcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.outcomes = _.flatten(vm.outcomes);
        }

        function createOutput() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                outcomeId: vm.selectedOutcomes[0].id,
                // coodinatorIdList: vm.selectedEmployeesUI.map(function (item) {
                //     return item.id;
                // })
                coordinatorName : vm.coordinatorName
            };
            outputService.createOutput(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create output ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.setup.outputList');
    app.controller('EditOutputCtrl',['_','outputService','toastr','$uibModalInstance', 'output', 'impacts', 'employeeService', 'ROLES', EditOutputCtrl]);

    /** @ngInject */
    function EditOutputCtrl(_, outputService,toastr,$uibModalInstance, output, impacts, employeeService, ROLES) {

        var vm = this;
        vm.number = output.number;
        vm.summary = output.summary;
        vm.impacts = impacts;
        vm.coordinatorName = output.coordinatorName;
        vm.selectedImpacts = [];
        vm.outcomes = [];
        vm.selectedOutcomes = [];
        vm.allEmployees = [];
        vm.selectedEmployeesUI = [];
        vm.outcomes = [];

        vm.mapOutcomes = mapOutcomes;
        vm.editOutput = editOutput;

        function init() {
            employeeService.getAllEmployeesByRole(ROLES.BY_NAME.COORDINATOR).then(function (data) {
                vm.allEmployees = data;
                for(var i=0;i<vm.allEmployees.length;i++){
                    for(var j=0; j<output.users.length; j++){
                        if(vm.allEmployees[i].id === output.users[j].id){
                            vm.allEmployees[i].ticked = true;
                        }
                    }
                }
            });
            for(var i = 0; i < vm.impacts.length; i++){
                if(vm.impacts[i].id === output.outcome.impact.id){
                    vm.impacts[i].ticked = true;
                    vm.selectedImpacts.push(impacts[i]);
                    vm.impacts[i].outcomes.forEach(function (outcome) {
                        if(outcome.status === 1){
                            if(outcome.id === output.outcome.id){
                                outcome.ticked = true;
                                vm.selectedOutcomes.push(outcome);
                            }
                            vm.outcomes.push(outcome);
                        }
                    });
                    break;
                }
            }
        }

        init();

        function editOutput() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                outcomeId: vm.selectedOutcomes[0].id,
                // coodinatorIdList: vm.selectedEmployeesUI.map(function (item) {
                //     return item.id;
                // })
                coordinatorName : vm.coordinatorName
            };
            outputService.updateOutput(output.id, data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not edit output ");
            })
        }

        function mapOutcomes() {
            vm.outcomes = vm.selectedImpacts.map(function (impact) {
                return impact.outcomes;
            });
            vm.outcomes = _.flatten(vm.outcomes);
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.profile')
        .controller('ProfilePicUploadModalCtrl', ['$filter', '$uibModalInstance', 'API', 'currentProfilePicURL', 'toastr', 'userId', 'Upload', ProfilePicUploadModalCtrl]);

    /** @ngInject */
    function ProfilePicUploadModalCtrl($filter, $uibModalInstance, API, currentProfilePicURL, toastr, userId, Upload) {

        var vm = this;
        vm.defaultPicture = null;
        vm.currentProfilePicURL = null;
        vm.isFileSelected = false;
        vm.fileSelected = fileSelected;
        vm.uploadProfilePicture = uploadProfilePicture;

        init();

        function init () {
            vm.currentProfilePicURL = currentProfilePicURL ? currentProfilePicURL : $filter('appImage')('theme/no-photo.png');
        }

        function fileSelected() {
            vm.isFileSelected = true;
        }

        function uploadProfilePicture(dataUrl, name) {
            vm.isFileSelected = false;
            Upload.upload({
                url: API.employee.uploadProfilePicture + userId,
                data: {
                    file: Upload.dataUrltoBlob(dataUrl, name)
                }
            }).then(function (response) {
                if (response.status === 200) {
                    $uibModalInstance.close(response.data.employeePicture);
                    toastr.success("Profile picture updated.");
                } else {
                    $uibModalInstance.dismiss("Failed to upload profile picture. " + response.message);
                    console.error("failed to upload profile picture : " + response.message);
                    toastr.error("Failed to upload profile picture. " + response.message);
                }

            }, function (response) {
                if (response.status > 0) {
                    $uibModalInstance.dismiss("Failed to upload profile picture. " + response.message);
                    console.error("failed to upload profile picture : " + response.message);
                    toastr.error("Failed to upload profile picture. " + response.message);
                }
            });
        }
    }
})();
(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup');
    app.controller('ImpactIndicatorEditCtrl', ['$stateParams', '$state', 'impactService', 'toastr', 'timeInterval', ImpactIndicatorEditCtrl]);

    /** @ngInject */
    function ImpactIndicatorEditCtrl($stateParams, $state, impactService, toastr, timeInterval) {


        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.baseline = null;
        vm.unit = null;
        vm.type = null;
        vm.typeOptions = null;
        vm.startDate = null;
        vm.tableData = [];
        vm.isOpen = false;
        vm.format = null;
        vm.isDirty = false;
        vm.monitoringSessions = [];

        vm.openCalendar = openCalendar;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;
        vm.deleteMonitoringSession = deleteMonitoringSession;
        vm.createMonitoringSession = createMonitoringSession;
        vm.extendMonitoring = extendMonitoring;
        vm.editMonitoringSession = editMonitoringSession;
        vm.updateIndicator = updateIndicator;

        function init() {
            vm.typeOptions = [{
                name: "Qualitative",
                value: 0
            }, {
                name: "Quantitative",
                value: 1
            }];
            impactService.getImpactIndicator($stateParams.id).then(function (data) {
                setupForIndicator(data);
            }, function () {
                toastr.error("Could not fetch impact indicator");
            });
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
        }

        init();

        function setupForIndicator(data) {
            vm.number = data.number;
            vm.summary = data.summary;
            vm.type = data.type;
            vm.unit = data.unit;
            vm.baseline = data.baseline;
            vm.startDate = new Date(data.startDate);
            vm.timeline = data.timeline;
            vm.monitoringInterval = data.monitoringInterval;
            vm.meansOfVerification = data.meansOfVerification;
            vm.assumption = data.assumption;
            if (vm.type === 1) {
                vm.baseline = Number(vm.baseline);
            }
            vm.monitoringSessions = [];
            vm.monitoringSessions = angular.copy(data.impactMonitoringSessions);
            vm.monitoringSessions.forEach(function (monitoringSession) {
                monitoringSession.isOpen = false;
                if (vm.type === 1) {
                    monitoringSession.target = Number(monitoringSession.target);
                }
            });
        }

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e, index) {
            e.preventDefault();
            e.stopPropagation();
            vm.monitoringSessions[index].isOpen = true;
        }

        function deleteMonitoringSession(monitoringSession) {
            impactService.deleteMonitoringSession(monitoringSession.id).then(function (data) {
                setupForIndicator(data);
            }, function () {
                toastr.error("Could not delete monitoring session");
            });
        }

        function createMonitoringSession(monitoringSession) {
            monitoringSession.timeOfMonitoring = monitoringSession.timeOfMonitoring.getTime();
            impactService.createMonitoringSession($stateParams.id, monitoringSession).then(function (impactMonitoringSession) {
                vm.monitoringSessions.pop();
                impactMonitoringSession.isOpen = false;
                if(vm.type === 1){
                    impactMonitoringSession.target = Number(impactMonitoringSession.target);
                }
                vm.monitoringSessions.push(impactMonitoringSession);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not create new monitoring session");
            });
        }

        function editMonitoringSession(monitoringSession) {
            if(!monitoringSession || !monitoringSession.id) return;
            monitoringSession.timeOfMonitoring = Number(monitoringSession.timeOfMonitoring);
            impactService.editMonitoringSession(monitoringSession.id, monitoringSession).then(function (data) {
                setupForIndicator(data);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not edit monitoring session");
            });
        }

        function updateIndicator() {
            var data = {
                "number": vm.number,
                "summary" : vm.summary,
                "meansOfVerification" : vm.meansOfVerification,
                "assumption" : vm.assumption,
                "type"      : vm.type,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : vm.baseline,
                "unit"      : vm.unit,
            };
            impactService.updateIndicator($stateParams.id,data).then(function (responseData) {
                toastr.success("Saved.");
                setupForIndicator(responseData);
            },function () {
                toastr.error("Could not update indicator");
            });
        }

        function extendMonitoring() {
            if (vm.type === null) return toastr.error("Please select Indicator type to edit");
            vm.monitoringSessions.push({
                "timeOfMonitoring": new Date(),
                "target": vm.type === 1 ? Number(0) : '',
                'isOpen': false,
                'new': true,
            });
        }

        function getUnitString() {
            return "( " + vm.unit + " )";
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup');
    app.controller('ImpactIndicatorCreateCtrl',['$stateParams','$state', 'impactService','toastr', 'timeInterval', ImpactIndicatorCreateCtrl]);

    /** @ngInject */
    function ImpactIndicatorCreateCtrl($stateParams, $state, impactService,toastr,timeInterval) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.unit = null;
        vm.timeLines = null;
        vm.startDate = null;
        vm.isOpen = false;
        vm.format = null;
        vm.intervals = null;
        vm.selectedTimeLine = null;
        vm.selectedInterval = null;
        vm.intervalsToBeShown = null;
        vm.typeOptions = null;
        vm.type = null;
        vm.baseline = null;
        vm.tableData = [];

        vm.openCalendar = openCalendar;
        vm.createImpactIndicator = createImpactIndicator;
        vm.selectInterval = selectInterval;
        vm.createTableData = createTableData;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;

        function init() {
            vm.startDate = new Date();
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
            vm.type = 1;
            vm.timeLines = [
                // 'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];
            vm.typeOptions = [{
                name:"Qualitative",
                value:0
            },{
                name:"Quantitative",
                value:1
            }];
            vm.intervals = timeInterval;
        }
        init();

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }

        function createImpactIndicator() {
            var monitoringData = angular.copy(vm.tableData);
            monitoringData = monitoringData.map( function (data) {
                data.timeOfMonitoring = data.timeOfMonitoring.getTime();
                return data;
            });
            var data = {
                "number": vm.number,
                "summary" : vm.summary,
                "meansOfVerification" : vm.meansOfVerification,
                "assumption" : vm.assumption,
                "type"      : vm.type,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : vm.baseline,
                "unit"      : vm.unit,
                "timeline"  : vm.intervals && vm.intervals[vm.selectedTimeLine] && vm.intervals[vm.selectedTimeLine].value ? vm.intervals[vm.selectedTimeLine].value : 0,
                "interval"  : vm.selectedInterval? vm.selectedInterval.value : 0,
                "monitoringSessionRequests" : monitoringData
            };
            impactService.createImpactIndicator($stateParams.id,data).then(function () {
                $state.go('impactSetup',{id:$stateParams.id});
                toastr.success("Impact indicator created.");
            },function () {
                toastr.error("Could not create indicator");
            });
        }

        function selectInterval () {
            if(vm.selectedTimeLine !== 'Immediate'){
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
        }

        function createTableData() {
            if(vm.type === null)
               return toastr.error("Please select Indicator type to edit")

            var rowsToCreate = (Number(vm.intervals[vm.selectedTimeLine].value))/Number(vm.selectedInterval.value);
            vm.tableData = [];
            for(var i = 1 ;i <= rowsToCreate;i++){
                vm.tableData.push({
                    "timeOfMonitoring" : moment(vm.startDate).add(i * vm.selectedInterval.value,'M').toDate(),
                    "target" : (vm.type === 1 && vm.baseline !== '')? '': '',
                    'isOpen' : false,
                })
            }
        }

        function getUnitString() {
            return "( " + vm.unit +" )";
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.impactSetup');
    app.controller('OutcomeCreateModalCtrl',['outcomeService','toastr','$uibModalInstance','impactId', OutcomeCreateModalCtrl]);

    /** @ngInject */
    function OutcomeCreateModalCtrl(outcomeService,toastr,$uibModalInstance,impactId) {

        var vm = this;

        vm.number = null;
        vm.summary = null;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;

        vm.createOutcome = createOutcome;

        function init() {
            vm.impactId = impactId;
        }
        init();
        function createOutcome() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                impactId: vm.impactId,
                indicators:[{
                    indicator:vm.indicator,
                    meansOfVerification: vm.meansOfVerification,
                    assumption: vm.assumption
                }]
            };
            outcomeService.createOutcome(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create outcome ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeSetup');
    app.controller('OutcomeIndicatorCreateCtrl', ['$stateParams', '$state', 'outcomeService', 'toastr', 'timeInterval', OutcomeIndicatorCreateCtrl]);

    /** @ngInject */
    function OutcomeIndicatorCreateCtrl($stateParams, $state, outcomeService, toastr, timeInterval) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.unit = null;
        vm.timeLines = null;
        vm.startDate = null;
        vm.isOpen = false;
        vm.format = null;
        vm.intervals = null;
        vm.selectedTimeLine = null;
        vm.selectedInterval = null;
        vm.intervalsToBeShown = null;
        vm.typeOptions = null;
        vm.type = null;
        vm.baseline = null;
        vm.tableData = [];

        vm.openCalendar = openCalendar;
        vm.createOutcomeIndicator = createOutcomeIndicator;
        vm.selectInterval = selectInterval;
        vm.createTableData = createTableData;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;

        function init() {
            vm.startDate = new Date();
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
            vm.type = 1;
            vm.timeLines = [
                // 'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];
            vm.typeOptions = [{
                name: "Qualitative",
                value: 0
            }, {
                name: "Quantitative",
                value: 1
            }];
            vm.intervals = timeInterval;
            console.log("IN CREATE OUTCOME INDICATOR CTRL")
        }

        init();

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e, index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }

        function createOutcomeIndicator() {
            var monitoringData = angular.copy(vm.tableData);
            monitoringData = monitoringData.map(function (data) {
                data.timeOfMonitoring = data.timeOfMonitoring.getTime();
                return data;
            });
            var data = {
                "number": vm.number,
                "summary": vm.summary,
                "meansOfVerification": vm.meansOfVerification,
                "assumption": vm.assumption,
                "type": vm.type,
                "startDate": vm.startDate.getTime(),
                "baseline": vm.baseline,
                "unit": vm.unit,
                "timeline": vm.intervals && vm.intervals[vm.selectedTimeLine] && vm.intervals[vm.selectedTimeLine].value ? vm.intervals[vm.selectedTimeLine].value : 0,
                "interval": vm.selectedInterval ? vm.selectedInterval.value : 0,
                "monitoringSessionRequests": monitoringData
            };
            outcomeService.createOutcomeIndicator($stateParams.id, data).then(function () {
                $state.go('outcomeSetup', {id: $stateParams.id});
                toastr.success("Outcome indicator created.");
            }, function () {
                toastr.error("Could not create indicator");
            });
        }

        function selectInterval() {
            if (vm.selectedTimeLine !== 'Immediate') {
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
        }

        function createTableData() {
            if (vm.type === null)
                return toastr.error("Please select Indicator type to edit")

            var rowsToCreate = (Number(vm.intervals[vm.selectedTimeLine].value))/Number(vm.selectedInterval.value);
            vm.tableData = [];
            for (var i = 1; i <= rowsToCreate; i++) {
                vm.tableData.push({
                    "timeOfMonitoring": moment(vm.startDate).add(i * vm.selectedInterval.value, 'M').toDate(),
                    "target": (vm.type === 1 && vm.baseline !== '') ? '' : '',
                    'isOpen': false,
                })
            }
        }

        function getUnitString() {
            return "( " + vm.unit + " )";
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeSetup');
    app.controller('OutputCreateModalCtrl',['outputService','employeeService','toastr','$uibModalInstance','outcomeId', 'ROLES', OutputCreateModalCtrl]);

    /** @ngInject */
    function OutputCreateModalCtrl(outputService,employeeService,toastr,$uibModalInstance,outcomeId, ROLES) {

        var vm = this;

        vm.number = null;
        vm.summary = null;
        vm.indicator = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.allEmployees = [];
        vm.selectedEmployeesUI = [];

        vm.createOutput = createOutput;

        function init() {
            vm.outcomeId = outcomeId;
            employeeService.getAllEmployeesByRole(ROLES.BY_NAME.COORDINATOR).then(function (data) {
                vm.allEmployees = data;
            })
        }
        init();
        function createOutput() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                outcomeId: vm.outcomeId,
                coodinatorIdList: vm.selectedEmployeesUI.map(function (item) {
                    return item.id;
                })
            };
            outputService.createOutput(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create outcome ");
            })
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outcomeSetup');
    app.controller('OutcomeIndicatorEditCtrl',['$stateParams','$state', 'outcomeService','toastr', 'timeInterval', OutcomeIndicatorEditCtrl]);

    /** @ngInject */
    function OutcomeIndicatorEditCtrl($stateParams, $state, outcomeService,toastr,timeInterval) {


        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.baseline = null;
        vm.unit = null;
        vm.type = null;
        vm.typeOptions = null;
        vm.startDate = null;
        vm.tableData = [];
        vm.isOpen = false;
        vm.format = null;
        vm.isDirty = false;
        vm.monitoringSessions = [];

        vm.openCalendar = openCalendar;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;
        vm.deleteMonitoringSession = deleteMonitoringSession;
        vm.createMonitoringSession = createMonitoringSession;
        vm.extendMonitoring = extendMonitoring;
        vm.editMonitoringSession = editMonitoringSession;
        vm.updateIndicator = updateIndicator;

        function init() {
            vm.typeOptions = [{
                name:"Qualitative",
                value:0
            },{
                name:"Quantitative",
                value:1
            }];
            outcomeService.getOutcomeIndicator($stateParams.id).then(function (data) {
                setupForIndicator(data);
            },function () {
                toastr.error("Could not fetch indicator");
            });
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
        }

        init();

        function setupForIndicator(data) {
            vm.number = data.number;
            vm.summary = data.summary;
            vm.type = data.type;
            vm.unit = data.unit;
            vm.baseline = data.baseline;
            vm.startDate = new Date(data.startDate);
            vm.timeline = data.timeline;
            vm.monitoringInterval = data.monitoringInterval;
            vm.meansOfVerification = data.meansOfVerification;
            vm.assumption = data.assumption;
            if (vm.type === 1) {
                vm.baseline = Number(vm.baseline);
            }
            vm.monitoringSessions = [];
            vm.monitoringSessions = angular.copy(data.outcomeMonitoringSessions);
            vm.monitoringSessions.forEach(function (monitoringSession) {
                monitoringSession.isOpen = false;
                if (vm.type === 1) {
                    monitoringSession.target = Number(monitoringSession.target);
                }
            });
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.monitoringSessions[index].isOpen = true;
        }

        function deleteMonitoringSession(monitoringSession) {
            outcomeService.deleteMonitoringSession(monitoringSession.id).then(function (data) {
                setupForIndicator(data);
            }, function () {
                toastr.error("Could not delete monitoring session");
            });
        }

        function createMonitoringSession(monitoringSession) {
            monitoringSession.timeOfMonitoring = monitoringSession.timeOfMonitoring.getTime();
            outcomeService.createMonitoringSession($stateParams.id, monitoringSession).then(function (outcomeMonitoringSession) {
                vm.monitoringSessions.pop();
                outcomeMonitoringSession.isOpen = false;
                if(vm.type === 1){
                    outcomeMonitoringSession.target = Number(outcomeMonitoringSession.target);
                }
                vm.monitoringSessions.push(outcomeMonitoringSession);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not create new monitoring session");
            });
        }

        function editMonitoringSession(monitoringSession) {
            if(!monitoringSession || !monitoringSession.id) return;
            outcomeService.editMonitoringSession(monitoringSession.id, monitoringSession).then(function (data) {
                setupForIndicator(data);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not edit monitoring session");
            });
        }

        function updateIndicator() {
            var data = {
                "number": vm.number,
                "summary" : vm.summary,
                "meansOfVerification" : vm.meansOfVerification,
                "assumption" : vm.assumption,
                "type"      : vm.type,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : vm.baseline,
                "unit"      : vm.unit,
            };
            outcomeService.updateIndicator($stateParams.id,data).then(function (responseData) {
                toastr.success("Saved.");
                setupForIndicator(responseData);
            },function () {
                toastr.error("Could not update indicator");
            });
        }

        function extendMonitoring() {
            if (vm.type === null) return toastr.error("Please select Indicator type to edit");
            vm.monitoringSessions.push({
                "timeOfMonitoring": new Date(),
                "target": vm.type === 1 ? Number(0) : '',
                'isOpen': false,
                'new': true,
            });
        }

        function getUnitString() {
            return "( " + vm.unit + " )";
        }
    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputSetup');
    app.controller('MajorActivityCreateModalCtrl',['majorActivityService','toastr','$uibModalInstance','outputId', MajorActivityCreateModalCtrl]);

    /** @ngInject */
    function MajorActivityCreateModalCtrl(majorActivityService,toastr,$uibModalInstance,outputId) {

        var vm = this;

        vm.outputId = outputId;
        vm.number = null;
        vm.summary = null;
        vm.startDate = new Date();
        vm.isOpen = false;
        vm.format = 'MMM yyyy';

        vm.createMajorActivity = createMajorActivity;
        vm.openCalendar = openCalendar;


        function createMajorActivity() {
            var data = {
                number : vm.number,
                summary : vm.summary,
                outputId: vm.outputId,
                startDate: vm.startDate.getTime(),
            };
            majorActivityService.createMajorActivity(data).then(function (responseData) {
                $uibModalInstance.close(responseData);
            },function () {
                toastr.error("Could not create major activity ");
            })
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputSetup');
    app.controller('OutputIndicatorCreateCtrl', ['$stateParams', '$state', 'outputService', 'toastr', 'timeInterval', OutputIndicatorCreateCtrl]);

    /** @ngInject */
    function OutputIndicatorCreateCtrl($stateParams, $state, outputService, toastr, timeInterval) {

        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.unit = null;
        vm.timeLines = null;
        vm.startDate = null;
        vm.isOpen = false;
        vm.format = null;
        vm.intervals = null;
        vm.selectedTimeLine = null;
        vm.selectedInterval = null;
        vm.intervalsToBeShown = null;
        vm.typeOptions = null;
        vm.type = null;
        vm.baseline = null;
        vm.rowsToCreate = null;
        vm.tableData = [];

        vm.openCalendar = openCalendar;
        vm.createOutputIndicator = createOutputIndicator;
        vm.selectInterval = selectInterval;
        vm.createTableData = createTableData;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;

        function init() {
            vm.startDate = new Date();
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
            vm.type = 1;
            vm.timeLines = [
                // 'Immediate',
                '3 months',
                '6 months',
                '1 year',
                '2 years',
                '3 years',
                '4 years',
                '5 years',
                '6 years',
                '7 years',
                '8 years',
                '9 years',
                '10 years',
            ];
            vm.typeOptions = [{
                name: "Qualitative",
                value: 0
            }, {
                name: "Quantitative",
                value: 1
            }];
            vm.intervals = timeInterval;
            console.log("IN CREATE OUTCOME INDICATOR CTRL")
        }

        init();

        function openCalendar(e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e, index) {
            e.preventDefault();
            e.stopPropagation();
            vm.tableData[index].isOpen = true;
        }

        function createOutputIndicator() {
            var monitoringData = angular.copy(vm.tableData);
            monitoringData = monitoringData.map(function (data) {
                data.timeOfMonitoring = data.timeOfMonitoring.getTime();
                return data;
            });
            var data = {
                "number": vm.number,
                "summary": vm.summary,
                "meansOfVerification": vm.meansOfVerification,
                "assumption": vm.assumption,
                "type": vm.type,
                "startDate": vm.startDate.getTime(),
                "baseline": vm.baseline,
                "unit": vm.unit,
                "timeline": vm.intervals && vm.intervals[vm.selectedTimeLine] && vm.intervals[vm.selectedTimeLine].value ? vm.intervals[vm.selectedTimeLine].value : 0,
                "interval": vm.selectedInterval ? vm.selectedInterval.value : 0,
                "monitoringSessionRequests": monitoringData
            };
            outputService.createOutputIndicator($stateParams.id, data).then(function () {
                $state.go('outputSetup', {id: $stateParams.id});
                toastr.success("Output indicator created.");
            }, function () {
                toastr.error("Could not create indicator");
            });
        }

        function selectInterval() {
            if (vm.selectedTimeLine !== 'Immediate') {
                vm.intervalsToBeShown = vm.intervals[vm.selectedTimeLine].options;
            }
        }

        function createTableData() {
            if (vm.type === null)
                return toastr.error("Please select Indicator type to edit")

            var rowsToCreate = (Number(vm.intervals[vm.selectedTimeLine].value)) / Number(vm.selectedInterval.value);
            vm.tableData = [];
            for (var i = 1; i <= rowsToCreate; i++) {
                vm.tableData.push({
                    "timeOfMonitoring": moment(vm.startDate).add(i * vm.selectedInterval.value, 'M').toDate(),
                    "target": (vm.type === 1 && vm.baseline !== '') ? '' : '',
                    'isOpen': false,
                })
            }
        }

        function getUnitString() {
            return "( " + vm.unit + " )";
        }

    }

})();

(function () {
    'use strict';

    angular.module('NGOMonitoringClientApp.pages.main.outputSetup');
    app.controller('OutputIndicatorEditCtrl',['$stateParams','$state', 'outputService','toastr', 'timeInterval', OutputIndicatorEditCtrl]);

    /** @ngInject */
    function OutputIndicatorEditCtrl($stateParams, $state, outputService,toastr,timeInterval) {


        var vm = this;
        vm.number = null;
        vm.summary = null;
        vm.meansOfVerification = null;
        vm.assumption = null;
        vm.baseline = null;
        vm.unit = null;
        vm.type = null;
        vm.typeOptions = null;
        vm.startDate = null;
        vm.tableData = [];
        vm.isOpen = false;
        vm.format = null;
        vm.isDirty = false;
        vm.monitoringSessions = [];

        vm.openCalendar = openCalendar;
        vm.getUnitString = getUnitString;
        vm.openCalendarInTable = openCalendarInTable;
        vm.deleteMonitoringSession = deleteMonitoringSession;
        vm.createMonitoringSession = createMonitoringSession;
        vm.extendMonitoring = extendMonitoring;
        vm.editMonitoringSession = editMonitoringSession;
        vm.updateIndicator = updateIndicator;

        function init() {
            vm.typeOptions = [{
                name:"Qualitative",
                value:0
            },{
                name:"Quantitative",
                value:1
            }];
            outputService.getOutputIndicator($stateParams.id).then(function (data) {
                setupForIndicator(data);
            },function () {
                toastr.error("Could not fetch indicator");
            });
            vm.isOpen = false;
            vm.format = 'MMM yyyy';
        }

        init();

        function setupForIndicator(data) {
            vm.number = data.number;
            vm.summary = data.summary;
            vm.type = data.type;
            vm.unit = data.unit;
            vm.baseline = data.baseline;
            vm.startDate = new Date(data.startDate);
            vm.timeline = data.timeline;
            vm.monitoringInterval = data.monitoringInterval;
            vm.meansOfVerification = data.meansOfVerification;
            vm.assumption = data.assumption;
            if (vm.type === 1) {
                vm.baseline = Number(vm.baseline);
            }
            vm.monitoringSessions = [];
            vm.monitoringSessions = angular.copy(data.outputMonitoringSessions);
            vm.monitoringSessions.forEach(function (monitoringSession) {
                monitoringSession.isOpen = false;
                if (vm.type === 1) {
                    monitoringSession.target = Number(monitoringSession.target);
                }
            });
        }

        function openCalendar (e) {
            e.preventDefault();
            e.stopPropagation();
            vm.isOpen = true;
        }

        function openCalendarInTable(e,index) {
            e.preventDefault();
            e.stopPropagation();
            vm.monitoringSessions[index].isOpen = true;
        }

        function deleteMonitoringSession(monitoringSession) {
            outputService.deleteMonitoringSession(monitoringSession.id).then(function (data) {
                setupForIndicator(data);
            }, function () {
                toastr.error("Could not delete monitoring session");
            });
        }

        function createMonitoringSession(monitoringSession) {
            monitoringSession.timeOfMonitoring = monitoringSession.timeOfMonitoring.getTime();
            outputService.createMonitoringSession($stateParams.id, monitoringSession).then(function (outputMonitoringSession) {
                vm.monitoringSessions.pop();
                outputMonitoringSession.isOpen = false;
                if(vm.type === 1){
                    outputMonitoringSession.target = Number(outputMonitoringSession.target);
                }
                vm.monitoringSessions.push(outputMonitoringSession);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not create new monitoring session");
            });
        }

        function editMonitoringSession(monitoringSession) {
            if(!monitoringSession || !monitoringSession.id) return;
            outputService.editMonitoringSession(monitoringSession.id, monitoringSession).then(function (data) {
                setupForIndicator(data);
                toastr.success("Saved.");
            }, function () {
                toastr.error("Could not edit monitoring session");
            });
        }

        function updateIndicator() {
            var data = {
                "number": vm.number,
                "summary" : vm.summary,
                "meansOfVerification" : vm.meansOfVerification,
                "assumption" : vm.assumption,
                "type"      : vm.type,
                "startDate" : vm.startDate.getTime(),
                "baseline"  : vm.baseline,
                "unit"      : vm.unit,
            };
            outputService.updateIndicator($stateParams.id,data).then(function (responseData) {
                toastr.success("Saved.");
                setupForIndicator(responseData);
            },function () {
                toastr.error("Could not update indicator");
            });
        }

        function extendMonitoring() {
            if (vm.type === null) return toastr.error("Please select Indicator type to edit");
            vm.monitoringSessions.push({
                "timeOfMonitoring": new Date(),
                "target": vm.type === 1 ? Number(0) : '',
                'isOpen': false,
                'new': true,
            });
        }

        function getUnitString() {
            return "( " + vm.unit + " )";
        }
    }

})();

angular.module('NGOMonitoringClientApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/pages/auth/auth.html','<main class="auth-main" ng-if="$pageFinishedLoading"><div ui-view="pub"></div></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/main/main.html','<div class="body-bg"></div><main ng-if="$pageFinishedLoading" ng-class="{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }"><ba-sidebar></ba-sidebar><page-top></page-top><div class="al-main"><div class="al-content"><content-top></content-top><div ui-view="app" autoscroll="true" autoscroll-body-top=""></div></div></div><footer class="al-footer clearfix"><div class="al-footer-main clearfix"><div class="al-copy"><span style="font-family:Calibri">Co-funded by the European Union</span></div><ul class="al-share clearfix"><li><img style="height:40px;width: auto" src="assets/img/euLogo.jpg" alt=""></li><li><img style="height:40px;width: auto" src="assets/img/tdhLogo.png" alt=""></li><li><a href="https://www.inovacetech.com/" target="_blank"><img style="height:40px;width: auto" src="assets/img/inovace.png" alt=""></a></li></ul></div></footer><back-top></back-top></main><div id="preloader" ng-show="!$pageFinishedLoading"><div></div></div>');
$templateCache.put('app/pages/auth/login/login.html','<div class="login-background"><div class="login-bg"><img src="../assets/img/InovaceLogo.png" alt="inovace logo" class="login-logo-size"><form ng-submit="login()" no-validate=""><div class="form-group"><label for="inputEmail3">Email</label> <input type="email" class="form-control login" id="inputEmail3" placeholder="Email" ng-model="loginData.email" autocomplete="on"></div><div class="form-group"><label for="inputPassword3">Password</label> <input type="password" class="form-control login" id="inputPassword3" placeholder="Password" ng-model="loginData.password"></div><button type="submit" class="btn btn-primary login-button-primary">Login</button></form><ul class="login-social-icon hidden"><li><a href="#"><i class="fa fa-facebook-official" aria-hidden="true"></i></a></li><li><a href="#"><i class="fa fa-google-plus-official" aria-hidden="true"></i></a></li><li><a href="#"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li><li><a href="#"><i class="fa fa-skype" aria-hidden="true"></i></a></li></ul></div></div>');
$templateCache.put('app/pages/main/activityMenu/activityMenu.html','<style xmlns="http://www.w3.org/1999/html">\n    .list-avatar{\n        border-radius: 50%;\n        height: 30px;\n        width: 30px;\n        float: left;\n        margin-top: 2px;\n    }\n</style><div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Activity Menu" ba-panel-class="with-scroll"><div ng-if="vm.showFilters" ng-animate="\'slide" style="margin-bottom: 20px;"><div style="margin-top: 20px;text-align: center" class="row form-inline"><div class="form-group col-sm-4 col-xs-6"><h4>Impact</h4><div isteven-multi-select="" input-model="vm.impactList" output-model="vm.selectedImpactList" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Outcome</h4><div isteven-multi-select="" input-model="vm.outcomeList" output-model="vm.selectedOutcomeList" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Output</h4><div isteven-multi-select="" input-model="vm.outputList" output-model="vm.selectedOutputList" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-4" style="margin-top: 10px"><h4>Creation Date</h4><input date-range-picker="" class="form-control date-picker" type="text" ng-model="vm.datePicker.date" options="vm.datePicker.options" style="width: 100%; font-size: 12px; height: 34px; text-align: center;"></div><div class="form-group col-sm-4 col-xs-4" style="margin-top: 10px;"><h4>Month</h4><p class="input-group"><input type="text" class="form-control" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" datetime-picker="MMMM yyyy" ng-model="vm.selectedMonth" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default btn-block" ng-click="vm.openCalendar($event)"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-sm-4 col-xs-6" style="margin-top: 10px"><h4>Search by name</h4><input class="form-control" type="text" placeholder="Activity name ..." ng-model="vm.activityName" ng-keyup="$event.keyCode == 13 ? vm.searchActivity() : null"></div></div><div style="margin-top:10px; text-align: center;" class="row form-inline"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchActivity()"><i class="ion-search"></i>Search</button></div></div></div><div class="row"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6" style="text-align: center; margin-bottom: 20px;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filters" : "Show Filters"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="form-group col-sm-4 col-xs-6" ng-show="vm.checkbox.isAnySelected"><button type="button" class="btn btn-danger btn-with-icon" style="width: 100%;" ng-click="vm.filterEmployees()"><i class="ion-hammer"></i>Employee Action</button></div></div><div class="text-right"><a ng-click="vm.generateReport()"><button type="button" class="btn btn-info btn-with-icon"><i class="ion-android-checkmark-circle"></i>Generate Report</button></a></div><br><br><div class="text-center" ng-show="!vm.isActivityListLoaded"><br><br><i class="fa fa-cog fa-spin fa-4x fa-fw"></i><br></div><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px;"><colgroup><col span="1" style="width: 2%;"><col span="1" style="width: 32%;"><col span="1" style="width: 28%;"><col span="1" style="width: 19%;"><col span="1" style="width: 19%;"></colgroup><thead><th class="headers2" style="text-align: center"><input type="checkbox" ng-model="vm.isAllSelected" ng-change="vm.selectOrDeselectAll()"></th><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Output</th><th class="headers2" style="text-align: center">Outcome</th><th class="headers2" style="text-align: center">Impact</th></thead><tr ng-if="!(vm.activityList && vm.activityList.length > 0)"><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr ng-repeat-start="activityResponse in vm.activityList"><td valign="center" rowspan="{{activityResponse.activity.activityIndicators.length}}"><input type="checkbox" ng-model="activityResponse.selected" ng-change="vm.checkIfAllSelected()"></td><td rowspan="{{activityResponse.activity.activityIndicators.length}}"><a ui-sref="activityDetails({id : {{activityResponse.activity.id}}})">{{activityResponse.activity.summary}}</a></td><td rowspan="{{activityResponse.activity.activityIndicators.length}}" valign="center">{{activityResponse.activity.time | date:\'MMMM yyyy\'}}</td><td>{{activityResponse.activity.activityIndicators[0].indicator}}</td><td rowspan="{{activityResponse.activity.activityIndicators.length}}"><a ui-sref="outputDetails({id : {{activityResponse.outputId}}})">{{activityResponse.outputSummary}}</a></td><td rowspan="{{activityResponse.activity.activityIndicators.length}}"><a ui-sref="outcomeDetails({id : {{activityResponse.outcomeId}}})">{{activityResponse.outcomeSummary}}</a></td><td rowspan="{{activityResponse.activity.activityIndicators.length}}"><a ui-sref="impactSetup({id : {{activityResponse.impactId}}})">{{activityResponse.impactSummary}}</a></td></tr><tr ng-repeat-end="" ng-repeat="activityIndicator in activityResponse.activity.activityIndicators" ng-if="$index>0"><td>{{activityIndicator.indicator}}</td></tr></table><br><br></div></div></div></div>');
$templateCache.put('app/pages/main/activityDetails/activityDetails.html','<style>\n    .table > tbody > tr > td {\n        vertical-align: middle;\n    }\n    #researchFrameworkTable td{\n        width:1%;\n        white-space:nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="Activity Details"><div class="row"><div class="col-md-2"><strong style="text-decoration: underline">Number:</strong><strong>&nbsp;<i>{{vm.activity.number}}</i></strong></div></div><div class="row"><div class="col-md-10"><h4 style="margin-top: 20px"><b><i>{{vm.activity.summary}}</i></b></h4></div><div class="col-sm-2" style="margin-top:10px;float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.openEditSummaryModal()">Edit</button></div><hr></div><p style="margin-top: 20px"><b>Time</b>&nbsp;&nbsp;{{vm.activity.time| date:\'MMMM yyyy\'}}</p><p style="margin-top: 20px"><b>Created at</b>&nbsp;&nbsp;{{vm.activity.creationTime === null ? "Not given": vm.activity.creationTime | date: \'dd MMMM yyyy\'}}</p><h3 class="with-line">Indicators<div class="col-sm-2" style="float: right;padding-right: 0px"><a ui-sref="createActivityIndicator({id : vm.activity.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 25%;"><col span="1" style="width: 10%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Means of Verification</th><th class="headers2" style="text-align: center">Assumptions</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.activity.activityIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.meansOfVerification}}</td><td>{{indicator.assumption}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'indicator\')" style="text-align:center; margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Action Plans</h3><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 40%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Time Frame</th><th class="headers2" style="text-align: center">Responsibility</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.activity.activityIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.timeFrame}}</td><td>{{indicator.responsibility}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'actionPlan\')" style="margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table id="researchFrameworkTable" class="table table-bordered" style="margin-bottom: 20px;width: 100%;"><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collect method</th><th class="headers2" style="text-align: center">Researchers</th><th class="headers2" style="text-align: center">Frequency</th><th class="headers2" style="text-align: center">Place</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Supervisor Comment</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.activity.activityIndicators"><td style="width: 400px">{{indicator.indicator}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td>{{indicator.respondents}}</td><td>{{indicator.frequency}}</td><td>{{indicator.place}}</td><td>{{indicator.timeOfDataCollection}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.commentsFromSupervisor}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'research\')" style="margin:5px;width: 80px">Edit</button></td></tr></table></div><h3 class="with-line">Monitoring Framework</h3><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Deviation</th><th class="headers2" style="text-align: center">Causality</th><th class="headers2" style="text-align: center">Recommendation</th><th class="headers2" style="text-align: center">Reflection in Future Plan</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.activity.activityIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.deviation}}</td><td>{{indicator.causality}}</td><td>{{indicator.recommendation}}</td><td>{{indicator.reflectionInFuturePlan}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'monitoring\')" style="margin:5px;width: 80px">Edit</button></td></tr></table></div>');
$templateCache.put('app/pages/main/directives/monitoringSessionDirective.html','<td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td>{{quarter.achievedEvent}}</td><td>{{quarter.expenditure}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td>');
$templateCache.put('app/pages/main/employees/employees.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Employees" ba-panel-class="with-scroll"><div class="row"><div class="col-md-2 col-md-offset-10"><button class="btn btn-info btn-block" ng-click="vm.openCreateEmployeeModal()">Create User</button></div></div><table class="table table-bordered" style="margin-top: 10px"><thead><tr class="sortable"><th class="headers2">Name</th><th class="headers2">Email</th><th class="headers2">Role</th></tr></thead><tbody><tr ng-repeat="item in vm.allEmployees | orderBy:\'role\'"><td>{{item.name}}</td><td>{{item.email}}</td><td ng-if="item.role==1">Executive Director</td><td ng-if="item.role==2">Admin</td><td ng-if="item.role==3">MNE</td><td ng-if="item.role==4">Researcher</td><td ng-if="item.role==5">Coordinator</td><td ng-if="item.role==6">Partner NGO</td></tr></tbody></table><br><br></div></div></div></div>');
$templateCache.put('app/pages/main/generalReport/generalReport.html','<div ba-panel="" ba-panel-title="General Report"><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div><div class="col-md-4"><div class="form-group"><h4>Time</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.time" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group col-md-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top: 9%;" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div><hr><div ng-if="vm.dataLoaded"><h3 class="with-line">Impacts</h3><div ng-repeat="impact in vm.impactList" style="margin-bottom: 20px"><h4><b>Impact {{impact.impactNumber}}: {{impact.impactSummary}}</b></h4><ul ng-repeat="indicator in impact.reportIndicators" ng-if="impact.reportIndicators && impact.reportIndicators.length > 0"><li>{{indicator.indicatorSummary}}</li><ul><li>Target: {{indicator.reportMonitoringSession.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{indicator.reportMonitoringSession.achieved != null && !indicator.reportMonitoringSession.achieved.isEmpty() ? indicator.reportMonitoringSession.achieved + \' \' + indicator.unit ? indicator.unit : \'\' : \'Data not collected\'}}</li><li>Deviation: {{indicator.reportMonitoringSession.deviation != null && !indicator.reportMonitoringSession.deviation.isEmpty() ? indicator.reportMonitoringSession.deviation + \' \' + indicator.unit ? indicator.unit : \'\' : \'Data not collected\'}}</li><li>Causality: {{indicator.reportMonitoringSession.causality}}</li><li>Recommendation: {{indicator.reportMonitoringSession.recommendation}}</li></ul></ul></div><h3 class="with-line">Outcomes</h3><div ng-repeat="outcome in vm.outcomeList" style="margin-bottom: 20px"><h4><b>Outcome {{outcome.outcomeNumber}}: {{outcome.outcomeSummary}}</b></h4><ul ng-repeat="indicator in outcome.reportIndicators" ng-if="outcome.reportIndicators && outcome.reportIndicators.length > 0"><li>{{indicator.indicatorSummary}}</li><ul><li>Target: {{indicator.reportMonitoringSession.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{indicator.reportMonitoringSession.achieved != null && !indicator.reportMonitoringSession.achieved.isEmpty() ? indicator.reportMonitoringSession.achieved + \' \' + indicator.unit ? indicator.unit : \'\' : \'Data not collected\'}}</li><li>Deviation: {{indicator.reportMonitoringSession.deviation != null && !indicator.reportMonitoringSession.deviation.isEmpty() ? indicator.reportMonitoringSession.deviation + \' \' + indicator.unit ? indicator.unit : \'\' : \'Data not collected\'}}</li><li>Causality: {{indicator.reportMonitoringSession.causality}}</li><li>Recommendation: {{indicator.reportMonitoringSession.recommendation}}</li></ul></ul></div><h3 class="with-line">Outputs</h3><div ng-repeat="output in vm.outputList" style="margin-bottom: 20px"><h4><b>Output {{output.outputNumber}}: {{output.outputSummary}}</b></h4><ul ng-repeat="indicator in output.reportIndicators" ng-if="output.reportIndicators && output.reportIndicators.length > 0"><li>{{indicator.indicatorSummary}}</li><ul><li>Target: {{indicator.reportMonitoringSession.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{indicator.reportMonitoringSession.dataCollected ? indicator.reportMonitoringSession.achieved + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Deviation: {{indicator.reportMonitoringSession.dataCollected ? indicator.reportMonitoringSession.deviation + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Causality: {{indicator.reportMonitoringSession.causality}}</li><li>Recommendation: {{indicator.reportMonitoringSession.recommendation}}</li></ul></ul></div></div></div>');
$templateCache.put('app/pages/main/home/home.html','<div style="text-align: center; line-break: loose"><h1 style="font-size: 4em; margin-bottom: 20px;">Monitoring Software</h1><h3 style="margin-bottom: 20px;">for</h3><h1 style="font-size: 5em; margin-bottom: 20px;">Terre Des Hommes</h1><h3 style="margin-bottom: 20px;">by</h3><a style="margin-bottom: 20px;" href="http://www.inovacetech.com"><h3 style="font-size: 3em">Inovace Technologies</h3></a><br><button ui-sref="setup.impacts" style="width: 50%" type="button" class="btn btn-lg btn-primary">Start &rarr;</button></div>');
$templateCache.put('app/pages/main/outcomeDetails/outcomeDetails.html','<style>\n    .table > tbody > tr > td {\n        vertical-align: middle;\n    }\n     .table > tbody > tr > td {\n         vertical-align: middle;\n     }\n    #researchFrameworkTable td{\n        width:1%;\n        white-space:nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="Outcome Details" ba-panel-class="with-scroll"><div class="row"><div class="col-md-2"><strong style="text-decoration: underline">Number:</strong><strong>&nbsp;<i>{{vm.outcome.number}}</i></strong></div></div><div class="row"><div class="col-md-10"><h4 style="margin-top: 20px"><b><i>{{vm.outcome.summary}}</i></b></h4></div><div class="col-sm-2" style="margin-top:10px;float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.openEditSummaryModal()">Edit</button></div><hr></div><h3 class="with-line">Indicators<div class="col-sm-2" style="float: right;padding-right: 0px"><a ui-sref="createOutcomeIndicator({id : vm.outcome.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 25%;"><col span="1" style="width: 10%;"><thead><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Means of Verification</th><th class="headers2" style="text-align: center">Assumptions</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.outcome.outcomeIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.meansOfVerification}}</td><td>{{indicator.assumption}}</td><td><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'indicator\')" style="margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px" id="researchFrameworkTable"><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collection methods</th><th class="headers2" style="text-align: center">Researchers</th><th class="headers2" style="text-align: center">Frequency</th><th class="headers2" style="text-align: center">Place</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Comment From Supervisor</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.outcome.outcomeIndicators"><td style="width: 400px">{{indicator.indicator}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td>{{indicator.respondents}}</td><td>{{indicator.frequency}}</td><td>{{indicator.place}}</td><td>{{indicator.timeOfDataCollection}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.commentsFromSupervisor}}</td><td><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'research\')" style="margin:5px;width: 80px">Edit</button></td></tr></table></div><h3 class="with-line">Monitoring Framework</h3><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Deviation</th><th class="headers2" style="text-align: center">Causality</th><th class="headers2" style="text-align: center">Recommendation</th><th class="headers2" style="text-align: center">Reflection in Future Plan</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.outcome.outcomeIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.deviation}}</td><td>{{indicator.causality}}</td><td>{{indicator.recommendation}}</td><td>{{indicator.reflectionInFuturePlan}}</td><td><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'monitoring\')" style="margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Outputs<div class="col-sm-2" style="float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.outputCreateModal()">Add New</button></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 2%;"><col span="1" style="width: 32%;"><col span="1" style="width: 28%;"><col span="1" style="width: 19%;"><col span="1" style="width: 19%;"></colgroup><thead><th class="headers2" style="text-align: center">Number</th><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Means of Verification</th><th class="headers2" style="text-align: center">Assumptions</th></thead><tr ng-if="vm.outcome.outputs.length == 0"><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr ng-repeat-start="output in vm.outcome.outputs"><td valign="center" rowspan="{{output.outputIndicators.length}}">{{output.number}}</td><td rowspan="{{output.outputIndicators.length}}"><a ui-sref="outputDetails({id : {{output.id}}})">{{output.summary}}</a></td><td>{{output.outputIndicators[0].indicator}}</td><td>{{output.outputIndicators[0].meansOfVerification}}</td><td>{{output.outputIndicators[0].assumption}}</td></tr><tr ng-repeat-end="" ng-repeat="outputIndicator in output.outputIndicators" ng-if="$index>0"><td>{{outputIndicator.indicator}}</td><td>{{outputIndicator.meansOfVerification}}</td><td>{{outputIndicator.assumption}}</td></tr></table></div>');
$templateCache.put('app/pages/main/outputDetails/outputDetails.html','<style>\n    .table > tbody > tr > td {\n        vertical-align: middle;\n    }\n    #researchFrameworkTable td{\n        width:1%;\n        white-space:nowrap;\n    }\n</style><div ba-panel="" ba-panel-title="Output Details"><div class="row"><div class="col-md-2"><strong style="text-decoration: underline">Number:</strong><strong>&nbsp;<i>{{vm.output.number}}</i></strong></div></div><div class="row"><div class="col-md-10"><h4 style="margin-top: 20px"><b><i>{{vm.output.summary}}</i></b></h4></div><div class="col-sm-2" style="margin-top:10px;float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.openEditSummaryModal()">Edit</button></div><hr></div><h3 class="with-line">Indicators<div class="col-sm-2" style="float: right;padding-right: 0px"><a ui-sref="createOutputIndicator({id : vm.output.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 25%;"><col span="1" style="width: 10%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Means of Verification</th><th class="headers2" style="text-align: center">Assumptions</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.output.outputIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.meansOfVerification}}</td><td>{{indicator.assumption}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'indicator\')" style="text-align:center; margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table id="researchFrameworkTable" class="table table-bordered" style="margin-bottom: 20px;width: 100%;"><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collect method</th><th class="headers2" style="text-align: center">Researchers</th><th class="headers2" style="text-align: center">Frequency</th><th class="headers2" style="text-align: center">Place</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Supervisor Comment</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.output.outputIndicators"><td style="width: 400px">{{indicator.indicator}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td>{{indicator.respondents}}</td><td>{{indicator.frequency}}</td><td>{{indicator.place}}</td><td>{{indicator.timeOfDataCollection}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.commentsFromSupervisor}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'research\')" style="margin:5px;width: 80px">Edit</button></td></tr></table></div><h3 class="with-line">Monitoring Framework</h3><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 12%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator</th><th class="headers2" style="text-align: center">Actual Status</th><th class="headers2" style="text-align: center">Deviation</th><th class="headers2" style="text-align: center">Causality</th><th class="headers2" style="text-align: center">Recommendation</th><th class="headers2" style="text-align: center">Reflection in Future Plan</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.output.outputIndicators"><td style="text-align: left">{{indicator.indicator}}</td><td>{{indicator.actualStatus}}</td><td>{{indicator.deviation}}</td><td>{{indicator.causality}}</td><td>{{indicator.recommendation}}</td><td>{{indicator.reflectionInFuturePlan}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditModal(indicator,\'monitoring\')" style="margin:5px;width: 80px">Edit</button></td></tr></table><h3 class="with-line">Activities<div class="col-sm-2" style="float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.activityCreateModalCtrl()">Add New</button></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px;"><colgroup><col span="1" style="width: 2%;"><col span="1" style="width: 32%;"><col span="1" style="width: 28%;"><col span="1" style="width: 19%;"><col span="1" style="width: 19%;"></colgroup><thead><th class="headers2" style="text-align: center">Number</th><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Indicators</th><th class="headers2" style="text-align: center">Means of Verification</th><th class="headers2" style="text-align: center">Assumptions</th></thead><tr ng-if="!(vm.output.activities && vm.output.activities.length > 0)"><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr ng-repeat-start="activity in vm.output.activities"><td valign="center" rowspan="{{activity.activityIndicators.length}}">{{activity.number}}</td><td rowspan="{{activity.activityIndicators.length}}"><a ui-sref="activityDetails({id : {{activity.id}}})">{{activity.summary}}</a></td><td>{{activity.activityIndicators[0].indicator}}</td><td>{{activity.activityIndicators[0].meansOfVerification}}</td><td>{{activity.activityIndicators[0].assumption}}</td></tr><tr ng-repeat-end="" ng-repeat="activityIndicator in activity.activityIndicators" ng-if="$index>0"><td>{{activityIndicator.indicator}}</td><td>{{activityIndicator.meansOfVerification}}</td><td>{{activityIndicator.assumption}}</td></tr></table></div>');
$templateCache.put('app/pages/main/outputMenu/outputMenu.html','<style>\n    td{\n        vertical-align: middle;\n    }\n</style><div class="widgets"><div ba-panel="" ba-panel-title="Output Menu" ba-panel-class="with-scroll"><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.outputList.length > 0"><thead><th class="headers2" style="text-align: center">Number</th><th class="headers2" style="text-align: center;vertical-align: middle">Summary</th><th class="headers2" style="text-align: center">Activity Number</th><th class="headers2" style="text-align: center">Activity Summary</th></thead><tr ng-repeat-start="output in vm.outputList" ng-if="vm.outputList.length > 0"><td rowspan="{{output.activities.length}}">{{output.number}}</td><td rowspan="{{output.activities.length}}"><a ui-sref="outputDetails({id : {{output.id}}})">{{output.summary}}</a></td><td>{{output.activities[0].number}}</td><td><a ui-sref="activityDetails({id : {{output.activities[0].id}}})">{{output.activities[0].summary}}</a></td></tr><tr ng-repeat-end="" ng-repeat="activity in output.activities" ng-if="$index>0"><td>{{activity.number}}</td><td><a ui-sref="activityDetails({id : {{activity.id}}})">{{activity.summary}}</a></td></tr><div class="row text-center" ng-if="vm.outputList.length == 0"><p><i>No Outputs available</i></p></div></table></div></div>');
$templateCache.put('app/pages/main/profile/profile.html','<div ng-show="vm.waitForLoading">Please wait while the profile is loading...</div><div ba-panel="" ba-panel-class="horizontal-tabs tabs-panel" ng-show="!vm.waitForLoading"><uib-tabset active="$tabSetStatus.activeTab"><uib-tab heading="Profile Information" select="vm.onProfileInfoTabSelect()"><div include-with-scope="app/pages/main/profile/profileInfo/profileInfo.html"></div></uib-tab></uib-tabset></div>');
$templateCache.put('app/pages/main/projects/projects.html','<div class="widgets"><div class="row"><div class="col-md-12"><div ba-panel="" ba-panel-title="Manage Projects" ba-panel-class="with-scroll"><div class="row"><div class="col-md-10" style="text-align: center" ng-if="!vm.allProjects || vm.allProjects.length<1">No Projects founds.</div><div class="col-md-2" style="float:right;"><button class="btn btn-info btn-block" ng-click="vm.openCreateProjectModal()">Create Project</button></div></div><table class="table table-bordered" style="margin-top: 10px" ng-if="vm.allProjects && vm.allProjects.length>0"><colgroup><col span="1" style="width: 50%;"><col span="1" style="width: 5%;"><col span="1" style="width: 5%;"><col span="1" style="width: 40%;"></colgroup><thead><tr class="sortable"><th>Name</th><th>Country</th><th>Status</th><th>Action</th></tr></thead><tbody><tr ng-repeat="item in vm.allProjects"><td>{{item.name}}</td><td>{{item.country}}</td><td ng-if="item.status==-1">Deleted</td><td ng-if="item.status==0">Inactive</td><td ng-if="item.status==1">Active</td><td ng-if="item.status==2">Finished</td><td><div class="row" style="padding-top: 10px; padding-bottom: 10px; vertical-align: middle;" ng-if="item.status==0 || item.status==1"><div class="col-md-4"><button class="btn btn-info" style="width: 100%" ng-click="vm.openEditProjectModal(item)">Edit</button></div><div class="col-md-4"><button class="btn btn-primary" style="width: 100%" ng-click="vm.changeStatus(item, 2)">Finished</button></div><div class="col-md-4"><button class="btn btn-danger" style="width: 100%" ng-click="vm.deleteProject(item)">Delete</button></div></div><span ng-if="item.status==-1 || item.status==2" style="display: inline-block;padding-top: 15px; padding-bottom: 15px;">Cannot take any action on this project.</span></td></tr></tbody></table><br><br></div></div></div></div>');
$templateCache.put('app/theme/components/baSidebar/ba-sidebar.html','<aside class="al-sidebar" ng-swipe-right="$baSidebarService.setMenuCollapsed(false)" ng-swipe-left="$baSidebarService.setMenuCollapsed(true)" ng-mouseleave="hoverElemTop=selectElemTop"><ul class="al-sidebar-list" slimscroll="{height: \'{{menuHeight}}px\'}" slimscroll-watch="menuHeight"><li ng-repeat="item in ::menuItems" class="al-sidebar-list-item" ng-class="::{\'with-sub-menu\': item.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="item"><a ng-mouseenter="hoverItem($event, item)" ui-state="item.stateRef || \'\'" ng-href="{{::(item.fixedHref ? item.fixedHref: \'\')}}" ng-if="::!item.subMenu" class="al-sidebar-list-link"><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span></a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::item.subMenu" class="al-sidebar-list-link" ba-ui-sref-toggler=""><i class="{{ ::item.icon }}"></i><span>{{ ::item.title }}</span> <b class="fa fa-angle-down" ui-sref-active="fa-angle-up" ng-if="::item.subMenu"></b></a><ul ng-if="::item.subMenu" class="al-sidebar-sublist" ng-class="{\'slide-right\': item.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-repeat="subitem in ::item.subMenu" ng-class="::{\'with-sub-menu\': subitem.subMenu}" ui-sref-active="selected" ba-sidebar-toggling-item="subitem" class="ba-sidebar-sublist-item"><a ng-mouseenter="hoverItem($event, item)" ng-if="::subitem.subMenu" ba-ui-sref-toggler="" class="al-sidebar-list-link subitem-submenu-link"><span>{{ ::subitem.title }}</span> <b class="fa" ng-class="{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}" ng-if="::subitem.subMenu"></b></a><ul ng-if="::subitem.subMenu" class="al-sidebar-sublist subitem-submenu-list" ng-class="{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}" ba-ui-sref-toggling-submenu=""><li ng-mouseenter="hoverItem($event, item)" ng-repeat="subSubitem in ::subitem.subMenu" ui-sref-active="selected"><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::subSubitem.disabled" class="al-sidebar-list-link">{{ ::subSubitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ui-state="subSubitem.stateRef || \'\'" ng-if="::!subSubitem.disabled" ng-href="{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter="hoverItem($event, item)" href="" ng-if="::(!subitem.subMenu && subitem.disabled)" class="al-sidebar-list-link">{{ ::subitem.title }}</a> <a ng-mouseenter="hoverItem($event, item)" ng-if="::(!subitem.subMenu && !subitem.disabled)" ui-state="subitem.stateRef || \'\'" ng-href="{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}">{{ ::subitem.title}}</a></li></ul></li></ul><div class="sidebar-hover-elem" ng-style="{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}" ng-class="{\'show-hover-elem\': showHoverElem }"></div></aside>');
$templateCache.put('app/theme/components/baWizard/baWizard.html','<div class="ba-wizard"><div class="ba-wizard-navigation-container"><div ng-repeat="t in $baWizardController.tabs" class="ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}" ng-click="$baWizardController.selectTab($index)">{{t.title}}</div></div><div class="progress ba-wizard-progress"><div class="progress-bar progress-bar-danger active" role="progressbar" aria-valuemin="0" aria-valuemax="100" ng-style="{width: $baWizardController.progress + \'%\'}"></div></div><div class="steps" ng-transclude=""></div><nav><ul class="pager ba-wizard-pager"><li class="previous"><button ng-disabled="$baWizardController.isFirstTab()" ng-click="$baWizardController.previousTab()" type="button" class="btn btn-primary"><span aria-hidden="true">&larr;</span> previous</button></li><li class="next"><button ng-disabled="$baWizardController.isLastTab()" ng-click="$baWizardController.nextTab()" type="button" class="btn btn-primary">next <span aria-hidden="true">&rarr;</span></button></li></ul></nav></div>');
$templateCache.put('app/theme/components/baWizard/baWizardStep.html','<section ng-show="selected" class="step" ng-transclude=""></section>');
$templateCache.put('app/theme/components/backTop/backTop.html','<i class="fa fa-angle-up back-top" id="backTop" title="Back to Top"></i>');
$templateCache.put('app/theme/components/contentTop/contentTop.html','<div class="content-top clearfix"><h1 class="al-title">{{ activePageTitle }}</h1></div>');
$templateCache.put('app/theme/components/msgCenter/msgCenter.html','<ul class="al-msg-center clearfix"><li uib-dropdown=""><a href="" uib-dropdown-toggle=""><i class="fa fa-bell-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Notifications</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in notifications"><div class="img-area"><img ng-class="{\'photo-msg-item\' : !msg.image}" ng-src="{{::( msg.image || (users[msg.userId].name | profilePicture) )}}"></div><div class="msg-area"><div ng-bind-html="getMessage(msg)"></div><span>{{ msg.time }}</span></div></a></div><a href="">See all notifications</a></div></li><li uib-dropdown=""><a href="" class="msg" uib-dropdown-toggle=""><i class="fa fa-envelope-o"></i><span>5</span><div class="notification-ring"></div></a><div uib-dropdown-menu="" class="top-dropdown-menu"><i class="dropdown-arr"></i><div class="header clearfix"><strong>Messages</strong> <a href="">Mark All as Read</a> <a href="">Settings</a></div><div class="msg-list"><a href="" class="clearfix" ng-repeat="msg in messages"><div class="img-area"><img class="photo-msg-item" ng-src="{{::( users[msg.userId].name | profilePicture )}}"></div><div class="msg-area"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href="">See all messages</a></div></li></ul>');
$templateCache.put('app/theme/components/pageTop/pageTop.html','<head><meta name="viewport" content="width=device-width, initial-scale=1.0"><style>\n        @media screen and (min-width: 0px) and (max-width: 720px) {\n            #employeeName {\n\n            display: none;\n            }\n        }\n    </style></head><div class="page-top clearfix" scroll-position="scrolled" max-height="50" ng-class="{\'scrolled\': scrolled}"><a ui-sref="home" class="al-logo clearfix">Monitoring Software</a> <a href="" class="collapse-menu-link ion-navicon" ba-sidebar-toggle-menu=""></a><div class="user-profile clearfix"><div class="al-user-profile" uib-dropdown=""><a uib-dropdown-toggle="" class="profile-toggle-link"><div class="al-user-profile-name"><img ng-src="../assets/img/theme/no-photo.png" ng-if="!loggedInUser.employeePicture.employeeFile || !loggedInUser.employeePicture.employeeFile.url"> <img ng-src="{{loggedInUser.employeePicture.employeeFile.url}}" ng-if="loggedInUser.employeePicture.employeeFile.url"></div></a><ul class="top-dropdown-menu profile-dropdown" uib-dropdown-menu=""><li><i class="dropdown-arr"></i></li><li><a class="hideMedia" ui-sref="profile({employeeId: {{loggedInUser.id}}})"><i class="fa fa-user"></i>Profile</a></li><li><a ui-sref="logout" class="signout"><i class="fa fa-power-off"></i>Sign out</a></li></ul></div></div><div class="questions-section" id="employeeName"><a ui-sref="profile({employeeId: {{loggedInUser.id}}})">{{loggedInUser.name}}</a></div></div>');
$templateCache.put('app/theme/components/progressBarRound/progressBarRound.html','<svg class="center-block progress-bar-round" width="200" height="200"><circle cx="100" cy="100" r="90" fill="none" stroke="#F8F8FF" stroke-width="8"></circle><circle cx="100" cy="100" r="90" fill="none" id="loader" class="" stroke="#209e91" stroke-width="8" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" stroke-linecap="round"></circle><text text-anchor="middle" class="loading" x="100" y="90">Loading...</text><text class="percentage" text-anchor="middle" x="100" y="130">{{progress}}%</text></svg>');
$templateCache.put('app/theme/components/widgets/widgets.html','<div class="widgets"><div ng-repeat="widgetBlock in ngModel" ng-class="{\'row\': widgetBlock.widgets.length > 1}"><div ng-repeat="widgetCol in widgetBlock.widgets" ng-class="{\'col-md-6\': widgetBlock.widgets.length === 2}" ng-model="widgetCol" class="widgets-block"><div ba-panel="" ba-panel-title="{{::widget.title}}" ng-repeat="widget in widgetCol" ba-panel-class="with-scroll {{widget.panelClass}}"><div ng-include="widget.url"></div></div></div></div></div>');
$templateCache.put('app/theme/inputs/baSwitcher/baSwitcher.html','<label class="switcher-container"><input type="checkbox" ng-model="switcherValue"><div class="switcher" ng-class="::switcherStyle"><div class="handle-container"><span class="handle handle-on">Active</span> <span class="handle"></span> <span class="handle handle-off">Off</span></div></div></label>');
$templateCache.put('app/pages/main/activityMenu/activityReport/activityReport.html','<style>\n\n</style><div ba-panel="" ba-panel-title="Activity Report" ba-panel-class="with-scroll"><h3 class="with-line">Activity Report</h3><ol ng-repeat="impact in vm.reportObjectList" style="line-height: 200%" ng-show="vm.reportObjectList != null && vm.reportObjectList.length > 0"><li><b>Impact Name :</b> <span>{{impact.summary}}</span><ol ng-repeat="outcome in impact.outcomes"><li><b>Outcome Name :</b><span>{{outcome.summary}}</span><ol ng-repeat="output in outcome.outputs"><li><b>Output Name :</b><span>{{output.summary}}</span><ul ng-repeat="activity in output.activities"><li><b>Activity Name :</b> <span>{{activity.summary}}</span><ul ng-repeat="indicator in activity.activityIndicators"><li><b>Indicator :</b><span>{{indicator.indicator}}</span><ul><li><b>Deviation :</b><span>{{indicator.deviation}}</span></li><li><b>Causality :</b><span>{{indicator.causality}}</span></li><li><b>Recommendation :</b>{{indicator.recommendation}}</li><li><b>Future Plan :</b>{{indicator.reflectionInFuturePlan}}</li></ul></li></ul></li></ul></li></ol></li></ol></li></ol><div class="row text-center" ng-show="vm.reportObjectList === null || vm.reportObjectList.length === 0"><div><span><i>No activities selected.</i></span></div></div></div>');
$templateCache.put('app/pages/main/dataCollection/activityData/activityData.html','<style>\n    td{\n        vertical-align: middle!important;\n    }\n    .edit-button{\n        width: 150px!important;\n        height: 50px!important;\n    }\n</style><div ba-panel="" ba-panel-title="Activities" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showDiv"><div class="form-group col-md-4 col-xs-12"><h4>Name</h4><input class="form-control" type="text" placeholder="Activity summary key words/responsible agency name ..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchActivities() : null"></div><div class="col-md-4 col-xs-6"><div class="form-group"><h4>Start Time</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group col-md-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div></div><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showDiv"><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedProjects.length > 0">Select Impact</h4><div ng-if="vm.selectedProjects.length > 0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-select-all="vm.mapOutcomes()" on-clear="vm.mapOutcomes()" on-reset="vm.mapOutcomes()" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedImpacts.length > 0">Outcome Number</h4><div ng-if="vm.selectedImpacts.length > 0" isteven-multi-select="" input-model="vm.multiselectOutcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outputs" on-item-click="vm.mapOutputs()" on-select-all="vm.mapOutputs()" on-select-none="vm.mapOutputs()"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedOutcomes.length > 0">Output Number</h4><div ng-if="vm.selectedOutcomes.length > 0" isteven-multi-select="" input-model="vm.multiSelectOutputs" output-model="vm.selectedOutputs" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary activities"></div></div></div><div class="row" ng-show="vm.showDiv"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchActivities()"><i class="ion-search"></i>Search</button></div><div class="form-group col-sm-4 col-xs-6"></div></div><div class="row"><div class="col-md-2" style="text-align: center; margin-bottom: 20px;"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showDiv = !vm.showDiv"><em style="margin-right: 10px">{{vm.showDiv ? "Hide Filters" : "Show Filters"}}</em></a> <a href="" ng-click="vm.showDiv = !vm.showDiv"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.outputsToShow.length > 0"><thead><th class="headers2" style="text-align: center">Output Number</th><th class="headers2" style="text-align: center;vertical-align: middle">Summary</th><th class="headers2" style="text-align: center">Activity Number</th><th class="headers2" style="text-align: center">Activity Title</th><th class="headers2" style="text-align: center"></th></thead><tr ng-repeat-start="output in vm.outputsToShow"><td rowspan="{{output.activities.length}}">{{output.number}}</td><td rowspan="{{output.activities.length}}"><a ui-sref="outputDetails({id : {{output.id}}})">{{output.summary}}</a></td><td>{{output.activities[0].serialNumber}}</td><td>{{output.activities[0].title}}</td><td class="edit-button" ng-if="vm.isActivityEligibleForDataCollection(output.activities[0])"><a ui-sref="activityDataCollection({ id : {{output.activities[0].id}}})"><button class="btn btn-primary btn-block" style="padding: 5px">Data Collection</button></a></td><td ng-if="!vm.isActivityEligibleForDataCollection(output.activities[0])"><a ui-sref="setup.editActivity({activityId: {{output.activities[0].id}}})">Targets Not Setup.</a></td></tr><tr ng-repeat-end="" ng-repeat="activity in output.activities" ng-if="$index>0"><td>{{activity.serialNumber}}</td><td>{{activity.title}}</td><td class="edit-button" ng-if="vm.isActivityEligibleForDataCollection(activity)"><a ui-sref="activityDataCollection({ id : {{activity.id}}})"><button class="btn btn-primary btn-block" style="padding: 5px">Data Collection</button></a></td><td ng-if="!vm.isActivityEligibleForDataCollection(activity)"><a ui-sref="setup.editActivity({activityId: {{activity.id}}})">Targets Not Setup.</a></td></tr><div class="row text-center" ng-if="vm.outputsToShow.length == 0"><p><i>No Activities available</i></p></div></table></div>');
$templateCache.put('app/pages/main/dataCollection/impactData/impactData.html','<div ba-panel="" ba-panel-title="Impact List" ba-panel-class="with-scroll"><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.impacts.length > 0"><colgroup><col span="1" style="width: 5%;"><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 30%;"></colgroup><thead><th class="headers2" style="text-align: center">Number</th><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Project</th><th class="headers2" style="text-align: center">Action</th></thead><tr ng-repeat="impact in vm.impacts | orderBy:\'number\'" ng-if="vm.impacts.length > 0"><td>{{impact.number}}</td><td>{{impact.summary}}</td><td>{{impact.project.name}}</td><td><button class="btn btn-primary" style="width: 100%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-click="vm.openDataCollectionModal(impact)" ng-if="impact.impactIndicators && impact.impactIndicators.length>0">Data Insert</button><div ng-if="!impact.impactIndicators || impact.impactIndicators.length<1"><p style="margin-top: 10px;">Impact Not Set Up Properly.</p><p>Please add indicators.</p></div></td></tr><div class="row text-center" ng-if="vm.impacts.length == 0"><p><i>No impacts available</i></p></div></table></div>');
$templateCache.put('app/pages/main/dataCollection/outcomeData/outcomeData.html','<div ba-panel="" ba-panel-title="Outcome Data Collection" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-6" ng-if="vm.selectedProjects.length!=0"><h4>Select Impact</h4><div ng-if="vm.selectedProjects.length!=0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.filterImpacts()"><i class="ion-search"></i>Search</button></div></div><div class="row"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.selectedOutcomes.length > 0"><colgroup><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 35%;"></colgroup><thead><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Impact</th><th class="headers2" style="text-align: center">Action</th></thead><tr ng-repeat="outcome in vm.selectedOutcomes | orderBy:\'number\'" ng-if="vm.selectedOutcomes.length > 0"><td>{{outcome.number}}. {{outcome.summary}}</td><td>{{outcome.impact.number}}. {{outcome.impact.summary}}</td><td><button class="btn btn-primary" style="width: 100%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-click="vm.openDataCollectionModal(outcome)" ng-if="vm.isOutcomeValidForDataCollection(outcome)">Data Insert</button><div ng-if="!vm.isOutcomeValidForDataCollection(outcome)"><p style="margin-top: 10px;">Outcome Not Set Up Properly.</p><p>Please setup indicators & monitoring sessions.</p></div></td></tr></table><div class="row text-center" ng-if="vm.selectedOutcomes.length == 0"><p><i>No outcomes available</i></p></div></div>');
$templateCache.put('app/pages/main/activityDetails/edit/editActivityIndicator.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div ng-show="vm.type == \'indicator\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.indicator.meansOfVerification"></textarea></div></div></div><br><br><div class="row"><div class="col-md-6"><div class="form-group"><label for="description">Assumption</label> <textarea id="description" class="form-control" ng-model="vm.indicator.assumption"></textarea></div></div></div></div><div ng-show="vm.type == \'actionPlan\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Time Frame</label> <textarea class="form-control" ng-model="vm.indicator.timeFrame"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Responsibility</label> <textarea class="form-control" ng-model="vm.indicator.responsibility"></textarea></div></div></div></div><div ng-show="vm.type == \'research\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reasearchers</label> <input type="text" class="form-control" ng-model="vm.indicator.respondents"></div></div><div class="col-sm-6"><div class="form-group"><label>Frequency</label> <input type="text" class="form-control" ng-model="vm.indicator.frequency"></div></div><div class="col-sm-6"><div class="form-group"><label>Place</label> <input type="text" class="form-control" ng-model="vm.indicator.place"></div></div><div class="col-sm-6"><div class="form-group"><label>Time</label> <input type="text" class="form-control" ng-model="vm.indicator.timeOfDataCollection"></div></div><div class="col-sm-6"><div class="form-group"><label>Actual Status</label> <input type="text" class="form-control" ng-model="vm.indicator.actualStatus"></div></div><div class="col-sm-6"><div class="form-group"><label>Comments from Supervisor</label> <textarea class="form-control" ng-model="vm.indicator.commentsFromSupervisor"></textarea></div></div></div><br><br></div><div ng-show="vm.type == \'monitoring\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.indicator.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.indicator.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.indicator.recommendation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reflection In Future Plan</label> <textarea class="form-control" ng-model="vm.indicator.reflectionInFuturePlan"></textarea></div></div></div><br><br></div><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateIndicator()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/activityDetails/edit/editSummary.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.activity.number"></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.activity.summary"></textarea></div></div></div><br><br><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateSummary()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/dataCollection/outputData/outputData.html','<div ba-panel="" ba-panel-title="Outputs" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedProjects.length > 0">Select Impact</h4><div ng-if="vm.selectedProjects.length > 0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedImpacts.length > 0">Select Outcome</h4><div ng-if="vm.selectedImpacts.length > 0" isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs"></div></div></div><div class="row" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchOutputs()"><i class="ion-search"></i>Search</button></div><div class="form-group col-sm-4 col-xs-6"></div></div><div class="row" style="margin-top: 10px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.allOutputs.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2">Outputs</th><th class="headers2">Outcome</th><th class="headers2"></th></thead><tr ng-repeat="output in vm.allOutputs | orderBy:\'number\'"><td>{{output.number}}. {{output.summary}}</td><td>{{output.outcome.number}}. {{output.outcome.summary}}</td><td><button class="btn btn-primary" style="width: 100%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-click="vm.openDataCollectionModal(output)" ng-if="vm.isOutputValidForDataCollection(output)">Data Insert</button><div ng-if="!vm.isOutputValidForDataCollection(output)"><p style="margin-top: 10px;">Output Not Set Up Properly.</p><p>Please setup indicators & monitoring sessions.</p></div></td></tr><tr ng-if="vm.allOutputs.length === 0"><td colspan="4"><p><i>No outputs available</i></p></td></tr></table></div>');
$templateCache.put('app/pages/main/employees/actions/employeeActions.html','<div><div ba-panel="" ba-panel-title="Employee List" ng-animate="\'slide" style="margin-bottom: 20px;"><div class="row" style="margin-left: 5px"><div class="row" ng-if="vm.select.notSelectedEmployees"><div class="col-xs-2 col-sm-2"></div><div class="col-sm-2"><h4 class="text-right" style="margin-top: 10px">Select Employee</h4></div><div class="col-sm-3 col-xs-6"><div isteven-multi-select="" input-model="vm.select.notSelectedEmployees" output-model="vm.select.multiselectEmployees" button-label="name" item-label="name" tick-property="ticked" output-properties="id name office department shift designation leavePolicy weeklyOffDaysPolicy"></div></div><div class="col-sm-2 col-xs-6"><button type="button" class="btn btn-primary btn-with-icon" ng-click="vm.populateTableFromMultiSelect()" style="width:100%; height: 38px;"><i class="ion-checkmark-round"></i>Select</button></div><br><br><br><br></div><div class="row col-md-12"><table class="table table-bordered text-center bottom" ng-if="(vm.select.selectedEmployees.length > 0)" style="margin-bottom: 20px"><tr><td>Name</td><td>Company</td><td>Office</td><td>Department</td><td>Shift</td><td>Designation</td><td>Leave Policy</td><td>Weekly Off Days Policy</td><td>Action</td></tr><tr ng-repeat="item in vm.select.selectedEmployees"><td>{{item.name}}</td><td>{{item.office.company.name}}</td><td>{{item.office.name}}</td><td>{{item.department.name}}</td><td>{{item.shift.name}}</td><td ng-if="!item.designation.name">Not assigned</td><td ng-if="item.designation.name">{{item.designation.name}}</td><td ng-if="!item.leavePolicy.name">Not assigned</td><td ng-if="item.leavePolicy.name">{{item.leavePolicy.name}}</td><td ng-if="!item.weeklyOffDaysPolicy.name">Not assigned</td><td ng-if="item.weeklyOffDaysPolicy.name">{{item.weeklyOffDaysPolicy.name}}</td><td><button class="btn btn-danger btn-block" style="margin-left: 5px;margin-top: 5px;margin-bottom: 5px" ng-click="vm.removeEmployeeFromTable(item)">Remove</button></td></tr></table><h4 ng-if="(!vm.select.selectedEmployees || vm.select.selectedEmployees.length == 0)">No employee selected</h4></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><h4 class="text-uppercase"><strong>Assign Department</strong></h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.select.selectedDepartment" ng-options="d.name for d in vm.department.departmentList"><option value="" selected="" disabled="" hidden="">Select a department</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.assignBatchDepartment()">Save</button></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><hr><h4 class="text-uppercase"><strong>Assign Shift</strong></h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.select.selectedShift" ng-options="s.name for s in vm.shift.shiftList"><option value="" selected="" disabled="" hidden="">Select a shift</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.assignBatchShift()">Save</button></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><hr><h4 class="text-uppercase"><strong>Assign Designation</strong></h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.select.selectedDesignation" ng-options="d.name for d in vm.designation.designationList"><option value="" selected="" disabled="" hidden="">Select a designation</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.assignBatchDesignation()">Save</button></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><hr><h4 class="text-uppercase">Assign Leave Policy</h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.select.selectedLeavePolicy" ng-options="l.name for l in vm.leavePolicy.leavePolicyList"><option value="" selected="" disabled="" hidden="">Select a leave Policy</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.assignBatchLeavePolicy()">Save</button></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><hr><h4 class="text-uppercase"><strong>Assign Weekly Off Days Policy</strong></h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.select.selectedWeeklyOffDaysPolicy" ng-options="w.name for w in vm.weeklyOffDaysPolicy.weeklyOffDaysPolicyList"><option value="" selected="" disabled="" hidden="">Select a weekly off days Policy</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.assignBatchWeeklyOffDaysPolicy()">Save</button></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><hr><h4 class="text-uppercase"><strong>Allocate to Device</strong></h4><hr><div class="col-md-6"><select class="form-control" ng-model="vm.selectedDevice" ng-options="d.identifier for d in vm.devices"><option value="" selected="" disabled="" hidden="">Select a Device</option></select></div><div class="col-md-6"><button class="btn btn-primary btn-block" ng-click="vm.allocateToDevice()">Save</button></div><hr></div><div class="row" style="margin-top:50px" ng-if="(vm.select.selectedEmployees.length > 0)"><h4 class="text-uppercase"><strong>Temporary Permissions</strong></h4><hr><div class="col-md-3" style="margin-top:10px"><h4>From</h4></div><div class="col-md-3"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.fromTime" is-open="vm.isOpenFrom"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarFromTime($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="row" ng-if="(vm.select.selectedEmployees.length > 0)"><div class="col-md-3" style="margin-top:10px"><h4>To</h4></div><div class="col-md-3"><p class="input-group"><input type="text" class="form-control" datetime-picker="dd MMM yyyy HH:mm" ng-model="vm.toTime" is-open="vm.isOpenTo"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarToTime($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="row" style="margin-bottom:50px" ng-if="(vm.select.selectedEmployees.length > 0)"><div class="col-md-3" style="margin-top:10px"><h4>Device</h4></div><div class="col-md-3"><div isteven-multi-select="" input-model="vm.devices" output-model="vm.temporarySelectedDevice" button-label="identifier" item-label="identifier" tick-property="ticked" output-properties="identifier" selection-mode="single"></div></div><div class="col-md-6 text-center"><button class="btn btn-primary btn-block" ng-click="vm.saveTemporaryAllocation()">Save</button></div></div></div></div></div>');
$templateCache.put('app/pages/main/employees/create/createEmployee.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Employee<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Name</label> <input type="text" class="form-control" ng-model="vm.name"></div></div><div class="col-sm-6"><div class="form-group"><label>Email</label> <input type="text" class="form-control" ng-model="vm.email"></div></div></div><br><br><div class="row"><div class="col-sm-6"><div class="form-group"><label>Password</label> <input type="password" class="form-control" ng-model="vm.password"></div></div><div class="col-sm-6"><div class="form-group"><label>Confirm Password</label> <input type="password" class="form-control" ng-model="vm.confirmPassword"></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Select Role</label><select class="form-control" ng-model="vm.role"><option value="" selected="" disabled="" hidden="">Choose Role</option><option value="1" selected="selected">Executive Director</option><option value="2">Admin</option><option value="3">MNE</option><option value="4">Researcher</option><option value="5">Coordinator</option><option value="6">Partner NGO</option></select></div></div></div></div><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createEmployee()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/generalReport/activityDetailsReport/activityDetailsReport.html','<div ba-panel="" ba-panel-title="Impact Report"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="row"><div class="form-group col-sm-3 col-xs-3"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-md-3 col-xs-3"><h4>Select Outcome</h4><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs" on-item-click="vm.generateOutputs()" selection-mode="single"></div></div><div class="form-group col-sm-3 col-xs-3"><h4>Select Output</h4><div isteven-multi-select="" input-model="vm.outputs" output-model="vm.selectedOutputs" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary majorActivities" selection-mode="single"></div></div><div class="form-group col-md-3 col-xs-3"><h4>Responsible Agency</h4><input class="form-control" style="height: 38px;" type="text" placeholder="Agency Name" ng-model="vm.search.agencyName" ng-keyup="$event.keyCode == 13 ? vm.search() : null"></div></div><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-3 col-xs-3"><h4>Select Fields</h4><div isteven-multi-select="" input-model="vm.extras" output-model="vm.selectedExtras" button-label="name" item-label="name" tick-property="ticked" output-properties="value"></div></div><div class="col-sm-3 col-xs-3"><div class="form-group"><h4>Start Month</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpenFrom" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarFrom($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="col-sm-3 col-xs-3"><div class="form-group"><h4>End Month</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.endDate" is-open="vm.isOpenTo" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarTo($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group col-sm-3 col-xs-3"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" tick-property="ticked" output-properties="id number outcomes"></div></div></div><div class="row"><div class="form-group col-md-4 col-md-offset-4"><div class="text-center"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="margin-top:30px" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div></div></div><div class="row" style="margin-top: 20px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div></div><div class="row" style="margin-bottom: 10px"><div class="col-md-7"><a ng-href="{{vm.excelUrl}}" target="_self"><button type="button" ng-if="vm.excelUrl!=null && excelUrl != \'\'" class="btn btn-primary">Excel</button></a></div></div><div class="horizontal-scroll" ng-if="vm.isDataLoaded"><table class="table table-bordered" style="table-layout: auto;width: 100%"><tr><td rowspan="3">Serial</td><td rowspan="3">Activity</td><td rowspan="3">Responsible Agency</td><td rowspan="3">Means of Verification</td><td rowspan="3" ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')">Description</td><td rowspan="3" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}" class="headers2">Total Target</td><td ng-repeat="month in vm.monthList" class="headers4" colspan="{{(10 + (vm.activityExtrasToShow.includes(\'customUnit\')? 2: 0)+ vm.monitoringSessionExtrasToShow.length)}}">{{month | date: \'MMM yyyy\'}}</td><td rowspan="3" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}" class="headers2">Total Achievement</td></tr><tr><td ng-repeat-start="n in [].constructor(vm.monthList.length) track by $index" class="headers4" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}">Target</td><td ng-repeat-end="" colspan="{{(5+(vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)+(vm.monitoringSessionExtrasToShow.length))}}" class="headers4">Achievement</td></tr><tr></tr><tr><td></td><td></td><td></td><td></td><td ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')"></td><td class="headers2">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" class="headers2">Unit</td><td class="headers2">Budget</td><td class="headers2">Male</td><td class="headers2">Female</td><td class="headers2">Total</td><td ng-repeat-start="n in [].constructor(vm.monthList.length) track by $index" class="headers4">Event</td><td class="headers4" ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">Unit</td><td class="headers4">Budget</td><td class="headers4">Male</td><td class="headers4">Female</td><td class="headers4">Total</td><td class="headers4">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" class="headers4">Unit</td><td class="headers4">Expenditure</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\')">Reason Of Deviation</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\')">Not Done Sub Activities</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\')">Challenge</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\')">Lesson</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\')">Recommendation</td><td class="headers4" ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\')">Description</td><td class="headers4">Male</td><td class="headers4">Female</td><td ng-repeat-end="" class="headers4">Total</td><td class="headers2">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" class="headers2">Unit</td><td class="headers2">Expenditure</td><td class="headers2">Male</td><td class="headers2">Female</td><td class="headers2">Total</td></tr><tr ng-repeat="activity in vm.reportResponse"><td style="text-align: center;white-space: nowrap">{{activity.serialNumber}}</td><td style="text-align: left!important;white-space: nowrap">{{activity.title}}</td><td>{{activity.responsibleAgency}}</td><td>{{activity.meansOfVerification}}</td><td ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')">{{activity.description}}</td><td>{{activity.yearlyTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.yearlyTargetDetails.targetUnit}}</td><td>{{activity.yearlyTargetDetails.budget}}</td><td>{{activity.yearlyTargetDetails.targetMaleParticipants}}</td><td>{{activity.yearlyTargetDetails.targetFemaleParticipants}}</td><td>{{activity.yearlyTargetDetails.targetParticipants}}</td><div><td ng-repeat-start="quarter in activity.firstQuarterTargetDetailsList track by $index">{{quarter.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.targetUnit}}</td><td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td>{{quarter.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.achievedUnit}}</td><td>{{quarter.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\')">{{quarter.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\')">{{quarter.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\')">{{quarter.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\')">{{quarter.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\')">{{quarter.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\')">{{quarter.activityDescription}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td><td ng-repeat-end="">{{quarter.participants}}</td></div><td>{{activity.yearlyTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.yearlyTargetDetails.achievedUnit}}</td><td>{{activity.yearlyTargetDetails.expenditure}}</td><td>{{activity.yearlyTargetDetails.maleParticipants}}</td><td>{{activity.yearlyTargetDetails.femaleParticipants}}</td><td>{{activity.yearlyTargetDetails.participants}}</td></tr></table></div></div>');
$templateCache.put('app/pages/main/generalReport/impactReport/impactReport.html','<div ba-panel="" ba-panel-title="Impact Report"><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.generateImpacts()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Monitoring Sessions</h4><div isteven-multi-select="" input-model="vm.filteredMonitoringSessionList" output-model="vm.selectedMonitoringSessionTimes" button-label="name" item-label="name" tick-property="ticked" output-properties="name" selection-mode="multiple"></div></div><div class="form-group col-md-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top: 9%;" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div><div ng-if="vm.dataLoaded"><h3 class="with-line">Impacts</h3><div ng-repeat="impact in vm.selectedImpactList" style="margin-bottom: 20px"><h4><b>Impact {{impact.number}}: {{impact.summary}}</b></h4><ul ng-repeat="indicator in impact.impactIndicators| orderBy:\'indicator.number\'" ng-if="impact.impactIndicators && impact.impactIndicators.length > 0"><li>{{indicator.number}}. {{indicator.summary}}</li><h5><b>Baseline :</b>{{indicator.baseline}}</h5><ul ng-repeat="session in indicator.impactMonitoringSessions" ng-if="vm.selectedMonitoringSessionIdSet.has(session.id)"><br><h5>{{session.timeOfMonitoringText}}</h5><li>Target: {{session.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{session.achieved != null ? session.achieved + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Deviation: {{session.achieved != null ? session.deviation + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Causality: {{session.causality}}</li><li>Recommendation: {{session.recommendation}}</li><br></ul></ul></div></div></div>');
$templateCache.put('app/pages/main/generalReport/activityReport/activityReport.html','<div ba-panel="" ba-panel-title="Impact Report"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="row"><div class="form-group col-sm-4 col-xs-4"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-md-4 col-xs-4"><h4>Select Outcome</h4><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs" on-item-click="vm.generateOutputs()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Select Output</h4><div isteven-multi-select="" input-model="vm.outputs" output-model="vm.selectedOutputs" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary majorActivities" selection-mode="single"></div></div></div><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-3 col-xs-3"><h4>Select Fields</h4><div isteven-multi-select="" input-model="vm.extras" output-model="vm.selectedExtras" button-label="name" item-label="name" tick-property="ticked" output-properties="value" on-item-click="vm.populateExtrasToShow()"></div></div><div class="form-group col-md-3 col-xs-3"><h4>Responsible Agency</h4><input class="form-control" style="height: 38px;" type="text" placeholder="Agency Name" ng-model="vm.search.agencyName" ng-keyup="$event.keyCode == 13 ? vm.search() : null"></div><div class="col-sm-3 col-xs-3"><div class="form-group"><h4>Year</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'year\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="form-group col-sm-3 col-xs-3"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" tick-property="ticked" output-properties="id number outcomes"></div></div></div><div class="row"><div class="form-group col-md-4 col-md-offset-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top:30px" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div></div><div class="row" style="margin-top: 20px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div></div><div class="row" style="margin-bottom: 10px"><div class="col-md-7"><a ng-href="{{vm.excelUrl}}" target="_self"><button type="button" ng-if="vm.excelUrl!=null && excelUrl != \'\'" class="btn btn-primary">Excel</button></a></div></div><div class="horizontal-scroll"><table class="table table-bordered" style="table-layout: auto;width: 100%" ng-if="vm.isDataLoaded"><tr><td rowspan="3">Serial</td><td rowspan="3">Activity</td><td rowspan="3">Responsible Agency</td><td rowspan="3">Means of Verification</td><td rowspan="3" ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')">Description</td><td rowspan="3" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}" class="headers2">Yearly Target</td><td ng-repeat="month in vm.firstQuarter" ng-class="($index > 0 && $index % 3 == 0) ? \'headers3\' : \'headers4\'" colspan="{{vm.getColspanForMonthlyCells($index)}}">{{month}}</td><td ng-repeat="month in vm.secondQuarter" ng-class="($index > 0 && $index % 3 == 0) ? \'headers3\' : \'headers4\'" colspan="{{vm.getColspanForMonthlyCells($index)}}">{{month}}</td><td ng-repeat="month in vm.thirdQuarter" ng-class="($index > 0 && $index % 3 == 0) ? \'headers3\' : \'headers4\'" colspan="{{vm.getColspanForMonthlyCells($index)}}">{{month}}</td><td ng-repeat="month in vm.fourthQuarter" ng-class="($index > 0 && $index % 3 == 0) ? \'headers3\' : \'headers4\'" colspan="{{vm.getColspanForMonthlyCells($index)}}">{{month}}</td><td rowspan="3" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}" class="headers2">Yearly Achievement</td></tr><tr><td ng-repeat-start="n in [].constructor(16) track by $index" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" colspan="{{5 + (vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)}}">Target</td><td ng-repeat-end="" colspan="{{(($index+1) % 4 == 0) ? (5+(vm.activityExtrasToShow.includes(\'customUnit\') ? 1 : 0)) : (5+(vm.activityExtrasToShow.includes(\'customUnit\'))+vm.monitoringSessionExtrasToShow.length)}}" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Achievement</td></tr><tr></tr><tr><td></td><td></td><td></td><td></td><td ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')"></td><td class="headers2">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" class="headers2">Event</td><td class="headers2">Budget</td><td class="headers2">Male</td><td class="headers2">Female</td><td class="headers2">Total</td><td ng-repeat-start="n in [].constructor(16) track by $index" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Unit</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Budget</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Male</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Female</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Total</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Unit</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Expenditure</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\')">Reason Of Deviation</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\')">Not Done Sub Activities</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'challenge\')">Challenge</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\')">Lesson</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'recommendation\')">Recommendation</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'" ng-if="(($index + 1) % 4 != 0) && vm.monitoringSessionExtrasToShow.includes(\'activityDescription\')">Description</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Male</td><td ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Female</td><td ng-repeat-end="" ng-class="(($index + 1) % 4 == 0) ? \'headers3\' : \'headers4\'">Total</td><td class="headers2">Event</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')" class="headers2">Event</td><td class="headers2">Expenditure</td><td class="headers2">Male</td><td class="headers2">Female</td><td class="headers2">Total</td></tr><tr ng-repeat="activity in vm.reportResponse"><td style="text-align: center;white-space: nowrap">{{activity.serialNumber}}</td><td style="text-align: left!important;white-space: nowrap">{{activity.title}}</td><td>{{activity.responsibleAgency}}</td><td>{{activity.meansOfVerification}}</td><td ng-if="vm.activityExtrasToShow.includes(\'activityDescriptionPerProposal\')">{{activity.description}}</td><td>{{activity.yearlyTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.yearlyTargetDetails.targetUnit}}</td><td>{{activity.yearlyTargetDetails.budget}}</td><td>{{activity.yearlyTargetDetails.targetMaleParticipants}}</td><td>{{activity.yearlyTargetDetails.targetFemaleParticipants}}</td><td>{{activity.yearlyTargetDetails.targetParticipants}}</td><div><td ng-repeat-start="quarter in activity.firstQuarterTargetDetailsList track by $index">{{quarter.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.targetUnit}}</td><td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td>{{quarter.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.achievedUnit}}</td><td>{{quarter.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{quarter.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{quarter.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{quarter.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{quarter.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{quarter.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{quarter.activityDescription}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td><td ng-repeat-end="">{{quarter.participants}}</td></div><td>{{activity.firstQuarterTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.firstQuarterTargetDetails.targetUnit}}</td><td>{{activity.firstQuarterTargetDetails.budget}}</td><td>{{activity.firstQuarterTargetDetails.targetMaleParticipants}}</td><td>{{activity.firstQuarterTargetDetails.targetFemaleParticipants}}</td><td>{{activity.firstQuarterTargetDetails.targetParticipants}}</td><td>{{activity.firstQuarterTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.firstQuarterTargetDetails.achievedUnit}}</td><td>{{activity.firstQuarterTargetDetails.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{activity.firstQuarterTargetDetails.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{activity.firstQuarterTargetDetails.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{activity.firstQuarterTargetDetails.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{activity.firstQuarterTargetDetails.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{activity.firstQuarterTargetDetails.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{activity.firstQuarterTargetDetails.activityDescription}}</td><td>{{activity.firstQuarterTargetDetails.maleParticipants}}</td><td>{{activity.firstQuarterTargetDetails.femaleParticipants}}</td><td>{{activity.firstQuarterTargetDetails.participants}}</td><div><td ng-repeat-start="quarter in activity.secondQuarterTargetDetailsList">{{quarter.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.targetUnit}}</td><td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.achievedEvent}}</td><td>{{quarter.achievedUnit}}</td><td>{{quarter.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{quarter.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{quarter.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{quarter.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{quarter.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{quarter.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{quarter.activityDescription}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td><td ng-repeat-end="">{{quarter.participants}}</td></div><td>{{activity.secondQuarterTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.secondQuarterTargetDetails.targetUnit}}</td><td>{{activity.secondQuarterTargetDetails.budget}}</td><td>{{activity.secondQuarterTargetDetails.targetMaleParticipants}}</td><td>{{activity.secondQuarterTargetDetails.targetFemaleParticipants}}</td><td>{{activity.secondQuarterTargetDetails.targetParticipants}}</td><td>{{activity.secondQuarterTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.secondQuarterTargetDetails.achievedUnit}}</td><td>{{activity.secondQuarterTargetDetails.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{activity.secondQuarterTargetDetails.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{activity.secondQuarterTargetDetails.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{activity.secondQuarterTargetDetails.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{activity.secondQuarterTargetDetails.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{activity.secondQuarterTargetDetails.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{activity.secondQuarterTargetDetails.activityDescription}}</td><td>{{activity.secondQuarterTargetDetails.maleParticipants}}</td><td>{{activity.secondQuarterTargetDetails.femaleParticipants}}</td><td>{{activity.secondQuarterTargetDetails.participants}}</td><div><td ng-repeat-start="quarter in activity.thirdQuarterTargetDetailsList">{{quarter.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.targetUnit}}</td><td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td>{{quarter.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.achievedUnit}}</td><td>{{quarter.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{quarter.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{quarter.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{quarter.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{quarter.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{quarter.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{quarter.activityDescription}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td><td ng-repeat-end="">{{quarter.participants}}</td></div><td>{{activity.thirdQuarterTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.thirdQuarterTargetDetails.targetUnit}}</td><td>{{activity.thirdQuarterTargetDetails.budget}}</td><td>{{activity.thirdQuarterTargetDetails.targetMaleParticipants}}</td><td>{{activity.thirdQuarterTargetDetails.targetFemaleParticipants}}</td><td>{{activity.thirdQuarterTargetDetails.targetParticipants}}</td><td>{{activity.thirdQuarterTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.thirdQuarterTargetDetails.achievedUnit}}</td><td>{{activity.thirdQuarterTargetDetails.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{activity.thirdQuarterTargetDetails.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{activity.thirdQuarterTargetDetails.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{activity.thirdQuarterTargetDetails.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{activity.thirdQuarterTargetDetails.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{activity.thirdQuarterTargetDetails.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{activity.thirdQuarterTargetDetails.activityDescription}}</td><td>{{activity.thirdQuarterTargetDetails.maleParticipants}}</td><td>{{activity.thirdQuarterTargetDetails.femaleParticipants}}</td><td>{{activity.thirdQuarterTargetDetails.participants}}</td><div><td ng-repeat-start="quarter in activity.fourthQuarterTargetDetailsList">{{quarter.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.targetUnit}}</td><td>{{quarter.budget}}</td><td>{{quarter.targetMaleParticipants}}</td><td>{{quarter.targetFemaleParticipants}}</td><td>{{quarter.targetParticipants}}</td><td>{{quarter.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{quarter.achievedUnit}}</td><td>{{quarter.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{quarter.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{quarter.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{quarter.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{quarter.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{quarter.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{quarter.activityDescription}}</td><td>{{quarter.maleParticipants}}</td><td>{{quarter.femaleParticipants}}</td><td ng-repeat-end="">{{quarter.participants}}</td></div><td>{{activity.fourthQuarterTargetDetails.targetEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.fourthQuarterTargetDetails.targetUnit}}</td><td>{{activity.fourthQuarterTargetDetails.budget}}</td><td>{{activity.fourthQuarterTargetDetails.targetMaleParticipants}}</td><td>{{activity.fourthQuarterTargetDetails.targetFemaleParticipants}}</td><td>{{activity.fourthQuarterTargetDetails.targetParticipants}}</td><td>{{activity.fourthQuarterTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.fourthQuarterTargetDetails.achievedUnit}}</td><td>{{activity.fourthQuarterTargetDetails.expenditure}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'reasonOfDeviation\') && $last == false">{{activity.fourthQuarterTargetDetails.reasonOfDeviation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'notDoneSubActivities\') && $last == false">{{activity.fourthQuarterTargetDetails.notDoneSubActivities}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'challenge\') && $last == false">{{activity.fourthQuarterTargetDetails.challenge}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'lessonLearnt\') && $last == false">{{activity.fourthQuarterTargetDetails.lessonLearnt}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'recommendation\') && $last == false">{{activity.fourthQuarterTargetDetails.recommendation}}</td><td ng-if="vm.monitoringSessionExtrasToShow.includes(\'activityDescription\') && $last == false">{{activity.fourthQuarterTargetDetails.activityDescription}}</td><td>{{activity.fourthQuarterTargetDetails.maleParticipants}}</td><td>{{activity.fourthQuarterTargetDetails.femaleParticipants}}</td><td>{{activity.fourthQuarterTargetDetails.participants}}</td><td>{{activity.yearlyTargetDetails.achievedEvent}}</td><td ng-if="vm.activityExtrasToShow.includes(\'customUnit\')">{{activity.yearlyTargetDetails.achievedUnit}}</td><td>{{activity.yearlyTargetDetails.expenditure}}</td><td>{{activity.yearlyTargetDetails.maleParticipants}}</td><td>{{activity.yearlyTargetDetails.femaleParticipants}}</td><td>{{activity.yearlyTargetDetails.participants}}</td></tr></table></div></div>');
$templateCache.put('app/pages/main/generalReport/outcomeReport/outcomeReport.html','<div ba-panel="" ba-panel-title="Impact Report"><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.generateImpacts()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impactList" output-model="vm.selectedImpact" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Monitoring Sessions</h4><div isteven-multi-select="" input-model="vm.filteredMonitoringSessionList" output-model="vm.selectedMonitoringSessionTimes" button-label="name" item-label="name" tick-property="ticked" output-properties="name" selection-mode="multiple"></div></div></div><div class="row"><div class="form-group col-md-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top: 2%;" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div><div ng-if="vm.dataLoaded"><h3 class="with-line">Outcomes</h3><div ng-repeat="outcome in vm.selectedOutcomeList" style="margin-bottom: 20px"><h4><b>Outcome {{outcome.number}}: {{outcome.summary}}</b></h4><ul ng-repeat="indicator in outcome.outcomeIndicators| orderBy:\'indicator.number\'" ng-if="outcome.outcomeIndicators && outcome.outcomeIndicators.length > 0"><li>{{indicator.number}}. {{indicator.summary}}</li><h5><b>Baseline :</b>{{indicator.baseline}}</h5><ul ng-repeat="session in indicator.outcomeMonitoringSessions" ng-if="vm.selectedMonitoringSessionIdSet.has(session.id)"><br><h5>{{session.timeOfMonitoringText}}</h5><li>Target: {{session.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{session.achieved != null ? session.achieved + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Deviation: {{session.achieved != null ? session.deviation + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Causality: {{session.causality}}</li><li>Recommendation: {{session.recommendation}}</li><br></ul></ul></div></div></div>');
$templateCache.put('app/pages/main/generalReport/outputReport/outputReport.html','<div ba-panel="" ba-panel-title="Impact Report"><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" on-item-click="vm.generateImpacts()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impactList" output-model="vm.selectedImpact" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Select Outcome</h4><div isteven-multi-select="" input-model="vm.outcomeList" output-model="vm.selectedOutcome" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id outputs" on-item-click="vm.generateOutputs()" selection-mode="single"></div></div></div><div class="row" style="margin-top: 5px;"><div class="form-group col-sm-4 col-xs-4"><h4>Monitoring Sessions</h4><div isteven-multi-select="" input-model="vm.filteredMonitoringSessionList" output-model="vm.selectedMonitoringSessionTimes" button-label="name" item-label="name" tick-property="ticked" output-properties="name" selection-mode="multiple"></div></div><div class="form-group col-md-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top: 9%;" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div><div ng-if="vm.dataLoaded"><h3 class="with-line">Outputs</h3><div ng-repeat="output in vm.selectedOutputList" style="margin-bottom: 20px"><h4><b>Output {{output.number}}: {{output.summary}}</b></h4><ul ng-repeat="indicator in output.outputIndicators | orderBy:\'indicator.number\'" ng-if="output.outputIndicators && output.outputIndicators.length > 0"><li>{{indicator.number}}. {{indicator.summary}}</li><h5><b>Baseline :</b>{{indicator.baseline}}</h5><ul ng-repeat="session in indicator.outputMonitoringSessions" ng-if="vm.selectedMonitoringSessionIdSet.has(session.id)"><br><h5>{{session.timeOfMonitoringText}}</h5><li>Target: {{session.target}} {{indicator.unit ? indicator.unit : \'\'}}</li><li>Achieved: {{session.achieved != null ? session.achieved + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Deviation: {{session.achieved != null ? session.deviation + \' \' + (indicator.unit ? indicator.unit : \'\') : \'Data not collected\'}}</li><li>Causality: {{session.causality}}</li><li>Recommendation: {{session.recommendation}}</li><br></ul></ul></div></div></div>');
$templateCache.put('app/pages/main/monitoring/activityMonitoring/activityMonitoring.html','<style>\n    td{\n        vertical-align: middle!important;\n    }\n    .edit-button{\n        width: 150px!important;\n        height: 50px!important;\n    }\n</style><div ba-panel="" ba-panel-title="Activity Monitoring" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center;" class="row form-inline" ng-show="vm.showDiv"><div class="form-group col-md-4 col-xs-4"><h4>Name</h4><input class="form-control" type="text" placeholder="Activity summary key words/responsible agency name ..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.searchActivities : null"></div><div class="col-md-4"><div class="form-group"><h4>Start Time</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isStartDatePickerOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openStartDatePicker($event)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="col-md-4"><div class="form-group"><h4>End Time</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.endDate" is-open="vm.isEndDatePickerOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openEndDatePicker($event)"><i class="fa fa-calendar"></i></button></span></p></div></div></div><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showDiv"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-4"><h4 ng-if="vm.selectedProjects.length > 0">Select Impact</h4><div ng-if="vm.selectedProjects.length > 0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-select-all="vm.mapOutcomes()" on-clear="vm.mapOutcomes()" on-reset="vm.mapOutcomes()" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-sm-4 col-xs-4"><h4 ng-if="vm.selectedImpacts.length > 0">Outcome Number</h4><div ng-if="vm.selectedImpacts.length > 0" isteven-multi-select="" input-model="vm.multiselectOutcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outputs" on-item-click="vm.mapOutputs()" on-select-all="vm.mapOutputs()" on-select-none="vm.mapOutputs()"></div></div></div><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showDiv"><div class="form-group col-sm-4 col-xs-4"><h4 ng-if="vm.selectedOutcomes.length > 0">Output Number</h4><div ng-if="vm.selectedOutcomes.length > 0" isteven-multi-select="" input-model="vm.multiSelectOutputs" output-model="vm.selectedOutputs" button-label="number" item-label="number" tick-property="ticked" output-properties="id number summary activities"></div></div></div><div class="row" ng-show="vm.showDiv"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchActivities()"><i class="ion-search"></i>Search</button></div><div class="form-group col-sm-4 col-xs-6"></div></div><div class="row"><div class="col-md-2" style="text-align: center; margin-bottom: 20px;"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showDiv = !vm.showDiv"><em style="margin-right: 10px">{{vm.showDiv ? "Hide Filters" : "Show Filters"}}</em></a> <a href="" ng-click="vm.showDiv = !vm.showDiv"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.outputsToShow.length > 0"><thead><th class="headers2" style="text-align: center">Output Number</th><th class="headers2" style="text-align: center;vertical-align: middle">Summary</th><th class="headers2" style="text-align: center">Activity Number</th><th class="headers2" style="text-align: center">Activity Title</th><th class="headers2" style="text-align: center"></th></thead><tr ng-repeat-start="output in vm.outputsToShow"><td rowspan="{{output.activities.length}}">{{output.number}}</td><td rowspan="{{output.activities.length}}"><a ui-sref="outputDetails({id : {{output.id}}})">{{output.summary}}</a></td><td>{{output.activities[0].serialNumber}}</td><td>{{output.activities[0].title}}</td><td class="edit-button"><a ui-sref="activityPerformMonitoring({ id : {{output.activities[0].id}}})"><button class="btn btn-primary btn-block" style="padding: 5px">Monitoring</button></a></td></tr><tr ng-repeat-end="" ng-repeat="activity in output.activities" ng-if="$index>0"><td>{{activity.serialNumber}}</td><td>{{activity.title}}</td><td class="edit-button"><a ui-sref="activityPerformMonitoring({ id : {{activity.id}}})"><button class="btn btn-primary btn-block" style="padding: 5px">Monitoring</button></a></td></tr><div class="row text-center" ng-if="vm.outputsToShow.length == 0"><p><i>No Activities available</i></p></div></table></div>');
$templateCache.put('app/pages/main/monitoring/impactMonitoring/impactMonitoring.html','<div ba-panel="" ba-panel-title="Impact List" ba-panel-class="with-scroll"><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.impacts.length > 0"><colgroup><col span="1" style="width: 5%;"><col span="1" style="width: 40%;"><col span="1" style="width: 25%;"><col span="1" style="width: 30%;"></colgroup><thead><th class="headers2" style="text-align: center">Number</th><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Project</th><th class="headers2" style="text-align: center">Action</th></thead><tr ng-repeat="impact in vm.impacts | orderBy:\'number\'" ng-if="vm.impacts.length > 0"><td>{{impact.number}}</td><td>{{impact.summary}}</td><td>{{impact.project.name}}</td><td><a ui-sref="monitoring.impactMonitoringDetails({id : {{impact.id}}})" style="width: 100%; padding-left:5px;!important; padding-right: 5px;!important;"><button class="btn btn-primary" style="width: 100%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-if="impact.isValid">Monitoring</button></a><div ng-if="!impact.isValid"><p style="margin-top: 10px;">Impact Not Set Up Properly.</p><p>Please add indicators and monitoring sessions.</p></div></td></tr><div class="row text-center" ng-if="vm.impacts.length == 0"><p><i>No impacts available</i></p></div></table></div>');
$templateCache.put('app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoring.html','<div ba-panel="" ba-panel-title="Outcome Monitoring" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-6"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.filterImpacts()"><i class="ion-search"></i>Search</button></div></div><div class="row"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"><button class="btn btn-info btn-block" ng-click="vm.openCreateOutcomeModal()">Add Outcome</button></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.selectedOutcomes.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Impact</th><th class="headers2" style="text-align: center">Action</th></thead><tr ng-repeat="outcome in vm.selectedOutcomes | orderBy:\'number\'" ng-if="vm.selectedOutcomes.length > 0"><td>{{outcome.number}}. {{outcome.summary}}</td><td>{{outcome.impact.number}}. {{outcome.impact.summary}}</td><td><a ui-sref="monitoring.outcomeMonitoringDetails({id : {{outcome.id}}})"><button class="btn btn-primary" style="width: 80%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-if="vm.isOutcomeValidForMonitoring(outcome)">Monitoring</button></a><div ng-if="!vm.isOutcomeValidForMonitoring(outcome)"><p style="margin-top: 10px;">Outcome Not Set Up Properly.</p><p>Please setup indicators & monitoring sessions.</p></div></td></tr></table><div class="row text-center" ng-if="vm.selectedOutcomes.length == 0"><p><i>No outcomes available</i></p></div></div>');
$templateCache.put('app/pages/main/monitoring/outputMonitoring/outputMonitoring.html','<div ba-panel="" ba-panel-title="Outputs" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedProjects.length > 0">Select Impact</h4><div ng-if="vm.selectedProjects.length > 0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedImpacts.length > 0">Select Outcome</h4><div ng-if="vm.selectedImpacts.length > 0" isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs"></div></div></div><div class="row" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchOutputs()"><i class="ion-search"></i>Search</button></div><div class="form-group col-sm-4 col-xs-6"></div></div><div class="row" style="margin-top: 10px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.allOutputs.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2">Outputs</th><th class="headers2">Outcome</th><th class="headers2"></th></thead><tr ng-repeat="output in vm.allOutputs | orderBy:\'number\'"><td>{{output.number}}. {{output.summary}}</td><td>{{output.outcome.number}}. {{output.outcome.summary}}</td><td><a ui-sref="monitoring.outputMonitoringDetails({id : {{output.id}}})"><button class="btn btn-primary" style="width: 80%; margin-top:10px;!important;margin-bottom:10px;!important;" ng-if="vm.isOutputValidForMonitoring(output)">Monitoring</button></a><div ng-if="!vm.isOutputValidForMonitoring(output)"><p style="margin-top: 10px;">Output Not Set Up Properly.</p><p>Please setup indicators & monitoring sessions.</p></div></td></tr><tr ng-if="vm.allOutputs.length === 0"><td colspan="4"><p><i>No outputs available</i></p></td></tr></table></div>');
$templateCache.put('app/pages/main/outcomeDetails/create/createIndicator.html','<style>\n    td{\n        vertical-align: middle!important;\n    }\n</style><div ba-panel="" ba-panel-title="Create Outcome Indicator"><div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div></div><div class="row" ng-if="vm.type == 1"><div class="col-sm-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-sm-1" style="margin-top: 30px"><div>{{vm.unit}}</div></div><div class="col-sm-2"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div><div class="col-sm-6" style="margin-top: 30px"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-right: 60px"><input type="radio" ng-model="vm.type" ng-value="option.value" style="margin-right: 10px">{{option.name}}</label></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-sm-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div><div class="col-sm-6"><div class="form-group" style="margin-top:30px"><label ng-repeat="option in vm.typeOptions" style="margin-right: 60px"><input type="radio" ng-model="vm.type" ng-value="option.value" style="margin-right: 10px">{{option.name}}</label></div></div></div></div><div class="row"><div class="col-sm-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-sm-6"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-sm-6" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedInterval != null"><thead><th>Time of Monitoring</th><th>Target Achieved {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Means of Verification</th><th>Assumption</th></thead><tbody><tr ng-repeat="row in vm.tableData"><td style="padding-top: 15px"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" is-open="row.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.targetAchieved"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.targetAchieved"></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td style="padding: 5px"><input type="text" class="form-control" ng-model="row.meansOfVerification"></td><td style="padding: 5px"><input type="text" class="form-control" ng-model="row.assumption"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createOutcomeIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outcomeDetails/create/createOutput.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Means Of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOutcome()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outcomeDetails/edit/edit.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div ng-show="vm.type == \'indicator\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.indicator.meansOfVerification"></textarea></div></div></div><br><br><div class="row"><div class="col-md-6"><div class="form-group"><label for="description">Assumption</label> <textarea id="description" class="form-control" ng-model="vm.indicator.assumption"></textarea></div></div></div></div><div ng-show="vm.type == \'research\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reasearchers</label> <input type="text" class="form-control" ng-model="vm.indicator.respondents"></div></div><div class="col-sm-6"><div class="form-group"><label>Frequency</label> <input type="text" class="form-control" ng-model="vm.indicator.frequency"></div></div><div class="col-sm-6"><div class="form-group"><label>Place</label> <input type="text" class="form-control" ng-model="vm.indicator.place"></div></div><div class="col-sm-6"><div class="form-group"><label>Time</label> <input type="text" class="form-control" ng-model="vm.indicator.timeOfDataCollection"></div></div><div class="col-sm-6"><div class="form-group"><label>Actual Status</label> <input type="text" class="form-control" ng-model="vm.indicator.actualStatus"></div></div><div class="col-sm-6"><div class="form-group"><label>Comments from Supervisor</label> <textarea class="form-control" ng-model="vm.indicator.commentsFromSupervisor"></textarea></div></div></div><br><br></div><div ng-show="vm.type == \'monitoring\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.indicator.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.indicator.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.indicator.recommendation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reflection In Future Plan</label> <textarea class="form-control" ng-model="vm.indicator.reflectionInFuturePlan"></textarea></div></div></div><br><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateIndicator()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outcomeDetails/edit/editSummary.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group"><label>Name</label> <input type="text" class="form-control" ng-model="vm.outcome.number"></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.outcome.summary"></textarea></div></div></div><br><br><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateSummary()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outputDetails/create/createActivity.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Means Of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row form-group"><label style="margin-left: 15px">Time</label><br><div class="col-sm-6"><p class="input-group"><input type="text" class="form-control" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" datetime-picker="MMMM" ng-model="vm.time" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event)"><i class="fa fa-calendar"></i></button></span></p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createActivity()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outputDetails/create/createIndicator.html','<style>\n    td{\n        vertical-align: middle!important;\n    }\n</style><div ba-panel="" ba-panel-title="Create Output Indicator"><div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div></div><div class="row" ng-if="vm.type == 1"><div class="col-sm-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-sm-1" style="margin-top: 30px"><div>{{vm.unit}}</div></div><div class="col-sm-2"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div><div class="col-sm-6" style="margin-top: 30px"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-right: 60px"><input type="radio" ng-model="vm.type" ng-value="option.value" style="margin-right: 10px">{{option.name}}</label></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-sm-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div><div class="col-sm-6"><div class="form-group" style="margin-top:30px"><label ng-repeat="option in vm.typeOptions" style="margin-right: 60px"><input type="radio" ng-model="vm.type" ng-value="option.value" style="margin-right: 10px">{{option.name}}</label></div></div></div></div><div class="row"><div class="col-sm-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-sm-6"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-sm-6" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedInterval != null && vm.selectedTimeLine != \'Immediate\'"><thead><th>Time of Monitoring</th><th>Target Achieved {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Means of Verification</th><th>Assumption</th></thead><tbody><tr ng-repeat="row in vm.tableData"><td style="padding-top: 15px"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" is-open="row.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.targetAchieved"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.targetAchieved"></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td style="padding: 5px"><input type="text" class="form-control" ng-model="row.meansOfVerification"></td><td style="padding: 5px"><input type="text" class="form-control" ng-model="row.assumption"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createOutputIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outputDetails/edit/editOutputIndicator.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div ng-show="vm.type == \'indicator\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.indicator.meansOfVerification"></textarea></div></div></div><br><br><div class="row"><div class="col-md-6"><div class="form-group"><label for="description">Assumption</label> <textarea id="description" class="form-control" ng-model="vm.indicator.assumption"></textarea></div></div></div></div><div ng-show="vm.type == \'research\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator.indicator"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reasearchers</label> <input type="text" class="form-control" ng-model="vm.indicator.respondents"></div></div><div class="col-sm-6"><div class="form-group"><label>Frequency</label> <input type="text" class="form-control" ng-model="vm.indicator.frequency"></div></div><div class="col-sm-6"><div class="form-group"><label>Place</label> <input type="text" class="form-control" ng-model="vm.indicator.place"></div></div><div class="col-sm-6"><div class="form-group"><label>Time</label> <input type="text" class="form-control" ng-model="vm.indicator.timeOfDataCollection"></div></div><div class="col-sm-6"><div class="form-group"><label>Actual Status</label> <input type="text" class="form-control" ng-model="vm.indicator.actualStatus"></div></div><div class="col-sm-6"><div class="form-group"><label>Comments from Supervisor</label> <textarea class="form-control" ng-model="vm.indicator.commentsFromSupervisor"></textarea></div></div></div><br><br></div><div ng-show="vm.type == \'monitoring\'"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.indicator.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.indicator.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.indicator.recommendation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Reflection In Future Plan</label> <textarea class="form-control" ng-model="vm.indicator.reflectionInFuturePlan"></textarea></div></div></div><br><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateIndicator()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/outputDetails/edit/editSummary.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-12"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.output.number"></div></div></div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.output.summary"></textarea></div></div></div><br><br><br><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateSummary()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/activityDetails/create/createIndicator.html','<style>\n    td{\n        vertical-align: middle!important;\n    }\n</style><div ba-panel="" ba-panel-title="Create Activity Indicator"><div><div class="row"><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div></div><div class="row" ng-if="vm.type == 1"><div class="col-sm-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-sm-1" style="margin-top: 30px"><div>{{vm.unit}}</div></div><div class="col-sm-2"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-sm-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-sm-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-sm-6"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedTimeLine != null"><thead><th>Time of Monitoring</th><th>Target Achieved {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Means of Verification</th></thead><tbody><tr ng-repeat="row in vm.tableData"><td style="padding-top: 15px"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" is-open="row.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.targetAchieved"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.targetAchieved"></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td style="padding: 5px"><input type="text" class="form-control" ng-model="row.meansOfVerification"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createActivityIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/profileInfo.html','<div><div include-with-scope="app/pages/main/profile/profileInfo/generalInfo/generalInfo.partial.html"></div><div include-with-scope="app/pages/main/profile/profileInfo/actions/actions.partial.html"></div><div include-with-scope="app/pages/main/profile/profileInfo/details/details.partial.html"></div></div>');
$templateCache.put('app/pages/main/projects/create/createProject.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Project<hr></h4></div><div class="modal-body"><div><div class="form-group"><label>Name</label> <input type="text" class="form-control" ng-model="vm.name"></div><div class="form-group"><label>Country</label> <input type="text" class="form-control" ng-model="vm.country"></div></div><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createProject()">Create Project</button></div></div>');
$templateCache.put('app/pages/main/projects/edit/editProject.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Project<hr></h4></div><div class="modal-body"><div><div class="form-group"><label>Name</label> <input type="text" class="form-control" ng-model="vm.name"></div><div class="form-group"><label>Country</label> <input type="text" class="form-control" ng-model="vm.country"></div></div><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateProjectName()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/activity/activity.html','<div ba-panel="" ba-panel-title="Activity" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="row"><div class="form-group col-sm-4 col-xs-4"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-4"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-md-4 col-xs-4"><h4>Select Outcome</h4><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs" on-item-click="vm.generateOutputs()" selection-mode="single"></div></div></div><div class="row" style="margin-top: 20px;"><div class="form-group col-sm-4 col-xs-4"><h4>Select Output</h4><div isteven-multi-select="" input-model="vm.outputs" output-model="vm.selectedOutputs" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary majorActivities" selection-mode="single"></div></div><div class="form-group col-md-4 col-xs-4"><h4>Name</h4><input class="form-control" type="text" placeholder="Activity summary key words/responsible agency name ..." ng-model="vm.search.searchName" ng-keyup="$event.keyCode == 13 ? vm.search() : null"></div><div class="col-md-4"><div class="form-group"><h4>Start Time</h4><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div></div><div class="row" style="margin-top: 20px;"><div class="form-group col-md-offset-4 col-md-4 col-xs-4"><button type="button" class="btn btn-primary btn-with-icon btn-block" style="width: 100%;margin-top:30px" ng-click="vm.search()"><i class="ion-search"></i>Search</button></div></div></div><div class="row" style="margin-top: 20px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"><button class="btn btn-info btn-block" ui-sref="setup.createActivity">Add Activity</button></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.activityList.length > 0"><colgroup><col span="1" style="width: 20%;"><col span="1" style="width: 10%;"><col span="1" style="width: 5%;"><col span="1" style="width: 5%;"><col span="1" style="width: 10%;"><col span="1" style="width: 10%;"><col span="1" style="width: 10%;"><col span="1" style="width: 10%;"><col span="1" style="width: 20%;"></colgroup><thead><th class="headers2">Activity</th><th class="headers2">Target Event</th><th class="headers2">Male</th><th class="headers2">Female</th><th class="headers2">Timeline</th><th class="headers2">Agencies</th><th class="headers2">Budget</th><th class="headers2">Output</th><th class="headers2">Edit/Delete</th></thead><tr ng-repeat="activity in vm.activityList | orderBy:\'serialNo\'"><td>{{activity.serialNumber}}. {{activity.title}}</td><td>{{activity.targetEvent}}</td><td>{{activity.maleParticipants}}</td><td>{{activity.femaleParticipants}}</td><td>{{vm.convertMillisToDate(activity.startDate)}} to {{vm.convertMillisToDate(activity.endDate)}}</td><td>{{activity.responsibleAgency}}</td><td>{{activity.budget}}</td><td>{{activity.output.number}}. {{activity.output.summary}}</td><td><div style="padding-top: 10px; padding-bottom: 10px; vertical-align: middle; display: inline-block; width: 100%"><button class="btn btn-info" style="width: 47%" ng-disabled="vm.isResponsePending" ui-sref="setup.editActivity({activityId: {{activity.id}}})">Setup</button> <button class="btn btn-danger" style="width: 47%" ng-disabled="vm.isResponsePending" ng-if="vm.deletingImpact != activity.id" ng-click="vm.deleteactivity(activity)">Delete</button> <button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-if="vm.deletingImpact == activity.id">Please Wait</button></div></td></tr><tr ng-if="vm.activityList.length === 0"><td colspan="8"><p><i>No major activities available</i></p></td></tr></table></div>');
$templateCache.put('app/pages/main/dataCollection/activityData/dataCollection/activityDataCollection.html','<div ba-panel="" ba-panel-title="Data Collection" ba-panel-class="with-scroll"><div><div class="row"><div class="col-md-12"><div class="form-group"><label>Activity Title:</label> <span><b>{{vm.activity.serialNumber}}.{{vm.activity.title}}</b></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Select Data Collection Session</label><div isteven-multi-select="" input-model="vm.monitoringSessions" output-model="vm.selectedMonitoringSession" button-label="readableDate" item-label="readableDate" tick-property="ticked" selection-mode="single" on-item-click="vm.setupMonitoringSessionForDataCollection()"></div></div></div></div><hr><div ng-if="vm.selectedMonitoringSession.length > 0"><table class="table table-bordered"><thead><tr><td class="text-left"></td><td class="text-center">Target</td><td class="text-center">Achievement</td><td class="text-center">Deviation</td></tr></thead><tbody><tr><td>Event</td><td>{{vm.selectedMonitoringSession[0].targetEvent}}</td><td>{{vm.selectedMonitoringSession[0].achievedEvent}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetEvent,vm.selectedMonitoringSession[0].achievedEvent)}}</td></tr><tr><td>Male</td><td>{{vm.selectedMonitoringSession[0].targetMale}}</td><td>{{vm.selectedMonitoringSession[0].achievedMale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetMale,vm.selectedMonitoringSession[0].achievedMale)}}</td></tr><tr><td>Female</td><td>{{vm.selectedMonitoringSession[0].targetFemale}}</td><td>{{vm.selectedMonitoringSession[0].achievedFemale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetFemale,vm.selectedMonitoringSession[0].achievedFemale)}}</td></tr><tr><td>Total</td><td>{{vm.selectedMonitoringSession[0].targetFemale + vm.selectedMonitoringSession[0].targetMale}}</td><td>{{vm.selectedMonitoringSession[0].achievedFemale + vm.selectedMonitoringSession[0].achievedMale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetFemale + vm.selectedMonitoringSession[0].targetMale,vm.selectedMonitoringSession[0].achievedFemale + vm.selectedMonitoringSession[0].achievedMale)}}</td></tr><tr><td>Budget</td><td>{{vm.selectedMonitoringSession[0].budget}}</td><td>{{vm.selectedMonitoringSession[0].spentBudget}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].budget , vm.selectedMonitoringSession[0].spentBudget)}}</td></tr><tr><td>Unit</td><td>{{vm.selectedMonitoringSession[0].targetUnit}}</td><td>{{vm.selectedMonitoringSession[0].achievedUnit}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetUnit , vm.selectedMonitoringSession[0].achievedUnit)}}</td></tr></tbody></table><hr><div class="row bottom"><div class="col-md-3"><label>Activity Description</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.activityDescription"></textarea></div></div><div class="row bottom" ng-if="!vm.achievedUnitEnabled" ng-click="vm.achievedUnitEnabled = true"><div class="col-md-3"><span><a class="link-btn" href="#">Achieved In Unit (Optional)</a></span></div></div><div class="row bottom" ng-if="vm.achievedUnitEnabled"><div class="col-md-3"><label>Achieved In Unit</label></div><div class="col-md-9"><div class="d-flex-space-between-5"><input type="number" class="form-control" ng-model="vm.achievedInUnit"> <button type="button" class="btn btn-default" ng-click="vm.achievedUnitEnabled = false"><i class="fa fa-close"></i></button></div></div></div><div class="row bottom"><div class="col-md-3"><label>Achieved Event</label></div><div class="col-md-9"><input type="number" class="form-control" ng-model="vm.achievedEvent"></div></div><div class="row bottom"><div class="col-md-3"><label>Male Participants</label></div><div class="col-md-9"><input type="number" class="form-control" ng-model="vm.achievedMale"></div></div><div class="row bottom"><div class="col-md-3"><label>Female Participants</label></div><div class="col-md-9"><input type="number" class="form-control" ng-model="vm.achievedFemale"></div></div><div class="row" style="margin-bottom: 30px"><div class="col-md-3"><label>Total Participants</label></div><div class="col-md-9">{{vm.achievedMale + vm.achievedFemale}}</div></div><div class="row bottom"><div class="col-md-3"><label>Budget Spent</label></div><div class="col-md-9"><input type="number" class="form-control" ng-model="vm.budgetSpent"></div></div><div class="row"><div class="col-md-3 col-md-offset-9"><button class="btn btn-primary btn-block" ng-click="vm.performDataCollection()">Save</button></div></div></div></div></div>');
$templateCache.put('app/pages/main/dataCollection/impactData/dataCollectionModal/impactDataCollection.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Impact Data Collection<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-12"><div class="form-group"><label>Impact Summary:</label> <span><b>{{vm.impact.summary}}</b></span></div></div></div><br><div class="row"><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.impact.impactIndicators" output-model="vm.selectedIndicator" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.impactMonitoringSessions" output-model="vm.selectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><hr><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Information Required</label></div><div class="col-md-9"><span>{{vm.indicator.informationRequired}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Source of Information</label></div><div class="col-md-9"><span>{{vm.indicator.sourceOfInfo}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Data collection Method</label></div><div class="col-md-9"><span>{{vm.indicator.dataCollectionMethod}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Target</label></div><div class="col-md-9"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Actual Status {{!vm.indicator.unit ? \'\' : \'(\' + vm.indicator.unit + \')\' }}</label></div><div class="col-md-9"><input type="number" class="form-control" ng-if="vm.indicator.type == 1" ng-model="vm.monitoringSession.achieved"> <textarea type="text" class="form-control" ng-if="vm.indicator.type == 0" ng-model="vm.monitoringSession.achieved"></textarea></div></div><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save Data</button></div></div>');
$templateCache.put('app/pages/main/dataCollection/outcomeData/dataCollectionModal/outcomeDataCollection.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Outcome Data Collection<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-12"><div class="form-group"><label>Outcome Summary:</label> <span><b>{{vm.outcome.summary}}</b></span></div></div></div><br><div class="row"><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.outcome.outcomeIndicators" output-model="vm.selectedIndicator" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.outcomeMonitoringSessions" output-model="vm.selectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><hr><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Information Required</label></div><div class="col-md-9"><span>{{vm.indicator.informationRequired}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Source of Information</label></div><div class="col-md-9"><span>{{vm.indicator.sourceOfInfo}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Data collection Method</label></div><div class="col-md-9"><span>{{vm.indicator.dataCollectionMethod}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Target</label></div><div class="col-md-9"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Actual Status {{!vm.indicator.unit ? \'\' : \'(\' + vm.indicator.unit + \')\' }}</label></div><div class="col-md-9"><input type="number" class="form-control" ng-if="vm.indicator.type == 1" ng-model="vm.monitoringSession.achieved"> <textarea type="text" class="form-control" ng-if="vm.indicator.type == 0" ng-model="vm.monitoringSession.achieved"></textarea></div></div><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save Data</button></div></div>');
$templateCache.put('app/pages/main/dataCollection/outputData/dataCollectionModal/outputDataCollection.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Output Data Collection<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-12"><div class="form-group"><label>Output Summary:</label> <span><b>{{vm.output.summary}}</b></span></div></div></div><br><div class="row"><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.output.outputIndicators" output-model="vm.selectedIndicator" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.outputMonitoringSessions" output-model="vm.selectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><hr><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Information Required</label></div><div class="col-md-9"><span>{{vm.indicator.informationRequired}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Source of Information</label></div><div class="col-md-9"><span>{{vm.indicator.sourceOfInfo}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Data collection Method</label></div><div class="col-md-9"><span>{{vm.indicator.dataCollectionMethod}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Target</label></div><div class="col-md-9"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><br><div class="row" ng-if="vm.indicator && vm.monitoringSession"><div class="col-md-3"><label>Actual Status {{!vm.indicator.unit ? \'\' : \'(\' + vm.indicator.unit + \')\' }}</label></div><div class="col-md-9"><input type="number" class="form-control" ng-if="vm.indicator.type == 1" ng-model="vm.monitoringSession.achieved"> <textarea type="text" class="form-control" ng-if="vm.indicator.type == 0" ng-model="vm.monitoringSession.achieved"></textarea></div></div><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save Data</button></div></div>');
$templateCache.put('app/pages/main/monitoring/activityMonitoring/monitoring/activityPerformMonitoring.html','<div ba-panel="" ba-panel-title="Monitoring" ba-panel-class="with-scroll"><div><div class="row"><div class="col-md-12"><div class="form-group"><label>Activity Title:</label> <span><b>{{vm.activity.serialNumber}}.{{vm.activity.title}}</b></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.monitoringSessions" output-model="vm.selectedMonitoringSession" button-label="readableDate" item-label="readableDate" tick-property="ticked" selection-mode="single" on-item-click="vm.setupMonitoringSessionForDataCollection()"></div></div></div></div><div ng-if="vm.selectedMonitoringSession.length > 0"><h3 class="with-line">Collected Data</h3><table class="table table-bordered"><thead><tr><td class="text-left"></td><td class="text-center">Target</td><td class="text-center">Achievement</td><td class="text-center">Deviation</td></tr></thead><tbody><tr><td>Event</td><td>{{vm.selectedMonitoringSession[0].targetEvent}}</td><td>{{vm.selectedMonitoringSession[0].achievedEvent}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetEvent,vm.selectedMonitoringSession[0].achievedEvent)}}</td></tr><tr><td>Male</td><td>{{vm.selectedMonitoringSession[0].targetMale}}</td><td>{{vm.selectedMonitoringSession[0].achievedMale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetMale,vm.selectedMonitoringSession[0].achievedMale)}}</td></tr><tr><td>Female</td><td>{{vm.selectedMonitoringSession[0].targetFemale}}</td><td>{{vm.selectedMonitoringSession[0].achievedFemale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetFemale,vm.selectedMonitoringSession[0].achievedFemale)}}</td></tr><tr><td>Total</td><td>{{vm.selectedMonitoringSession[0].targetFemale + vm.selectedMonitoringSession[0].targetMale}}</td><td>{{vm.selectedMonitoringSession[0].achievedFemale + vm.selectedMonitoringSession[0].achievedMale}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetFemale + vm.selectedMonitoringSession[0].targetMale,vm.selectedMonitoringSession[0].achievedFemale + vm.selectedMonitoringSession[0].achievedMale)}}</td></tr><tr><td>Budget</td><td>{{vm.selectedMonitoringSession[0].budget}}</td><td>{{vm.selectedMonitoringSession[0].spentBudget}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].budget , vm.selectedMonitoringSession[0].spentBudget)}}</td></tr><tr><td>Unit</td><td>{{vm.selectedMonitoringSession[0].targetUnit}}</td><td>{{vm.selectedMonitoringSession[0].achievedUnit}}</td><td>{{vm.getDeviation(vm.selectedMonitoringSession[0].targetUnit , vm.selectedMonitoringSession[0].achievedUnit)}}</td></tr></tbody></table><h3 class="with-line">Monitoring Feedback</h3><div class="row bottom"><div class="col-md-3"><label>Reason of Deviation</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.reasonOfDeviation"></textarea></div></div><div class="row bottom"><div class="col-md-3"><label>Not Done Activities</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.notDoneActivities"></textarea></div></div><div class="row bottom"><div class="col-md-3"><label>Challenges</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.challenge"></textarea></div></div><div class="row bottom"><div class="col-md-3"><label>Lesson Learnt</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.lessonLearnt"></textarea></div></div><div class="row bottom"><div class="col-md-3"><label>Recommendation</label></div><div class="col-md-9"><textarea class="form-control" ng-model="vm.recommendation"></textarea></div></div><div class="row"><div class="col-md-3 col-md-offset-9"><button class="btn btn-primary btn-block" ng-click="vm.performMonitoring()">Save</button></div></div></div></div></div>');
$templateCache.put('app/pages/main/monitoring/impactMonitoring/impactMonitoringDetails/impactMonitoringDetails.html','<div ba-panel="" ba-panel-title="Impact Monitoring" ba-panel-class="with-scroll"><h4 style="margin-top: 20px">Impact {{vm.impact.number}} : <b>{{vm.impact.summary}}</b></h4><hr><div><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.impact.impactIndicators" output-model="vm.multiselectSelectedIndicator" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.impactMonitoringSessions" output-model="vm.multiselectSelectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><div><br></div><div ng-if="vm.monitoringSession && vm.monitoringSession.dataCollected"><div><h4>Collected Data</h4><hr style="margin-top: 0!important;"></div><div style="padding-bottom: 35px;"><div class="col-md-6"><div class="col-md-5"><label>Target</label></div><div class="col-md-7"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Achieved</label></div><div class="col-md-7"><span>{{vm.monitoringSession.achieved}} {{vm.indicator.unit}}</span></div></div></div><div style="padding-bottom: 35px;" ng-if="vm.indicator.type===1"><div class="col-md-6"><div class="col-md-5"><label>Deviation</label></div><div class="col-md-7"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Deviation in Percentage</label></div><div class="col-md-7"><span>{{vm.monitoringSession.deviation * 100 / vm.monitoringSession.target}}%</span></div></div></div><div style="float:left; width: 100%;margin-top: 20px;"><h4>Monitoring Feedback</h4><hr style="margin-top: 0!important;"></div><div class="row" style="width: 100%;"><button class="btn btn-info btn-block" style="float:right;width: 200px;" ng-click="vm.openEditMonitoringFeedbackModal()">Edit Monitoring Feedback</button></div><div style="padding-bottom: 35px; padding-top: 20px;"><div class="col-md-6"><div class="col-md-6"><label>Deviation</label></div><div class="col-md-6"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Causality</label></div><div class="col-md-7"><span>{{vm.monitoringSession.causality}}</span></div></div></div><div style="padding-bottom: 35px;"><div class="col-md-3" style="padding-left: 30px;"><label>Recommendation</label></div><div class="col-md-9"><span>{{vm.monitoringSession.recommendation}}</span></div></div></div><div ng-if="vm.monitoringSession && !vm.monitoringSession.achieved" style="text-align: center"><p>No data collection has been done for this monitoring session.</p></div><div ng-if="!vm.monitoringSession" style="text-align: center"><p>Please select an indicator and a monitoring session first.</p></div></div>');
$templateCache.put('app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoringDetails/outcomeMonitoringDetails.html','<div ba-panel="" ba-panel-title="Outcome Monitoring" ba-panel-class="with-scroll"><h4 style="margin-top: 20px">Outcome {{vm.outcome.number}} : <b>{{vm.outcome.summary}}</b></h4><hr><div><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.outcome.outcomeIndicators" output-model="vm.multiselectSelectedIndicator" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.outcomeMonitoringSessions" output-model="vm.multiselectSelectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><div><br></div><div ng-if="vm.monitoringSession && vm.monitoringSession.achieved"><div><h4>Collected Data</h4><hr style="margin-top: 0!important;"></div><div style="padding-bottom: 35px;"><div class="col-md-6"><div class="col-md-5"><label>Target</label></div><div class="col-md-7"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Achieved</label></div><div class="col-md-7"><span>{{vm.monitoringSession.achieved}} {{vm.indicator.unit}}</span></div></div></div><div style="padding-bottom: 35px;" ng-if="vm.indicator.type===1"><div class="col-md-6"><div class="col-md-5"><label>Deviation</label></div><div class="col-md-7"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Deviation in Percentage</label></div><div class="col-md-7"><span>{{(vm.monitoringSession.deviation * 100) / vm.monitoringSession.target}}%</span></div></div></div><div style="float:left; width: 100%;margin-top: 20px;"><h4>Monitoring Feedback</h4><hr style="margin-top: 0!important;"></div><div class="row" style="width: 100%;"><button class="btn btn-info btn-block" style="float:right;width: 200px;" ng-click="vm.openEditMonitoringFeedbackModal()">Edit Monitoring Feedback</button></div><div style="padding-bottom: 35px; padding-top: 20px;"><div class="col-md-6"><div class="col-md-6"><label>Deviation</label></div><div class="col-md-6"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Causality</label></div><div class="col-md-7"><span>{{vm.monitoringSession.causality}}</span></div></div></div><div style="padding-bottom: 35px;"><div class="col-md-3" style="padding-left: 30px;"><label>Recommendation</label></div><div class="col-md-9"><span>{{vm.monitoringSession.recommendation}}</span></div></div></div><div ng-if="vm.monitoringSession && !vm.monitoringSession.achieved" style="text-align: center"><p>No data collection has been done for this monitoring session.</p></div><div ng-if="!vm.monitoringSession" style="text-align: center"><p>Please select an indicator and a monitoring session first.</p></div></div>');
$templateCache.put('app/pages/main/monitoring/outputMonitoring/outputMonitoringDetails/outputMonitoringDetails.html','<div ba-panel="" ba-panel-title="Output Monitoring" ba-panel-class="with-scroll"><h4 style="margin-top: 20px">Output {{vm.output.number}} : <b>{{vm.output.summary}}</b></h4><hr><div><div class="col-md-6"><div class="form-group"><label>Select Indicator</label><div isteven-multi-select="" input-model="vm.output.outputIndicators" output-model="vm.multiselectSelectedIndicator" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapIndicators()"></div></div></div><div class="col-md-6"><div class="form-group"><label>Select Monitoring Session</label><div isteven-multi-select="" input-model="vm.outputMonitoringSessions" output-model="vm.multiselectSelectedMonitoringSession" button-label="timeOfMonitoringText" item-label="timeOfMonitoringText" tick-property="ticked" output-properties="id" selection-mode="single" on-item-click="vm.mapMonitoringSession()"></div></div></div></div><div><br></div><div ng-if="vm.monitoringSession && vm.monitoringSession.dataCollected"><div><h4>Collected Data</h4><hr style="margin-top: 0!important;"></div><div style="padding-bottom: 35px;"><div class="col-md-6"><div class="col-md-5"><label>Target</label></div><div class="col-md-7"><span>{{vm.monitoringSession.target}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Achieved</label></div><div class="col-md-7"><span>{{vm.monitoringSession.achieved}} {{vm.indicator.unit}}</span></div></div></div><div style="padding-bottom: 35px;" ng-if="vm.indicator.type===1"><div class="col-md-6"><div class="col-md-5"><label>Deviation</label></div><div class="col-md-7"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Deviation in Percentage</label></div><div class="col-md-7"><span>{{(vm.monitoringSession.deviation * 100) / vm.monitoringSession.target}}%</span></div></div></div><div style="float:left; width: 100%;margin-top: 20px;"><h4>Monitoring Feedback</h4><hr style="margin-top: 0!important;"></div><div class="row" style="width: 100%;"><button class="btn btn-info btn-block" style="float:right;width: 200px;" ng-click="vm.openEditMonitoringFeedbackModal()">Edit Monitoring Feedback</button></div><div style="padding-bottom: 35px; padding-top: 20px;"><div class="col-md-6"><div class="col-md-6"><label>Deviation</label></div><div class="col-md-6"><span>{{vm.monitoringSession.deviation}} {{vm.indicator.unit}}</span></div></div><div class="col-md-6"><div class="col-md-5"><label>Causality</label></div><div class="col-md-7"><span>{{vm.monitoringSession.causality}}</span></div></div></div><div style="padding-bottom: 35px;"><div class="col-md-3" style="padding-left: 30px;"><label>Recommendation</label></div><div class="col-md-9"><span>{{vm.monitoringSession.recommendation}}</span></div></div></div><div ng-if="vm.monitoringSession && !vm.monitoringSession.achieved" style="text-align: center"><p>No data collection has been done for this monitoring session.</p></div><div ng-if="!vm.monitoringSession" style="text-align: center"><p>Please select an indicator and a monitoring session first.</p></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/actions.partial.html','<div ng-controller="ProfileActionCtrl as vm"><h3 class="with-line">Actions</h3><div class="social-profiles row clearfix"><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[0].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.openAllowLoginModal()"><i class="socicon {{ vm.profileActions[0].icon }}"></i> <span>{{ vm.profileActions[0].name }}</span></a></div><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[1].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.profileActions[1].action();"><i class="socicon {{ vm.profileActions[1].icon }}"></i> <span>{{ vm.profileActions[1].name }}</span></a></div><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[2].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.showProfilePictureUploadModal()"><i class="socicon {{ vm.profileActions[2].icon }}"></i> <span>{{ vm.profileActions[2].name }}</span></a></div><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[3].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.openUploadDocumentModal()"><i class="socicon {{ vm.profileActions[3].icon }}"></i> <span>{{ vm.profileActions[3].name }}</span></a></div><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[4].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.openManualEntryModal()"><i class="socicon {{ vm.profileActions[4].icon }}"></i> <span>{{ vm.profileActions[4].name }}</span></a></div><div class="col-md-3 col-sm-4"><a ng-class="vm.profileActions[5].willBeSelected ? \'sn-link connected\':\'sn-link\'" ng-click="vm.openAddAddressModal()"><i class="socicon {{ vm.profileActions[5].icon }}"></i> <span>{{ vm.profileActions[5].name }}</span></a></div><div class="col-md-3 col-sm-4"><a class="sn-link" ng-click="vm.enrolFingerprint()"><i class="socicon {{ vm.profileActions[6].icon }}"></i> <span>{{ vm.profileActions[6].name }}</span></a></div><div class="col-md-3 col-sm-4"><a class="sn-link" ng-click="vm.openApplyForLeaveModal()"><i class="socicon {{ vm.profileActions[7].icon }}"></i> <span>{{ vm.profileActions[7].name }}</span></a></div></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/address.accordion.partial.html','<div class="col-md-5 addressDiv" ng-repeat="address in vm.user.addresses" ng-if="!vm.user.addresses.isEmpty()"><table class="table borderless" id="addressTable"><tbody><tr><td><strong class="customLabel">Type</strong></td><td><a href="#" editable-select="address.type" e-ng-options="type.value as type.type for type in vm.addressTypeList.list" onbeforesave="vm.updateAddress({ \'type\' : $data } , address.id)"><span ng-if="address.type == 1">Permanent</span> <span ng-if="address.type == 2">Present</span> <span ng-if="address.type == 3">Home</span></a></td></tr><tr><td><strong class="customLabel">Address</strong></td><td><a href="#" editable-text="address.address" onbeforesave="vm.updateAddress({ \'address\' : $data } , address.id)">{{ address.address || \'empty\'}}</a></td></tr><tr><td><strong class="customLabel">District</strong></td><td><a href="#" editable-text="address.district" onbeforesave="vm.updateAddress({ \'district\' : $data } , address.id)">{{ address.district || \'empty\'}}</a></td></tr><tr><td><strong class="customLabel">Thana</strong></td><td><a href="#" editable-text="address.thana" onbeforesave="vm.updateAddress({ \'thana\' : $data } , address.id)">{{ address.thana || \'empty\'}}</a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/changePass.accordion.partial.html','<div><br><br><div class="col-md-2"><label for="inputPassword" class="col-sm-3 control-label" id="profilePagePasswordLabel">Password</label></div><div class="col-md-3"><input type="password" class="form-control" id="inputPassword" ng-model="vm.changePass.passwordText"></div><div class="col-md-2"><label for="inputConfirmPassword" class="col-sm-3 control-label">Confirm Password</label></div><div class="col-md-3"><input type="password" class="form-control" id="inputConfirmPassword" ng-model="vm.changePass.confirmPasswordText"></div><div class="col-md-2" style="margin-bottom: 30px;"><button class="btn btn-primary" ng-click="vm.updatePasswordFunction()">Submit</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/details.partial.html','<div ng-controller="ProfileDetailsAccordionCtrl as vm"><h3 class="with-line">Details</h3><uib-accordion><br><uib-accordion-group heading="Personal & Contact Information" panel-class="bootstrap-panel accordion-panel panel-default"><div include-with-scope="app/pages/main/profile/profileInfo/details/personalInfo.accordion.partial.html"></div></uib-accordion-group><uib-accordion-group heading="Address" ng-if="vm.user.addresses.length !=0"><div include-with-scope="app/pages/main/profile/profileInfo/details/address.accordion.partial.html"></div></uib-accordion-group><uib-accordion-group is-open="vm.isChangedPasswordOpen" heading="Change Password" panel-class="bootstrap-panel accordion-panel panel-default panel-open" id="passwordReset"><div include-with-scope="app/pages/main/profile/profileInfo/details/changePass.accordion.partial.html"></div></uib-accordion-group><uib-accordion-group heading="Documents"><div include-with-scope="app/pages/main/profile/profileInfo/details/documents.accordion.partial.html"></div></uib-accordion-group><uib-accordion-group heading="Employment History"><div style="margin-left: 20px;margin-top: 20px"><a href="#" editable-textarea="vm.user.employeeDetails.previousEmploymentHistory" onbeforesave="vm.updateEducationHistory($data)">{{ vm.user.employeeDetails.previousEmploymentHistory || \'No Employment History provided. Click to add.\'}}</a></div><br><br></uib-accordion-group><uib-accordion-group heading="Education history"><div style="margin-left: 20px;margin-top: 20px"><p><a href="#" editable-textarea="vm.user.employeeDetails.educationHistory" onbeforesave="vm.updateEducationHistory($data)">{{ vm.user.employeeDetails.educationHistory || \'No Education History provided. Click to add.\'}}</a></p></div><br><br></uib-accordion-group></uib-accordion></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/documents.accordion.partial.html','<div style="margin: 20px;"><table class="table table-striped employeeDocument"><thead><tr><th style="text-align: left;"><strong>Document Type</strong></th><th style="text-align: left;"><strong>Description</strong></th><th style="text-align: left;"><strong>Link</strong></th></tr></thead><tbody><tr ng-repeat="document in vm.user.documents"><td ng-if="document.type==1" style="text-align: left;">SSC Certificates</td><td ng-if="document.type==2" style="text-align: left;">HSC Certificates</td><td ng-if="document.type==3" style="text-align: left;">Bachelor Certificates</td><td ng-if="document.type==4" style="text-align: left;">Passport</td><td ng-if="document.type==5" style="text-align: left;">NID</td><td style="text-align: left;">{{document.description}}</td><td style="text-align: left;"><a href="{{document.employeeFile.url}}">Download</a></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/profile/profileInfo/details/personalInfo.accordion.partial.html','<div><div class="row profilePageRowAllignment"><div class="col-md-6"><strong class="customLabel">Father\'s Name</strong> <a href="#" editable-text="vm.user.employeeDetails.fatherName" id="profilePageFathersNameDisplay" onbeforesave="vm.updateFathersName($data)">{{ vm.user.employeeDetails.fatherName || \'empty\'}}</a> <span></span></div><div class="col-md-6"><strong class="customLabel">Email</strong> <a href="#" editable-text="vm.user.email" id="profilePageEmailDisplay" onbeforesave="vm.updateEmail($data)">{{ vm.user.email || \'empty\'}}</a></div></div><div class="row profilePageRowAllignment"><div class="col-md-6"><strong class="customLabel">Mother\'s name</strong> <a href="#" editable-text="vm.user.employeeDetails.motherName" id="profilePageMothersNameDisplay" onbeforesave="vm.updateMothersName($data)">{{vm.user.employeeDetails.motherName || \'empty\'}}</a></div><div class="col-md-6"><strong class="customLabel">Office Phone</strong> <a href="#" class="profilePagePhoneDisplay" editable-text="vm.user.employeeDetails.phoneOffice" onbeforesave="vm.updatePhoneOffice($data)">{{vm.user.employeeDetails.phoneOffice || \'empty\'}}</a></div></div><div class="row profilePageRowAllignment"><div class="col-md-6"><strong class="customLabel">Gender</strong> <a href="#" editable-text="vm.user.employeeDetails.gender" onbeforesave="vm.updateGender($data)" e-maxlength="12" id="profilePageGenderDisplay">{{vm.user.employeeDetails.gender || \'empty\'}}</a></div><div class="col-md-6"><strong class="customLabel">Home Phone</strong> <a class="profilePagePhoneDisplay" href="#" editable-text="vm.user.employeeDetails.phoneHome" onbeforesave="vm.updatePhoneHome($data)">{{vm.user.employeeDetails.phoneHome || \'empty\'}}</a></div></div><div class="row profilePageRowAllignment"><div class="col-md-6"><strong class="customLabel">Date of Birth</strong> <a href="#" editable-bsdate="vm.user.employeeDetails.dateOfBirthDisplay" e-is-open="vm.opened.$data" e-ng-click="vm.open($event,\'$data\')" e-datepicker-popup="dd-MMMM-yyyy" id="profilePageDateOfBirthDisplay" onbeforesave="vm.updateDateOfBirth($data)">{{(vm.user.employeeDetails.dateOfBirthDisplay | date:"dd/MM/yyyy") || \'empty\'}}</a></div><div class="col-md-6"><strong class="customLabel">Cell Phone</strong> <a href="#" editable-text="vm.user.employeeDetails.phoneMobile" onbeforesave="vm.updatePhoneMobile($data)" id="profilePageCellPhoneDisplay">{{vm.user.employeeDetails.phoneMobile || \'empty\'}}</a></div></div><br></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/generalInfo.partial.html','<div ng-controller="GeneralInfoCtrl as vm"><h3 class="with-line">General Information</h3><div class="row"><div class="col-md-6" include-with-scope="app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePic.partial.html"></div><div ng-if="vm.isDataReady"><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Name</label> <a href="#" editable-text="vm.user.name" onbeforesave="vm.updateName($data)">{{ vm.user.name || \'Empty\'}}</a></div><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Identifier</label> <strong>{{vm.user.employeeIdentifier}}</strong></div><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Email</label> <a href="#" editable-text="vm.user.email" onbeforesave="vm.updateEmail($data)">{{ vm.user.email || \'Empty\'}}</a></div><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Department</label> <a href="#" editable-select="vm.user.department.id" e-ng-options="dept.id as dept.name for dept in vm.departmentList" onbeforesave="vm.updateDepartment($data)">{{ vm.showDepartment() }}</a></div><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Designation</label> <a href="#" editable-select="vm.user.designation.id" e-ng-options="desg.id as desg.name for desg in vm.designationList" onbeforesave="vm.updateDesignation($data)">{{ vm.showDesignation() }}</a></div><div class="col-md-6 bottom"><label class="col-sm-3 control-label">Shift</label> <a href="#" editable-select="vm.user.shift.id" e-ng-options="shift.id as shift.name for shift in vm.shiftList" onbeforesave="vm.updateShift($data)">{{ vm.showShift() }}</a></div><div class="col-md-6 bottom" style="float: right"><label class="col-sm-3 control-label">Login Status</label> <span>{{ vm.user.allowLogin ? \'Allowed\' : \'Not Allowed\'}}</span></div></div></div></div>');
$templateCache.put('app/pages/main/setupMenu/activity/createActivity/createActivity.html','<div ba-panel="" ba-panel-title="Create Activity" ba-panel-class="with-scroll"><div><div class="row"><div class="form-group col-sm-4 col-xs-4"><label>Select Impact</label><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.generateOutcomes()" selection-mode="single"></div></div><div class="form-group col-md-4 col-xs-4"><label>Select Outcome</label><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs" on-item-click="vm.generateOutputs()" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-4"><label>Select Output</label><div isteven-multi-select="" input-model="vm.outputs" output-model="vm.selectedOutputs" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary majorActivities" selection-mode="single"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Serial No</label> <input type="text" class="form-control" ng-model="vm.serialNumber"></div></div><div class="col-md-6"><div class="form-group"><label>Title</label> <textarea class="form-control" ng-model="vm.title"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label><b>Show Custom Unit</b></label> <span style="margin-left: 10px"><input type="checkbox" ng-model="vm.showCustomUnit"></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Event</label> <input type="text" class="form-control" ng-model="vm.event"></div></div><div class="col-md-6" ng-show="vm.showCustomUnit"><div class="form-group"><label>Unit</label> <input type="text" class="form-control" ng-model="vm.unit"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Target Event</label> <input type="text" class="form-control" ng-model="vm.targetEvent"></div></div><div class="col-md-6" ng-show="vm.showCustomUnit"><div class="form-group"><label>Target Unit</label> <input type="text" class="form-control" ng-model="vm.targetUnit"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Budget</label> <input type="number" class="form-control" ng-model="vm.budget"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Male Participants</label> <input type="number" class="form-control" ng-model="vm.maleParticipants"></div></div><div class="col-md-6"><div class="form-group"><label>Female Participants</label> <input type="number" class="form-control" ng-model="vm.femaleParticipants"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label><b>Total Target Participants</b> <span style="margin-left: 10px">{{vm.maleParticipants + vm.femaleParticipants}}</span></label></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <input type="text" class="form-control" ng-model="vm.meansOfVerification"></div></div><div class="col-md-6"><div class="form-group"><label>Description of The Activity As Per Proposal</label> <input type="text" class="form-control" ng-model="vm.description"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Responsible Agency</label> <input type="text" class="form-control" ng-model="vm.responsibleAgency"></div></div><div class="col-md-6"><div class="form-group"><label>Type</label><select type="text" class="form-control" ng-model="vm.type" ng-change="vm.determineTimelineAndInterval()"><option value="1">One Off</option><option value="2">Phase By Phase</option></select></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label>Start Time</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="col-md-4" ng-if="vm.type == 2"><div class="form-group"><label>End Time</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.endDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-disabled="vm.type == 1" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-sm-6" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.tableData.length > 0"><thead><th style="width: 200px">Month</th><th colspan="{{vm.showCustomUnit ? 6 :5}}">Monthly Target</th><th colspan="{{vm.showCustomUnit ? 6 :5}}">Total Target</th></thead><tbody><tr><td></td><td ng-show="vm.showCustomUnit">Unit</td><td>Event</td><td>Male</td><td>Female</td><td>Total</td><td>Budget</td><td ng-show="vm.showCustomUnit">Unit</td><td>Event</td><td>Male</td><td>Female</td><td>Total</td><td>Budget</td></tr><tr ng-repeat="row in vm.tableData"><td style="padding-top: 15px;overflow:visible;"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" is-open="row.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px" ng-show="vm.showCustomUnit"><input type="number" class="form-control" ng-change="vm.adjustTotalTargetUnit(\'targetUnit\',\'totalTargetUnit\')" ng-model="row.targetUnit"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetEvent\',\'totalTargetEvent\')" class="form-control" ng-model="row.targetEvent"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetMale\',\'totalTargetMale\')" class="form-control" ng-model="row.targetMale"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetFemale\',\'totalTargetFemale\')" class="form-control" ng-model="row.targetFemale"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetFemale\',\'totalTargetFemale\')" class="form-control" ng-model="row.targetPeople"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'budget\',\'totalBudget\')" class="form-control" ng-model="row.budget"></td><td style="padding: 5px" ng-show="vm.showCustomUnit"><input type="number" class="form-control" ng-model="row.totalTargetUnit"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetEvent"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetMale"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetFemale"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetPeople"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalBudget"></td></tr></tbody></table><div class="row text-right"><div class="col-md-12"><button class="btn btn-info" ng-click="vm.createActivity()">Submit</button></div></div></div></div>');
$templateCache.put('app/pages/main/setupMenu/activity/deleteModal/delete.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>Are you sure you want to delete this major activity?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="$close()">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/activity/editActivity/editActivity.html','<div ba-panel="" ba-panel-title="Create Activity" ba-panel-class="with-scroll"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Serial No</label> <input type="text" class="form-control" ng-model="vm.activity.serialNumber"></div></div><div class="col-md-6"><div class="form-group"><label>Title</label> <textarea class="form-control" ng-model="vm.activity.title"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label><b>Show Custom Unit</b></label> <span style="margin-left: 10px"><input type="checkbox" ng-model="vm.showCustomUnit"></span></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Event</label> <input type="text" class="form-control" ng-model="vm.activity.event"></div></div><div class="col-md-6" ng-show="vm.showCustomUnit"><div class="form-group"><label>Unit</label> <input type="text" class="form-control" ng-model="vm.activity.unit"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Target Event</label> <input type="text" class="form-control" ng-model="vm.activity.targetEvent"></div></div><div class="col-md-6" ng-show="vm.showCustomUnit"><div class="form-group"><label>Target Unit</label> <input type="text" class="form-control" ng-model="vm.activity.targetUnit"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Budget</label> <input type="number" class="form-control" ng-model="vm.activity.budget"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Male Participants</label> <input type="number" class="form-control" ng-model="vm.activity.maleParticipants"></div></div><div class="col-md-6"><div class="form-group"><label>Female Participants</label> <input type="number" class="form-control" ng-model="vm.activity.femaleParticipants"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label><b>Total Target Participants</b> <span style="margin-left: 10px">{{vm.activity.maleParticipants + vm.activity.femaleParticipants}}</span></label></div><div class="form-group"><label><b>Total Budget</b> <span style="margin-left: 10px">{{vm.activity.budget}}</span></label></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <input type="text" class="form-control" ng-model="vm.activity.meansOfVerification"></div></div><div class="col-md-6"><div class="form-group"><label>Description of The Activity As Per Proposal</label> <input type="text" class="form-control" ng-model="vm.activity.description"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Responsible Agency</label> <input type="text" class="form-control" ng-model="vm.activity.responsibleAgency"></div></div></div><div class="row"><div class="col-md-4"><div class="form-group"><label>Start Time</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.activity.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div><div class="col-md-4" ng-if="vm.type == 2"><div class="form-group"><label>End Time</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.acitivty.endDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div></div><div class="row bottom text-right"><div class="col-md-2 col-md-offset-10"><button class="btn btn-info btn-block" ng-click="vm.updateActivity()">Save Changes</button></div></div><div class="row bottom"><div class="col-md-2"><button class="btn btn-info btn-block" ng-click="vm.extendMonitoring()">Extend Monitoring</button></div></div><table class="table table-bordered" ng-if="vm.activity.activityMonitoringSessions.length > 0"><thead><th style="width: 200px">Month</th><th colspan="{{vm.showCustomUnit ? 6 : 5}}">Monthly Target</th><th colspan="{{vm.showCustomUnit ? 6 : 5}}">Total Target</th><th style="width: 150px;">Action</th></thead><tbody><tr><td></td><td ng-show="vm.showCustomUnit">Unit</td><td>Event</td><td>Male</td><td>Female</td><td>Total</td><td>Budget</td><td ng-show="vm.showCustomUnit">Unit</td><td>Event</td><td>Male</td><td>Female</td><td>Total</td><td>Budget</td><td></td></tr><tr ng-repeat="row in vm.activity.activityMonitoringSessions"><td style="padding-top: 15px;overflow:visible;"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoringInDate" datepicker-options="{minMode: \'month\',maxMode:\'month\', datepickerMode: \'month\'}" is-open="row.isOpen"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px" ng-show="vm.showCustomUnit"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetUnit\',\'totalTargetUnit\')" class="form-control" ng-model="row.targetUnit"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetEvent\',\'totalTargetEvent\')" class="form-control" ng-model="row.targetEvent"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetMale\',\'totalTargetMale\')" class="form-control" ng-model="row.targetMale"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetFemale\',\'totalTargetFemale\')" class="form-control" ng-model="row.targetFemale"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'targetPeople\',\'totalTargetPeople\')" class="form-control" ng-model="row.targetPeople"></td><td style="padding: 5px"><input type="number" ng-change="vm.adjustTotalTargetUnit(\'budget\',\'totalBudget\')" class="form-control" ng-model="row.budget"></td><td style="padding: 5px" ng-show="vm.showCustomUnit"><input type="number" class="form-control" ng-model="row.totalTargetUnit"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetEvent"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetMale"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetFemale"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalTargetPeople"></td><td style="padding: 5px"><input type="number" class="form-control" ng-model="row.totalBudget"></td><td><button class="btn btn-danger" style="width: 45%;" ng-click="vm.deleteMonitoringSession($index,row)">Delete</button> <button class="btn btn-primary" style="width: 45%;" ng-if="row.id != null" ng-click="vm.editMonitoringSession(row)">Save</button> <button class="btn btn-primary" style="width: 45%;" ng-click="vm.addMonitoringSession(row)" ng-if="row.id == null">Save</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/outcomeSetup.html','<div ba-panel="" ba-panel-title="Setup Outcome" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 10px;"><div class="col-md-10"><h4 style="margin-top: 20px">Outcome {{vm.outcome.number}} : <b>{{vm.outcome.summary}}</b></h4></div></div><div><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Indicators" is-open="vm.accordion.indicatorsIsOpen"><div include-with-scope="app/pages/main/setupMenu/outcome/outcomeSetup/partials/indicators.partial.html" ng-if="vm.accordion.indicatorsIsOpen"></div></div></uib-accordion><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Research Framework" is-open="vm.accordion.researchFrameworkIsOpen" ng-if="vm.outcome.outcomeIndicators && vm.outcome.outcomeIndicators.length>0"><div include-with-scope="app/pages/main/setupMenu/outcome/outcomeSetup/partials/researchFramework.partial.html"></div></div></uib-accordion><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Manage Outputs of This Outcome" is-open="vm.accordion.outputsIsOpen"><div include-with-scope="app/pages/main/setupMenu/outcome/outcomeSetup/partials/outputs.partial.html"></div></div></uib-accordion></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeList/outcomeList.html','<div ba-panel="" ba-panel-title="Outcome List" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id"></div></div><div class="form-group col-sm-4 col-xs-6"><h4>Select Impact</h4><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" selection-mode="single"></div></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.filterImpacts()"><i class="ion-search"></i>Search</button></div></div><div class="row"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"><button class="btn btn-info btn-block" ng-click="vm.openCreateOutcomeModal()" ng-disabled="vm.isResponsePending">Add Outcome</button></div></div><table class="table table-bordered" style="margin-bottom: 50px;" ng-if="vm.selectedOutcomes.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Impact</th><th class="headers2" style="text-align: center">Action</th></thead><tbody ng-if="vm.selectedOutcomes.length > 0"><tr ng-repeat="outcome in vm.selectedOutcomes | orderBy:\'number\'"><td><a ui-sref="outcomeSetup({id : {{outcome.id}}})">{{outcome.number}}. {{outcome.summary}}</a></td><td>{{outcome.impact.number + \'. \' + outcome.impact.summary}}</td><td><div class="row" style="padding-top: 10px; padding-bottom: 10px; vertical-align: middle;"><div class="col-md-4" style="text-align: center"><button class="btn btn-info" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-click="vm.openEditOutcomeModal(outcome)">Edit</button></div><div class="col-md-4" style="text-align: center"><a ui-sref="outcomeSetup({\'id\': {{ outcome.id }} })" style="width: 90%;"><button class="btn btn-primary" style="width: 100%" ng-disabled="vm.isResponsePending">Setup</button></a></div><div class="col-md-4" style="text-align: center"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-if="vm.deletingImpact != outcome.id" ng-click="vm.deleteOutcome(outcome)">Delete</button></div><div class="col-md-4" style="text-align: center" ng-if="vm.deletingImpact == outcome.id"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending">Please Wait</button></div></div></td></tr><tr ng-if="vm.selectedOutcomes.length === 0"><td colspan="4"><p><i>No outcomes available</i></p></td></tr></tbody></table></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactList/impactList.html','<div ba-panel="" ba-panel-title="Impact List" ba-panel-class="with-scroll"><div class="col-sm-2" style="float: right;padding-right: 0px; margin-bottom: 10px;"><button class="btn btn-info btn-block" ng-click="vm.openCreateIndicatorModal()" ng-disabled="vm.isResponsePending">Add Impact</button></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.impacts.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2" style="text-align: center">Summary</th><th class="headers2" style="text-align: center">Project</th><th class="headers2" style="text-align: center">Action</th></thead><tr ng-repeat="impact in vm.impacts | orderBy:\'number\'" ng-if="vm.impacts.length > 0"><td><a ui-sref="impactSetup({id : {{impact.id}}})">{{impact.number}}. {{impact.summary}}</a></td><td>{{impact.project.name}}</td><td><div class="row" style="padding-top: 10px; padding-bottom: 10px; vertical-align: middle;"><div class="col-md-4" style="text-align: center"><button class="btn btn-info" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-click="vm.openEditImpactModal(impact)">Edit</button></div><div class="col-md-4" style="text-align: center"><a ui-sref="impactSetup({id : {{impact.id}}})" style="width: 90%;"><button class="btn btn-primary" style="width: 100%" ng-disabled="vm.isResponsePending">Setup</button></a></div><div class="col-md-4" style="text-align: center" ng-if="vm.deletingImpact != impact.id"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-click="vm.deleteImpact(impact)">Delete</button></div><div class="col-md-4" style="text-align: center" ng-if="vm.deletingImpact == impact.id"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending">Please Wait</button></div></div></td></tr><tr ng-if="vm.impacts.length === 0"><td colspan="5"><p><i>No impacts available</i></p></td></tr></table></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/impactSetup.html','<div ba-panel="" ba-panel-title="Setup Impact" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 10px;"><div class="col-md-10"><h4 style="margin-top: 20px">Impact {{vm.impact.number}} : <b>{{vm.impact.summary}}</b></h4></div></div><div><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Indicators" is-open="vm.accordion.indicatorsIsOpen"><div include-with-scope="app/pages/main/setupMenu/impact/impactSetup/partials/indicators.partial.html" ng-if="vm.accordion.indicatorsIsOpen"></div></div></uib-accordion><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Research Framework" is-open="vm.accordion.researchFrameworkIsOpen" ng-if="vm.impact.impactIndicators && vm.impact.impactIndicators.length>0"><div include-with-scope="app/pages/main/setupMenu/impact/impactSetup/partials/researchFramework.partial.html"></div></div></uib-accordion><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Manage Outcomes of This Impact" is-open="vm.accordion.outcomesIsOpen"><div include-with-scope="app/pages/main/setupMenu/impact/impactSetup/partials/outcomes.partial.html"></div></div></uib-accordion></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputList/outputList.html','<div ba-panel="" ba-panel-title="Outputs" ba-panel-class="with-scroll"><div style="margin-top: 20px;text-align: center" class="row form-inline" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"><h4>Select Project</h4><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProjects" button-label="name" item-label="name" on-item-click="vm.filterImpactsDisplayValues()" tick-property="ticked" output-properties="id number outcomes"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedProjects.length > 0">Select Impact</h4><div ng-if="vm.selectedProjects.length > 0" isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-sm-4 col-xs-6"><h4 ng-if="vm.selectedImpacts.length > 0">Select Outcome</h4><div ng-if="vm.selectedImpacts.length > 0" isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number summary outputs"></div></div></div><div class="row" ng-show="vm.showFilters"><div class="form-group col-sm-4 col-xs-6"></div><div class="form-group col-sm-4 col-xs-6"><h4><br></h4><button type="button" class="btn btn-primary btn-with-icon" style="width: 100%;" ng-click="vm.searchOutputs()"><i class="ion-search"></i>Search</button></div><div class="form-group col-sm-4 col-xs-6"></div></div><div class="row" style="margin-top: 10px;"><div class="col-md-2"></div><div class="form-group col-md-8" style="text-align: center;"><a href="" ng-click="vm.showFilters = !vm.showFilters"><em style="margin-right: 10px">{{vm.showFilters ? "Hide Filter" : "Show Filter"}}</em></a> <a href="" ng-click="vm.showFilters = !vm.showFilters"><i class="i-dashboardfilter"></i></a></div><div class="col-md-2" style="float: right;"><button class="btn btn-info btn-block" ng-disabled="vm.isResponsePending" ng-click="vm.openCreateOutputModal()">Add Output</button></div></div><table class="table table-bordered" style="margin-bottom: 50px;margin-top: 20px" ng-if="vm.allOutputs.length > 0"><colgroup><col span="1" style="width: 35%;"><col span="1" style="width: 20%;"><col span="1" style="width: 45%;"></colgroup><thead><th class="headers2">Outputs</th><th class="headers2">Outcome</th><th class="headers2"></th></thead><tr ng-repeat="output in vm.allOutputs | orderBy:\'number\'"><td><a ui-sref="outputSetup({id : {{output.id}}})">{{output.number}}. {{output.summary}}</a></td><td>{{output.outcome.number}}. {{output.outcome.summary}}</td><td><div class="row" style="padding-top: 10px; padding-bottom: 10px; vertical-align: middle;"><div class="col-md-4" style="text-align: center"><button class="btn btn-info" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-click="vm.openEditOutputModal(output)">Edit</button></div><div class="col-md-4" style="text-align: center"><a ui-sref="outputSetup({\'id\': {{ output.id }} })" style="width: 90%;"><button class="btn btn-primary" style="width: 100%" ng-disabled="vm.isResponsePending">Setup</button></a></div><div class="col-md-4" style="text-align: center"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending" ng-if="vm.deletingImpact != output.id" ng-click="vm.deleteOutput(output)">Delete</button></div><div class="col-md-4" style="text-align: center" ng-if="vm.deletingImpact == output.id"><button class="btn btn-danger" style="width: 90%;" ng-disabled="vm.isResponsePending">Please Wait</button></div></div></td></tr><tr ng-if="vm.allOutputs.length === 0"><td colspan="4"><p><i>No outputs available</i></p></td></tr></table></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/outputSetup.html','<div ba-panel="" ba-panel-title="Setup Output" ba-panel-class="with-scroll"><div class="row" style="margin-bottom: 10px;"><div class="col-md-10"><h4 style="margin-top: 20px">Output {{vm.output.number}} : <b>{{vm.output.summary}}</b></h4></div></div><div><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Indicators" is-open="vm.accordion.indicatorsIsOpen"><div include-with-scope="app/pages/main/setupMenu/output/outputSetup/partials/indicators.partial.html" ng-if="vm.accordion.indicatorsIsOpen"></div></div></uib-accordion><uib-accordion><div uib-accordion-group="" class="panel-default" heading="Setup Research Framework" is-open="vm.accordion.researchFrameworkIsOpen" ng-if="vm.output.outputIndicators && vm.output.outputIndicators.length>0"><div include-with-scope="app/pages/main/setupMenu/output/outputSetup/partials/researchFramework.partial.html"></div></div></uib-accordion></div></div>');
$templateCache.put('app/pages/main/monitoring/outcomeMonitoring/outcomeMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-6" ng-if="vm.indicator.type!==1"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.monitoringSession.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.monitoringSession.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.monitoringSession.recommendation"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/monitoring/impactMonitoring/impactMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-6" ng-if="vm.indicator.type!==1"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.monitoringSession.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.monitoringSession.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.monitoringSession.recommendation"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/monitoring/outputMonitoring/outputMonitoringDetails/editMonitoringFeedbackModal/editMonitoringFeedback.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-6" ng-if="vm.indicator.type!==1"><div class="form-group"><label>Deviation</label> <textarea class="form-control" ng-model="vm.monitoringSession.deviation"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Causality</label> <textarea class="form-control" ng-model="vm.monitoringSession.causality"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Recommendation</label> <textarea class="form-control" ng-model="vm.monitoringSession.recommendation"></textarea></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.save()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/addAddress/addAddress.action.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Add Address<hr></h4></div><div class="modal-body"><div class="row"><div class="col-sm-6"><div class="form-group"><label>Address</label> <textarea class="form-control" ng-model="address" placeholder="Address"></textarea></div></div><div class="col-sm-6"><div class="form-group"><label>Type</label><select class="form-control" ng-model="type" placeholder="Type"><option value="1" ng-disabled="vm.isAddressTypeAlreadyProvided(1)">Permanent</option><option value="2" ng-disabled="vm.isAddressTypeAlreadyProvided(2)">Present</option><option value="3" ng-disabled="vm.isAddressTypeAlreadyProvided(3)">Home</option></select></div></div></div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Thana</label> <input type="text" class="form-control" ng-model="thana" placeholder="Thana"></div></div><div class="col-sm-6"><div class="form-group"><label>District</label> <input type="text" class="form-control" ng-model="district" placeholder="District"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.addAddress(address, thana, district, type)">Submit</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/allowLogin/allowLogin.modal.html','<div class="modal-content"><div class="modal-header bg-danger"><i class="ion-information-circled modal-icon"></i><span>Confirmation</span></div><div class="modal-body"><p>{{vm.name}} is currently <em ng-if="vm.allowLogin">allowed to login.</em><em ng-if="!vm.allowLogin">Not allowed to login.</em> Are you sure you want to <em ng-if="vm.allowLogin">revoke login privilege.</em> <em ng-if="!vm.allowLogin">allow login privilege?</em></p></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateAllowLogin(!vm.allowLogin)">Yes</button> <button type="button" class="btn btn-danger" ng-click="$dismiss()">No</button></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/actions/documentUpload/documentUpload.modal.html','<div class="modal-content"><div class="modal-header bg-primary"><i class="ion-information-circled modal-icon"></i><span>Document Upload</span></div><div class="modal-body"><form><div class="row"><div class="col-md-4 text-left"><span>Document Type</span></div><div class="col-md-8"><select class="form-control" ng-model="documentType"><option value="1">SSC Certificates</option><option value="2">HSC Certificates</option><option value="3">Bachelor Certificates</option><option value="4">Passport</option><option value="5">NID</option></select></div></div><br><br><div class="row"><div class="col-md-4 text-left"><span>Description</span></div><div class="col-md-8"><textarea class="form-control" ng-model="description"></textarea></div></div><br><br><div><input type="file" ngf-select="" ng-model="file" ngf-multiple="false" ngf-max-size="2MB" ngf-accept="\'.pdf,docx,doc\'"></div><br><br><div class="text-right"><button class="btn btn-primary" style="width: 100px" ng-click="vm.uploadDocument(description, documentType, file)">Upload</button></div></form></div></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePic.partial.html','<div class="form-group row clearfix" ng-controller="ProfilePicCtrl as vm"><div><div class="col-sm-9"><div class="userpic"><div class="userpic-wrapper"><img ng-src="{{vm.imageSource()}}" ng-click="vm.showProfilePictureUploadModal()"></div><i class="ion-ios-close-outline" ng-click="vm.removePicture()" ng-if="!vm.noPicture"></i> <a href="" class="change-userpic" ng-click="vm.showProfilePictureUploadModal()">Change Profile Picture</a></div></div></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/edit/setupResearchFramework.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Setup Research Framework<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div></div><br><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.setupResearchFramework()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/partials/indicators.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Indicators of This Outcome<div class="col-md-2" style="float: right;padding-right: 0px"><a ui-sref="createOutcomeIndicator({id : vm.outcome.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 29%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Baseline</th><th class="headers2" style="text-align: center">Monitoring</th><th class="headers2" style="text-align: center">Target</th><th class="headers2" style="text-align: center">Actions</th></thead><tbody ng-repeat="indicator in vm.outcome.outcomeIndicators | orderBy:\'number\'"><tr><td rowspan="{{indicator.outcomeMonitoringSessions.length}}">{{indicator.number}}. {{indicator.summary}}</td><td rowspan="{{indicator.outcomeMonitoringSessions.length}}">{{indicator.timeline < 12 ? indicator.timeline + \'Months\' : indicator.timeline/12 + \' Year\'}}</td><td rowspan="{{indicator.outcomeMonitoringSessions.length}}">{{indicator.baseline}} {{indicator.unit}}</td><td>{{vm.convertMillisToDate(indicator.outcomeMonitoringSessions[0].timeOfMonitoring)}}</td><td>{{indicator.outcomeMonitoringSessions[0].target}} {{indicator.unit}}</td><td rowspan="{{indicator.outcomeMonitoringSessions.length}}"><button class="btn btn-info" ui-sref="editOutcomeIndicator({id: {{indicator.id}}})" style="margin:5px;width: 80px">Edit</button> <button class="btn btn-danger" ng-click="vm.deleteIndicator(indicator.id)" style="margin:5px;width: 80px">Delete</button></td></tr><tr ng-repeat="monitoringSession in indicator.outcomeMonitoringSessions" ng-if="$index > 0"><td>{{vm.convertMillisToDate(monitoringSession.timeOfMonitoring)}}</td><td>{{monitoringSession.target}} {{indicator.unit}}</td></tr></tbody><tbody ng-if="vm.outcome.outcomeIndicators.length == 0"><tr><td colspan="6">No Indicators Found.</td></tr></tbody></table>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/partials/outputs.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Outputs Under This Outcome ( Outcome {{vm.outcome.number}} )<div class="col-md-2" style="float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.outputCreateModal()">Add New</button></div></h3><table class="table table-bordered" style="margin-bottom: 20px;"><thead><th class="headers2" style="text-align: center">Output Summary</th><th class="headers2" style="text-align: center">Indicators</th></thead><tr ng-if="!vm.outcome.outputs.length"><td colspan="2">No outputs found</td></tr><tr ng-repeat-start="output in vm.outcome.outputs"><td rowspan="{{output.outputIndicators.length}}"><a ui-sref="outputSetup({id : {{output.id}}})">{{output.number}}. {{output.summary}}</a></td><td colspan="3" ng-if="output.outputIndicators == null || output.outputIndicators.length == 0">No indicators.</td><td ng-if="output.outputIndicators.length >0">{{output.outputIndicators[0].number}}. {{output.outputIndicators[0].summary}}</td></tr><tr ng-repeat-end="" ng-repeat="outputIndicator in output.outputIndicators" ng-if="$index > 0"><td>{{outputIndicator.number}}. {{outputIndicator.summary}}</td></tr></table>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/partials/researchFramework.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table class="table table-bordered" style="margin-bottom: 20px;width: 100%;" id="researchFrameworkTable"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 10%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collection methods</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.outcome.outcomeIndicators | orderBy:\'number\'"><td>{{indicator.number}}. {{indicator.summary}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openSetupResearchFrameworkModal(indicator)" style="margin:5px;width: 80px">Edit</button></td></tr><tr ng-if="vm.outcome.outcomeIndicators.length == 0"><td colspan="5">No Indicators Found.</td></tr></table></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeList/create/createOutcome.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Outcome<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Select Impact</label><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpact" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOutcome()">Create Outcome</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeList/edit/editOutcome.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Outcome<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Select Impact</label><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpact" button-label="summary" item-label="summary" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.editOutcome()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactList/create/createImpact.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Impact<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Select Project</label><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createImpact()">Create Impact</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactList/edit/editImpact.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Impact<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-sm-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-sm-6"><div class="form-group"><label>Select Project</label><div isteven-multi-select="" input-model="vm.projects" output-model="vm.selectedProject" button-label="name" item-label="name" tick-property="ticked" output-properties="id" selection-mode="single"></div></div></div><div class="col-sm-12"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.editImpact()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/edit/editResearchFramework.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Research Framework<hr></h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div></div><br><br></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.updateIndicator()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/partials/indicators.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Indicators of This Impact<div class="col-md-2" style="float: right;padding-right: 0px"><a ui-sref="createImpactIndicator({id : vm.impact.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 29%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Baseline</th><th class="headers2" style="text-align: center">Monitoring</th><th class="headers2" style="text-align: center">Target</th><th class="headers2" style="text-align: center">Actions</th></thead><tbody ng-repeat="indicator in vm.impact.impactIndicators | orderBy:\'number\'"><tr><td rowspan="{{indicator.impactMonitoringSessions.length}}">{{indicator.number}}. {{indicator.summary}}</td><td rowspan="{{indicator.impactMonitoringSessions.length}}">{{indicator.timeline < 12 ? indicator.timeline + \' Months\' : indicator.timeline/12 + \' Year\'}}</td><td rowspan="{{indicator.impactMonitoringSessions.length}}">{{indicator.baseline}} {{indicator.unit}}</td><td>{{vm.convertMillisToDate(indicator.impactMonitoringSessions[0].timeOfMonitoring)}}</td><td>{{indicator.impactMonitoringSessions[0].target}} {{indicator.unit}}</td><td rowspan="{{indicator.impactMonitoringSessions.length}}"><button class="btn btn-info" ui-sref="editImpactIndicator({id: {{indicator.id}}})" style="margin:5px;width: 80px">Edit</button> <button class="btn btn-danger" ng-click="vm.deleteImpactIndicator(indicator.id)" style="margin:5px;width: 80px">Delete</button></td></tr><tr ng-repeat="monitoringSession in indicator.impactMonitoringSessions" ng-if="$index > 0"><td>{{vm.convertMillisToDate(monitoringSession.timeOfMonitoring)}}</td><td>{{monitoringSession.target}} {{indicator.unit}}</td></tr></tbody><tbody ng-if="!vm.impact || !vm.impact.impactIndicators || vm.impact.impactIndicators.length<1"><tr><td colspan="6">No Indicators Found.</td></tr></tbody></table>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/partials/outcomes.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Outcomes Under This Impact ( Impact {{vm.impact.number}} )<div class="col-md-2" style="float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.outcomeCreateModalCtrl()">Add New</button></div></h3><table class="table table-bordered" style="margin-bottom: 20px;"><thead><th class="headers2" style="text-align: center">Output Summary</th><th class="headers2" style="text-align: center">Indicators</th></thead><tr ng-if="!vm.impact.outcomes.length"><td colspan="2">No outcomes found</td></tr><tr ng-repeat-start="outcome in vm.impact.outcomes" ng-if="vm.impact.outcomes.length>0"><td rowspan="{{outcome.outcomeIndicators.length}}"><a ui-sref="outcomeSetup({id : {{outcome.id}}})">{{outcome.number}}. {{outcome.summary}}</a></td><td ng-if="!outcome.outcomeIndicators || !outcome.outcomeIndicators [0]">No indicators.</td><td ng-if="outcome.outcomeIndicators[0]">{{outcome.outcomeIndicators[0].number}}. {{outcome.outcomeIndicators[0].summary}}</td></tr><tr ng-repeat-end="" ng-repeat="outcomeIndicator in outcome.outcomeIndicators" ng-if="$index>0"><td>{{outcomeIndicator.number}}. {{outcomeIndicator.summary}}</td></tr></table>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/partials/researchFramework.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table class="table table-bordered" style="margin-bottom: 20px;width: 100%;" id="researchFrameworkTable"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 10%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collection methods</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.impact.impactIndicators | orderBy:\'number\'"><td>{{indicator.number}}. {{indicator.summary}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openEditResearchFrameworkModal(indicator)" style="margin:5px;width: 80px">Edit</button></td></tr><tr ng-if="!vm.impact.impactIndicators || vm.impact.impactIndicators.length < 1"><td colspan="5">No Indicators Found.</td></tr></table></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputList/create/createOutput.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Output<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="form-group col-md-6 col-xs-6"><label>Select Impact</label><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-md-6 col-xs-6"><label>Select Outcome</label><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Output Coordinator</label> <input type="text" class="form-control" ng-model="vm.coordinatorName"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOutput()">Create Output</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputList/edit/editOutput.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit Outcome<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="form-group col-md-6 col-xs-6"><label>Select Impact</label><div isteven-multi-select="" input-model="vm.impacts" output-model="vm.selectedImpacts" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id number outcomes" on-item-click="vm.mapOutcomes()"></div></div><div class="form-group col-md-6 col-xs-6"><label>Select Outcome</label><div isteven-multi-select="" input-model="vm.outcomes" output-model="vm.selectedOutcomes" button-label="number summary" item-label="number summary" tick-property="ticked" output-properties="id"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Output Coordinator</label> <input type="text" class="form-control" ng-model="vm.coordinatorName"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.editOutput()">Save Changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/edit/setupResearchFramework.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Edit<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Info Required</label> <textarea class="form-control" ng-model="vm.indicator.informationRequired"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Source Of Info</label> <textarea class="form-control" ng-model="vm.indicator.sourceOfInfo"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Data Collection Methods</label> <textarea class="form-control" ng-model="vm.indicator.dataCollectionMethod"></textarea></div></div></div><br><br></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.setupResearchFramework()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/partials/indicators.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Indicators of This Output<div class="col-md-2" style="float: right;padding-right: 0px"><a ui-sref="createOutputIndicator({id : vm.output.id })"><button class="btn btn-info btn-block">Add New</button></a></div></h3><table class="table table-bordered" style="margin-bottom: 20px;margin-top: 20px"><colgroup><col span="1" style="width: 29%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"><col span="1" style="width: 28%;"><col span="1" style="width: 5%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Time</th><th class="headers2" style="text-align: center">Baseline</th><th class="headers2" style="text-align: center">Monitoring</th><th class="headers2" style="text-align: center">Target</th><th class="headers2" style="text-align: center">Actions</th></thead><tbody ng-repeat="indicator in vm.output.outputIndicators | orderBy:\'number\'"><tr><td rowspan="{{indicator.outputMonitoringSessions.length}}">{{indicator.number}}. {{indicator.summary}}</td><td rowspan="{{indicator.outputMonitoringSessions.length}}">{{indicator.timeline < 12 ? indicator.timeline + \' Months\' : indicator.timeline/12 + \' Year\'}}</td><td rowspan="{{indicator.outputMonitoringSessions.length}}">{{indicator.baseline}} {{indicator.unit}}</td><td>{{vm.convertMillisToDate(indicator.outputMonitoringSessions[0].timeOfMonitoring)}}</td><td>{{indicator.outputMonitoringSessions[0].target}} {{indicator.unit}}</td><td rowspan="{{indicator.outputMonitoringSessions.length}}"><button class="btn btn-info" ui-sref="editOutputIndicator({id: {{indicator.id}}})" style="margin:5px;width: 80px">Edit</button> <button class="btn btn-danger" ng-click="vm.deleteIndicator(indicator.id)" style="margin:5px;width: 80px">Delete</button></td></tr><tr ng-repeat="monitoringSession in indicator.outputMonitoringSessions" ng-if="$index > 0"><td>{{vm.convertMillisToDate(monitoringSession.timeOfMonitoring)}}</td><td>{{monitoringSession.target}} {{indicator.unit}}</td></tr></tbody><tbody ng-if="vm.output.outputIndicators.length == 0"><tr><td colspan="6">No Indicators Found.</td></tr></tbody></table>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/partials/majorActivities.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Major Activities Under This Output ( Output {{vm.output.number}} )<div class="col-md-2" style="float: right;padding-right: 0px"><button class="btn btn-info btn-block" ng-click="vm.majorActivityCreateModal()">Add New</button></div></h3><table class="table table-bordered" style="margin-bottom: 20px;"><colgroup><col span="1" style="width: 10%;"><col span="1" style="width: 90%;"></colgroup><thead><th class="headers2" style="text-align: center">#</th><th class="headers2" style="text-align: center">Major Activity</th></thead><tr ng-if="!vm.output.majorActivities.length"><td colspan="2">No Major Activities Found</td></tr><tr ng-repeat="majorActivity in vm.output.majorActivities"><td>{{majorActivity.number}}</td><td>{{majorActivity.summary}}</td></tr></table>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/partials/researchFramework.partial.html','<h3 class="with-line" style="padding-top: 0px!important;">Setup Research Framework</h3><div style="overflow-x: scroll; margin-top:0"><table class="table table-bordered" style="margin-bottom: 20px;width: 100%;" id="researchFrameworkTable"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 20%;"><col span="1" style="width: 10%;"></colgroup><thead><th class="headers2" style="text-align: center">Indicator Summary</th><th class="headers2" style="text-align: center">Info Required</th><th class="headers2" style="text-align: center">Source of Info</th><th class="headers2" style="text-align: center">Data collection methods</th><th class="headers2" style="text-align: center">Actions</th></thead><tr ng-repeat="indicator in vm.output.outputIndicators | orderBy:\'number\'"><td>{{indicator.number}}. {{indicator.summary}}</td><td>{{indicator.informationRequired}}</td><td>{{indicator.sourceOfInfo}}</td><td>{{indicator.dataCollectionMethod}}</td><td style="text-align:center;vertical-align:middle;"><button class="btn btn-info" ng-click="vm.openSetupResearchFrameworkModal(indicator)" style="margin:5px;width: 80px">Edit</button></td></tr><tr ng-if="vm.output.outputIndicators.length == 0"><td colspan="5">No Indicators Found.</td></tr></table></div>');
$templateCache.put('app/pages/main/profile/profileInfo/generalInfo/profilePic/profilePicUploadModal/profilePicUpload.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Upload Profile Picture</h4></div><form name="picUploadForm"><div class="modal-body"><div style="text-align: center"><div ng-show="!vm.isFileSelected" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;"><img ng-src="{{vm.currentProfilePicURL}}" width="100%"></div><div ngf-drop="" ng-model="picFile" ngf-pattern="image/*" style="background: #E4E4E4; overflow: hidden; width: 400px; height: 300px; margin: auto;" ng-show="vm.isFileSelected"><img-crop image="picFile | ngfDataUrl" result-image="croppedDataUrl" ng-init="croppedDataUrl=\'\'" area-type="square"></img-crop></div><button ngf-select="" ng-model="picFile" accept="image/*" class="btn btn-default btn-with-icon" style="margin-top: 10px; margin-bottom: 10px" ngf-change="vm.fileSelected()"><i class="ion-images"></i>Select Image</button><div><img ng-src="{{croppedDataUrl}}"></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.uploadProfilePicture(croppedDataUrl, picFile.name)" ng-if="vm.isFileSelected">Upload</button></div></form></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/create/output/createOutput.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Output<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div><div class="form-group"><label>Output Coordinators</label><div isteven-multi-select="" input-model="vm.allEmployees" output-model="vm.selectedEmployeesUI" button-label="name" item-label="name" tick-property="ticked" output-properties="id"></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOutput()">Create Output</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/create/indicator/createIndicator.html','<div ba-panel="" ba-panel-title="Create Outcome Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-4"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-4"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-md-4" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedInterval != null && vm.selectedTimeLine != \'Immediate\'"><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th></thead><tbody><tr ng-repeat="row in vm.tableData" ng-class="{ \'tdwithdate\': row.isOpen }"><td style="padding-top: 15px"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createOutcomeIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/outcome/outcomeSetup/edit/editIndicatorDetails/editIndicatorDetails.html','<div ba-panel="" ba-panel-title="Edit Outcome Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-6"><button type="button" class="btn btn-info" ng-click="vm.updateIndicator()" style="float:right;margin-top: 20px">Save Changes</button></div></div><div><button type="button" class="btn btn-info" ng-click="vm.extendMonitoring()" style="margin-top: 10px; margin-bottom: 20px;float: right">Extend Monitoring</button></div><div ng-if="vm.monitoringSessions && vm.monitoringSessions.length > 0"><h3 class="with-line">Monitoring Sessions</h3><table class="table table-bordered"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 50%;"><col span="1" style="width: 20%;"></colgroup><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Delete</th></thead><tbody><tr ng-repeat="row in vm.monitoringSessions | orderBy:\'timeOfMonitoring\'"><td style="padding-top: 15px" ng-class="{ \'tdwithdate\': row.isOpen }"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td><button class="btn btn-danger" style="width: 45%;" ng-click="vm.deleteMonitoringSession(row)" ng-if="!row.achieved && !row.new">Delete</button> <button class="btn btn-primary" style="width: 45%;" ng-click="vm.editMonitoringSession(row)" ng-if="!row.achieved && !row.new">Save</button> <button class="btn btn-primary" style="width: 90%;" ng-click="vm.createMonitoringSession(row)" ng-if="row.new">Save</button> <span ng-if="row.achieved">Already data collected for this monitoring session.</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/create/indicator/createIndicator.html','<div ba-panel="" ba-panel-title="Create Impact Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-4"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-4"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-md-4" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedInterval != null && vm.selectedTimeLine != \'Immediate\'"><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th></thead><tbody><tr ng-repeat="row in vm.tableData"><td style="padding-top: 15px" ng-class="{ \'tdwithdate\': row.isOpen }"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createImpactIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/create/outcome/createOutcome.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Indicator</label> <textarea class="form-control" ng-model="vm.indicator"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Means Of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createOutcome()">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/impact/impactSetup/edit/editIndicatorDetails/editIndicatorDetails.html','<div ba-panel="" ba-panel-title="Edit Impact Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-6"><button type="button" class="btn btn-info" ng-click="vm.updateIndicator()" style="float:right;margin-top: 20px">Save Changes</button></div></div><div><button type="button" class="btn btn-info" ng-click="vm.extendMonitoring()" style="margin-top: 10px; margin-bottom: 20px;float: right">Extend Monitoring</button></div><div ng-if="vm.monitoringSessions && vm.monitoringSessions.length > 0"><h3 class="with-line">Monitoring Sessions</h3><table class="table table-bordered"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 50%;"><col span="1" style="width: 20%;"></colgroup><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Delete</th></thead><tbody><tr ng-repeat="row in vm.monitoringSessions | orderBy:\'timeOfMonitoring\'"><td style="padding-top: 15px" ng-class="{ \'tdwithdate\': row.isOpen }"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td><button class="btn btn-danger" style="width: 45%;" ng-click="vm.deleteMonitoringSession(row)" ng-if="!row.achieved && !row.new">Delete</button> <button class="btn btn-primary" style="width: 45%;" ng-click="vm.editMonitoringSession(row)" ng-if="!row.achieved && !row.new">Save</button> <button class="btn btn-primary" style="width: 90%;" ng-click="vm.createMonitoringSession(row)" ng-if="row.new">Save</button> <span ng-if="row.achieved">Already data collected for this monitoring session.</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/edit/editIndicatorDetails/editIndicatorDetails.html','<div ba-panel="" ba-panel-title="Edit Output Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-6"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-6"><button type="button" class="btn btn-info" ng-click="vm.updateIndicator()" style="float:right;margin-top: 20px">Save Changes</button></div></div><div><button type="button" class="btn btn-info" ng-click="vm.extendMonitoring()" style="margin-top: 10px; margin-bottom: 20px;float: right">Extend Monitoring</button></div><div ng-if="vm.monitoringSessions && vm.monitoringSessions.length > 0"><h3 class="with-line">Monitoring Sessions</h3><table class="table table-bordered"><colgroup><col span="1" style="width: 30%;"><col span="1" style="width: 50%;"><col span="1" style="width: 20%;"></colgroup><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th><th>Delete</th></thead><tbody><tr ng-repeat="row in vm.monitoringSessions | orderBy:\'timeOfMonitoring\'"><td style="padding-top: 15px" ng-class="{ \'tdwithdate\': row.isOpen }"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td><td><button class="btn btn-danger" style="width: 45%;" ng-click="vm.deleteMonitoringSession(row)" ng-if="!row.achieved && !row.new">Delete</button> <button class="btn btn-primary" style="width: 45%;" ng-click="vm.editMonitoringSession(row)" ng-if="!row.achieved && !row.new">Save</button> <button class="btn btn-primary" style="width: 90%;" ng-click="vm.createMonitoringSession(row)" ng-if="row.new">Save</button> <span ng-if="row.achieved">Already data collected for this monitoring session.</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/create/indicator/createIndicator.html','<div ba-panel="" ba-panel-title="Create Output Indicator"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label>Means of Verification</label> <textarea class="form-control" ng-model="vm.meansOfVerification"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Assumption</label> <textarea class="form-control" ng-model="vm.assumption"></textarea></div></div></div><div class="row"><div class="form-group"><label ng-repeat="option in vm.typeOptions" style="margin-left: 15px"><input type="radio" ng-model="vm.type" ng-value="option.value" ng-change="vm.createTableData()" style="margin-right: 10px">{{option.name}}</label></div></div><div class="row" ng-if="vm.type == 1"><div class="col-md-3"><div class="form-group"><label>Baseline</label> <input type="number" class="form-control" ng-model="vm.baseline"></div></div><div class="col-md-4" style="margin-top: 30px;"><div style="text-overflow: ellipsis; overflow: hidden; width: 260px; height: 1.2em; white-space: nowrap;">{{vm.unit}}</div></div><div class="col-md-5"><div class="form-group"><label>Unit</label> <input class="form-control" ng-model="vm.unit"></div></div></div><div class="row" ng-if="vm.type === 0"><div class="col-md-6"><div class="form-group"><label>Baseline</label> <input type="text" class="form-control" ng-model="vm.baseline"></div></div></div></div><div class="row"><div class="col-md-4"><label class="customFormLabel">Start Date</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-4"><div class="form-group"><label>Time Line</label><select class="form-control" ng-model="vm.selectedTimeLine" ng-options="item as item for item in vm.timeLines" ng-change="vm.selectInterval()"></select></div></div><div class="col-md-4" ng-if="vm.selectedTimeLine != null && vm.selectedTimeLine != \'Immediate\'"><div class="form-group"><label>Interval</label><select class="form-control" ng-model="vm.selectedInterval" ng-options="item as item.time for item in vm.intervalsToBeShown" ng-change="vm.createTableData()"></select></div></div></div><table class="table table-bordered" ng-if="vm.selectedInterval != null && vm.selectedTimeLine != \'Immediate\'"><thead><th>Time of Monitoring</th><th>Target {{vm.type == 1 && vm.unit != null && vm.unit != \'\' ? vm.getUnitString() : \'\'}}</th></thead><tbody><tr ng-repeat="row in vm.tableData" ng-class="{ \'tdwithdate\': row.isOpen }"><td style="padding-top: 15px"><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="MMM yyyy" ng-model="row.timeOfMonitoring" is-open="row.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendarInTable($event,$index)"><i class="fa fa-calendar"></i></button></span></p></td><td style="padding: 5px"><input type="number" class="form-control" ng-if="vm.type == 1" ng-model="row.target"> <input type="text" class="form-control" ng-if="vm.type == 0" ng-model="row.target"></td></tr></tbody></table><div class="row text-right"><button type="button" class="btn btn-primary" ng-click="vm.createOutputIndicator()" style="margin-top: 20px">Save changes</button></div></div>');
$templateCache.put('app/pages/main/setupMenu/output/outputSetup/create/majorActivity/createMajorActivity.modal.html','<div class="modal-content"><div class="modal-header"><button type="button" class="close" ng-click="$dismiss()" aria-label="Close"><em class="ion-ios-close-empty sn-link-close"></em></button><h4 class="modal-title" id="myModalLabel">Create Major Activity<hr></h4></div><div class="modal-body"><div><div class="row"><div class="col-md-6"><div class="form-group"><label>Number</label> <input type="text" class="form-control" ng-model="vm.number"></div></div><div class="col-md-6"><div class="form-group"><label>Summary</label> <textarea class="form-control" ng-model="vm.summary"></textarea></div></div><div class="col-md-6"><div class="form-group"><label>Start Time</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="{{vm.format}}" ng-model="vm.startDate" is-open="vm.isOpen" datepicker-options="{minMode: \'month\'}" datepicker-mode="\'month\'"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar($event, prop)"><i class="fa fa-calendar"></i></button></span></p></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.createMajorActivity()">Create Major Activity</button></div></div>');}]);